
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref182"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref182"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3OncY", function(module, exports) {

$parcel$export(module.exports, "Config", () => $9d936a2aecb96285$export$29cd7b75162a9425);

var $e7OfR = parcelRequire("e7OfR");

var $hPtJY = parcelRequire("hPtJY");
const $9d936a2aecb96285$export$29cd7b75162a9425 = {
    debug: $9d936a2aecb96285$var$get("debug", false),
    reduxLogger: $9d936a2aecb96285$var$get("reduxLogger", false),
    basePath: $9d936a2aecb96285$var$get("basePath", "/"),
    appVersion: $9d936a2aecb96285$var$get("appVersion", ""),
    pipelineServerURL: $9d936a2aecb96285$var$get("pipelineServerURL", "http://localhost:9000"),
    recordServerURL: $9d936a2aecb96285$var$get("recordServerURL", "http://localhost:9001"),
    converterServerURL: $9d936a2aecb96285$var$get("converterServerURL", "http://localhost:9002"),
    objectServerURL: $9d936a2aecb96285$var$get("objectServerURL", "http://localhost:9003"),
    authzServerURL: $9d936a2aecb96285$var$get("authzServerURL", "http://localhost:9004"),
    fileServerURL: $9d936a2aecb96285$var$get("fileServerURL", "http://localhost:9005"),
    eventServerURL: $9d936a2aecb96285$var$get("eventServerURL", "http://localhost:9006"),
    oidcClientID: $9d936a2aecb96285$var$get("oidcClientID", "sheila"),
    oidcBaseURL: $9d936a2aecb96285$var$get("oidcBaseURL", "https://sheila.cadol.es/auth"),
    oidcLogoutURL: $9d936a2aecb96285$var$get("oidcLogoutURL", "https://sheila.cadol.es/auth/oauth2/sessions/logout"),
    oidcPostLoginRedirectURL: $9d936a2aecb96285$var$get("oidcPostLoginRedirectURL", "http://localhost:8000/callback"),
    oidcPostLogoutRedirectURL: $9d936a2aecb96285$var$get("oidcPostLogoutRedirectURL", "http://localhost:8000/"),
    maxEntriesPerWorklist: $9d936a2aecb96285$var$get("maxEntriesPerWorklist", 96),
    sentryDSN: $9d936a2aecb96285$var$get("sentryDSN", ""),
    sentryEnvironment: $9d936a2aecb96285$var$get("sentryEnvironment", window.location.host),
    sentryTracesSampleRate: $9d936a2aecb96285$var$get("sentryTracesSampleRate", 0.2),
    // Table de correspondance des interprétations du moteur de règles avec les groupes de résultats
    hlaRuleEngineInterpretationMappings: $9d936a2aecb96285$var$get("hlaRuleEngineInterpretationMappings", {
        [(0, $e7OfR.HLAEngineInterpretation).Unknown]: "",
        [(0, $e7OfR.HLAEngineInterpretation).Allowed]: "OK",
        [(0, $e7OfR.HLAEngineInterpretation).Forbidden]: "NOK",
        [(0, $e7OfR.HLAEngineInterpretation).GreyZone]: "UND"
    }),
    eventPollInterval: $9d936a2aecb96285$var$get("eventPollInterval", 10)
};
function $9d936a2aecb96285$var$get(key, defaultValue) {
    // @ts-expect-error
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    const config = Object.assign({}, $hPtJY.env || {}, window.__CONFIG__ || {});
    if (config?.[key] !== undefined) return config[key];
    else return defaultValue;
}

});
parcelRegister("e7OfR", function(module, exports) {
/** 
 * !!! DO NOT MODIFY !!!
 * 
 * File generated from types definition in project https://forge.cadoles.com/EFS/sheila.
 *
 * See misc/script/generate-type-defs.sh script for more informations.
 **/ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HLAEngineInterpretation = void 0;
var $a488b3ad4957d0fb$var$HLAEngineInterpretation;
(function(HLAEngineInterpretation) {
    HLAEngineInterpretation["Unknown"] = "unknown";
    HLAEngineInterpretation["Allowed"] = "allowed";
    HLAEngineInterpretation["Forbidden"] = "forbidden";
    HLAEngineInterpretation["GreyZone"] = "greyZone";
})($a488b3ad4957d0fb$var$HLAEngineInterpretation || (module.exports.HLAEngineInterpretation = $a488b3ad4957d0fb$var$HLAEngineInterpretation = {}));

});

parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("kQ0sT", function(module, exports) {

$parcel$export(module.exports, "captureException", () => $f2b90654edf2c0a1$export$f5282963edea4a68);
$parcel$export(module.exports, "captureMessage", () => $f2b90654edf2c0a1$export$45654777c133ae80);
$parcel$export(module.exports, "captureEvent", () => $f2b90654edf2c0a1$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "setContext", () => $f2b90654edf2c0a1$export$2f04de43fe27971a);
$parcel$export(module.exports, "lastEventId", () => $f2b90654edf2c0a1$export$5d4e9fd7fac8e617);
$parcel$export(module.exports, "isEnabled", () => $f2b90654edf2c0a1$export$3b029eb57ac4d562);
$parcel$export(module.exports, "startSession", () => $f2b90654edf2c0a1$export$c0d84948cecf78d8);
$parcel$export(module.exports, "captureSession", () => $f2b90654edf2c0a1$export$667e7b4d445d566b);

var $4Baka = parcelRequire("4Baka");

var $kGYVh = parcelRequire("kGYVh");

var $fKzCQ = parcelRequire("fKzCQ");

var $kkdRz = parcelRequire("kkdRz");

var $dfMsQ = parcelRequire("dfMsQ");

var $hi47i = parcelRequire("hi47i");

var $6OhB9 = parcelRequire("6OhB9");

var $6OKHc = parcelRequire("6OKHc");

var $2fKhD = parcelRequire("2fKhD");

var $g1WRa = parcelRequire("g1WRa");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $f2b90654edf2c0a1$export$f5282963edea4a68(exception, hint) {
    return (0, $kGYVh.getCurrentScope)().captureException(exception, (0, $g1WRa.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $f2b90654edf2c0a1$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return (0, $kGYVh.getCurrentScope)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $f2b90654edf2c0a1$export$1462b974fdcf6ba2(event, hint) {
    return (0, $kGYVh.getCurrentScope)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $f2b90654edf2c0a1$export$2f04de43fe27971a(name, context) {
    (0, $kGYVh.getIsolationScope)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $f2b90654edf2c0a1$export$bb4922da0dd51b92(extras) {
    (0, $kGYVh.getIsolationScope)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $f2b90654edf2c0a1$export$8e8e7789d42ed61d(key, extra) {
    (0, $kGYVh.getIsolationScope)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $f2b90654edf2c0a1$export$74a8fb34822092e6(tags) {
    (0, $kGYVh.getIsolationScope)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $f2b90654edf2c0a1$export$a37d07ee78eb4569(key, value) {
    (0, $kGYVh.getIsolationScope)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $f2b90654edf2c0a1$export$8b6bb3dd62a01be2(user) {
    (0, $kGYVh.getIsolationScope)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $f2b90654edf2c0a1$export$5d4e9fd7fac8e617() {
    return (0, $kGYVh.getIsolationScope)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $f2b90654edf2c0a1$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $kGYVh.getCurrentScope)();
    const client = (0, $kGYVh.getClient)();
    if (!client) (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $6OhB9.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $f2b90654edf2c0a1$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $f2b90654edf2c0a1$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $6OKHc.timestampInSeconds)();
    function finishCheckIn(status) {
        $f2b90654edf2c0a1$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $6OKHc.timestampInSeconds)() - now
        });
    }
    return (0, $kGYVh.withIsolationScope)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ((0, $dfMsQ.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn("ok");
        }, (e)=>{
            finishCheckIn("error");
            throw e;
        });
        else finishCheckIn("ok");
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $f2b90654edf2c0a1$export$4909b86c8034bf73(timeout) {
    const client = (0, $kGYVh.getClient)();
    if (client) return client.flush(timeout);
    (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $f2b90654edf2c0a1$export$8360e631d277ea4d(timeout) {
    const client = (0, $kGYVh.getClient)();
    if (client) return client.close(timeout);
    (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $f2b90654edf2c0a1$export$3f95c6f800b78024() {
    return !!(0, $kGYVh.getClient)();
}
/** If the SDK is initialized & enabled. */ function $f2b90654edf2c0a1$export$3b029eb57ac4d562() {
    const client = (0, $kGYVh.getClient)();
    return !!client && client.getOptions().enabled !== false && !!client.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $f2b90654edf2c0a1$export$9aac0b9f77928fbf(callback) {
    (0, $kGYVh.getIsolationScope)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $f2b90654edf2c0a1$export$c0d84948cecf78d8(context) {
    const client = (0, $kGYVh.getClient)();
    const isolationScope = (0, $kGYVh.getIsolationScope)();
    const currentScope = (0, $kGYVh.getCurrentScope)();
    const { release: release, environment: environment = (0, $4Baka.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $2fKhD.GLOBAL_OBJ).navigator || {};
    const session = (0, $kkdRz.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $kkdRz.updateSession)(currentSession, {
        status: "exited"
    });
    $f2b90654edf2c0a1$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $f2b90654edf2c0a1$export$17a5be43989a0bc1() {
    const isolationScope = (0, $kGYVh.getIsolationScope)();
    const currentScope = (0, $kGYVh.getCurrentScope)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $kkdRz.closeSession)(session);
    $f2b90654edf2c0a1$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $f2b90654edf2c0a1$var$_sendSessionUpdate() {
    const isolationScope = (0, $kGYVh.getIsolationScope)();
    const currentScope = (0, $kGYVh.getCurrentScope)();
    const client = (0, $kGYVh.getClient)();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $f2b90654edf2c0a1$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $f2b90654edf2c0a1$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $f2b90654edf2c0a1$var$_sendSessionUpdate();
}

});
parcelRegister("4Baka", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", () => $3592a0510b526070$export$849dbeeeda01ae98);
const $3592a0510b526070$export$849dbeeeda01ae98 = "production";

});

parcelRegister("kGYVh", function(module, exports) {

$parcel$export(module.exports, "getCurrentScope", () => $f106fce27ec076f7$export$c7be4b0125a10cba);
$parcel$export(module.exports, "getIsolationScope", () => $f106fce27ec076f7$export$68f3af03034c9e90);
$parcel$export(module.exports, "getGlobalScope", () => $f106fce27ec076f7$export$aa55d5ab8e05984f);
$parcel$export(module.exports, "withScope", () => $f106fce27ec076f7$export$ec58d9285c204497);
$parcel$export(module.exports, "withIsolationScope", () => $f106fce27ec076f7$export$9a4fed82c350c2bd);
$parcel$export(module.exports, "getClient", () => $f106fce27ec076f7$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "getTraceContextFromScope", () => $f106fce27ec076f7$export$1e83db7ee4876dc4);

var $7YCyf = parcelRequire("7YCyf");

var $iNK7c = parcelRequire("iNK7c");

var $4rxjU = parcelRequire("4rxjU");

var $l1oVX = parcelRequire("l1oVX");

var $2fKhD = parcelRequire("2fKhD");
/**
 * Get the currently active scope.
 */ function $f106fce27ec076f7$export$c7be4b0125a10cba() {
    const carrier = (0, $iNK7c.getMainCarrier)();
    const acs = (0, $7YCyf.getAsyncContextStrategy)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $f106fce27ec076f7$export$68f3af03034c9e90() {
    const carrier = (0, $iNK7c.getMainCarrier)();
    const acs = (0, $7YCyf.getAsyncContextStrategy)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $f106fce27ec076f7$export$aa55d5ab8e05984f() {
    return (0, $2fKhD.getGlobalSingleton)("globalScope", ()=>new (0, $4rxjU.Scope)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $f106fce27ec076f7$export$ec58d9285c204497(...rest) {
    const carrier = (0, $iNK7c.getMainCarrier)();
    const acs = (0, $7YCyf.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $f106fce27ec076f7$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $iNK7c.getMainCarrier)();
    const acs = (0, $7YCyf.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $f106fce27ec076f7$export$6bb76d6eba7e258c() {
    return $f106fce27ec076f7$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $f106fce27ec076f7$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    // TODO(v9): Use generateSpanId() instead of spanId
    // eslint-disable-next-line deprecation/deprecation
    const { traceId: traceId, spanId: spanId, parentSpanId: parentSpanId } = propagationContext;
    const traceContext = (0, $l1oVX.dropUndefinedKeys)({
        trace_id: traceId,
        span_id: spanId,
        parent_span_id: parentSpanId
    });
    return traceContext;
}

});
parcelRegister("7YCyf", function(module, exports) {

$parcel$export(module.exports, "getAsyncContextStrategy", () => $5cec0a7bd2540b32$export$f639b0c2752203be);

var $iNK7c = parcelRequire("iNK7c");

var $eGYpZ = parcelRequire("eGYpZ");
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $5cec0a7bd2540b32$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $iNK7c.getMainCarrier)();
    const sentry = (0, $iNK7c.getSentryCarrier)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $5cec0a7bd2540b32$export$f639b0c2752203be(carrier) {
    const sentry = (0, $iNK7c.getSentryCarrier)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $eGYpZ.getStackAsyncContextStrategy)();
}

});
parcelRegister("iNK7c", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", () => $db00931c27c5ec41$export$19eade501500c6c1);
$parcel$export(module.exports, "getSentryCarrier", () => $db00931c27c5ec41$export$c8bfa33e4e8ae492);

var $faPnA = parcelRequire("faPnA");

var $2fKhD = parcelRequire("2fKhD");
/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $db00931c27c5ec41$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $db00931c27c5ec41$export$c8bfa33e4e8ae492((0, $2fKhD.GLOBAL_OBJ));
    return 0, $2fKhD.GLOBAL_OBJ;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $db00931c27c5ec41$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $faPnA.SDK_VERSION);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $faPnA.SDK_VERSION] = __SENTRY__[0, $faPnA.SDK_VERSION] || {};
}

});
parcelRegister("faPnA", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", () => $b0bfa51115099518$export$31499a9cd224b78c);
// This is a magic string replaced by rollup
const $b0bfa51115099518$export$31499a9cd224b78c = "8.50.0";

});

parcelRegister("2fKhD", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", () => $1a40e26460b4422e$export$f1a6cdb1459e81d1);
$parcel$export(module.exports, "getGlobalSingleton", () => $1a40e26460b4422e$export$7e223ec222791509);

var $faPnA = parcelRequire("faPnA");
/** Get's the global object for the current JavaScript runtime */ const $1a40e26460b4422e$export$f1a6cdb1459e81d1 = globalThis;
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $1a40e26460b4422e$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $1a40e26460b4422e$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const versionedCarrier = __SENTRY__[0, $faPnA.SDK_VERSION] = __SENTRY__[0, $faPnA.SDK_VERSION] || {};
    return versionedCarrier[name] || (versionedCarrier[name] = creator());
}

});


parcelRegister("eGYpZ", function(module, exports) {

$parcel$export(module.exports, "getStackAsyncContextStrategy", () => $ab23dab597a507b7$export$329d4d4d54e42710);

var $5MoSi = parcelRequire("5MoSi");

var $4rxjU = parcelRequire("4rxjU");

var $dfMsQ = parcelRequire("dfMsQ");

var $iNK7c = parcelRequire("iNK7c");
/**
 * This is an object that holds a stack of scopes.
 */ class $ab23dab597a507b7$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $4rxjU.Scope)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $4rxjU.Scope)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $dfMsQ.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $ab23dab597a507b7$var$getAsyncContextStack() {
    const registry = (0, $iNK7c.getMainCarrier)();
    const sentry = (0, $iNK7c.getSentryCarrier)(registry);
    return sentry.stack = sentry.stack || new $ab23dab597a507b7$export$d36ec451f120cfba((0, $5MoSi.getDefaultCurrentScope)(), (0, $5MoSi.getDefaultIsolationScope)());
}
function $ab23dab597a507b7$var$withScope(callback) {
    return $ab23dab597a507b7$var$getAsyncContextStack().withScope(callback);
}
function $ab23dab597a507b7$var$withSetScope(scope, callback) {
    const stack = $ab23dab597a507b7$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $ab23dab597a507b7$var$withIsolationScope(callback) {
    return $ab23dab597a507b7$var$getAsyncContextStack().withScope(()=>{
        return callback($ab23dab597a507b7$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $ab23dab597a507b7$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $ab23dab597a507b7$var$withIsolationScope,
        withScope: $ab23dab597a507b7$var$withScope,
        withSetScope: $ab23dab597a507b7$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $ab23dab597a507b7$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$ab23dab597a507b7$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$ab23dab597a507b7$var$getAsyncContextStack().getIsolationScope()
    };
}

});
parcelRegister("5MoSi", function(module, exports) {

$parcel$export(module.exports, "getDefaultCurrentScope", () => $4354bb0fac58a6e0$export$6f1b9191db9c4d5);
$parcel$export(module.exports, "getDefaultIsolationScope", () => $4354bb0fac58a6e0$export$de9862929b76bf57);

var $4rxjU = parcelRequire("4rxjU");

var $2fKhD = parcelRequire("2fKhD");
/** Get the default current scope. */ function $4354bb0fac58a6e0$export$6f1b9191db9c4d5() {
    return (0, $2fKhD.getGlobalSingleton)("defaultCurrentScope", ()=>new (0, $4rxjU.Scope)());
}
/** Get the default isolation scope. */ function $4354bb0fac58a6e0$export$de9862929b76bf57() {
    return (0, $2fKhD.getGlobalSingleton)("defaultIsolationScope", ()=>new (0, $4rxjU.Scope)());
}

});
parcelRegister("4rxjU", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $33c387bb26fe522d$export$775b6bb06e53a214);

var $kkdRz = parcelRequire("kkdRz");

var $dfMsQ = parcelRequire("dfMsQ");

var $hi47i = parcelRequire("hi47i");

var $6OhB9 = parcelRequire("6OhB9");

var $iWfxY = parcelRequire("iWfxY");

var $6OKHc = parcelRequire("6OKHc");

var $vNNF0 = parcelRequire("vNNF0");

var $dc48k = parcelRequire("dc48k");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $33c387bb26fe522d$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information.
 */ class $33c387bb26fe522d$var$ScopeClass {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** Request Mode Session Status */ // eslint-disable-next-line deprecation/deprecation
    /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $iWfxY.generateTraceId)(),
            spanId: (0, $iWfxY.generateSpanId)()
        };
    }
    /**
   * @inheritDoc
   */ clone() {
        const newScope = new $33c387bb26fe522d$var$ScopeClass();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $dc48k._setSpanForScope)(newScope, (0, $dc48k._getSpanForScope)(this));
        return newScope;
    }
    /**
   * @inheritDoc
   */ setClient(client) {
        this._client = client;
    }
    /**
   * @inheritDoc
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this._client;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $kkdRz.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const [scopeInstance, requestSession] = scopeToMerge instanceof $33c387bb26fe522d$export$775b6bb06e53a214 ? [
            scopeToMerge.getScopeData(),
            scopeToMerge.getRequestSession()
        ] : (0, $dfMsQ.isPlainObject)(scopeToMerge) ? [
            captureContext,
            captureContext.requestSession
        ] : [];
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (requestSession) this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._session = undefined;
        (0, $dc48k._setSpanForScope)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $iWfxY.generateTraceId)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $33c387bb26fe522d$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $6OKHc.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $dc48k._getSpanForScope)(this)
        };
    }
    /**
   * @inheritDoc
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $vNNF0.merge)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = {
            // eslint-disable-next-line deprecation/deprecation
            spanId: (0, $iWfxY.generateSpanId)(),
            ...context
        };
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $6OhB9.uuid4)();
        if (!this._client) {
            (0, $hi47i.logger).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $6OhB9.uuid4)();
        if (!this._client) {
            (0, $hi47i.logger).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $6OhB9.uuid4)();
        if (!this._client) {
            (0, $hi47i.logger).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Holds additional event information.
 */ const $33c387bb26fe522d$export$775b6bb06e53a214 = $33c387bb26fe522d$var$ScopeClass;

});
parcelRegister("kkdRz", function(module, exports) {

$parcel$export(module.exports, "makeSession", () => $ecc06dd71ed8ff5f$export$14a186326edbb264);
$parcel$export(module.exports, "updateSession", () => $ecc06dd71ed8ff5f$export$531818e825e774db);
$parcel$export(module.exports, "closeSession", () => $ecc06dd71ed8ff5f$export$56521d9ba90f62ee);




var $l1oVX = parcelRequire("l1oVX");

var $6OKHc = parcelRequire("6OKHc");

var $6OhB9 = parcelRequire("6OhB9");

/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $ecc06dd71ed8ff5f$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $6OKHc.timestampInSeconds)();
    const session = {
        sid: (0, $6OhB9.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$ecc06dd71ed8ff5f$var$sessionToJSON(session)
    };
    if (context) $ecc06dd71ed8ff5f$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $ecc06dd71ed8ff5f$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $6OKHc.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $6OhB9.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $ecc06dd71ed8ff5f$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $ecc06dd71ed8ff5f$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $ecc06dd71ed8ff5f$var$sessionToJSON(session) {
    return (0, $l1oVX.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});
parcelRegister("l1oVX", function(module, exports) {

$parcel$export(module.exports, "fill", () => $f4dd084fe83374eb$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $f4dd084fe83374eb$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $f4dd084fe83374eb$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $f4dd084fe83374eb$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "convertToPlainObject", () => $f4dd084fe83374eb$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $f4dd084fe83374eb$export$b0244d5063c0b61b);
$parcel$export(module.exports, "dropUndefinedKeys", () => $f4dd084fe83374eb$export$d25f2688db1bb433);

var $hA6iJ = parcelRequire("hA6iJ");

var $24aKj = parcelRequire("24aKj");

var $dfMsQ = parcelRequire("dfMsQ");

var $hi47i = parcelRequire("hi47i");

var $hLnp0 = parcelRequire("hLnp0");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $f4dd084fe83374eb$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $f4dd084fe83374eb$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch (e) {
        (0, $24aKj.DEBUG_BUILD) && (0, $hi47i.logger).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $f4dd084fe83374eb$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $24aKj.DEBUG_BUILD) && (0, $hi47i.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $f4dd084fe83374eb$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $f4dd084fe83374eb$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $f4dd084fe83374eb$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 *
 * @deprecated This function is deprecated and will be removed in the next major version of the SDK.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f4dd084fe83374eb$export$9ef804feabbcbaf1(object) {
    return Object.entries(object).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $f4dd084fe83374eb$export$62ff257738bf57f5(value) {
    if ((0, $dfMsQ.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$f4dd084fe83374eb$var$getOwnProperties(value)
    };
    else if ((0, $dfMsQ.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $f4dd084fe83374eb$var$serializeEventTarget(value.target),
            currentTarget: $f4dd084fe83374eb$var$serializeEventTarget(value.currentTarget),
            ...$f4dd084fe83374eb$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $dfMsQ.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $f4dd084fe83374eb$var$serializeEventTarget(target) {
    try {
        return (0, $dfMsQ.isElement)(target) ? (0, $hA6iJ.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $f4dd084fe83374eb$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $f4dd084fe83374eb$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($f4dd084fe83374eb$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return "[object has no keys]";
    if (firstKey.length >= maxLength) return (0, $hLnp0.truncate)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $hLnp0.truncate)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $f4dd084fe83374eb$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $f4dd084fe83374eb$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $f4dd084fe83374eb$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($f4dd084fe83374eb$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.getOwnPropertyNames(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $f4dd084fe83374eb$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($f4dd084fe83374eb$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $f4dd084fe83374eb$var$isPojo(input) {
    if (!(0, $dfMsQ.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e2) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $f4dd084fe83374eb$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $dfMsQ.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("hA6iJ", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", () => $cccaafc2216668b2$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $cccaafc2216668b2$export$1cfafeee2987818b);
$parcel$export(module.exports, "getDomElement", () => $cccaafc2216668b2$export$c660c1f3ab49225c);
$parcel$export(module.exports, "getComponentName", () => $cccaafc2216668b2$export$26727cfcc4d7e0fc);

var $dfMsQ = parcelRequire("dfMsQ");

var $2fKhD = parcelRequire("2fKhD");
const $cccaafc2216668b2$var$WINDOW = (0, $2fKhD.GLOBAL_OBJ);
const $cccaafc2216668b2$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $cccaafc2216668b2$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $cccaafc2216668b2$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $cccaafc2216668b2$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $cccaafc2216668b2$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($cccaafc2216668b2$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $dfMsQ.isString)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $cccaafc2216668b2$export$1cfafeee2987818b() {
    try {
        return $cccaafc2216668b2$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existence of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 *
 * @deprecated This method is deprecated and will be removed in the next major version.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $cccaafc2216668b2$export$c660c1f3ab49225c(selector) {
    if ($cccaafc2216668b2$var$WINDOW.document && $cccaafc2216668b2$var$WINDOW.document.querySelector) return $cccaafc2216668b2$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $cccaafc2216668b2$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$cccaafc2216668b2$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}

});
parcelRegister("dfMsQ", function(module, exports) {

$parcel$export(module.exports, "isError", () => $9a62450b4f3c2c3b$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $9a62450b4f3c2c3b$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $9a62450b4f3c2c3b$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $9a62450b4f3c2c3b$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $9a62450b4f3c2c3b$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $9a62450b4f3c2c3b$export$844ec244b1367d54);
$parcel$export(module.exports, "isParameterizedString", () => $9a62450b4f3c2c3b$export$dbcbffa59149b824);
$parcel$export(module.exports, "isPrimitive", () => $9a62450b4f3c2c3b$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $9a62450b4f3c2c3b$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $9a62450b4f3c2c3b$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $9a62450b4f3c2c3b$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $9a62450b4f3c2c3b$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $9a62450b4f3c2c3b$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $9a62450b4f3c2c3b$export$bc2894c7158efbac);
$parcel$export(module.exports, "isVueViewModel", () => $9a62450b4f3c2c3b$export$7916fad0ebc23f48);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $9a62450b4f3c2c3b$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$e6127cc7fe7395c3(wat) {
    switch($9a62450b4f3c2c3b$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$var$isBuiltin(wat, className) {
    return $9a62450b4f3c2c3b$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$9f9636d330b71954(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$ef9e2056653f0c8e(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$12e869b2a583f783(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$844ec244b1367d54(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$c3825b437cbdea5c(wat) {
    return wat === null || $9a62450b4f3c2c3b$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$53b83ca8eaab0383(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$49841c62b9eff15(wat) {
    return $9a62450b4f3c2c3b$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $9a62450b4f3c2c3b$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$bc2894c7158efbac(wat) {
    return $9a62450b4f3c2c3b$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $9a62450b4f3c2c3b$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}

});


parcelRegister("24aKj", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $18144a665bc8acf7$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $18144a665bc8acf7$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("hi47i", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", () => $c9674f9e04798056$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "originalConsoleMethods", () => $c9674f9e04798056$export$77c4ce905194557b);
$parcel$export(module.exports, "consoleSandbox", () => $c9674f9e04798056$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $c9674f9e04798056$export$af88d00dbe7f521);

var $24aKj = parcelRequire("24aKj");

var $2fKhD = parcelRequire("2fKhD");
/** Prefix for logging strings */ const $c9674f9e04798056$var$PREFIX = "Sentry Logger ";
const $c9674f9e04798056$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $c9674f9e04798056$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $c9674f9e04798056$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $2fKhD.GLOBAL_OBJ))) return callback();
    const console = (0, $2fKhD.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($c9674f9e04798056$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $c9674f9e04798056$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $c9674f9e04798056$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $24aKj.DEBUG_BUILD) $c9674f9e04798056$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $c9674f9e04798056$export$cda52e2a8927a2ca(()=>{
                (0, $2fKhD.GLOBAL_OBJ).console[name](`${$c9674f9e04798056$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $c9674f9e04798056$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $c9674f9e04798056$export$af88d00dbe7f521 = (0, $2fKhD.getGlobalSingleton)("logger", $c9674f9e04798056$var$makeLogger);

});

parcelRegister("hLnp0", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $cee8faa76567523a$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $cee8faa76567523a$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $cee8faa76567523a$export$465e9d514283d4fd);
$parcel$export(module.exports, "stringMatchesSomePattern", () => $cee8faa76567523a$export$a7a5ec66062ea5d);

var $dfMsQ = parcelRequire("dfMsQ");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $cee8faa76567523a$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $cee8faa76567523a$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $cee8faa76567523a$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $dfMsQ.isVueViewModel)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $cee8faa76567523a$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $dfMsQ.isString)(value)) return false;
    if ((0, $dfMsQ.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $dfMsQ.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $cee8faa76567523a$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$cee8faa76567523a$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});


parcelRegister("6OKHc", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => $4f6ba265374890ec$export$7740643b9eeaf0c4);
$parcel$export(module.exports, "timestampInSeconds", () => $4f6ba265374890ec$export$ee52dced521e3e18);
$parcel$export(module.exports, "browserPerformanceTimeOrigin", () => $4f6ba265374890ec$export$baf075a948ffc0bf);

var $2fKhD = parcelRequire("2fKhD");
const $4f6ba265374890ec$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $4f6ba265374890ec$export$7740643b9eeaf0c4() {
    return Date.now() / $4f6ba265374890ec$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $4f6ba265374890ec$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $2fKhD.GLOBAL_OBJ);
    if (!performance || !performance.now) return $4f6ba265374890ec$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $4f6ba265374890ec$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $4f6ba265374890ec$export$ee52dced521e3e18 = $4f6ba265374890ec$var$createUnixTimestampInSecondsFunc();
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 *
 * @deprecated This variable will be removed in the next major version.
 */ let $4f6ba265374890ec$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $4f6ba265374890ec$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $2fKhD.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        // eslint-disable-next-line deprecation/deprecation
        $4f6ba265374890ec$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            // eslint-disable-next-line deprecation/deprecation
            $4f6ba265374890ec$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            // eslint-disable-next-line deprecation/deprecation
            $4f6ba265374890ec$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    // eslint-disable-next-line deprecation/deprecation
    $4f6ba265374890ec$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();

});

parcelRegister("6OhB9", function(module, exports) {

$parcel$export(module.exports, "uuid4", () => $4f55103f4332a5b0$export$19f53698e68b2496);
$parcel$export(module.exports, "getEventDescription", () => $4f55103f4332a5b0$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $4f55103f4332a5b0$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $4f55103f4332a5b0$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $4f55103f4332a5b0$export$6de4ffac6a2f1098);

var $l1oVX = parcelRequire("l1oVX");

var $hLnp0 = parcelRequire("hLnp0");

var $2fKhD = parcelRequire("2fKhD");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $4f55103f4332a5b0$export$19f53698e68b2496() {
    const gbl = (0, $2fKhD.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $4f55103f4332a5b0$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $4f55103f4332a5b0$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $4f55103f4332a5b0$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $4f55103f4332a5b0$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $4f55103f4332a5b0$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $4f55103f4332a5b0$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $4f55103f4332a5b0$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $4f55103f4332a5b0$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $4f55103f4332a5b0$export$d364f2020ab30578(input) {
    const match = input.match($4f55103f4332a5b0$var$SEMVER_REGEXP) || [];
    const major = $4f55103f4332a5b0$var$_parseInt(match[1]);
    const minor = $4f55103f4332a5b0$var$_parseInt(match[2]);
    const patch = $4f55103f4332a5b0$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $4f55103f4332a5b0$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $hLnp0.snipLine)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $hLnp0.snipLine)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $hLnp0.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $4f55103f4332a5b0$export$6de4ffac6a2f1098(exception) {
    if ($4f55103f4332a5b0$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $l1oVX.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $4f55103f4332a5b0$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch (e) {} // eslint-disable-line no-empty
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 *
 * @deprecated This function has been deprecated and will not be replaced.
 */ function $4f55103f4332a5b0$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});


parcelRegister("iWfxY", function(module, exports) {

$parcel$export(module.exports, "generateTraceId", () => $dc99b4184ec29e47$export$dc6d7ea554bcce10);
$parcel$export(module.exports, "generateSpanId", () => $dc99b4184ec29e47$export$295213bc4d0c54ad);

var $6OhB9 = parcelRequire("6OhB9");
/**
 * Returns a new minimal propagation context.
 *
 * @deprecated Use `generateTraceId` and `generateSpanId` instead.
 */ function $dc99b4184ec29e47$export$37f0f2f9cf343e5e() {
    return {
        traceId: $dc99b4184ec29e47$export$dc6d7ea554bcce10(),
        spanId: $dc99b4184ec29e47$export$295213bc4d0c54ad()
    };
}
/**
 * Generate a random, valid trace ID.
 */ function $dc99b4184ec29e47$export$dc6d7ea554bcce10() {
    return (0, $6OhB9.uuid4)();
}
/**
 * Generate a random, valid span ID.
 */ function $dc99b4184ec29e47$export$295213bc4d0c54ad() {
    return (0, $6OhB9.uuid4)().substring(16);
}

});

parcelRegister("vNNF0", function(module, exports) {

$parcel$export(module.exports, "merge", () => $05f9869a4b646370$export$4950aa0f605343fb);
/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $05f9869a4b646370$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && mergeObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $05f9869a4b646370$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}

});

parcelRegister("dc48k", function(module, exports) {

$parcel$export(module.exports, "_setSpanForScope", () => $99af9a2b040631ba$export$3f25fa50c18e20ca);
$parcel$export(module.exports, "_getSpanForScope", () => $99af9a2b040631ba$export$91f063ebb8eff307);

var $l1oVX = parcelRequire("l1oVX");
const $99af9a2b040631ba$var$SCOPE_SPAN_FIELD = "_sentrySpan";
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $99af9a2b040631ba$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $l1oVX.addNonEnumerableProperty)(scope, $99af9a2b040631ba$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$99af9a2b040631ba$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $99af9a2b040631ba$export$91f063ebb8eff307(scope) {
    return scope[$99af9a2b040631ba$var$SCOPE_SPAN_FIELD];
}

});






parcelRegister("fKzCQ", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", () => $b776c95debaa4af0$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $b776c95debaa4af0$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("g1WRa", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", () => $baba650ac852ba0c$export$2d67fb380bd11267);
$parcel$export(module.exports, "parseEventHintOrCaptureContext", () => $baba650ac852ba0c$export$76b5f966996d1653);

var $4Baka = parcelRequire("4Baka");

var $kGYVh = parcelRequire("kGYVh");

var $luMZm = parcelRequire("luMZm");

var $4rxjU = parcelRequire("4rxjU");

var $1pGI9 = parcelRequire("1pGI9");

var $6OhB9 = parcelRequire("6OhB9");

var $886wr = parcelRequire("886wr");

var $hLnp0 = parcelRequire("hLnp0");

var $6OKHc = parcelRequire("6OKHc");

var $3zNRu = parcelRequire("3zNRu");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $baba650ac852ba0c$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $6OhB9.uuid4)(),
        timestamp: event.timestamp || (0, $6OKHc.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $baba650ac852ba0c$export$d7e04067a6fbc882(prepared, options);
    $baba650ac852ba0c$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $baba650ac852ba0c$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $baba650ac852ba0c$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $6OhB9.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $kGYVh.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $3zNRu.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $3zNRu.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $3zNRu.applyScopeDataToEvent)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $luMZm.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $baba650ac852ba0c$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $baba650ac852ba0c$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $baba650ac852ba0c$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $4Baka.DEFAULT_ENVIRONMENT);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    if (event.message) event.message = (0, $hLnp0.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $hLnp0.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $hLnp0.truncate)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $baba650ac852ba0c$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $1pGI9.getFilenameToDebugIdMap)(stackParser);
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (filenameDebugIdMap && frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $baba650ac852ba0c$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $baba650ac852ba0c$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $baba650ac852ba0c$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $886wr.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $886wr.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $886wr.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $886wr.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $886wr.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $886wr.normalize)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts && event.contexts.flags && normalized.contexts) normalized.contexts.flags = (0, $886wr.normalize)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $baba650ac852ba0c$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $4rxjU.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $baba650ac852ba0c$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($baba650ac852ba0c$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($baba650ac852ba0c$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $baba650ac852ba0c$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $4rxjU.Scope) || typeof hint === "function";
}
const $baba650ac852ba0c$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $baba650ac852ba0c$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$baba650ac852ba0c$var$captureContextKeys.includes(key));
}

});
parcelRegister("luMZm", function(module, exports) {

$parcel$export(module.exports, "notifyEventProcessors", () => $fa62667502ab5c7a$export$bf2a096c3e883e79);

var $fKzCQ = parcelRequire("fKzCQ");

var $dfMsQ = parcelRequire("dfMsQ");

var $hi47i = parcelRequire("hi47i");

var $di9R8 = parcelRequire("di9R8");
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $fa62667502ab5c7a$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $di9R8.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $fKzCQ.DEBUG_BUILD) && processor.id && result === null && (0, $hi47i.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $dfMsQ.isThenable)(result)) result.then((final)=>$fa62667502ab5c7a$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $fa62667502ab5c7a$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("di9R8", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", () => $9ad49a0639c06d33$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $9ad49a0639c06d33$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $9ad49a0639c06d33$export$78e43115b553f358);

var $dfMsQ = parcelRequire("dfMsQ");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $9ad49a0639c06d33$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($9ad49a0639c06d33$var$States || ($9ad49a0639c06d33$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $9ad49a0639c06d33$export$1fda8aa4d135f8aa(value) {
    return new $9ad49a0639c06d33$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $9ad49a0639c06d33$export$78e43115b553f358(reason) {
    return new $9ad49a0639c06d33$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $9ad49a0639c06d33$export$6f292d4960313241 {
    constructor(executor){
        $9ad49a0639c06d33$export$6f292d4960313241.prototype.__init.call(this);
        $9ad49a0639c06d33$export$6f292d4960313241.prototype.__init2.call(this);
        $9ad49a0639c06d33$export$6f292d4960313241.prototype.__init3.call(this);
        $9ad49a0639c06d33$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $9ad49a0639c06d33$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $9ad49a0639c06d33$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $9ad49a0639c06d33$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($9ad49a0639c06d33$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($9ad49a0639c06d33$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $9ad49a0639c06d33$var$States.PENDING) return;
            if ((0, $dfMsQ.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $9ad49a0639c06d33$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $9ad49a0639c06d33$var$States.RESOLVED) handler[1](this._value);
                if (this._state === $9ad49a0639c06d33$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});


parcelRegister("1pGI9", function(module, exports) {

$parcel$export(module.exports, "getFilenameToDebugIdMap", () => $107941ce73c7a34f$export$e069fee9c632ed00);
$parcel$export(module.exports, "getDebugImagesForResources", () => $107941ce73c7a34f$export$5a7368330d9ee6e3);

var $2fKhD = parcelRequire("2fKhD");
let $107941ce73c7a34f$var$parsedStackResults;
let $107941ce73c7a34f$var$lastKeysCount;
let $107941ce73c7a34f$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $107941ce73c7a34f$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $2fKhD.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($107941ce73c7a34f$var$cachedFilenameDebugIds && debugIdKeys.length === $107941ce73c7a34f$var$lastKeysCount) return $107941ce73c7a34f$var$cachedFilenameDebugIds;
    $107941ce73c7a34f$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $107941ce73c7a34f$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$107941ce73c7a34f$var$parsedStackResults) $107941ce73c7a34f$var$parsedStackResults = {};
        const result = $107941ce73c7a34f$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame && stackFrame.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $107941ce73c7a34f$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $107941ce73c7a34f$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $107941ce73c7a34f$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $107941ce73c7a34f$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: "sourcemap",
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}

});

parcelRegister("886wr", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $5eb42146e0d2c9ef$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $5eb42146e0d2c9ef$export$23fbbb20bed71033);

var $dfMsQ = parcelRequire("dfMsQ");

var $3fUI5 = parcelRequire("3fUI5");

var $l1oVX = parcelRequire("l1oVX");

var $5v1oS = parcelRequire("5v1oS");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5eb42146e0d2c9ef$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $5eb42146e0d2c9ef$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $5eb42146e0d2c9ef$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $5eb42146e0d2c9ef$export$a3295358bff77e(object, depth);
    if ($5eb42146e0d2c9ef$var$jsonSize(normalized) > maxSize) return $5eb42146e0d2c9ef$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $5eb42146e0d2c9ef$var$visit(key, value, depth = Infinity, maxProperties = Infinity, // eslint-disable-next-line deprecation/deprecation
memo = (0, $3fUI5.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $5eb42146e0d2c9ef$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $5eb42146e0d2c9ef$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $l1oVX.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $5eb42146e0d2c9ef$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $5eb42146e0d2c9ef$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $dfMsQ.isVueViewModel)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $dfMsQ.isSyntheticEvent)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $5v1oS.getFunctionName)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $5eb42146e0d2c9ef$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $5eb42146e0d2c9ef$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $5eb42146e0d2c9ef$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5eb42146e0d2c9ef$var$jsonSize(value) {
    return $5eb42146e0d2c9ef$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $5eb42146e0d2c9ef$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}

});
parcelRegister("3fUI5", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", () => $25eec345af6c49d3$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 *
 * @deprecated This function is deprecated and will be removed in the next major version.
 */ // TODO(v9): Move this function into normalize() directly
function $25eec345af6c49d3$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("5v1oS", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_FUNCTION", () => $4010ef0d9b3761f9$export$27c7e15d453fc0ac);
$parcel$export(module.exports, "createStackParser", () => $4010ef0d9b3761f9$export$a5739666fb2d03d4);
$parcel$export(module.exports, "stackParserFromStackParserOptions", () => $4010ef0d9b3761f9$export$1d5cf88b347146d4);
$parcel$export(module.exports, "getFunctionName", () => $4010ef0d9b3761f9$export$aad197c7121a6651);
$parcel$export(module.exports, "getFramesFromEvent", () => $4010ef0d9b3761f9$export$91d8ca51bd9f6a47);
const $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT = 50;
const $4010ef0d9b3761f9$export$27c7e15d453fc0ac = "?";
// Used to sanitize webpack (error: *) wrapped stack errors
const $4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $4010ef0d9b3761f9$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($4010ef0d9b3761f9$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $4010ef0d9b3761f9$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $4010ef0d9b3761f9$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $4010ef0d9b3761f9$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $4010ef0d9b3761f9$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($4010ef0d9b3761f9$var$STRIP_FRAME_REGEXP.test($4010ef0d9b3761f9$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $4010ef0d9b3761f9$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $4010ef0d9b3761f9$var$getLastStackFrame(localStack).filename,
            function: frame.function || $4010ef0d9b3761f9$export$27c7e15d453fc0ac
        }));
}
function $4010ef0d9b3761f9$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $4010ef0d9b3761f9$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $4010ef0d9b3761f9$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $4010ef0d9b3761f9$var$defaultFunctionName;
        return fn.name || $4010ef0d9b3761f9$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $4010ef0d9b3761f9$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $4010ef0d9b3761f9$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}

});


parcelRegister("3zNRu", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", () => $29ab5181ea4a2c1b$export$43988bc651a80216);
$parcel$export(module.exports, "mergeScopeData", () => $29ab5181ea4a2c1b$export$25ac7e259a513db4);

var $jdzJv = parcelRequire("jdzJv");

var $l1oVX = parcelRequire("l1oVX");

var $vNNF0 = parcelRequire("vNNF0");

var $4H7Y8 = parcelRequire("4H7Y8");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $29ab5181ea4a2c1b$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $29ab5181ea4a2c1b$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $29ab5181ea4a2c1b$var$applySpanToEvent(event, span);
    $29ab5181ea4a2c1b$var$applyFingerprintToEvent(event, fingerprint);
    $29ab5181ea4a2c1b$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $29ab5181ea4a2c1b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $29ab5181ea4a2c1b$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, "extra", extra);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, "tags", tags);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, "user", user);
    $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, "contexts", contexts);
    data.sdkProcessingMetadata = (0, $vNNF0.merge)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $29ab5181ea4a2c1b$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $vNNF0.merge)(data[prop], mergeVal, 1);
}
function $29ab5181ea4a2c1b$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    const cleanedExtra = (0, $l1oVX.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $l1oVX.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $l1oVX.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $l1oVX.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $29ab5181ea4a2c1b$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $29ab5181ea4a2c1b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $29ab5181ea4a2c1b$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $4H7Y8.spanToTraceContext)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $jdzJv.getDynamicSamplingContextFromSpan)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $4H7Y8.getRootSpan)(span);
    const transactionName = (0, $4H7Y8.spanToJSON)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $29ab5181ea4a2c1b$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("jdzJv", function(module, exports) {

$parcel$export(module.exports, "freezeDscOnSpan", () => $dfdaf30e5fcd5fd9$export$7398c93e763ca9fd);
$parcel$export(module.exports, "getDynamicSamplingContextFromScope", () => $dfdaf30e5fcd5fd9$export$89ef1736f08c6b2b);
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", () => $dfdaf30e5fcd5fd9$export$a117f995597e25df);

var $4Baka = parcelRequire("4Baka");

var $kGYVh = parcelRequire("kGYVh");

var $yQUXg = parcelRequire("yQUXg");

var $gdhAa = parcelRequire("gdhAa");

var $l1oVX = parcelRequire("l1oVX");

var $jArAO = parcelRequire("jArAO");

var $4H7Y8 = parcelRequire("4H7Y8");
/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD = "_frozenDsc";
/**
 * Freeze the given DSC on the given span.
 */ function $dfdaf30e5fcd5fd9$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $l1oVX.addNonEnumerableProperty)(spanWithMaybeDsc, $dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $dfdaf30e5fcd5fd9$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = (0, $l1oVX.dropUndefinedKeys)({
        environment: options.environment || (0, $4Baka.DEFAULT_ENVIRONMENT),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit("createDsc", dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $dfdaf30e5fcd5fd9$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $dfdaf30e5fcd5fd9$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $dfdaf30e5fcd5fd9$export$a117f995597e25df(span) {
    const client = (0, $kGYVh.getClient)();
    if (!client) return {};
    const rootSpan = (0, $4H7Y8.getRootSpan)(span);
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$dfdaf30e5fcd5fd9$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return frozenDsc;
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceState = rootSpan.spanContext().traceState;
    const traceStateDsc = traceState && traceState.get("sentry.dsc");
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $gdhAa.baggageHeaderToDynamicSamplingContext)(traceStateDsc);
    if (dscOnTraceState) return dscOnTraceState;
    // Else, we generate it from the span
    const dsc = $dfdaf30e5fcd5fd9$export$366bad00d6815eed(span.spanContext().traceId, client);
    const jsonSpan = (0, $4H7Y8.spanToJSON)(rootSpan);
    const attributes = jsonSpan.data || {};
    const maybeSampleRate = attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE];
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = jsonSpan.description;
    if (source !== "url" && name) dsc.transaction = name;
    // How can we even land here with hasTracingEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $jArAO.hasTracingEnabled)()) dsc.sampled = String((0, $4H7Y8.spanIsSampled)(rootSpan));
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $dfdaf30e5fcd5fd9$export$95cf936fdacaff7b(span) {
    const dsc = $dfdaf30e5fcd5fd9$export$a117f995597e25df(span);
    return (0, $gdhAa.dynamicSamplingContextToSentryBaggageHeader)(dsc);
}

});
parcelRegister("yQUXg", function(module, exports) {

$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", () => $068c396dceb690a1$export$d7a7d984b0791405);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", () => $068c396dceb690a1$export$ccfe0a40627cc34b);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", () => $068c396dceb690a1$export$1a413bd9a88fdb09);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", () => $068c396dceb690a1$export$cca8dd30f57f805e);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON", () => $068c396dceb690a1$export$ba73f34502b7a3b3);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT", () => $068c396dceb690a1$export$f5f95cff026507b5);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE", () => $068c396dceb690a1$export$69cd5c610c7bb96a);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", () => $068c396dceb690a1$export$165ce9a229f6f050);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", () => $068c396dceb690a1$export$1efec95406bbe327);
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME", () => $068c396dceb690a1$export$fea48ba9f4550879);
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $068c396dceb690a1$export$d7a7d984b0791405 = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $068c396dceb690a1$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $068c396dceb690a1$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $068c396dceb690a1$export$cca8dd30f57f805e = "sentry.origin";
/** The reason why an idle span finished. */ const $068c396dceb690a1$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $068c396dceb690a1$export$f5f95cff026507b5 = "sentry.measurement_unit";
/** The value of a measurement, which may be stored as a TimedEvent. */ const $068c396dceb690a1$export$69cd5c610c7bb96a = "sentry.measurement_value";
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $068c396dceb690a1$export$165ce9a229f6f050 = "sentry.custom_span_name";
/**
 * The id of the profile that this span occurred in.
 */ const $068c396dceb690a1$export$1efec95406bbe327 = "sentry.profile_id";
const $068c396dceb690a1$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $068c396dceb690a1$export$b016f89ac1066ec = "cache.hit";
const $068c396dceb690a1$export$3110e4c3f4386399 = "cache.key";
const $068c396dceb690a1$export$86be76deee227ff2 = "cache.item_size";
/** TODO: Remove these once we update to latest semantic conventions */ const $068c396dceb690a1$export$be7a251980e7e946 = "http.request.method";
const $068c396dceb690a1$export$25dfd73e0e32c6e1 = "url.full";

});

parcelRegister("gdhAa", function(module, exports) {

$parcel$export(module.exports, "SENTRY_BAGGAGE_KEY_PREFIX", () => $bcdb7fb6cf7e08bf$export$6e69537d67fa20f);
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", () => $bcdb7fb6cf7e08bf$export$5b96ee2c8421f107);
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", () => $bcdb7fb6cf7e08bf$export$56766feef403f365);

var $24aKj = parcelRequire("24aKj");

var $dfMsQ = parcelRequire("dfMsQ");

var $hi47i = parcelRequire("hi47i");
/**
 * @deprecated Use a `"baggage"` string directly
 */ const $bcdb7fb6cf7e08bf$export$9ca9946bd449ac06 = "baggage";
const $bcdb7fb6cf7e08bf$export$6e69537d67fa20f = "sentry-";
const $bcdb7fb6cf7e08bf$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $bcdb7fb6cf7e08bf$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $bcdb7fb6cf7e08bf$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $bcdb7fb6cf7e08bf$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($bcdb7fb6cf7e08bf$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($bcdb7fb6cf7e08bf$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $bcdb7fb6cf7e08bf$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$bcdb7fb6cf7e08bf$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $bcdb7fb6cf7e08bf$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $bcdb7fb6cf7e08bf$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $dfMsQ.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $bcdb7fb6cf7e08bf$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $bcdb7fb6cf7e08bf$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $bcdb7fb6cf7e08bf$export$bdd844ddb2def819) {
            (0, $24aKj.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}

});

parcelRegister("jArAO", function(module, exports) {

$parcel$export(module.exports, "hasTracingEnabled", () => $e426c875bd1d2890$export$5008da00b1b6dee6);

var $kGYVh = parcelRequire("kGYVh");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $e426c875bd1d2890$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $kGYVh.getClient)();
    const options = maybeOptions || client && client.getOptions();
    // eslint-disable-next-line deprecation/deprecation
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}

});

parcelRegister("4H7Y8", function(module, exports) {

$parcel$export(module.exports, "TRACE_FLAG_NONE", () => $36b15c0d755e29f6$export$208d5b368507fb8b);
$parcel$export(module.exports, "TRACE_FLAG_SAMPLED", () => $36b15c0d755e29f6$export$eb571cd9b5d98de8);
$parcel$export(module.exports, "spanToTransactionTraceContext", () => $36b15c0d755e29f6$export$4c3967a8a2f6bbd6);
$parcel$export(module.exports, "spanToJSON", () => $36b15c0d755e29f6$export$92d8c23565496537);
$parcel$export(module.exports, "spanToTraceContext", () => $36b15c0d755e29f6$export$46c6fbd1d265ebf0);
$parcel$export(module.exports, "spanToTraceHeader", () => $36b15c0d755e29f6$export$7e9f8ae9e4a328ab);
$parcel$export(module.exports, "spanIsSampled", () => $36b15c0d755e29f6$export$5caecac1caaf3a71);
$parcel$export(module.exports, "spanTimeInputToSeconds", () => $36b15c0d755e29f6$export$3f7581298f56c6d7);
$parcel$export(module.exports, "getStatusMessage", () => $36b15c0d755e29f6$export$e238a77ea3a8cd66);
$parcel$export(module.exports, "addChildSpanToSpan", () => $36b15c0d755e29f6$export$81397d924722cc65);
$parcel$export(module.exports, "removeChildSpanFromSpan", () => $36b15c0d755e29f6$export$c2a0c9438bb89d91);
$parcel$export(module.exports, "getSpanDescendants", () => $36b15c0d755e29f6$export$340c5c8a13ffc680);
$parcel$export(module.exports, "getRootSpan", () => $36b15c0d755e29f6$export$c4c6a79b1260ca1b);
$parcel$export(module.exports, "getActiveSpan", () => $36b15c0d755e29f6$export$1be426a8e585c83e);
$parcel$export(module.exports, "showSpanDropWarning", () => $36b15c0d755e29f6$export$d11691ff45a3e535);

var $7YCyf = parcelRequire("7YCyf");

var $iNK7c = parcelRequire("iNK7c");

var $kGYVh = parcelRequire("kGYVh");

var $j7q4e = parcelRequire("j7q4e");

var $yQUXg = parcelRequire("yQUXg");

var $02dIh = parcelRequire("02dIh");

var $hi47i = parcelRequire("hi47i");

var $l1oVX = parcelRequire("l1oVX");

var $iWfxY = parcelRequire("iWfxY");

var $6OKHc = parcelRequire("6OKHc");

var $AIi6N = parcelRequire("AIi6N");

var $dc48k = parcelRequire("dc48k");
// These are aligned with OpenTelemetry trace flags
const $36b15c0d755e29f6$export$208d5b368507fb8b = 0x0;
const $36b15c0d755e29f6$export$eb571cd9b5d98de8 = 0x1;
// todo(v9): Remove this once we've stopped dropping spans via `beforeSendSpan`
let $36b15c0d755e29f6$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $36b15c0d755e29f6$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin } = $36b15c0d755e29f6$export$92d8c23565496537(span);
    return (0, $l1oVX.dropUndefinedKeys)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin
    });
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $36b15c0d755e29f6$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $36b15c0d755e29f6$export$92d8c23565496537(span).parent_span_id;
    const span_id = isRemote ? (0, $iWfxY.generateSpanId)() : spanId;
    return (0, $l1oVX.dropUndefinedKeys)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $36b15c0d755e29f6$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $36b15c0d755e29f6$export$5caecac1caaf3a71(span);
    return (0, $AIi6N.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $36b15c0d755e29f6$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $36b15c0d755e29f6$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $36b15c0d755e29f6$var$ensureTimestampInSeconds(input.getTime());
    return (0, $6OKHc.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $36b15c0d755e29f6$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $36b15c0d755e29f6$export$92d8c23565496537(span) {
    if ($36b15c0d755e29f6$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    try {
        const { spanId: span_id, traceId: trace_id } = span.spanContext();
        // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
        if ($36b15c0d755e29f6$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
            const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status } = span;
            return (0, $l1oVX.dropUndefinedKeys)({
                span_id: span_id,
                trace_id: trace_id,
                data: attributes,
                description: name,
                parent_span_id: parentSpanId,
                start_timestamp: $36b15c0d755e29f6$export$3f7581298f56c6d7(startTime),
                // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
                timestamp: $36b15c0d755e29f6$export$3f7581298f56c6d7(endTime) || undefined,
                status: $36b15c0d755e29f6$export$e238a77ea3a8cd66(status),
                op: attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_OP],
                origin: attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
                _metrics_summary: (0, $j7q4e.getMetricSummaryJsonForSpan)(span)
            });
        }
        // Finally, at least we have `spanContext()`....
        return {
            span_id: span_id,
            trace_id: trace_id
        };
    } catch (e) {
        return {};
    }
}
function $36b15c0d755e29f6$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $36b15c0d755e29f6$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $36b15c0d755e29f6$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $36b15c0d755e29f6$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $36b15c0d755e29f6$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $02dIh.SPAN_STATUS_UNSET)) return undefined;
    if (status.code === (0, $02dIh.SPAN_STATUS_OK)) return "ok";
    return status.message || "unknown_error";
}
const $36b15c0d755e29f6$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $36b15c0d755e29f6$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
/**
 * Adds an opaque child span reference to a span.
 */ function $36b15c0d755e29f6$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$36b15c0d755e29f6$var$ROOT_SPAN_FIELD] || span;
    (0, $l1oVX.addNonEnumerableProperty)(childSpan, $36b15c0d755e29f6$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $l1oVX.addNonEnumerableProperty)(span, $36b15c0d755e29f6$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $36b15c0d755e29f6$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $36b15c0d755e29f6$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($36b15c0d755e29f6$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD] ? Array.from(span[$36b15c0d755e29f6$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $36b15c0d755e29f6$export$c4c6a79b1260ca1b(span) {
    return span[$36b15c0d755e29f6$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $36b15c0d755e29f6$export$1be426a8e585c83e() {
    const carrier = (0, $iNK7c.getMainCarrier)();
    const acs = (0, $7YCyf.getAsyncContextStrategy)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $dc48k._getSpanForScope)((0, $kGYVh.getCurrentScope)());
}
/**
 * Updates the metric summary on the currently active span
 */ function $36b15c0d755e29f6$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = $36b15c0d755e29f6$export$1be426a8e585c83e();
    if (span) (0, $j7q4e.updateMetricSummaryOnSpan)(span, metricType, sanitizedName, value, unit, tags, bucketKey);
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 *
 * todo(v9): Remove this once we've stopped dropping spans via `beforeSendSpan`.
 */ function $36b15c0d755e29f6$export$d11691ff45a3e535() {
    if (!$36b15c0d755e29f6$var$hasShownSpanDropWarning) {
        (0, $hi47i.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Deprecation warning: Returning null from `beforeSendSpan` will be disallowed from SDK version 9.0.0 onwards. The callback will only support mutating spans. To drop certain spans, configure the respective integrations directly.");
        });
        $36b15c0d755e29f6$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $36b15c0d755e29f6$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "custom",
        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME)]: name
    });
}

});
parcelRegister("j7q4e", function(module, exports) {

$parcel$export(module.exports, "getMetricSummaryJsonForSpan", () => $deb2e427fa07e3b2$export$2e7205e45c58797d);
$parcel$export(module.exports, "updateMetricSummaryOnSpan", () => $deb2e427fa07e3b2$export$102c7b059b14a4a);

var $l1oVX = parcelRequire("l1oVX");
/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ const $deb2e427fa07e3b2$var$METRICS_SPAN_FIELD = "_sentryMetrics";
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $deb2e427fa07e3b2$export$2e7205e45c58797d(span) {
    const storage = span[$deb2e427fa07e3b2$var$METRICS_SPAN_FIELD];
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        const arr = output[exportKey] || (output[exportKey] = []);
        arr.push((0, $l1oVX.dropUndefinedKeys)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on a span.
 */ function $deb2e427fa07e3b2$export$102c7b059b14a4a(span, metricType, sanitizedName, value, unit, tags, bucketKey) {
    const existingStorage = span[$deb2e427fa07e3b2$var$METRICS_SPAN_FIELD];
    const storage = existingStorage || (span[$deb2e427fa07e3b2$var$METRICS_SPAN_FIELD] = new Map());
    const exportKey = `${metricType}:${sanitizedName}@${unit}`;
    const bucketItem = storage.get(bucketKey);
    if (bucketItem) {
        const [, summary] = bucketItem;
        storage.set(bucketKey, [
            exportKey,
            {
                min: Math.min(summary.min, value),
                max: Math.max(summary.max, value),
                count: summary.count += 1,
                sum: summary.sum += value,
                tags: summary.tags
            }
        ]);
    } else storage.set(bucketKey, [
        exportKey,
        {
            min: value,
            max: value,
            count: 1,
            sum: value,
            tags: tags
        }
    ]);
}

});

parcelRegister("02dIh", function(module, exports) {

$parcel$export(module.exports, "SPAN_STATUS_UNSET", () => $006ad32cdaebe09b$export$136e25984ba4a383);
$parcel$export(module.exports, "SPAN_STATUS_OK", () => $006ad32cdaebe09b$export$58f7963109c806fc);
$parcel$export(module.exports, "SPAN_STATUS_ERROR", () => $006ad32cdaebe09b$export$f966a0446ece71e);
$parcel$export(module.exports, "setHttpStatus", () => $006ad32cdaebe09b$export$2ad6630ec8164254);
const $006ad32cdaebe09b$export$136e25984ba4a383 = 0;
const $006ad32cdaebe09b$export$58f7963109c806fc = 1;
const $006ad32cdaebe09b$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $006ad32cdaebe09b$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $006ad32cdaebe09b$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $006ad32cdaebe09b$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $006ad32cdaebe09b$export$f966a0446ece71e,
        message: "unknown_error"
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $006ad32cdaebe09b$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $006ad32cdaebe09b$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}

});

parcelRegister("AIi6N", function(module, exports) {

$parcel$export(module.exports, "TRACEPARENT_REGEXP", () => $06e5b8314e290bf2$export$394a210812ba3012);
$parcel$export(module.exports, "propagationContextFromHeaders", () => $06e5b8314e290bf2$export$261f383d16a93e39);
$parcel$export(module.exports, "generateSentryTraceHeader", () => $06e5b8314e290bf2$export$f35d907436da45cf);

var $gdhAa = parcelRequire("gdhAa");

var $iWfxY = parcelRequire("iWfxY");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $06e5b8314e290bf2$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $06e5b8314e290bf2$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($06e5b8314e290bf2$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $06e5b8314e290bf2$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $06e5b8314e290bf2$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $gdhAa.baggageHeaderToDynamicSamplingContext)(baggage);
    if (!traceparentData || !traceparentData.traceId) return {
        traceId: (0, $iWfxY.generateTraceId)(),
        spanId: (0, $iWfxY.generateSpanId)()
    };
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    const virtualSpanId = (0, $iWfxY.generateSpanId)();
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        spanId: virtualSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $06e5b8314e290bf2$export$f35d907436da45cf(traceId = (0, $iWfxY.generateTraceId)(), spanId = (0, $iWfxY.generateSpanId)(), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}

});






parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";

var $8coUR = parcelRequire("8coUR");
var $1c29a66706a62afd$var$n = "function" === typeof Symbol && Symbol.for, $1c29a66706a62afd$var$p = $1c29a66706a62afd$var$n ? Symbol.for("react.element") : 60103, $1c29a66706a62afd$var$q = $1c29a66706a62afd$var$n ? Symbol.for("react.portal") : 60106, $1c29a66706a62afd$var$r = $1c29a66706a62afd$var$n ? Symbol.for("react.fragment") : 60107, $1c29a66706a62afd$var$t = $1c29a66706a62afd$var$n ? Symbol.for("react.strict_mode") : 60108, $1c29a66706a62afd$var$u = $1c29a66706a62afd$var$n ? Symbol.for("react.profiler") : 60114, $1c29a66706a62afd$var$v = $1c29a66706a62afd$var$n ? Symbol.for("react.provider") : 60109, $1c29a66706a62afd$var$w = $1c29a66706a62afd$var$n ? Symbol.for("react.context") : 60110, $1c29a66706a62afd$var$x = $1c29a66706a62afd$var$n ? Symbol.for("react.forward_ref") : 60112, $1c29a66706a62afd$var$y = $1c29a66706a62afd$var$n ? Symbol.for("react.suspense") : 60113, $1c29a66706a62afd$var$z = $1c29a66706a62afd$var$n ? Symbol.for("react.memo") : 60115, $1c29a66706a62afd$var$A = $1c29a66706a62afd$var$n ? Symbol.for("react.lazy") : 60116, $1c29a66706a62afd$var$B = "function" === typeof Symbol && Symbol.iterator;
function $1c29a66706a62afd$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1c29a66706a62afd$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$E = {};
function $1c29a66706a62afd$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$E;
    this.updater = c || $1c29a66706a62afd$var$D;
}
$1c29a66706a62afd$var$F.prototype.isReactComponent = {};
$1c29a66706a62afd$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($1c29a66706a62afd$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$G() {}
$1c29a66706a62afd$var$G.prototype = $1c29a66706a62afd$var$F.prototype;
function $1c29a66706a62afd$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$E;
    this.updater = c || $1c29a66706a62afd$var$D;
}
var $1c29a66706a62afd$var$I = $1c29a66706a62afd$var$H.prototype = new $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$I.constructor = $1c29a66706a62afd$var$H;
$8coUR($1c29a66706a62afd$var$I, $1c29a66706a62afd$var$F.prototype);
$1c29a66706a62afd$var$I.isPureReactComponent = !0;
var $1c29a66706a62afd$var$J = {
    current: null
}, $1c29a66706a62afd$var$K = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$1c29a66706a62afd$var$K.call(b, e) && !$1c29a66706a62afd$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $1c29a66706a62afd$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $1c29a66706a62afd$var$J.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$p;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g, $1c29a66706a62afd$var$Q = [];
function $1c29a66706a62afd$var$R(a, b, c, e) {
    if ($1c29a66706a62afd$var$Q.length) {
        var d = $1c29a66706a62afd$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $1c29a66706a62afd$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $1c29a66706a62afd$var$Q.length && $1c29a66706a62afd$var$Q.push(a);
}
function $1c29a66706a62afd$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$p:
                case $1c29a66706a62afd$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $1c29a66706a62afd$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $1c29a66706a62afd$var$U(d, k);
        g += $1c29a66706a62afd$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $1c29a66706a62afd$var$B && a[$1c29a66706a62afd$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $1c29a66706a62afd$var$U(d, k++), g += $1c29a66706a62afd$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($1c29a66706a62afd$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $1c29a66706a62afd$var$V(a, b, c) {
    return null == a ? 0 : $1c29a66706a62afd$var$T(a, "", b, c);
}
function $1c29a66706a62afd$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape(a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $1c29a66706a62afd$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $1c29a66706a62afd$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($1c29a66706a62afd$var$O(a) && (a = $1c29a66706a62afd$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + c)), e.push(a));
}
function $1c29a66706a62afd$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($1c29a66706a62afd$var$P, "$&/") + "/");
    b = $1c29a66706a62afd$var$R(b, g, e, d);
    $1c29a66706a62afd$var$V(a, $1c29a66706a62afd$var$aa, b);
    $1c29a66706a62afd$var$S(b);
}
var $1c29a66706a62afd$var$Y = {
    current: null
};
function $1c29a66706a62afd$var$Z() {
    var a = $1c29a66706a62afd$var$Y.current;
    if (null === a) throw Error($1c29a66706a62afd$var$C(321));
    return a;
}
var $1c29a66706a62afd$var$ba = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $1c29a66706a62afd$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $8coUR
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $1c29a66706a62afd$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $1c29a66706a62afd$var$R(null, null, b, c);
        $1c29a66706a62afd$var$V(a, $1c29a66706a62afd$var$W, b);
        $1c29a66706a62afd$var$S(b);
    },
    count: function(a) {
        return $1c29a66706a62afd$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $1c29a66706a62afd$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error($1c29a66706a62afd$var$C(143));
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$F;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$u;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$H;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$t;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$y;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$ba;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($1c29a66706a62afd$var$C(267, a));
    var e = $8coUR({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $1c29a66706a62afd$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$1c29a66706a62afd$var$K.call(b, h) && !$1c29a66706a62afd$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $1c29a66706a62afd$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$Z().useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a, b) {
    return $1c29a66706a62afd$var$Z().useContext(a, b);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$Z().useEffect(a, b);
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, c) {
    return $1c29a66706a62afd$var$Z().useImperativeHandle(a, b, c);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$Z().useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$Z().useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, c) {
    return $1c29a66706a62afd$var$Z().useReducer(a, b, c);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$Z().useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$Z().useState(a);
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "16.14.0";

});
parcelRegister("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("1u0KT", function(module, exports) {
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});
parcelRegister("Xw6Mv", function(module, exports) {
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $acw62 = parcelRequire("acw62");

var $8coUR = parcelRequire("8coUR");

var $fO90s = parcelRequire("fO90s");
function u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$acw62) throw Error(u(227));
function ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var da = !1, ea = null, fa = !1, ha = null, ia = {
    onError: function(a) {
        da = !0;
        ea = a;
    }
};
function ja(a, b, c, d, e, f, g, h, k) {
    da = !1;
    ea = null;
    ba.apply(ia, arguments);
}
function ka(a, b, c, d, e, f, g, h, k) {
    ja.apply(this, arguments);
    if (da) {
        if (da) {
            var l = ea;
            da = !1;
            ea = null;
        } else throw Error(u(198));
        fa || (fa = !0, ha = l);
    }
}
var la = null, ma = null, na = null;
function oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = na(c);
    ka(d, b, void 0, a);
    a.currentTarget = null;
}
var pa = null, qa = {};
function ra() {
    if (pa) for(var a in qa){
        var b = qa[a], c = pa.indexOf(a);
        if (!(-1 < c)) throw Error(u(96, a));
        if (!sa[c]) {
            if (!b.extractEvents) throw Error(u(97, a));
            sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if (ta.hasOwnProperty(h)) throw Error(u(99, h));
                ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error(u(98, d, a));
            }
        }
    }
}
function ua(a, b, c) {
    if (va[a]) throw Error(u(100, a));
    va[a] = b;
    wa[a] = b.eventTypes[c].dependencies;
}
var sa = [], ta = {}, va = {}, wa = {};
function xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!qa.hasOwnProperty(c) || qa[c] !== d) {
            if (qa[c]) throw Error(u(102, c));
            qa[c] = d;
            b = !0;
        }
    }
    b && ra();
}
var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), za = null, Aa = null, Ba = null;
function Ca(a) {
    if (a = ma(a)) {
        if ("function" !== typeof za) throw Error(u(280));
        var b = a.stateNode;
        b && (b = la(b), za(a.stateNode, a.type, b));
    }
}
function Da(a) {
    Aa ? Ba ? Ba.push(a) : Ba = [
        a
    ] : Aa = a;
}
function Ea() {
    if (Aa) {
        var a = Aa, b = Ba;
        Ba = Aa = null;
        Ca(a);
        if (b) for(a = 0; a < b.length; a++)Ca(b[a]);
    }
}
function Fa(a, b) {
    return a(b);
}
function Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ha() {}
var Ia = Fa, Ja = !1, Ka = !1;
function La() {
    if (null !== Aa || null !== Ba) Ha(), Ea();
}
function Ma(a, b, c) {
    if (Ka) return a(b, c);
    Ka = !0;
    try {
        return Ia(a, b, c);
    } finally{
        Ka = !1, La();
    }
}
var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Oa = Object.prototype.hasOwnProperty, Pa = {}, Qa = {};
function Ra(a) {
    if (Oa.call(Qa, a)) return !0;
    if (Oa.call(Pa, a)) return !1;
    if (Na.test(a)) return Qa[a] = !0;
    Pa[a] = !0;
    return !1;
}
function Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    C[a] = new v(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    C[b] = new v(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    C[a] = new v(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    C[a] = new v(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    C[a] = new v(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    C[a] = new v(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    C[a] = new v(a, 5, !1, a.toLowerCase(), null, !1);
});
var Ua = /[\-:]([a-z])/g;
function Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !1);
});
C.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !0);
});
var Wa = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = {
    current: null
});
Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function Xa(a, b, c, d) {
    var e = C.hasOwnProperty(b) ? C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var Ya = /^(.*)[\\\/]/, E = "function" === typeof Symbol && Symbol.for, Za = E ? Symbol.for("react.element") : 60103, $a = E ? Symbol.for("react.portal") : 60106, ab = E ? Symbol.for("react.fragment") : 60107, bb = E ? Symbol.for("react.strict_mode") : 60108, cb = E ? Symbol.for("react.profiler") : 60114, db = E ? Symbol.for("react.provider") : 60109, eb = E ? Symbol.for("react.context") : 60110, fb = E ? Symbol.for("react.concurrent_mode") : 60111, gb = E ? Symbol.for("react.forward_ref") : 60112, hb = E ? Symbol.for("react.suspense") : 60113, ib = E ? Symbol.for("react.suspense_list") : 60120, jb = E ? Symbol.for("react.memo") : 60115, kb = E ? Symbol.for("react.lazy") : 60116, lb = E ? Symbol.for("react.block") : 60121, mb = "function" === typeof Symbol && Symbol.iterator;
function nb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = mb && a[mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ab:
            return "Fragment";
        case $a:
            return "Portal";
        case cb:
            return "Profiler";
        case bb:
            return "StrictMode";
        case hb:
            return "Suspense";
        case ib:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case eb:
            return "Context.Consumer";
        case db:
            return "Context.Provider";
        case gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case jb:
            return pb(a.type);
        case lb:
            return pb(a.render);
        case kb:
            if (a = 1 === a._status ? a._result : null) return pb(a);
    }
    return null;
}
function qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = pb(a.type);
                c = null;
                d && (c = pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace(Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
function rb(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function tb(a) {
    var b = sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function xb(a) {
    a._valueTracker || (a._valueTracker = tb(a));
}
function yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function zb(a, b) {
    var c = b.checked;
    return $8coUR({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function Bb(a, b) {
    b = b.checked;
    null != b && Xa(a, "checked", b, !1);
}
function Cb(a, b) {
    Bb(a, b);
    var c = rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Fb(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function Gb(a, b) {
    a = $8coUR({
        children: void 0
    }, b);
    if (b = Fb(b.children)) a.children = b;
    return a;
}
function Hb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(u(91));
    return $8coUR({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function Jb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: rb(c)
    };
}
function Kb(a, b) {
    var c = rb(b.value), d = rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function Nb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Pb, Qb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== Mb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        Pb = Pb || document.createElement("div");
        Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = Pb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function Rb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Tb = {
    animationend: Sb("Animation", "AnimationEnd"),
    animationiteration: Sb("Animation", "AnimationIteration"),
    animationstart: Sb("Animation", "AnimationStart"),
    transitionend: Sb("Transition", "TransitionEnd")
}, Ub = {}, Vb = {};
ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);
function Wb(a) {
    if (Ub[a]) return Ub[a];
    if (!Tb[a]) return a;
    var b = Tb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Vb) return Ub[a] = b[c];
    return a;
}
var Xb = Wb("animationend"), Yb = Wb("animationiteration"), Zb = Wb("animationstart"), $b = Wb("transitionend"), ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), bc = new ("function" === typeof WeakMap ? WeakMap : Map);
function cc(a) {
    var b = bc.get(a);
    void 0 === b && (b = new Map, bc.set(a, b));
    return b;
}
function dc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function ec(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function fc(a) {
    if (dc(a) !== a) throw Error(u(188));
}
function gc(a) {
    var b = a.alternate;
    if (!b) {
        b = dc(a);
        if (null === b) throw Error(u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return fc(e), a;
                if (f === d) return fc(e), b;
                f = f.sibling;
            }
            throw Error(u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(u(189));
            }
        }
        if (c.alternate !== d) throw Error(u(190));
    }
    if (3 !== c.tag) throw Error(u(188));
    return c.stateNode.current === c ? a : b;
}
function hc(a) {
    a = gc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function ic(a, b) {
    if (null == b) throw Error(u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var kc = null;
function lc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)oa(a, b[d], c[d]);
        else b && oa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function mc(a) {
    null !== a && (kc = ic(kc, a));
    a = kc;
    kc = null;
    if (a) {
        jc(a, lc);
        if (kc) throw Error(u(95));
        if (fa) throw a = ha, fa = !1, ha = null, a;
    }
}
function nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function oc(a) {
    if (!ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var pc = [];
function qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > pc.length && pc.push(a);
}
function rc(a, b, c, d) {
    if (pc.length) {
        var e = pc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function sc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = tc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = nc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < sa.length; k++){
            var l = sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = ic(h, l));
        }
        mc(h);
    }
}
function uc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                vc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                vc(b, "focus", !0);
                vc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                oc(a) && vc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === ac.indexOf(a) && F(a, b);
        }
        c.set(a, null);
    }
}
var wc, xc, yc, zc = !1, Ac = [], Bc = null, Cc = null, Dc = null, Ec = new Map, Fc = new Map, Gc = [], Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a, b) {
    var c = cc(b);
    Hc.forEach(function(a) {
        uc(a, b, c);
    });
    Ic.forEach(function(a) {
        uc(a, b, c);
    });
}
function Kc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function Lc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            Bc = null;
            break;
        case "dragenter":
        case "dragleave":
            Cc = null;
            break;
        case "mouseover":
        case "mouseout":
            Dc = null;
            break;
        case "pointerover":
        case "pointerout":
            Ec.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Fc.delete(b.pointerId);
    }
}
function Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = Kc(b, c, d, e, f), null !== b && (b = Nc(b), null !== b && xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function Oc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return Bc = Mc(Bc, a, b, c, d, e), !0;
        case "dragenter":
            return Cc = Mc(Cc, a, b, c, d, e), !0;
        case "mouseover":
            return Dc = Mc(Dc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Ec.set(f, Mc(Ec.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Fc.set(f, Mc(Fc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Pc(a) {
    var b = tc(a.target);
    if (null !== b) {
        var c = dc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = ec(c), null !== b) {
                    a.blockedOn = b;
                    $fO90s.unstable_runWithPriority(a.priority, function() {
                        yc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = Nc(b);
        null !== c && xc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function Sc(a, b, c) {
    Qc(a) && c.delete(b);
}
function Tc() {
    for(zc = !1; 0 < Ac.length;){
        var a = Ac[0];
        if (null !== a.blockedOn) {
            a = Nc(a.blockedOn);
            null !== a && wc(a);
            break;
        }
        var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : Ac.shift();
    }
    null !== Bc && Qc(Bc) && (Bc = null);
    null !== Cc && Qc(Cc) && (Cc = null);
    null !== Dc && Qc(Dc) && (Dc = null);
    Ec.forEach(Sc);
    Fc.forEach(Sc);
}
function Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, zc || (zc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, Tc)));
}
function Vc(a) {
    function b(b) {
        return Uc(b, a);
    }
    if (0 < Ac.length) {
        Uc(Ac[0], a);
        for(var c = 1; c < Ac.length; c++){
            var d = Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Bc && Uc(Bc, a);
    null !== Cc && Uc(Cc, a);
    null !== Dc && Uc(Dc, a);
    Ec.forEach(b);
    Fc.forEach(b);
    for(c = 0; c < Gc.length; c++)d = Gc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Gc.length && (c = Gc[0], null === c.blockedOn);)Pc(c), null === c.blockedOn && Gc.shift();
}
var Wc = {}, Yc = new Map, Zc = new Map, $c = [
    "abort",
    "abort",
    Xb,
    "animationEnd",
    Yb,
    "animationIteration",
    Zb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $b,
    "transitionEnd",
    "waiting",
    "waiting"
];
function ad(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        Zc.set(d, b);
        Yc.set(d, f);
        Wc[e] = f;
    }
}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
ad($c, 2);
for(var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++)Zc.set(bd[cd], 0);
var dd = $fO90s.unstable_UserBlockingPriority, ed = $fO90s.unstable_runWithPriority, fd = !0;
function F(a, b) {
    vc(b, a, !1);
}
function vc(a, b, c) {
    var d = Zc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = gd.bind(null, b, 1, a);
            break;
        case 1:
            d = hd.bind(null, b, 1, a);
            break;
        default:
            d = id.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function gd(a, b, c, d) {
    Ja || Ha();
    var e = id, f = Ja;
    Ja = !0;
    try {
        Ga(e, a, b, c, d);
    } finally{
        (Ja = f) || La();
    }
}
function hd(a, b, c, d) {
    ed(dd, id.bind(null, a, b, c, d));
}
function id(a, b, c, d) {
    if (fd) {
        if (0 < Ac.length && -1 < Hc.indexOf(a)) a = Kc(null, a, b, c, d), Ac.push(a);
        else {
            var e = Rc(a, b, c, d);
            if (null === e) Lc(a, d);
            else if (-1 < Hc.indexOf(a)) a = Kc(e, a, b, c, d), Ac.push(a);
            else if (!Oc(e, a, b, c, d)) {
                Lc(a, d);
                a = rc(a, d, null, b);
                try {
                    Ma(sc, a);
                } finally{
                    qc(a);
                }
            }
        }
    }
}
function Rc(a, b, c, d) {
    c = nc(d);
    c = tc(c);
    if (null !== c) {
        var e = dc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = ec(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = rc(a, d, c, b);
    try {
        Ma(sc, a);
    } finally{
        qc(a);
    }
    return null;
}
var jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, kd = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(jd).forEach(function(a) {
    kd.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        jd[b] = jd[a];
    });
});
function ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || jd.hasOwnProperty(a) && jd[a] ? ("" + b).trim() : b + "px";
}
function md(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var nd = $8coUR({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function od(a, b) {
    if (b) {
        if (nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(u(62, ""));
    }
}
function pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var qd = Mb.html;
function rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = cc(a);
    b = wa[b];
    for(var d = 0; d < b.length; d++)uc(b[d], a, c);
}
function sd() {}
function td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function ud(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function vd(a, b) {
    var c = ud(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = ud(c);
    }
}
function wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function xd() {
    for(var a = window, b = td(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = td(a.document);
    }
    return b;
}
function yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var zd = "$", Ad = "/$", Bd = "$?", Cd = "$!", Dd = null, Ed = null;
function Fd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Hd = "function" === typeof setTimeout ? setTimeout : void 0, Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function Jd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function Kd(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === zd || c === Cd || c === Bd) {
                if (0 === b) return a;
                b--;
            } else c === Ad && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Ld = Math.random().toString(36).slice(2), Md = "__reactInternalInstance$" + Ld, Nd = "__reactEventHandlers$" + Ld, Od = "__reactContainere$" + Ld;
function tc(a) {
    var b = a[Md];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[Od] || c[Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Kd(a); null !== a;){
                if (c = a[Md]) return c;
                a = Kd(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Nc(a) {
    a = a[Md] || a[Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(u(33));
}
function Qd(a) {
    return a[Nd] || null;
}
function Rd(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = la(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(u(231, b, typeof c));
    return c;
}
function Td(a, b, c) {
    if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
}
function Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = Rd(b);
        for(b = c.length; 0 < b--;)Td(c[b], "captured", a);
        for(b = 0; b < c.length; b++)Td(c[b], "bubbled", a);
    }
}
function Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
}
function Wd(a) {
    a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
}
function Xd(a) {
    jc(a, Ud);
}
var Yd = null, Zd = null, $d = null;
function ae() {
    if ($d) return $d;
    var a, b = Zd, c = b.length, d, e = "value" in Yd ? Yd.value : Yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function be() {
    return !0;
}
function ce() {
    return !1;
}
function G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? be : ce;
    this.isPropagationStopped = ce;
    return this;
}
$8coUR(G.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = be);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = be);
    },
    persist: function() {
        this.isPersistent = be;
    },
    isPersistent: ce,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = ce;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
G.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $8coUR(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $8coUR({}, d.Interface, a);
    c.extend = d.extend;
    de(c);
    return c;
};
de(G);
function ee(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function fe(a) {
    if (!(a instanceof this)) throw Error(u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function de(a) {
    a.eventPool = [];
    a.getPooled = ee;
    a.release = fe;
}
var ge = G.extend({
    data: null
}), he = G.extend({
    data: null
}), ie = [
    9,
    13,
    27,
    32
], je = ya && "CompositionEvent" in window, ke = null;
ya && "documentMode" in document && (ke = document.documentMode);
var le = ya && "TextEvent" in window && !ke, me = ya && (!je || ke && 8 < ke && 11 >= ke), ne = String.fromCharCode(32), oe = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, pe = !1;
function qe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== ie.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function re(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var se = !1;
function te(a, b) {
    switch(a){
        case "compositionend":
            return re(b);
        case "keypress":
            if (32 !== b.which) return null;
            pe = !0;
            return ne;
        case "textInput":
            return a = b.data, a === ne && pe ? null : a;
        default:
            return null;
    }
}
function ue(a, b) {
    if (se) return "compositionend" === a || !je && qe(a, b) ? (a = ae(), $d = Zd = Yd = null, se = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return me && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var ve = {
    eventTypes: oe,
    extractEvents: function(a, b, c, d) {
        var e;
        if (je) b: {
            switch(a){
                case "compositionstart":
                    var f = oe.compositionStart;
                    break b;
                case "compositionend":
                    f = oe.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = oe.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else se ? qe(a, c) && (f = oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = oe.compositionStart);
        f ? (me && "ko" !== c.locale && (se || f !== oe.compositionStart ? f === oe.compositionEnd && se && (e = ae()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = !0)), f = ge.getPooled(f, b, c, d), e ? f.data = e : (e = re(c), null !== e && (f.data = e)), Xd(f), e = f) : e = null;
        (a = le ? te(a, c) : ue(a, c)) ? (b = he.getPooled(oe.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!we[a.type] : "textarea" === b ? !0 : !1;
}
var ye = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function ze(a, b, c) {
    a = G.getPooled(ye.change, a, b, c);
    a.type = "change";
    Da(c);
    Xd(a);
    return a;
}
var Ae = null, Be = null;
function Ce(a) {
    mc(a);
}
function De(a) {
    var b = Pd(a);
    if (yb(b)) return a;
}
function Ee(a, b) {
    if ("change" === a) return b;
}
var Fe = !1;
ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
function Ge() {
    Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
}
function He(a) {
    if ("value" === a.propertyName && De(Be)) {
        if (a = ze(Be, a, nc(a)), Ja) mc(a);
        else {
            Ja = !0;
            try {
                Fa(Ce, a);
            } finally{
                Ja = !1, La();
            }
        }
    }
}
function Ie(a, b, c) {
    "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
}
function Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return De(Be);
}
function Ke(a, b) {
    if ("click" === a) return De(b);
}
function Le(a, b) {
    if ("input" === a || "change" === a) return De(b);
}
var Me = {
    eventTypes: ye,
    _isInputEventSupported: Fe,
    extractEvents: function(a, b, c, d) {
        var e = b ? Pd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = Ee;
        else if (xe(e)) {
            if (Fe) g = Le;
            else {
                g = Je;
                var h = Ie;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ke);
        if (g && (g = g(a, b))) return ze(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Db(e, "number", e.value);
    }
}, Ne = G.extend({
    view: null,
    detail: null
}), Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : !1;
}
function Qe() {
    return Pe;
}
var Re = 0, Se = 0, Te = !1, Ue = !1, Ve = Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Qe,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = Re;
        Re = a.screenX;
        return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = Se;
        Se = a.screenY;
        return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = !0, 0);
    }
}), We = Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), Xe = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, Ye = {
    eventTypes: Xe,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
                var h = dc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = Ve;
            var l = Xe.mouseLeave;
            var m = Xe.mouseEnter;
            var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";
        a = null == g ? f : Pd(g);
        f = null == b ? f : Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p) a: {
            k = d;
            m = p;
            g = 0;
            for(a = k; a; a = Rd(a))g++;
            a = 0;
            for(b = m; b; b = Rd(b))a++;
            for(; 0 < g - a;)k = Rd(k), g--;
            for(; 0 < a - g;)m = Rd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = Rd(k);
                m = Rd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = Rd(d);
        }
        for(d = []; p && p !== m;){
            g = p.alternate;
            if (null !== g && g === m) break;
            d.push(p);
            p = Rd(p);
        }
        for(p = 0; p < k.length; p++)Vd(k[p], "bubbled", l);
        for(p = d.length; 0 < p--;)Vd(d[p], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e = "function" === typeof Object.is ? Object.is : Ze, af = Object.prototype.hasOwnProperty;
function bf(a, b) {
    if ($e(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var cf = ya && "documentMode" in document && 11 >= document.documentMode, df = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, ef = null, ff = null, gf = null, hf = !1;
function jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if (hf || null == ef || ef !== td(c)) return null;
    c = ef;
    "selectionStart" in c && yd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return gf && bf(gf, c) ? null : (gf = c, a = G.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
}
var kf = {
    eventTypes: df,
    extractEvents: function(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = cc(e);
                f = wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? Pd(b) : window;
        switch(a){
            case "focus":
                if (xe(e) || "true" === e.contentEditable) ef = e, ff = b, gf = null;
                break;
            case "blur":
                gf = ff = ef = null;
                break;
            case "mousedown":
                hf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return hf = !1, jf(c, d);
            case "selectionchange":
                if (cf) break;
            case "keydown":
            case "keyup":
                return jf(c, d);
        }
        return null;
    }
}, lf = G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), mf = G.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), nf = Ne.extend({
    relatedTarget: null
});
function of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, rf = Ne.extend({
    key: function(a) {
        if (a.key) {
            var b = pf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Qe,
    charCode: function(a) {
        return "keypress" === a.type ? of(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), sf = Ve.extend({
    dataTransfer: null
}), tf = Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Qe
}), uf = G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), vf = Ve.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), wf = {
    eventTypes: Wc,
    extractEvents: function(a, b, c, d) {
        var e = Yc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === of(c)) return null;
            case "keydown":
            case "keyup":
                a = rf;
                break;
            case "blur":
            case "focus":
                a = nf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = Ve;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = sf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = tf;
                break;
            case Xb:
            case Yb:
            case Zb:
                a = lf;
                break;
            case $b:
                a = uf;
                break;
            case "scroll":
                a = Ne;
                break;
            case "wheel":
                a = vf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = mf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = We;
                break;
            default:
                a = G;
        }
        b = a.getPooled(e, b, c, d);
        Xd(b);
        return b;
    }
};
if (pa) throw Error(u(101));
pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ra();
var xf = Nc;
la = Qd;
ma = xf;
na = Pd;
xa({
    SimpleEventPlugin: wf,
    EnterLeaveEventPlugin: Ye,
    ChangeEventPlugin: Me,
    SelectEventPlugin: kf,
    BeforeInputEventPlugin: ve
});
var yf = [], zf = -1;
function H(a) {
    0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
}
function I(a, b) {
    zf++;
    yf[zf] = a.current;
    a.current = b;
}
var Af = {}, J = {
    current: Af
}, K = {
    current: !1
}, Bf = Af;
function Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Df() {
    H(K);
    H(J);
}
function Ef(a, b, c) {
    if (J.current !== Af) throw Error(u(168));
    I(J, b);
    I(K, c);
}
function Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(u(108, pb(b) || "Unknown", e));
    return $8coUR({}, c, {}, d);
}
function Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af;
    Bf = J.current;
    I(J, a);
    I(K, K.current);
    return !0;
}
function Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(u(169));
    c ? (a = Ff(a, b, Bf), d.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K);
    I(K, c);
}
var If = $fO90s.unstable_runWithPriority, Jf = $fO90s.unstable_scheduleCallback, Kf = $fO90s.unstable_cancelCallback, Lf = $fO90s.unstable_requestPaint, Mf = $fO90s.unstable_now, Nf = $fO90s.unstable_getCurrentPriorityLevel, Of = $fO90s.unstable_ImmediatePriority, Pf = $fO90s.unstable_UserBlockingPriority, Qf = $fO90s.unstable_NormalPriority, Rf = $fO90s.unstable_LowPriority, Sf = $fO90s.unstable_IdlePriority, Tf = {}, Uf = $fO90s.unstable_shouldYield, Vf = void 0 !== Lf ? Lf : function() {}, Wf = null, Xf = null, Yf = !1, Zf = Mf(), $f = 1E4 > Zf ? Mf : function() {
    return Mf() - Zf;
};
function ag() {
    switch(Nf()){
        case Of:
            return 99;
        case Pf:
            return 98;
        case Qf:
            return 97;
        case Rf:
            return 96;
        case Sf:
            return 95;
        default:
            throw Error(u(332));
    }
}
function bg(a) {
    switch(a){
        case 99:
            return Of;
        case 98:
            return Pf;
        case 97:
            return Qf;
        case 96:
            return Rf;
        case 95:
            return Sf;
        default:
            throw Error(u(332));
    }
}
function cg(a, b) {
    a = bg(a);
    return If(a, b);
}
function dg(a, b, c) {
    a = bg(a);
    return Jf(a, b, c);
}
function eg(a) {
    null === Wf ? (Wf = [
        a
    ], Xf = Jf(Of, fg)) : Wf.push(a);
    return Tf;
}
function gg() {
    if (null !== Xf) {
        var a = Xf;
        Xf = null;
        Kf(a);
    }
    fg();
}
function fg() {
    if (!Yf && null !== Wf) {
        Yf = !0;
        var a = 0;
        try {
            var b = Wf;
            cg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            Wf = null;
        } catch (c) {
            throw null !== Wf && (Wf = Wf.slice(a + 1)), Jf(Of, gg), c;
        } finally{
            Yf = !1;
        }
    }
}
function hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function ig(a, b) {
    if (a && a.defaultProps) {
        b = $8coUR({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var jg = {
    current: null
}, kg = null, lg = null, mg = null;
function ng() {
    mg = lg = kg = null;
}
function og(a) {
    var b = jg.current;
    H(jg);
    a.type._context._currentValue = b;
}
function pg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function qg(a, b) {
    kg = a;
    mg = lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && (rg = !0), a.firstContext = null);
}
function sg(a, b) {
    if (mg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) mg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === lg) {
            if (null === kg) throw Error(u(308));
            lg = b;
            kg.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else lg = lg.next = b;
    }
    return a._currentValue;
}
var tg = !1;
function ug(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function wg(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function xg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function yg(a, b) {
    var c = a.alternate;
    null !== c && vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function zg(a, b, c, d) {
    var e = a.updateQueue;
    tg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, p = null, x = null;
        if (null !== h) {
            var z = h;
            do {
                g = z.expirationTime;
                if (g < d) {
                    var ca = {
                        expirationTime: z.expirationTime,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    };
                    null === x ? (p = x = ca, m = k) : x = x.next = ca;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    });
                    Ag(g, z.suspenseConfig);
                    a: {
                        var D = a, t = z;
                        g = b;
                        ca = c;
                        switch(t.tag){
                            case 1:
                                D = t.payload;
                                if ("function" === typeof D) {
                                    k = D.call(ca, k, g);
                                    break a;
                                }
                                k = D;
                                break a;
                            case 3:
                                D.effectTag = D.effectTag & -4097 | 64;
                            case 0:
                                D = t.payload;
                                g = "function" === typeof D ? D.call(ca, k, g) : D;
                                if (null === g || void 0 === g) break a;
                                k = $8coUR({}, k, g);
                                break a;
                            case 2:
                                tg = !0;
                        }
                    }
                    null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        z
                    ] : g.push(z));
                }
                z = z.next;
                if (null === z || z === h) {
                    if (g = e.shared.pending, null === g) break;
                    else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = p;
        e.baseState = m;
        e.baseQueue = x;
        Bg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error(u(191, d));
            d.call(e);
        }
    }
}
var Dg = Wa.ReactCurrentBatchConfig, Eg = (new $acw62.Component).refs;
function Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8coUR({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var Jg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? dc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = Gg(), d = Dg.suspense;
        c = Hg(c, a, d);
        d = wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        xg(a, d);
        Ig(a, c);
    }
};
function Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !bf(c, d) || !bf(e, f) : !0;
}
function Lg(a, b, c) {
    var d = !1, e = Af;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = sg(f) : (e = L(b) ? Bf : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Cf(a, e) : Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Jg.enqueueReplaceState(b, b.state, null);
}
function Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Eg;
    ug(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = sg(f) : (f = L(b) ? Bf : J.current, e.context = Cf(a, f));
    zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Jg.enqueueReplaceState(e, e.state, null), zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var Og = Array.isArray;
function Pg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Eg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(u(284));
        if (!c._owner) throw Error(u(290, a));
    }
    return a;
}
function Qg(a, b) {
    if ("textarea" !== a.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function Rg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Sg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Tg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Pg(a, b, c), d.return = a, d;
        d = Ug(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Pg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Vg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Wg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Tg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case Za:
                    return c = Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = Pg(a, null, b), c.return = a, c;
                case $a:
                    return b = Vg(b, a.mode, c), b.return = a, b;
            }
            if (Og(b) || nb(b)) return b = Wg(b, a.mode, c, null), b.return = a, b;
            Qg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case Za:
                    return c.key === e ? c.type === ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Og(c) || nb(c)) return null !== e ? null : m(a, b, c, d, null);
            Qg(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Og(d) || nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Qg(b, d);
        }
        return null;
    }
    function ca(e, g, h, k) {
        for(var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++){
            m.index > y ? (A = m, m = null) : A = m.sibling;
            var q = x(e, m, h[y], k);
            if (null === q) {
                null === m && (m = A);
                break;
            }
            a && m && null === q.alternate && b(e, m);
            g = f(q, g, y);
            null === t ? l = q : t.sibling = q;
            t = q;
            m = A;
        }
        if (y === h.length) return c(e, m), l;
        if (null === m) {
            for(; y < h.length; y++)m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
            return l;
        }
        for(m = d(e, m); y < h.length; y++)A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function D(e, g, h, l) {
        var k = nb(h);
        if ("function" !== typeof k) throw Error(u(150));
        h = k.call(h);
        if (null == h) throw Error(u(151));
        for(var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()){
            t.index > y ? (A = t, t = null) : A = t.sibling;
            var D = x(e, t, q.value, l);
            if (null === D) {
                null === t && (t = A);
                break;
            }
            a && t && null === D.alternate && b(e, t);
            g = f(D, g, y);
            null === m ? k = D : m.sibling = D;
            m = D;
            t = A;
        }
        if (q.done) return c(e, t), k;
        if (null === t) {
            for(; !q.done; y++, q = h.next())q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
            return k;
        }
        for(t = d(e, t); !q.done; y++, q = h.next())q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        a && t.forEach(function(a) {
            return b(e, a);
        });
        return k;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Pg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ab ? (d = Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = Pg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Vg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Tg(f, a.mode, h), d.return = a, a = d), g(a);
        if (Og(f)) return ca(a, d, f, h);
        if (nb(f)) return D(a, d, f, h);
        l && Qg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error(u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var Xg = Rg(!0), Yg = Rg(!1), Zg = {}, $g = {
    current: Zg
}, ah = {
    current: Zg
}, bh = {
    current: Zg
};
function ch(a) {
    if (a === Zg) throw Error(u(174));
    return a;
}
function dh(a, b) {
    I(bh, b);
    I(ah, a);
    I($g, Zg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : Ob(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Ob(b, a);
    }
    H($g);
    I($g, b);
}
function eh() {
    H($g);
    H(ah);
    H(bh);
}
function fh(a) {
    ch(bh.current);
    var b = ch($g.current);
    var c = Ob(b, a.type);
    b !== c && (I(ah, a), I($g, c));
}
function gh(a) {
    ah.current === a && (H($g), H(ah));
}
var M = {
    current: 0
};
function hh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === Bd || c.data === Cd)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function ih(a, b) {
    return {
        responder: a,
        props: b
    };
}
var jh = Wa.ReactCurrentDispatcher, kh = Wa.ReactCurrentBatchConfig, lh = 0, N = null, O = null, P = null, mh = !1;
function Q() {
    throw Error(u(321));
}
function nh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e(a[c], b[c])) return !1;
    return !0;
}
function oh(a, b, c, d, e, f) {
    lh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    jh.current = null === a || null === a.memoizedState ? ph : qh;
    a = c(d, e);
    if (b.expirationTime === lh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error(u(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            jh.current = rh;
            a = c(d, e);
        }while (b.expirationTime === lh);
    }
    jh.current = sh;
    b = null !== O && null !== O.next;
    lh = 0;
    P = O = N = null;
    mh = !1;
    if (b) throw Error(u(300));
    return a;
}
function th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function uh() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(u(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function wh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < lh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > N.expirationTime && (N.expirationTime = l, Bg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $e(d, b.memoizedState) || (rg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function xh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e(f, b.memoizedState) || (rg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function yh(a) {
    var b = th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: vh,
        lastRenderedState: a
    };
    a = a.dispatch = zh.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function Ah(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Bh() {
    return uh().memoizedState;
}
function Ch(a, b, c, d) {
    var e = th();
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function Dh(a, b, c, d) {
    var e = uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && nh(d, g.deps)) {
            Ah(b, c, f, d);
            return;
        }
    }
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, f, d);
}
function Eh(a, b) {
    return Ch(516, 4, a, b);
}
function Fh(a, b) {
    return Dh(516, 4, a, b);
}
function Gh(a, b) {
    return Dh(4, 2, a, b);
}
function Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Dh(4, 2, Hh.bind(null, b, a), c);
}
function Jh() {}
function Kh(a, b) {
    th().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function Lh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Mh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Nh(a, b, c) {
    var d = ag();
    cg(98 > d ? 98 : d, function() {
        a(!0);
    });
    cg(97 < d ? 97 : d, function() {
        var d = kh.suspense;
        kh.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            kh.suspense = d;
        }
    });
}
function zh(a, b, c) {
    var d = Gg(), e = Dg.suspense;
    d = Hg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === N || null !== f && f === N) mh = !0, e.expirationTime = lh, N.expirationTime = lh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if ($e(h, g)) return;
        } catch (k) {} finally{}
        Ig(a, d);
    }
}
var sh = {
    readContext: sg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useResponder: Q,
    useDeferredValue: Q,
    useTransition: Q
}, ph = {
    readContext: sg,
    useCallback: Kh,
    useContext: sg,
    useEffect: Eh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Ch(4, 2, Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Ch(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = zh.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: yh,
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = yh(a), d = c[0], e = c[1];
        Eh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = yh(!1), c = b[0];
        b = b[1];
        return [
            Kh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, qh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: wh,
    useRef: Bh,
    useState: function() {
        return wh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = wh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = wh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, rh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: xh,
    useRef: Bh,
    useState: function() {
        return xh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = xh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = xh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, Oh = null, Ph = null, Qh = !1;
function Rh(a, b) {
    var c = Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function Th(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function Uh(a) {
    if (Qh) {
        var b = Ph;
        if (b) {
            var c = b;
            if (!Th(a, b)) {
                b = Jd(c.nextSibling);
                if (!b || !Th(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    Qh = !1;
                    Oh = a;
                    return;
                }
                Rh(Oh, c);
            }
            Oh = a;
            Ph = Jd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
    }
}
function Vh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    Oh = a;
}
function Wh(a) {
    if (a !== Oh) return !1;
    if (!Qh) return Vh(a), Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !Gd(b, a.memoizedProps)) for(b = Ph; b;)Rh(a, b), b = Jd(b.nextSibling);
    Vh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === Ad) {
                        if (0 === b) {
                            Ph = Jd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== zd && c !== Cd && c !== Bd || b++;
                }
                a = a.nextSibling;
            }
            Ph = null;
        }
    } else Ph = Oh ? Jd(a.stateNode.nextSibling) : null;
    return !0;
}
function Xh() {
    Ph = Oh = null;
    Qh = !1;
}
var Yh = Wa.ReactCurrentOwner, rg = !1;
function R(a, b, c, d) {
    b.child = null === a ? Yg(b, null, c, d) : Xg(b, a.child, c, d);
}
function Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    qg(b, e);
    d = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, d, e);
    return b.child;
}
function ai(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ci(a, b, g, d, e, f);
        a = Ug(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : bf, c(e, d) && a.ref === b.ref)) return $h(a, b, f);
    b.effectTag |= 1;
    a = Sg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ci(a, b, c, d, e, f) {
    return null !== a && bf(a.memoizedProps, d) && a.ref === b.ref && (rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $h(a, b, f)) : di(a, b, c, d, f);
}
function ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function di(a, b, c, d, e) {
    var f = L(c) ? Bf : J.current;
    f = Cf(b, f);
    qg(b, e);
    c = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, c, e);
    return b.child;
}
function fi(a, b, c, d, e) {
    if (L(c)) {
        var f = !0;
        Gf(b);
    } else f = !1;
    qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Lg(b, c, d), Ng(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l);
        tg = !1;
        var x = b.memoizedState;
        g.state = x;
        zg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), k = b.memoizedState), (h = tg || Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l), tg = !1, k = b.memoizedState, g.state = k, zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), x = b.memoizedState), (m = tg || Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return gi(a, b, c, d, f, e);
}
function gi(a, b, c, d, e, f) {
    ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && Hf(b, c, !1), $h(a, b, f);
    d = b.stateNode;
    Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = Xg(b, a.child, null, f), b.child = Xg(b, null, h, f)) : R(a, b, h, f);
    b.memoizedState = d.state;
    e && Hf(b, c, !0);
    return b.child;
}
function hi(a) {
    var b = a.stateNode;
    b.pendingContext ? Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ef(a, b.context, !1);
    dh(a, b.containerInfo);
}
var ii = {
    dehydrated: null,
    retryTime: 0
};
function ji(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    I(M, f & 1);
    if (null === a) {
        void 0 !== e.fallback && Uh(b);
        if (g) {
            g = e.fallback;
            e = Wg(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = Wg(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = ii;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = Yg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = Sg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            d = Sg(d, e);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = ii;
            b.child = c;
            return d;
        }
        c = Xg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = Wg(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        c = Wg(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = ii;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = Xg(b, a, e.children, c);
}
function ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    pg(a.return, b);
}
function li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    R(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && ki(a, c);
            else if (19 === a.tag) ki(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === hh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            li(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === hh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            li(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            li(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error(u(153));
    if (null !== b.child) {
        a = b.child;
        c = Sg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Sg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
var ni, oi, pi, qi;
ni = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
oi = function() {};
pi = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        ch($g.current);
        a = null;
        switch(c){
            case "input":
                f = zb(g, f);
                d = zb(g, d);
                a = [];
                break;
            case "option":
                f = Gb(g, f);
                d = Gb(g, d);
                a = [];
                break;
            case "select":
                f = $8coUR({}, f, {
                    value: void 0
                });
                d = $8coUR({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = Ib(g, f);
                d = Ib(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = sd);
        }
        od(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
qi = function(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function ri(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function si(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return L(b.type) && Df(), null;
        case 3:
            return eh(), H(K), H(J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !Wh(b) || (b.effectTag |= 4), oi(b), null;
        case 5:
            gh(b);
            c = ch(bh.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(u(166));
                    return null;
                }
                a = ch($g.current);
                if (Wh(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[Md] = b;
                    d[Nd] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < ac.length; a++)F(ac[a], d);
                            break;
                        case "source":
                            F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", d);
                            F("load", d);
                            break;
                        case "form":
                            F("reset", d);
                            F("submit", d);
                            break;
                        case "details":
                            F("toggle", d);
                            break;
                        case "input":
                            Ab(d, f);
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(d, f), F("invalid", d), rd(c, "onChange");
                    }
                    od(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : va.hasOwnProperty(g) && null != h && rd(c, g);
                    }
                    switch(e){
                        case "input":
                            xb(d);
                            Eb(d, f, !0);
                            break;
                        case "textarea":
                            xb(d);
                            Lb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = sd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === qd && (a = Nb(e));
                    a === qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[Md] = b;
                    a[Nd] = d;
                    ni(a, b, !1, !1);
                    b.stateNode = a;
                    g = pd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < ac.length; h++)F(ac[h], a);
                            h = d;
                            break;
                        case "source":
                            F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", a);
                            F("load", a);
                            h = d;
                            break;
                        case "form":
                            F("reset", a);
                            F("submit", a);
                            h = d;
                            break;
                        case "details":
                            F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            Ab(a, d);
                            h = zb(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "option":
                            h = Gb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = $8coUR({}, d, {
                                value: void 0
                            });
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(a, d);
                            h = Ib(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    od(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && Rb(a, l) : "number" === typeof l && Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (va.hasOwnProperty(f) ? null != l && rd(c, f) : null != l && Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            xb(a);
                            Eb(a, d, !1);
                            break;
                        case "textarea":
                            xb(a);
                            Lb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && Hb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = sd);
                    }
                    Fd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) qi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(u(166));
                c = ch(bh.current);
                ch($g.current);
                Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Md] = b, b.stateNode = c);
            }
            return null;
        case 13:
            H(M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1)) S === ti && (S = ui);
                else {
                    if (S === ti || S === ui) S = vi;
                    0 !== wi && null !== T && (xi(T, U), yi(T, wi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return eh(), oi(b), null;
        case 10:
            return og(b), null;
        case 17:
            return L(b.type) && Df(), null;
        case 19:
            H(M);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) ri(d, !1);
                else {
                    if (S !== ti || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = hh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            ri(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                                expirationTime: f.expirationTime,
                                firstContext: f.firstContext,
                                responders: f.responders
                            }), d = d.sibling;
                            I(M, M.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = hh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $f(), c.sibling = null, b = M.current, I(M, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error(u(156, b.tag));
}
function zi(a) {
    switch(a.tag){
        case 1:
            L(a.type) && Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            eh();
            H(K);
            H(J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error(u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return gh(a), null;
        case 13:
            return H(M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return H(M), null;
        case 4:
            return eh(), null;
        case 10:
            return og(a), null;
        default:
            return null;
    }
}
function Ai(a, b) {
    return {
        value: a,
        source: b,
        stack: qb(b)
    };
}
var Bi = "function" === typeof WeakSet ? WeakSet : Set;
function Ci(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = qb(c));
    null !== c && pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function Di(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        Ei(a, c);
    }
}
function Fi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Ei(a, c);
        }
        else b.current = null;
    }
}
function Gi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : ig(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(u(163));
}
function Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ji(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            Ii(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : ig(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && Cg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Cg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && Fd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Vc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error(u(163));
}
function Ki(a, b, c) {
    "function" === typeof Li && Li(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                cg(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                Ei(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && Di(b, c);
            break;
        case 5:
            Fi(b);
            break;
        case 4:
            Mi(a, b, c);
    }
}
function Ni(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && Ni(b);
}
function Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Pi(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (Oi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error(u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(u(161));
    }
    c.effectTag & 16 && (Rb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || Oi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? Qi(a, c, b) : Ri(a, c, b);
}
function Qi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = sd));
    else if (4 !== d && (a = a.child, null !== a)) for(Qi(a, b, c), a = a.sibling; null !== a;)Qi(a, b, c), a = a.sibling;
}
function Ri(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Ri(a, b, c), a = a.sibling; null !== a;)Ri(a, b, c), a = a.sibling;
}
function Mi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error(u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if (Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if (Ki(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function Si(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            Hi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[Nd] = d;
                    "input" === a && "radio" === d.type && null != d.name && Bb(c, d);
                    pd(a, e);
                    b = pd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? md(c, h) : "dangerouslySetInnerHTML" === g ? Qb(c, h) : "children" === g ? Rb(c, h) : Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            Cb(c, d);
                            break;
                        case "textarea":
                            Kb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? Hb(c, !!d.multiple, d.defaultValue, !0) : Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, Vc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, Ti = $f());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = ld("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            Ui(b);
            return;
        case 19:
            Ui(b);
            return;
        case 17:
            return;
    }
    throw Error(u(163));
}
function Ui(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Bi);
        b.forEach(function(b) {
            var d = Vi.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var Wi = "function" === typeof WeakMap ? WeakMap : Map;
function Xi(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Yi || (Yi = !0, Zi = d);
        Ci(a, b);
    };
    return c;
}
function $i(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ci(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === aj ? aj = new Set([
            this
        ]) : aj.add(this), Ci(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var bj = Math.ceil, cj = Wa.ReactCurrentDispatcher, dj = Wa.ReactCurrentOwner, V = 0, ej = 8, fj = 16, gj = 32, ti = 0, hj = 1, ij = 2, ui = 3, vi = 4, jj = 5, W = V, T = null, X = null, U = 0, S = ti, kj = null, lj = 1073741823, mj = 1073741823, nj = null, wi = 0, oj = !1, Ti = 0, pj = 500, Y = null, Yi = !1, Zi = null, aj = null, qj = !1, rj = null, sj = 90, tj = null, uj = 0, vj = null, wj = 0;
function Gg() {
    return (W & (fj | gj)) !== V ? 1073741821 - ($f() / 10 | 0) : 0 !== wj ? wj : wj = 1073741821 - ($f() / 10 | 0);
}
function Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if ((W & fj) !== V) return U;
    if (null !== c) a = hg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = hg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = hg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error(u(326));
    }
    null !== T && a === U && --a;
    return a;
}
function Ig(a, b) {
    if (50 < uj) throw uj = 0, vj = null, Error(u(185));
    a = xj(a, b);
    if (null !== a) {
        var c = ag();
        1073741823 === b ? (W & ej) !== V && (W & (fj | gj)) === V ? yj(a) : (Z(a), W === V && gg()) : Z(a);
        (W & 4) === V || 98 !== c && 99 !== c || (null === tj ? tj = new Map([
            [
                a,
                b
            ]
        ]) : (c = tj.get(a), (void 0 === c || c > b) && tj.set(a, b)));
    }
}
function xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && (T === e && (Bg(b), S === vi && xi(e, U)), yi(e, b));
    return e;
}
function zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));
    else {
        var b = zj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== Tf && Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? eg(yj.bind(null, a)) : dg(d, Bj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $f()
            });
            a.callbackNode = b;
        }
    }
}
function Bj(a, b) {
    wj = 0;
    if (b) return b = Gg(), Cj(a, b), Z(a), null;
    var c = zj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if ((W & (fj | gj)) !== V) throw Error(u(327));
        Dj();
        a === T && c === U || Ej(a, c);
        if (null !== X) {
            var d = W;
            W |= fj;
            var e = Fj();
            for(;;)try {
                Gj();
                break;
            } catch (h) {
                Hj(a, h);
            }
            ng();
            W = d;
            cj.current = e;
            if (S === hj) throw b = kj, Ej(a, c), xi(a, c), Z(a), b;
            if (null === X) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S, T = null, d){
                case ti:
                case hj:
                    throw Error(u(345));
                case ij:
                    Cj(a, 2 < c ? 2 : c);
                    break;
                case ui:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (1073741823 === lj && (e = Ti + pj - $f(), 10 < e)) {
                        if (oj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                Ej(a, c);
                                break;
                            }
                        }
                        f = zj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = Hd(Jj.bind(null, a), e);
                        break;
                    }
                    Jj(a);
                    break;
                case vi:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        Ej(a, c);
                        break;
                    }
                    e = zj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== mj ? d = 10 * (1073741821 - mj) - $f() : 1073741823 === lj ? d = 0 : (d = 10 * (1073741821 - lj) - 5E3, e = $f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * bj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = Hd(Jj.bind(null, a), d);
                        break;
                    }
                    Jj(a);
                    break;
                case jj:
                    if (1073741823 !== lj && null !== nj) {
                        f = lj;
                        var g = nj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            xi(a, c);
                            a.timeoutHandle = Hd(Jj.bind(null, a), d);
                            break;
                        }
                    }
                    Jj(a);
                    break;
                default:
                    throw Error(u(329));
            }
            Z(a);
            if (a.callbackNode === b) return Bj.bind(null, a);
        }
    }
    return null;
}
function yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    Dj();
    a === T && b === U || Ej(a, b);
    if (null !== X) {
        var c = W;
        W |= fj;
        var d = Fj();
        for(;;)try {
            Kj();
            break;
        } catch (e) {
            Hj(a, e);
        }
        ng();
        W = c;
        cj.current = d;
        if (S === hj) throw c = kj, Ej(a, b), xi(a, b), Z(a), c;
        if (null !== X) throw Error(u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        T = null;
        Jj(a);
        Z(a);
    }
    return null;
}
function Lj() {
    if (null !== tj) {
        var a = tj;
        tj = null;
        a.forEach(function(a, c) {
            Cj(c, a);
            Z(c);
        });
        gg();
    }
}
function Mj(a, b) {
    var c = W;
    W |= 1;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Nj(a, b) {
    var c = W;
    W &= -2;
    W |= ej;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Id(c));
    if (null !== X) for(c = X.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Df();
                break;
            case 3:
                eh();
                H(K);
                H(J);
                break;
            case 5:
                gh(d);
                break;
            case 4:
                eh();
                break;
            case 13:
                H(M);
                break;
            case 19:
                H(M);
                break;
            case 10:
                og(d);
        }
        c = c.return;
    }
    T = a;
    X = Sg(a.current, null);
    U = b;
    S = ti;
    kj = null;
    mj = lj = 1073741823;
    nj = null;
    wi = 0;
    oj = !1;
}
function Hj(a, b) {
    do {
        try {
            ng();
            jh.current = sh;
            if (mh) for(var c = N.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            lh = 0;
            P = O = N = null;
            mh = !1;
            if (null === X || null === X.return) return S = hj, kj = b, X = null;
            a: {
                var e = a, f = X.return, g = X, h = b;
                b = U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== (M.current & 1), p = f;
                    do {
                        var x;
                        if (x = 13 === p.tag) {
                            var z = p.memoizedState;
                            if (null !== z) x = null !== z.dehydrated ? !0 : !1;
                            else {
                                var ca = p.memoizedProps;
                                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var D = p.updateQueue;
                            if (null === D) {
                                var t = new Set;
                                t.add(k);
                                p.updateQueue = t;
                            } else D.add(k);
                            if (0 === (p.mode & 2)) {
                                p.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var y = wg(1073741823, null);
                                        y.tag = 2;
                                        xg(g, y);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var A = e.pingCache;
                            null === A ? (A = e.pingCache = new Wi, h = new Set, A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set, A.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var q = Oj.bind(null, e, k, g);
                                k.then(q, q);
                            }
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
                }
                S !== jj && (S = ij);
                h = Ai(h, g);
                p = f;
                do {
                    switch(p.tag){
                        case 3:
                            k = h;
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            var B = Xi(p, k, b);
                            yg(p, B);
                            break a;
                        case 1:
                            k = h;
                            var w = p.type, ub = p.stateNode;
                            if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === aj || !aj.has(ub)))) {
                                p.effectTag |= 4096;
                                p.expirationTime = b;
                                var vb = $i(p, k, b);
                                yg(p, vb);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            X = Pj(X);
        } catch (Xc) {
            b = Xc;
            continue;
        }
        break;
    }while (1);
}
function Fj() {
    var a = cj.current;
    cj.current = sh;
    return null === a ? sh : a;
}
function Ag(a, b) {
    a < lj && 2 < a && (lj = a);
    null !== b && a < mj && 2 < a && (mj = a, nj = b);
}
function Bg(a) {
    a > wi && (wi = a);
}
function Kj() {
    for(; null !== X;)X = Qj(X);
}
function Gj() {
    for(; null !== X && !Uf();)X = Qj(X);
}
function Qj(a) {
    var b = Rj(a.alternate, a, U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = Pj(a));
    dj.current = null;
    return b;
}
function Pj(a) {
    X = a;
    do {
        var b = X.alternate;
        a = X.return;
        if (0 === (X.effectTag & 2048)) {
            b = si(b, X, U);
            if (1 === U || 1 !== X.childExpirationTime) {
                for(var c = 0, d = X.child; null !== d;){
                    var e = d.expirationTime, f = d.childExpirationTime;
                    e > c && (c = e);
                    f > c && (c = f);
                    d = d.sibling;
                }
                X.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X.firstEffect), null !== X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
        } else {
            b = zi(X);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = X.sibling;
        if (null !== b) return b;
        X = a;
    }while (null !== X);
    S === ti && (S = jj);
    return null;
}
function Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function Jj(a) {
    var b = ag();
    cg(99, Sj.bind(null, a, b));
    return null;
}
function Sj(a, b) {
    do Dj();
    while (null !== rj);
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error(u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === T && (X = T = null, U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = W;
        W |= gj;
        dj.current = null;
        Dd = fd;
        var g = xd();
        if (yd(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (wb) {
                        h = null;
                        break a;
                    }
                    var p = 0, x = -1, z = -1, ca = 0, D = 0, t = g, y = null;
                    b: for(;;){
                        for(var A;;){
                            t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                            t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                            3 === t.nodeType && (p += t.nodeValue.length);
                            if (null === (A = t.firstChild)) break;
                            y = t;
                            t = A;
                        }
                        for(;;){
                            if (t === g) break b;
                            y === h && ++ca === l && (x = p);
                            y === m && ++D === k && (z = p);
                            if (null !== (A = t.nextSibling)) break;
                            t = y;
                            y = t.parentNode;
                        }
                        t = A;
                    }
                    h = -1 === x || -1 === z ? null : {
                        start: x,
                        end: z
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        Ed = {
            activeElementDetached: null,
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Y = e;
        do try {
            Tj();
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = e;
        do try {
            for(g = a, h = b; null !== Y;){
                var q = Y.effectTag;
                q & 16 && Rb(Y.stateNode, "");
                if (q & 128) {
                    var B = Y.alternate;
                    if (null !== B) {
                        var w = B.ref;
                        null !== w && ("function" === typeof w ? w(null) : w.current = null);
                    }
                }
                switch(q & 1038){
                    case 2:
                        Pi(Y);
                        Y.effectTag &= -3;
                        break;
                    case 6:
                        Pi(Y);
                        Y.effectTag &= -3;
                        Si(Y.alternate, Y);
                        break;
                    case 1024:
                        Y.effectTag &= -1025;
                        break;
                    case 1028:
                        Y.effectTag &= -1025;
                        Si(Y.alternate, Y);
                        break;
                    case 4:
                        Si(Y.alternate, Y);
                        break;
                    case 8:
                        l = Y, Mi(g, l, h), Ni(l);
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        w = Ed;
        B = xd();
        q = w.focusedElem;
        h = w.selectionRange;
        if (B !== q && q && q.ownerDocument && wd(q.ownerDocument.documentElement, q)) {
            null !== h && yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = vd(q, g), m = vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for(w = q; w = w.parentNode;)1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
            });
            "function" === typeof q.focus && q.focus();
            for(q = 0; q < B.length; q++)w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
        fd = !!Dd;
        Ed = Dd = null;
        a.current = c;
        Y = e;
        do try {
            for(q = a; null !== Y;){
                var ub = Y.effectTag;
                ub & 36 && Ji(q, Y.alternate, Y);
                if (ub & 128) {
                    B = void 0;
                    var vb = Y.ref;
                    if (null !== vb) {
                        var Xc = Y.stateNode;
                        switch(Y.tag){
                            case 5:
                                B = Xc;
                                break;
                            default:
                                B = Xc;
                        }
                        "function" === typeof vb ? vb(B) : vb.current = B;
                    }
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = null;
        Vf();
        W = f;
    } else a.current = c;
    if (qj) qj = !1, rj = a, sj = b;
    else for(Y = e; null !== Y;)b = Y.nextEffect, Y.nextEffect = null, Y = b;
    b = a.firstPendingTime;
    0 === b && (aj = null);
    1073741823 === b ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0;
    "function" === typeof Uj && Uj(c.stateNode, d);
    Z(a);
    if (Yi) throw Yi = !1, a = Zi, Zi = null, a;
    if ((W & ej) !== V) return null;
    gg();
    return null;
}
function Tj() {
    for(; null !== Y;){
        var a = Y.effectTag;
        0 !== (a & 256) && Gi(Y.alternate, Y);
        0 === (a & 512) || qj || (qj = !0, dg(97, function() {
            Dj();
            return null;
        }));
        Y = Y.nextEffect;
    }
}
function Dj() {
    if (90 !== sj) {
        var a = 97 < sj ? 97 : sj;
        sj = 90;
        return cg(a, Vj);
    }
}
function Vj() {
    if (null === rj) return !1;
    var a = rj;
    rj = null;
    if ((W & (fj | gj)) !== V) throw Error(u(331));
    var b = W;
    W |= gj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    Hi(5, c), Ii(5, c);
            }
        } catch (d) {
            if (null === a) throw Error(u(330));
            Ei(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    W = b;
    gg();
    return !0;
}
function Wj(a, b, c) {
    b = Ai(c, b);
    b = Xi(a, b, 1073741823);
    xg(a, b);
    a = xj(a, 1073741823);
    null !== a && Z(a);
}
function Ei(a, b) {
    if (3 === a.tag) Wj(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            Wj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === aj || !aj.has(d))) {
                a = Ai(b, a);
                a = $i(c, a, 1073741823);
                xg(c, a);
                c = xj(c, 1073741823);
                null !== c && Z(c);
                break;
            }
        }
        c = c.return;
    }
}
function Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    T === a && U === c ? S === vi || S === ui && 1073741823 === lj && $f() - Ti < pj ? Ej(a, U) : oj = !0 : Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z(a)));
}
function Vi(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = Gg(), b = Hg(b, a, null));
    a = xj(a, b);
    null !== a && Z(a);
}
var Rj;
Rj = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || K.current) rg = !0;
        else {
            if (d < c) {
                rg = !1;
                switch(b.tag){
                    case 3:
                        hi(b);
                        Xh();
                        break;
                    case 5:
                        fh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        L(b.type) && Gf(b);
                        break;
                    case 4:
                        dh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        I(jg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return ji(a, b, c);
                            I(M, M.current & 1);
                            b = $h(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        I(M, M.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return mi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        I(M, M.current);
                        if (!d) return null;
                }
                return $h(a, b, c);
            }
            rg = !1;
        }
    } else rg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = Cf(b, J.current);
            qg(b, c);
            e = oh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (L(d)) {
                    var f = !0;
                    Gf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                ug(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Fg(b, d, g, a);
                e.updater = Jg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                Ng(b, d, a, c);
                b = gi(null, b, d, !0, f, c);
            } else b.tag = 0, R(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = Xj(e);
                a = ig(e, a);
                switch(f){
                    case 0:
                        b = di(null, b, e, a, c);
                        break a;
                    case 1:
                        b = fi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = Zh(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ai(null, b, e, ig(e.type, a), d, c);
                        break a;
                }
                throw Error(u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), di(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), fi(a, b, d, e, c);
        case 3:
            hi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            vg(a, b);
            zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) Xh(), b = $h(a, b, c);
            else {
                if (e = b.stateNode.hydrate) Ph = Jd(b.stateNode.containerInfo.firstChild), Oh = b, e = Qh = !0;
                if (e) for(c = Yg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else R(a, b, d, c), Xh();
                b = b.child;
            }
            return b;
        case 5:
            return fh(b), null === a && Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Gd(d, e) ? g = null : null !== f && Gd(d, f) && (b.effectTag |= 16), ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && Uh(b), null;
        case 13:
            return ji(a, b, c);
        case 4:
            return dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Xg(b, null, d, c) : R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), Zh(a, b, d, e, c);
        case 7:
            return R(a, b, b.pendingProps, c), b.child;
        case 8:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(jg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !K.current) {
                            b = $h(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = wg(c, null), l.tag = 2, xg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    pg(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, qg(b, c), e = sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = ig(e, b.pendingProps), f = ig(e.type, f), ai(a, b, e, f, d, c);
        case 15:
            return ci(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = !0, Gf(b)) : a = !1, qg(b, c), Lg(b, d, e), Ng(b, d, e, c), gi(null, b, d, !0, a, c);
        case 19:
            return mi(a, b, c);
    }
    throw Error(u(156, b.tag));
};
var Uj = null, Li = null;
function Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        Uj = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        Li = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function Sh(a, b, c, d) {
    return new Zj(a, b, c, d);
}
function bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Xj(a) {
    if ("function" === typeof a) return bi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === gb) return 11;
        if (a === jb) return 14;
    }
    return 2;
}
function Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ab:
            return Wg(c.children, e, f, b);
        case fb:
            g = 8;
            e |= 7;
            break;
        case bb:
            g = 8;
            e |= 1;
            break;
        case cb:
            return a = Sh(12, c, b, e | 8), a.elementType = cb, a.type = cb, a.expirationTime = f, a;
        case hb:
            return a = Sh(13, c, b, e), a.type = hb, a.elementType = hb, a.expirationTime = f, a;
        case ib:
            return a = Sh(19, c, b, e), a.elementType = ib, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case db:
                    g = 10;
                    break a;
                case eb:
                    g = 9;
                    break a;
                case gb:
                    g = 11;
                    break a;
                case jb:
                    g = 14;
                    break a;
                case kb:
                    g = 16;
                    d = null;
                    break a;
                case lb:
                    g = 22;
                    break a;
            }
            throw Error(u(130, null == a ? a : typeof a, ""));
    }
    b = Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function Wg(a, b, c, d) {
    a = Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function Tg(a, b, c) {
    a = Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function Vg(a, b, c) {
    b = Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function xi(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function bk(a, b, c, d) {
    var e = b.current, f = Gg(), g = Dg.suspense;
    f = Hg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if (dc(c) !== c || 1 !== c.tag) throw Error(u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (L(k)) {
                c = Ff(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Af;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = wg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    xg(e, b);
    Ig(e, f);
    return f;
}
function ck(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function ek(a, b) {
    dk(a, b);
    (a = a.alternate) && dk(a, b);
}
function fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new ak(a, b, c), e = Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    ug(e);
    a[Od] = d.current;
    c && 0 !== b && Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
fk.prototype.render = function(a) {
    bk(a, this._internalRoot, null, null);
};
fk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    bk(null, a, null, function() {
        b[Od] = null;
    });
};
function gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new fk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function ik(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = ck(g);
                h.call(a);
            };
        }
        bk(b, g, a, e);
    } else {
        f = c._reactRootContainer = hk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = ck(g);
                k.call(a);
            };
        }
        Nj(function() {
            bk(b, g, a, e);
        });
    }
    return ck(g);
}
function jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
wc = function(a) {
    if (13 === a.tag) {
        var b = hg(Gg(), 150, 100);
        Ig(a, b);
        ek(a, b);
    }
};
xc = function(a) {
    13 === a.tag && (Ig(a, 3), ek(a, 3));
};
yc = function(a) {
    if (13 === a.tag) {
        var b = Gg();
        b = Hg(b, a, null);
        Ig(a, b);
        ek(a, b);
    }
};
za = function(a, b, c) {
    switch(b){
        case "input":
            Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Qd(d);
                        if (!e) throw Error(u(90));
                        yb(d);
                        Cb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            Kb(a, c);
            break;
        case "select":
            b = c.value, null != b && Hb(a, !!c.multiple, b, !1);
    }
};
Fa = Mj;
Ga = function(a, b, c, d, e) {
    var f = W;
    W |= 4;
    try {
        return cg(98, a.bind(null, b, c, d, e));
    } finally{
        W = f, W === V && gg();
    }
};
Ha = function() {
    (W & (1 | fj | gj)) === V && (Lj(), Dj());
};
Ia = function(a, b) {
    var c = W;
    W |= 2;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
};
function kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!gk(b)) throw Error(u(200));
    return jk(a, b, null, c);
}
var lk = {
    Events: [
        Nc,
        Pd,
        Qd,
        xa,
        ta,
        Xd,
        function(a) {
            jc(a, Wd);
        },
        Da,
        Ea,
        id,
        mc,
        Dj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return Yj($8coUR({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = hc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: tc,
    bundleType: 0,
    version: "16.14.0",
    rendererPackageName: "react-dom"
});
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lk;
exports.createPortal = kk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(u(188));
        throw Error(u(268, Object.keys(a)));
    }
    a = hc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    if ((W & (fj | gj)) !== V) throw Error(u(187));
    var c = W;
    W |= 1;
    try {
        return cg(99, a.bind(null, b));
    } finally{
        W = c, gg();
    }
};
exports.hydrate = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!gk(a)) throw Error(u(40));
    return a._reactRootContainer ? (Nj(function() {
        ik(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[Od] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Mj;
exports.unstable_createPortal = function(a, b) {
    return kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!gk(c)) throw Error(u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error(u(38));
    return ik(a, b, c, !1, d);
};
exports.version = "16.14.0";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
var $bcb017604639e9d7$var$f, $bcb017604639e9d7$var$g, $bcb017604639e9d7$var$h, $bcb017604639e9d7$var$k, $bcb017604639e9d7$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$p = null, $bcb017604639e9d7$var$q = null, $bcb017604639e9d7$var$t = function() {
        if (null !== $bcb017604639e9d7$var$p) try {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$p(!0, a);
            $bcb017604639e9d7$var$p = null;
        } catch (b) {
            throw setTimeout($bcb017604639e9d7$var$t, 0), b;
        }
    }, $bcb017604639e9d7$var$u = Date.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return Date.now() - $bcb017604639e9d7$var$u;
    };
    $bcb017604639e9d7$var$f = function(a) {
        null !== $bcb017604639e9d7$var$p ? setTimeout($bcb017604639e9d7$var$f, 0, a) : ($bcb017604639e9d7$var$p = a, setTimeout($bcb017604639e9d7$var$t, 0));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$q = setTimeout(a, b);
    };
    $bcb017604639e9d7$var$h = function() {
        clearTimeout($bcb017604639e9d7$var$q);
    };
    $bcb017604639e9d7$var$k = function() {
        return !1;
    };
    $bcb017604639e9d7$var$l = $bcb017604639e9d7$export$d66a1c1c77bd778b = function() {};
} else {
    var $bcb017604639e9d7$var$w = window.performance, $bcb017604639e9d7$var$x = window.Date, $bcb017604639e9d7$var$y = window.setTimeout, $bcb017604639e9d7$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $bcb017604639e9d7$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $bcb017604639e9d7$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof $bcb017604639e9d7$var$w && "function" === typeof $bcb017604639e9d7$var$w.now) $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$w.now();
    };
    else {
        var $bcb017604639e9d7$var$B = $bcb017604639e9d7$var$x.now();
        $bcb017604639e9d7$export$c4744153514ff05d = function() {
            return $bcb017604639e9d7$var$x.now() - $bcb017604639e9d7$var$B;
        };
    }
    var $bcb017604639e9d7$var$C = !1, $bcb017604639e9d7$var$D = null, $bcb017604639e9d7$var$E = -1, $bcb017604639e9d7$var$F = 5, $bcb017604639e9d7$var$G = 0;
    $bcb017604639e9d7$var$k = function() {
        return $bcb017604639e9d7$export$c4744153514ff05d() >= $bcb017604639e9d7$var$G;
    };
    $bcb017604639e9d7$var$l = function() {};
    $bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $bcb017604639e9d7$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $bcb017604639e9d7$var$H = new MessageChannel, $bcb017604639e9d7$var$I = $bcb017604639e9d7$var$H.port2;
    $bcb017604639e9d7$var$H.port1.onmessage = function() {
        if (null !== $bcb017604639e9d7$var$D) {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$G = a + $bcb017604639e9d7$var$F;
            try {
                $bcb017604639e9d7$var$D(!0, a) ? $bcb017604639e9d7$var$I.postMessage(null) : ($bcb017604639e9d7$var$C = !1, $bcb017604639e9d7$var$D = null);
            } catch (b) {
                throw $bcb017604639e9d7$var$I.postMessage(null), b;
            }
        } else $bcb017604639e9d7$var$C = !1;
    };
    $bcb017604639e9d7$var$f = function(a) {
        $bcb017604639e9d7$var$D = a;
        $bcb017604639e9d7$var$C || ($bcb017604639e9d7$var$C = !0, $bcb017604639e9d7$var$I.postMessage(null));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$E = $bcb017604639e9d7$var$y(function() {
            a($bcb017604639e9d7$export$c4744153514ff05d());
        }, b);
    };
    $bcb017604639e9d7$var$h = function() {
        $bcb017604639e9d7$var$z($bcb017604639e9d7$var$E);
        $bcb017604639e9d7$var$E = -1;
    };
}
function $bcb017604639e9d7$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $bcb017604639e9d7$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $bcb017604639e9d7$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $bcb017604639e9d7$var$K(n, c)) void 0 !== r && 0 > $bcb017604639e9d7$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $bcb017604639e9d7$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $bcb017604639e9d7$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $bcb017604639e9d7$var$N = [], $bcb017604639e9d7$var$O = [], $bcb017604639e9d7$var$P = 1, $bcb017604639e9d7$var$Q = null, $bcb017604639e9d7$var$R = 3, $bcb017604639e9d7$var$S = !1, $bcb017604639e9d7$var$T = !1, $bcb017604639e9d7$var$U = !1;
function $bcb017604639e9d7$var$V(a) {
    for(var b = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$M($bcb017604639e9d7$var$O);
        else if (b.startTime <= a) $bcb017604639e9d7$var$M($bcb017604639e9d7$var$O), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$J($bcb017604639e9d7$var$N, b);
        else break;
        b = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O);
    }
}
function $bcb017604639e9d7$var$W(a) {
    $bcb017604639e9d7$var$U = !1;
    $bcb017604639e9d7$var$V(a);
    if (!$bcb017604639e9d7$var$T) {
        if (null !== $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N)) $bcb017604639e9d7$var$T = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$X);
        else {
            var b = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O);
            null !== b && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$W, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$X(a, b) {
    $bcb017604639e9d7$var$T = !1;
    $bcb017604639e9d7$var$U && ($bcb017604639e9d7$var$U = !1, $bcb017604639e9d7$var$h());
    $bcb017604639e9d7$var$S = !0;
    var c = $bcb017604639e9d7$var$R;
    try {
        $bcb017604639e9d7$var$V(b);
        for($bcb017604639e9d7$var$Q = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N); null !== $bcb017604639e9d7$var$Q && (!($bcb017604639e9d7$var$Q.expirationTime > b) || a && !$bcb017604639e9d7$var$k());){
            var d = $bcb017604639e9d7$var$Q.callback;
            if (null !== d) {
                $bcb017604639e9d7$var$Q.callback = null;
                $bcb017604639e9d7$var$R = $bcb017604639e9d7$var$Q.priorityLevel;
                var e = d($bcb017604639e9d7$var$Q.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$Q.callback = e : $bcb017604639e9d7$var$Q === $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N) && $bcb017604639e9d7$var$M($bcb017604639e9d7$var$N);
                $bcb017604639e9d7$var$V(b);
            } else $bcb017604639e9d7$var$M($bcb017604639e9d7$var$N);
            $bcb017604639e9d7$var$Q = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N);
        }
        if (null !== $bcb017604639e9d7$var$Q) var m = !0;
        else {
            var n = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O);
            null !== n && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $bcb017604639e9d7$var$Q = null, $bcb017604639e9d7$var$R = c, $bcb017604639e9d7$var$S = !1;
    }
}
function $bcb017604639e9d7$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $bcb017604639e9d7$var$Z = $bcb017604639e9d7$var$l;
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$T || $bcb017604639e9d7$var$S || ($bcb017604639e9d7$var$T = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$X));
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$R;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$R;
    }
    var c = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$R = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$R = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = $bcb017604639e9d7$var$Z;
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$R = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$R = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $bcb017604639e9d7$var$Y(a);
    } else c = $bcb017604639e9d7$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $bcb017604639e9d7$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $bcb017604639e9d7$var$J($bcb017604639e9d7$var$O, a), null === $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N) && a === $bcb017604639e9d7$var$L($bcb017604639e9d7$var$O) && ($bcb017604639e9d7$var$U ? $bcb017604639e9d7$var$h() : $bcb017604639e9d7$var$U = !0, $bcb017604639e9d7$var$g($bcb017604639e9d7$var$W, e - d))) : (a.sortIndex = c, $bcb017604639e9d7$var$J($bcb017604639e9d7$var$N, a), $bcb017604639e9d7$var$T || $bcb017604639e9d7$var$S || ($bcb017604639e9d7$var$T = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$X)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = function() {
    var a = $bcb017604639e9d7$export$c4744153514ff05d();
    $bcb017604639e9d7$var$V(a);
    var b = $bcb017604639e9d7$var$L($bcb017604639e9d7$var$N);
    return b !== $bcb017604639e9d7$var$Q && null !== $bcb017604639e9d7$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $bcb017604639e9d7$var$Q.expirationTime || $bcb017604639e9d7$var$k();
};
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$R;
    return function() {
        var c = $bcb017604639e9d7$var$R;
        $bcb017604639e9d7$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$R = c;
        }
    };
};

});




parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
"use strict";
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});

parcelRegister("kfZjc", function(module, exports) {

$parcel$export(module.exports, "__RouterContext", () => $ebf4c3fe5600f7ed$export$63baa8ccbe60bb07);
$parcel$export(module.exports, "Router", () => $ebf4c3fe5600f7ed$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Redirect", () => $ebf4c3fe5600f7ed$export$2d8d895a0a0f636e);
$parcel$export(module.exports, "matchPath", () => $ebf4c3fe5600f7ed$export$81336c211d5ff295);
$parcel$export(module.exports, "Route", () => $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Switch", () => $ebf4c3fe5600f7ed$export$b5d5cf8927ab7262);
$parcel$export(module.exports, "useHistory", () => $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c);
$parcel$export(module.exports, "useLocation", () => $ebf4c3fe5600f7ed$export$45d76561a5302f2b);
$parcel$export(module.exports, "useParams", () => $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "useRouteMatch", () => $ebf4c3fe5600f7ed$export$632be4bb944c1bc7);

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $3np4r = parcelRequire("3np4r");


var $bv4qN = parcelRequire("bv4qN");

var $8nd05 = parcelRequire("8nd05");

var $8ugx5 = parcelRequire("8ugx5");
parcelRequire("4jPKB");

var $1En50 = parcelRequire("1En50");

var $9ORqK = parcelRequire("9ORqK");
var $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $ebf4c3fe5600f7ed$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $ebf4c3fe5600f7ed$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $ebf4c3fe5600f7ed$var$commonjsGlobal[key] = ($ebf4c3fe5600f7ed$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $ebf4c3fe5600f7ed$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $ebf4c3fe5600f7ed$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $ebf4c3fe5600f7ed$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $ebf4c3fe5600f7ed$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $ebf4c3fe5600f7ed$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $g7ajw.default)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $ebf4c3fe5600f7ed$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($ebf4c3fe5600f7ed$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $g7ajw.default)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $ebf4c3fe5600f7ed$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $ebf4c3fe5600f7ed$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext || $ebf4c3fe5600f7ed$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $ebf4c3fe5600f7ed$var$createNamedContext = function createNamedContext(name) {
    var context = $ebf4c3fe5600f7ed$var$createContext();
    context.displayName = name;
    return context;
};
var $ebf4c3fe5600f7ed$export$c213558b66925821 = /*#__PURE__*/ $ebf4c3fe5600f7ed$var$createNamedContext("Router-History");
var $ebf4c3fe5600f7ed$export$63baa8ccbe60bb07 = /*#__PURE__*/ $ebf4c3fe5600f7ed$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $ebf4c3fe5600f7ed$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $ebf4c3fe5600f7ed$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $3np4r.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $ebf4c3fe5600f7ed$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $ebf4c3fe5600f7ed$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $ebf4c3fe5600f7ed$var$messageType;
var $ebf4c3fe5600f7ed$var$cache = {};
var $ebf4c3fe5600f7ed$var$cacheLimit = 10000;
var $ebf4c3fe5600f7ed$var$cacheCount = 0;
function $ebf4c3fe5600f7ed$var$compilePath(path) {
    if ($ebf4c3fe5600f7ed$var$cache[path]) return $ebf4c3fe5600f7ed$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($8ugx5))).compile(path);
    if ($ebf4c3fe5600f7ed$var$cacheCount < $ebf4c3fe5600f7ed$var$cacheLimit) {
        $ebf4c3fe5600f7ed$var$cache[path] = generator;
        $ebf4c3fe5600f7ed$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $ebf4c3fe5600f7ed$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $ebf4c3fe5600f7ed$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $ebf4c3fe5600f7ed$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $3np4r.createLocation)(computedMatch ? typeof to === "string" ? $ebf4c3fe5600f7ed$export$82476f982757e71e(to, computedMatch.params) : (0, $8nd05.default)({}, to, {
            pathname: $ebf4c3fe5600f7ed$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $3np4r.createLocation)(prevProps.to);
                if (!(0, $3np4r.locationsAreEqual)(prevLocation, (0, $8nd05.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $ebf4c3fe5600f7ed$var$cache$1 = {};
var $ebf4c3fe5600f7ed$var$cacheLimit$1 = 10000;
var $ebf4c3fe5600f7ed$var$cacheCount$1 = 0;
function $ebf4c3fe5600f7ed$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $ebf4c3fe5600f7ed$var$cache$1[cacheKey] || ($ebf4c3fe5600f7ed$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($8ugx5)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($ebf4c3fe5600f7ed$var$cacheCount$1 < $ebf4c3fe5600f7ed$var$cacheLimit$1) {
        pathCache[path] = result;
        $ebf4c3fe5600f7ed$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $ebf4c3fe5600f7ed$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $ebf4c3fe5600f7ed$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $ebf4c3fe5600f7ed$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(children) === 0;
}
function $ebf4c3fe5600f7ed$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $bv4qN.default)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $8nd05.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $ebf4c3fe5600f7ed$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
function $ebf4c3fe5600f7ed$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $ebf4c3fe5600f7ed$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $8nd05.default)({}, location, {
        pathname: $ebf4c3fe5600f7ed$var$addLeadingSlash(basename) + location.pathname
    });
}
function $ebf4c3fe5600f7ed$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $ebf4c3fe5600f7ed$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $8nd05.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $ebf4c3fe5600f7ed$var$createURL(location) {
    return typeof location === "string" ? location : (0, $3np4r.createPath)(location);
}
function $ebf4c3fe5600f7ed$var$staticHandler(methodName) {
    return function() {
        (0, $bv4qN.default)(false);
    };
}
function $ebf4c3fe5600f7ed$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $ebf4c3fe5600f7ed$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $ebf4c3fe5600f7ed$var$noop;
        };
        _this.handleBlock = function() {
            return $ebf4c3fe5600f7ed$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $ebf4c3fe5600f7ed$var$addBasename(basename, (0, $3np4r.createLocation)(location));
        context.url = $ebf4c3fe5600f7ed$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $1En50.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $ebf4c3fe5600f7ed$var$addLeadingSlash(basename + $ebf4c3fe5600f7ed$var$createURL(path));
            },
            action: "POP",
            location: $ebf4c3fe5600f7ed$var$stripBasename(basename, (0, $3np4r.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $ebf4c3fe5600f7ed$var$staticHandler("go"),
            goBack: $ebf4c3fe5600f7ed$var$staticHandler("goBack"),
            goForward: $ebf4c3fe5600f7ed$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$55185c17a0fcbe46, (0, $8nd05.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $ebf4c3fe5600f7ed$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $bv4qN.default)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, (0, $8nd05.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $ebf4c3fe5600f7ed$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $1En50.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $bv4qN.default)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $8nd05.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(C, Component);
}
var $ebf4c3fe5600f7ed$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext;
function $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c() {
    return $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$c213558b66925821);
}
function $ebf4c3fe5600f7ed$export$45d76561a5302f2b() {
    return $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).location;
}
function $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef() {
    var match = $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $ebf4c3fe5600f7ed$export$632be4bb944c1bc7(path) {
    var location = $ebf4c3fe5600f7ed$export$45d76561a5302f2b();
    var match = $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).match;
    return path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, path) : match;
}
var $ebf4c3fe5600f7ed$var$global$1, $ebf4c3fe5600f7ed$var$key, $ebf4c3fe5600f7ed$var$buildNames, $ebf4c3fe5600f7ed$var$initialBuildName, $ebf4c3fe5600f7ed$var$secondaryBuildName;

});
parcelRegister("g7ajw", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbb54ce93eb94a95$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $VFVve.default)(t, o);
}

});
parcelRegister("VFVve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad5d8b55fe970db$export$2e2bcd8739ae039);
function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});
parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4905a8b274aa381$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});



parcelRegister("3np4r", function(module, exports) {

$parcel$export(module.exports, "createPath", () => $2756f79476f0245f$export$fe53371bee54353d);
$parcel$export(module.exports, "createLocation", () => $2756f79476f0245f$export$90c043f1c57770b8);
$parcel$export(module.exports, "locationsAreEqual", () => $2756f79476f0245f$export$c3e8bb440bd55b18);
$parcel$export(module.exports, "createBrowserHistory", () => $2756f79476f0245f$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $2756f79476f0245f$export$b71fdd3798280242);
$parcel$export(module.exports, "createMemoryHistory", () => $2756f79476f0245f$export$2b76ad033c6e6d08);

var $8nd05 = parcelRequire("8nd05");

var $WYl7Q = parcelRequire("WYl7Q");

var $9t72y = parcelRequire("9t72y");


var $bv4qN = parcelRequire("bv4qN");
function $2756f79476f0245f$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $2756f79476f0245f$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $2756f79476f0245f$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $2756f79476f0245f$var$stripBasename(path, prefix) {
    return $2756f79476f0245f$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $2756f79476f0245f$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $2756f79476f0245f$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $2756f79476f0245f$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $2756f79476f0245f$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $2756f79476f0245f$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $8nd05.default)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $WYl7Q.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $2756f79476f0245f$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $9t72y.default)(a.state, b.state);
}
function $2756f79476f0245f$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $2756f79476f0245f$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $2756f79476f0245f$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $2756f79476f0245f$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $2756f79476f0245f$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $2756f79476f0245f$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $2756f79476f0245f$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $2756f79476f0245f$var$PopStateEvent = "popstate";
var $2756f79476f0245f$var$HashChangeEvent = "hashchange";
function $2756f79476f0245f$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $2756f79476f0245f$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$2756f79476f0245f$var$canUseDOM && (0, $bv4qN.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $2756f79476f0245f$var$supportsHistory();
    var needsHashChangeListener = !$2756f79476f0245f$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $2756f79476f0245f$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $2756f79476f0245f$var$stripTrailingSlash($2756f79476f0245f$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $2756f79476f0245f$var$stripBasename(path, basename);
        return $2756f79476f0245f$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $8nd05.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($2756f79476f0245f$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($2756f79476f0245f$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($2756f79476f0245f$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $2756f79476f0245f$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($2756f79476f0245f$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($2756f79476f0245f$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($2756f79476f0245f$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($2756f79476f0245f$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $2756f79476f0245f$var$HashChangeEvent$1 = "hashchange";
var $2756f79476f0245f$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $2756f79476f0245f$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $2756f79476f0245f$var$stripLeadingSlash,
        decodePath: $2756f79476f0245f$var$addLeadingSlash
    },
    slash: {
        encodePath: $2756f79476f0245f$var$addLeadingSlash,
        decodePath: $2756f79476f0245f$var$addLeadingSlash
    }
};
function $2756f79476f0245f$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $2756f79476f0245f$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $2756f79476f0245f$var$pushHashPath(path) {
    window.location.hash = path;
}
function $2756f79476f0245f$var$replaceHashPath(path) {
    window.location.replace($2756f79476f0245f$var$stripHash(window.location.href) + "#" + path);
}
function $2756f79476f0245f$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$2756f79476f0245f$var$canUseDOM && (0, $bv4qN.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $2756f79476f0245f$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $2756f79476f0245f$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $2756f79476f0245f$var$stripTrailingSlash($2756f79476f0245f$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $2756f79476f0245f$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($2756f79476f0245f$var$getHashPath());
        if (basename) path = $2756f79476f0245f$var$stripBasename(path, basename);
        return $2756f79476f0245f$export$90c043f1c57770b8(path);
    }
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $8nd05.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $2756f79476f0245f$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $2756f79476f0245f$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $2756f79476f0245f$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $2756f79476f0245f$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $2756f79476f0245f$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $2756f79476f0245f$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $2756f79476f0245f$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $2756f79476f0245f$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $2756f79476f0245f$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $2756f79476f0245f$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $2756f79476f0245f$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $2756f79476f0245f$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $2756f79476f0245f$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $2756f79476f0245f$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($2756f79476f0245f$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($2756f79476f0245f$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($2756f79476f0245f$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $2756f79476f0245f$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $2756f79476f0245f$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $8nd05.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $2756f79476f0245f$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $2756f79476f0245f$export$90c043f1c57770b8(entry, undefined, createKey()) : $2756f79476f0245f$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $2756f79476f0245f$export$fe53371bee54353d;
    function push(path, state) {
        var action = "PUSH";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $2756f79476f0245f$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

});
parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("WYl7Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b14391bdc5d7d11$export$2e2bcd8739ae039);
function $0b14391bdc5d7d11$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $0b14391bdc5d7d11$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $0b14391bdc5d7d11$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $0b14391bdc5d7d11$var$isAbsolute(to);
    var isFromAbs = from && $0b14391bdc5d7d11$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $0b14391bdc5d7d11$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$0b14391bdc5d7d11$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $0b14391bdc5d7d11$export$2e2bcd8739ae039 = $0b14391bdc5d7d11$var$resolvePathname;

});

parcelRegister("9t72y", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e4c488965e5c6e8$export$2e2bcd8739ae039);
function $6e4c488965e5c6e8$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $6e4c488965e5c6e8$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $6e4c488965e5c6e8$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $6e4c488965e5c6e8$var$valueOf(a);
        var bValue = $6e4c488965e5c6e8$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $6e4c488965e5c6e8$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $6e4c488965e5c6e8$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $6e4c488965e5c6e8$export$2e2bcd8739ae039 = $6e4c488965e5c6e8$var$valueEqual;

});

parcelRegister("bv4qN", function(module, exports) {

$parcel$export(module.exports, "default", () => $85f606e562c81b96$export$2e2bcd8739ae039);
var $85f606e562c81b96$var$isProduction = true;
var $85f606e562c81b96$var$prefix = "Invariant failed";
function $85f606e562c81b96$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($85f606e562c81b96$var$isProduction) throw new Error($85f606e562c81b96$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($85f606e562c81b96$var$prefix, ": ").concat(provided) : $85f606e562c81b96$var$prefix;
    throw new Error(value);
}

});


parcelRegister("8ugx5", function(module, exports) {

var $a0lxx = parcelRequire("a0lxx");
/**
 * Expose `pathToRegexp`.
 */ module.exports = $62ddf3174d9df941$var$pathToRegexp;
module.exports.parse = $62ddf3174d9df941$var$parse;
module.exports.compile = $62ddf3174d9df941$var$compile;
module.exports.tokensToFunction = $62ddf3174d9df941$var$tokensToFunction;
module.exports.tokensToRegExp = $62ddf3174d9df941$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $62ddf3174d9df941$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $62ddf3174d9df941$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $62ddf3174d9df941$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $62ddf3174d9df941$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $62ddf3174d9df941$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $62ddf3174d9df941$var$compile(str, options) {
    return $62ddf3174d9df941$var$tokensToFunction($62ddf3174d9df941$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $62ddf3174d9df941$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $62ddf3174d9df941$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $62ddf3174d9df941$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $62ddf3174d9df941$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $62ddf3174d9df941$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($a0lxx(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $62ddf3174d9df941$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $62ddf3174d9df941$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $62ddf3174d9df941$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $62ddf3174d9df941$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $62ddf3174d9df941$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($62ddf3174d9df941$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $62ddf3174d9df941$var$flags(options));
    return $62ddf3174d9df941$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$stringToRegexp(path, keys, options) {
    return $62ddf3174d9df941$var$tokensToRegExp($62ddf3174d9df941$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$tokensToRegExp(tokens, keys, options) {
    if (!$a0lxx(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $62ddf3174d9df941$var$escapeString(token);
        else {
            var prefix = $62ddf3174d9df941$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $62ddf3174d9df941$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $62ddf3174d9df941$var$attachKeys(new RegExp("^" + route, $62ddf3174d9df941$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$pathToRegexp(path, keys, options) {
    if (!$a0lxx(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $62ddf3174d9df941$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($a0lxx(path)) return $62ddf3174d9df941$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $62ddf3174d9df941$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});
parcelRegister("a0lxx", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};

});


parcelRegister("4jPKB", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9cCWX"));

});

parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("9ORqK", function(module, exports) {
"use strict";

var $4jPKB = parcelRequire("4jPKB");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($4jPKB.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});


parcelRegister("4fGPb", function(module, exports) {

$parcel$export(module.exports, "Link", () => $3189c83282a9a1c6$export$a6c7ac8248d6e38a);
$parcel$export(module.exports, "Router", () => (parcelRequire("kfZjc")).Router);

var $kfZjc = parcelRequire("kfZjc");

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $3np4r = parcelRequire("3np4r");



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $bv4qN = parcelRequire("bv4qN");
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $3189c83282a9a1c6$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $3np4r.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $3189c83282a9a1c6$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $3np4r.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $3189c83282a9a1c6$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $3189c83282a9a1c6$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $3np4r.createLocation)(to, null, null, currentLocation) : to;
};
var $3189c83282a9a1c6$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $3189c83282a9a1c6$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef;
if (typeof $3189c83282a9a1c6$var$forwardRef === "undefined") $3189c83282a9a1c6$var$forwardRef = $3189c83282a9a1c6$var$forwardRefShim;
function $3189c83282a9a1c6$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $3189c83282a9a1c6$var$LinkAnchor = $3189c83282a9a1c6$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $1En50.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $8nd05.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$3189c83282a9a1c6$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($3189c83282a9a1c6$var$forwardRefShim !== $3189c83282a9a1c6$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $3189c83282a9a1c6$export$a6c7ac8248d6e38a = $3189c83282a9a1c6$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $3189c83282a9a1c6$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $1En50.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.__RouterContext).Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false);
        var history = context.history;
        var location = $3189c83282a9a1c6$var$normalizeToLocation($3189c83282a9a1c6$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $8nd05.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $3189c83282a9a1c6$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $3np4r.createPath)(context.location) === (0, $3np4r.createPath)($3189c83282a9a1c6$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($3189c83282a9a1c6$var$forwardRefShim !== $3189c83282a9a1c6$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, props);
    });
});
var $3189c83282a9a1c6$var$toType, $3189c83282a9a1c6$var$refType;
var $3189c83282a9a1c6$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $3189c83282a9a1c6$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef;
if (typeof $3189c83282a9a1c6$var$forwardRef$1 === "undefined") $3189c83282a9a1c6$var$forwardRef$1 = $3189c83282a9a1c6$var$forwardRefShim$1;
function $3189c83282a9a1c6$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $3189c83282a9a1c6$export$b0d92dbee9b5b60d = $3189c83282a9a1c6$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $1En50.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.__RouterContext).Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $3189c83282a9a1c6$var$normalizeToLocation($3189c83282a9a1c6$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $kfZjc.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $3189c83282a9a1c6$var$joinClassnames(className, activeClassName);
            style = (0, $8nd05.default)({}, style, activeStyle);
        }
        var props = (0, $8nd05.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($3189c83282a9a1c6$var$forwardRefShim$1 !== $3189c83282a9a1c6$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3189c83282a9a1c6$export$a6c7ac8248d6e38a, props);
    });
});
var $3189c83282a9a1c6$var$ariaCurrentType;

});

parcelRegister("jHTLJ", function(module, exports) {
$parcel$export(module.exports, "Provider", () => (parcelRequire("4hUQH")).default);
$parcel$export(module.exports, "shallowEqual", () => (parcelRequire("8PZ7r")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("2OPjR")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("iD0SF")).useSelector);
parcelRequire("gCPmi");
parcelRequire("7c7i6");
var $1u0KT = parcelRequire("1u0KT");

var $lnBci = parcelRequire("lnBci");
// with standard React renderers (ReactDOM, React Native)
(0, $lnBci.setBatch)((0, $1u0KT.unstable_batchedUpdates));

});
parcelRegister("gCPmi", function(module, exports) {

$parcel$export(module.exports, "Provider", () => (parcelRequire("4hUQH")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("2OPjR")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("iD0SF")).useSelector);
$parcel$export(module.exports, "shallowEqual", () => (parcelRequire("8PZ7r")).default);

var $4hUQH = parcelRequire("4hUQH");

var $2g8Bt = parcelRequire("2g8Bt");

var $7iEsg = parcelRequire("7iEsg");

var $hrvfy = parcelRequire("hrvfy");

var $2OPjR = parcelRequire("2OPjR");

var $iD0SF = parcelRequire("iD0SF");

var $4TSkt = parcelRequire("4TSkt");

var $8PZ7r = parcelRequire("8PZ7r");

});
parcelRegister("4hUQH", function(module, exports) {

$parcel$export(module.exports, "default", () => $31f4d8f6ffbbb628$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $7iEsg = parcelRequire("7iEsg");

var $j4jJy = parcelRequire("j4jJy");

var $atMb1 = parcelRequire("atMb1");
function $31f4d8f6ffbbb628$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $acw62.useMemo)(function() {
        var subscription = (0, $j4jJy.createSubscription)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $acw62.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $atMb1.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $7iEsg.ReactReduxContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $31f4d8f6ffbbb628$export$2e2bcd8739ae039 = $31f4d8f6ffbbb628$var$Provider;

});
parcelRegister("7iEsg", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", () => $55099852ccad0564$export$cc80c08dc91f1c00);

var $acw62 = parcelRequire("acw62");
var $55099852ccad0564$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
var $55099852ccad0564$export$2e2bcd8739ae039 = $55099852ccad0564$export$cc80c08dc91f1c00;

});

parcelRegister("j4jJy", function(module, exports) {

$parcel$export(module.exports, "createSubscription", () => $de1db2bafb2c3b5a$export$d567d2b9af322f8f);

var $lnBci = parcelRequire("lnBci");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $de1db2bafb2c3b5a$var$createListenerCollection() {
    var batch = (0, $lnBci.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $de1db2bafb2c3b5a$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $de1db2bafb2c3b5a$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $de1db2bafb2c3b5a$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $de1db2bafb2c3b5a$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $de1db2bafb2c3b5a$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}

});
parcelRegister("lnBci", function(module, exports) {

$parcel$export(module.exports, "setBatch", () => $f9089991fdc24c9c$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $f9089991fdc24c9c$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $f9089991fdc24c9c$var$defaultNoopBatch(callback) {
    callback();
}
var $f9089991fdc24c9c$var$batch = $f9089991fdc24c9c$var$defaultNoopBatch; // Allow injecting another batching function later
var $f9089991fdc24c9c$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $f9089991fdc24c9c$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $f9089991fdc24c9c$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $f9089991fdc24c9c$var$batch;
};

});


parcelRegister("atMb1", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $7a11fbbe9e9ac5f8$export$700979bc83e7db82);

var $acw62 = parcelRequire("acw62");
var $7a11fbbe9e9ac5f8$export$700979bc83e7db82 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);

});


parcelRegister("2g8Bt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a53bfd8072ab080$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $9ORqK = parcelRequire("9ORqK");

var $acw62 = parcelRequire("acw62");

var $cfvvO = parcelRequire("cfvvO");

var $j4jJy = parcelRequire("j4jJy");

var $atMb1 = parcelRequire("atMb1");

var $7iEsg = parcelRequire("7iEsg");
var $1a53bfd8072ab080$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $1a53bfd8072ab080$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $1a53bfd8072ab080$var$EMPTY_ARRAY = [];
var $1a53bfd8072ab080$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $1a53bfd8072ab080$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $1a53bfd8072ab080$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $1a53bfd8072ab080$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $atMb1.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $1a53bfd8072ab080$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $1a53bfd8072ab080$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: "STORE_UPDATED",
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $1a53bfd8072ab080$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $1a53bfd8072ab080$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? "connectAdvanced" : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? "store" : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $7iEsg.ReactReduxContext) : _ref2$context, connectOptions = (0, $1En50.default)(_ref2, $1a53bfd8072ab080$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $8nd05.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $acw62.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $acw62.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $1En50.default)(props, $1a53bfd8072ab080$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $acw62.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $cfvvO.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $acw62.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $acw62.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $acw62.useMemo)(function() {
                if (!shouldHandleStateChanges) return $1a53bfd8072ab080$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $j4jJy.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $acw62.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $8nd05.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $acw62.useReducer)($1a53bfd8072ab080$var$storeStateUpdatesReducer, $1a53bfd8072ab080$var$EMPTY_ARRAY, $1a53bfd8072ab080$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $acw62.useRef)();
            var lastWrapperProps = (0, $acw62.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $acw62.useRef)();
            var renderIsScheduled = (0, $acw62.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $1a53bfd8072ab080$var$useIsomorphicLayoutEffectWithArgs($1a53bfd8072ab080$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $1a53bfd8072ab080$var$useIsomorphicLayoutEffectWithArgs($1a53bfd8072ab080$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $acw62.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, (0, $8nd05.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $acw62.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Connect, (0, $8nd05.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(Connect, WrappedComponent);
    };
}

});
parcelRegister("cfvvO", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cgj07"));

});
parcelRegister("cgj07", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $8ed5b7d8837dad8a$export$a7c73072b1a182ae, (v) => $8ed5b7d8837dad8a$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $8ed5b7d8837dad8a$export$9f27bc3417b4524d, (v) => $8ed5b7d8837dad8a$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $8ed5b7d8837dad8a$export$db77ccec0bb4ccac, (v) => $8ed5b7d8837dad8a$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35, (v) => $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $8ed5b7d8837dad8a$export$ffb0004e005737fa, (v) => $8ed5b7d8837dad8a$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $8ed5b7d8837dad8a$export$b624eff549462981, (v) => $8ed5b7d8837dad8a$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $8ed5b7d8837dad8a$export$7897aa7841a5380c, (v) => $8ed5b7d8837dad8a$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $8ed5b7d8837dad8a$export$602eac185826482c, (v) => $8ed5b7d8837dad8a$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $8ed5b7d8837dad8a$export$e2c29f18771995cb, (v) => $8ed5b7d8837dad8a$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $8ed5b7d8837dad8a$export$5f8d39834fd61797, (v) => $8ed5b7d8837dad8a$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $8ed5b7d8837dad8a$export$74bf444e3cd11ea5, (v) => $8ed5b7d8837dad8a$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $8ed5b7d8837dad8a$export$92387174baf9b227, (v) => $8ed5b7d8837dad8a$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $8ed5b7d8837dad8a$export$ec112efeb987d9c6, (v) => $8ed5b7d8837dad8a$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $8ed5b7d8837dad8a$export$b706b080d889d2c9, (v) => $8ed5b7d8837dad8a$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $8ed5b7d8837dad8a$export$5be5a87408f70ddc, (v) => $8ed5b7d8837dad8a$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d, (v) => $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $8ed5b7d8837dad8a$export$455c2e768291efa6, (v) => $8ed5b7d8837dad8a$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $8ed5b7d8837dad8a$export$9522e17588c12572, (v) => $8ed5b7d8837dad8a$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $8ed5b7d8837dad8a$export$2110ac352bb060b9, (v) => $8ed5b7d8837dad8a$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $8ed5b7d8837dad8a$export$56885ab8b9c456ab, (v) => $8ed5b7d8837dad8a$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $8ed5b7d8837dad8a$export$d927fcb6adf8f9de, (v) => $8ed5b7d8837dad8a$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $8ed5b7d8837dad8a$export$b82d16f27459e05a, (v) => $8ed5b7d8837dad8a$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $8ed5b7d8837dad8a$export$522c17b4f5e123e8, (v) => $8ed5b7d8837dad8a$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6, (v) => $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $8ed5b7d8837dad8a$export$9b621391a187a31a, (v) => $8ed5b7d8837dad8a$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $8ed5b7d8837dad8a$export$f5bbd400c2f4426f, (v) => $8ed5b7d8837dad8a$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8ed5b7d8837dad8a$export$a7c73072b1a182ae;
var $8ed5b7d8837dad8a$export$9f27bc3417b4524d;
var $8ed5b7d8837dad8a$export$db77ccec0bb4ccac;
var $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35;
var $8ed5b7d8837dad8a$export$ffb0004e005737fa;
var $8ed5b7d8837dad8a$export$b624eff549462981;
var $8ed5b7d8837dad8a$export$7897aa7841a5380c;
var $8ed5b7d8837dad8a$export$602eac185826482c;
var $8ed5b7d8837dad8a$export$e2c29f18771995cb;
var $8ed5b7d8837dad8a$export$5f8d39834fd61797;
var $8ed5b7d8837dad8a$export$74bf444e3cd11ea5;
var $8ed5b7d8837dad8a$export$92387174baf9b227;
var $8ed5b7d8837dad8a$export$ec112efeb987d9c6;
var $8ed5b7d8837dad8a$export$b706b080d889d2c9;
var $8ed5b7d8837dad8a$export$5be5a87408f70ddc;
var $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d;
var $8ed5b7d8837dad8a$export$455c2e768291efa6;
var $8ed5b7d8837dad8a$export$9522e17588c12572;
var $8ed5b7d8837dad8a$export$2110ac352bb060b9;
var $8ed5b7d8837dad8a$export$56885ab8b9c456ab;
var $8ed5b7d8837dad8a$export$d927fcb6adf8f9de;
var $8ed5b7d8837dad8a$export$b82d16f27459e05a;
var $8ed5b7d8837dad8a$export$522c17b4f5e123e8;
var $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6;
var $8ed5b7d8837dad8a$export$9b621391a187a31a;
var $8ed5b7d8837dad8a$export$f5bbd400c2f4426f;
"use strict";
var $8ed5b7d8837dad8a$var$b = 60103, $8ed5b7d8837dad8a$var$c = 60106, $8ed5b7d8837dad8a$var$d = 60107, $8ed5b7d8837dad8a$var$e = 60108, $8ed5b7d8837dad8a$var$f = 60114, $8ed5b7d8837dad8a$var$g = 60109, $8ed5b7d8837dad8a$var$h = 60110, $8ed5b7d8837dad8a$var$k = 60112, $8ed5b7d8837dad8a$var$l = 60113, $8ed5b7d8837dad8a$var$m = 60120, $8ed5b7d8837dad8a$var$n = 60115, $8ed5b7d8837dad8a$var$p = 60116, $8ed5b7d8837dad8a$var$q = 60121, $8ed5b7d8837dad8a$var$r = 60122, $8ed5b7d8837dad8a$var$u = 60117, $8ed5b7d8837dad8a$var$v = 60129, $8ed5b7d8837dad8a$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $8ed5b7d8837dad8a$var$x = Symbol.for;
    $8ed5b7d8837dad8a$var$b = $8ed5b7d8837dad8a$var$x("react.element");
    $8ed5b7d8837dad8a$var$c = $8ed5b7d8837dad8a$var$x("react.portal");
    $8ed5b7d8837dad8a$var$d = $8ed5b7d8837dad8a$var$x("react.fragment");
    $8ed5b7d8837dad8a$var$e = $8ed5b7d8837dad8a$var$x("react.strict_mode");
    $8ed5b7d8837dad8a$var$f = $8ed5b7d8837dad8a$var$x("react.profiler");
    $8ed5b7d8837dad8a$var$g = $8ed5b7d8837dad8a$var$x("react.provider");
    $8ed5b7d8837dad8a$var$h = $8ed5b7d8837dad8a$var$x("react.context");
    $8ed5b7d8837dad8a$var$k = $8ed5b7d8837dad8a$var$x("react.forward_ref");
    $8ed5b7d8837dad8a$var$l = $8ed5b7d8837dad8a$var$x("react.suspense");
    $8ed5b7d8837dad8a$var$m = $8ed5b7d8837dad8a$var$x("react.suspense_list");
    $8ed5b7d8837dad8a$var$n = $8ed5b7d8837dad8a$var$x("react.memo");
    $8ed5b7d8837dad8a$var$p = $8ed5b7d8837dad8a$var$x("react.lazy");
    $8ed5b7d8837dad8a$var$q = $8ed5b7d8837dad8a$var$x("react.block");
    $8ed5b7d8837dad8a$var$r = $8ed5b7d8837dad8a$var$x("react.server.block");
    $8ed5b7d8837dad8a$var$u = $8ed5b7d8837dad8a$var$x("react.fundamental");
    $8ed5b7d8837dad8a$var$v = $8ed5b7d8837dad8a$var$x("react.debug_trace_mode");
    $8ed5b7d8837dad8a$var$w = $8ed5b7d8837dad8a$var$x("react.legacy_hidden");
}
function $8ed5b7d8837dad8a$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $8ed5b7d8837dad8a$var$b:
                switch(a = a.type, a){
                    case $8ed5b7d8837dad8a$var$d:
                    case $8ed5b7d8837dad8a$var$f:
                    case $8ed5b7d8837dad8a$var$e:
                    case $8ed5b7d8837dad8a$var$l:
                    case $8ed5b7d8837dad8a$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8ed5b7d8837dad8a$var$h:
                            case $8ed5b7d8837dad8a$var$k:
                            case $8ed5b7d8837dad8a$var$p:
                            case $8ed5b7d8837dad8a$var$n:
                            case $8ed5b7d8837dad8a$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $8ed5b7d8837dad8a$var$c:
                return t;
        }
    }
}
var $8ed5b7d8837dad8a$var$z = $8ed5b7d8837dad8a$var$g, $8ed5b7d8837dad8a$var$A = $8ed5b7d8837dad8a$var$b, $8ed5b7d8837dad8a$var$B = $8ed5b7d8837dad8a$var$k, $8ed5b7d8837dad8a$var$C = $8ed5b7d8837dad8a$var$d, $8ed5b7d8837dad8a$var$D = $8ed5b7d8837dad8a$var$p, $8ed5b7d8837dad8a$var$E = $8ed5b7d8837dad8a$var$n, $8ed5b7d8837dad8a$var$F = $8ed5b7d8837dad8a$var$c, $8ed5b7d8837dad8a$var$G = $8ed5b7d8837dad8a$var$f, $8ed5b7d8837dad8a$var$H = $8ed5b7d8837dad8a$var$e, $8ed5b7d8837dad8a$var$I = $8ed5b7d8837dad8a$var$l;
$8ed5b7d8837dad8a$export$a7c73072b1a182ae = $8ed5b7d8837dad8a$var$h;
$8ed5b7d8837dad8a$export$9f27bc3417b4524d = $8ed5b7d8837dad8a$var$z;
$8ed5b7d8837dad8a$export$db77ccec0bb4ccac = $8ed5b7d8837dad8a$var$A;
$8ed5b7d8837dad8a$export$8392c0c9d3dcbd35 = $8ed5b7d8837dad8a$var$B;
$8ed5b7d8837dad8a$export$ffb0004e005737fa = $8ed5b7d8837dad8a$var$C;
$8ed5b7d8837dad8a$export$b624eff549462981 = $8ed5b7d8837dad8a$var$D;
$8ed5b7d8837dad8a$export$7897aa7841a5380c = $8ed5b7d8837dad8a$var$E;
$8ed5b7d8837dad8a$export$602eac185826482c = $8ed5b7d8837dad8a$var$F;
$8ed5b7d8837dad8a$export$e2c29f18771995cb = $8ed5b7d8837dad8a$var$G;
$8ed5b7d8837dad8a$export$5f8d39834fd61797 = $8ed5b7d8837dad8a$var$H;
$8ed5b7d8837dad8a$export$74bf444e3cd11ea5 = $8ed5b7d8837dad8a$var$I;
$8ed5b7d8837dad8a$export$92387174baf9b227 = function() {
    return !1;
};
$8ed5b7d8837dad8a$export$ec112efeb987d9c6 = function() {
    return !1;
};
$8ed5b7d8837dad8a$export$b706b080d889d2c9 = function(a) {
    return $8ed5b7d8837dad8a$var$y(a) === $8ed5b7d8837dad8a$var$h;
};
$8ed5b7d8837dad8a$export$5be5a87408f70ddc = function(a) {
    return $8ed5b7d8837dad8a$var$y(a) === $8ed5b7d8837dad8a$var$g;
};
$8ed5b7d8837dad8a$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8ed5b7d8837dad8a$var$b;
};
$8ed5b7d8837dad8a$export$455c2e768291efa6 = function(a) {
    return $8ed5b7d8837dad8a$var$y(a) === $8ed5b7d8837dad8a$var$k;
};
$8ed5b7d8837dad8a$export$9522e17588c12572 = function(a) {
    return $8ed5b7d8837dad8a$var$y(a) === $8ed5b7d8837dad8a$var$d;
};
$8ed5b7d8837dad8a$export$2110ac352bb060b9 = function(a) {
    return $8ed5b7d8837dad8a$var$y(a) === $8ed5b7d8837dad8a$var$p;
};
$8ed5b7d8837dad8a$export$56885ab8b9c456ab = function(a) {
    return $8ed5b7d8837dad8a$var$y(a) === $8ed5b7d8837dad8a$var$n;
};
$8ed5b7d8837dad8a$export$d927fcb6adf8f9de = function(a) {
    return $8ed5b7d8837dad8a$var$y(a) === $8ed5b7d8837dad8a$var$c;
};
$8ed5b7d8837dad8a$export$b82d16f27459e05a = function(a) {
    return $8ed5b7d8837dad8a$var$y(a) === $8ed5b7d8837dad8a$var$f;
};
$8ed5b7d8837dad8a$export$522c17b4f5e123e8 = function(a) {
    return $8ed5b7d8837dad8a$var$y(a) === $8ed5b7d8837dad8a$var$e;
};
$8ed5b7d8837dad8a$export$1aabd8a0274ecfd6 = function(a) {
    return $8ed5b7d8837dad8a$var$y(a) === $8ed5b7d8837dad8a$var$l;
};
$8ed5b7d8837dad8a$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8ed5b7d8837dad8a$var$d || a === $8ed5b7d8837dad8a$var$f || a === $8ed5b7d8837dad8a$var$v || a === $8ed5b7d8837dad8a$var$e || a === $8ed5b7d8837dad8a$var$l || a === $8ed5b7d8837dad8a$var$m || a === $8ed5b7d8837dad8a$var$w || "object" === typeof a && null !== a && (a.$$typeof === $8ed5b7d8837dad8a$var$p || a.$$typeof === $8ed5b7d8837dad8a$var$n || a.$$typeof === $8ed5b7d8837dad8a$var$g || a.$$typeof === $8ed5b7d8837dad8a$var$h || a.$$typeof === $8ed5b7d8837dad8a$var$k || a.$$typeof === $8ed5b7d8837dad8a$var$u || a.$$typeof === $8ed5b7d8837dad8a$var$q || a[0] === $8ed5b7d8837dad8a$var$r) ? !0 : !1;
};
$8ed5b7d8837dad8a$export$f5bbd400c2f4426f = $8ed5b7d8837dad8a$var$y;

});



parcelRegister("hrvfy", function(module, exports) {

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $2g8Bt = parcelRequire("2g8Bt");

var $8PZ7r = parcelRequire("8PZ7r");

var $ih4tx = parcelRequire("ih4tx");

var $kSE8V = parcelRequire("kSE8V");

var $7EQ16 = parcelRequire("7EQ16");

var $40Fxm = parcelRequire("40Fxm");
var $cb2d32d6c07199e9$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $cb2d32d6c07199e9$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $cb2d32d6c07199e9$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $cb2d32d6c07199e9$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $2g8Bt.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $kSE8V.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $ih4tx.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $7EQ16.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $40Fxm.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $cb2d32d6c07199e9$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $8PZ7r.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $8PZ7r.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $8PZ7r.default) : _ref3$areMergedPropsE, extraOptions = (0, $1En50.default)(_ref3, $cb2d32d6c07199e9$var$_excluded);
        var initMapStateToProps = $cb2d32d6c07199e9$var$match(mapStateToProps, mapStateToPropsFactories, "mapStateToProps");
        var initMapDispatchToProps = $cb2d32d6c07199e9$var$match(mapDispatchToProps, mapDispatchToPropsFactories, "mapDispatchToProps");
        var initMergeProps = $cb2d32d6c07199e9$var$match(mergeProps, mergePropsFactories, "mergeProps");
        return connectHOC(selectorFactory, (0, $8nd05.default)({
            // used in error messages
            methodName: "connect",
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $cb2d32d6c07199e9$export$2e2bcd8739ae039 = /*#__PURE__*/ $cb2d32d6c07199e9$export$9f9feb656dec1fc4();

});
parcelRegister("8PZ7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $66f27f2048ec2805$export$2e2bcd8739ae039);
function $66f27f2048ec2805$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $66f27f2048ec2805$export$2e2bcd8739ae039(objA, objB) {
    if ($66f27f2048ec2805$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$66f27f2048ec2805$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRegister("ih4tx", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4dd493c66c4df43$export$2e2bcd8739ae039);

var $96XmR = parcelRequire("96XmR");

var $3TktP = parcelRequire("3TktP");
function $d4dd493c66c4df43$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === "function" ? (0, $3TktP.wrapMapToPropsFunc)(mapDispatchToProps, "mapDispatchToProps") : undefined;
}
function $d4dd493c66c4df43$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $3TktP.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $d4dd493c66c4df43$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $3TktP.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $96XmR.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $d4dd493c66c4df43$export$2e2bcd8739ae039 = [
    $d4dd493c66c4df43$export$a9f27b4b187c1166,
    $d4dd493c66c4df43$export$ba20d1a7aa0c4a90,
    $d4dd493c66c4df43$export$94a6e55709d4d961
];

});
parcelRegister("96XmR", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a22b9cec285f673$export$2e2bcd8739ae039);
function $6a22b9cec285f673$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

});

parcelRegister("3TktP", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", () => $2d566511964cb2c4$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $2d566511964cb2c4$export$8d46c7f53c8c602f);
parcelRequire("jKoYp");
function $2d566511964cb2c4$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $2d566511964cb2c4$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $2d566511964cb2c4$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $2d566511964cb2c4$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $2d566511964cb2c4$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("jKoYp", function(module, exports) {

var $btfXQ = parcelRequire("btfXQ");

var $7CByU = parcelRequire("7CByU");
function $e605af63e5bbc093$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $btfXQ.default)(value)) (0, $7CByU.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

});
parcelRegister("btfXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $859ec94da7aa38c4$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $859ec94da7aa38c4$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});

parcelRegister("7CByU", function(module, exports) {

$parcel$export(module.exports, "default", () => $58c9380df5fc9ad2$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $58c9380df5fc9ad2$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});




parcelRegister("kSE8V", function(module, exports) {

$parcel$export(module.exports, "default", () => $f337fd5395077a96$export$2e2bcd8739ae039);

var $3TktP = parcelRequire("3TktP");
function $f337fd5395077a96$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === "function" ? (0, $3TktP.wrapMapToPropsFunc)(mapStateToProps, "mapStateToProps") : undefined;
}
function $f337fd5395077a96$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $3TktP.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
var $f337fd5395077a96$export$2e2bcd8739ae039 = [
    $f337fd5395077a96$export$23fc470827b14aa,
    $f337fd5395077a96$export$514bc8c1a53c1d66
];

});

parcelRegister("7EQ16", function(module, exports) {

$parcel$export(module.exports, "default", () => $59349e43bbd01749$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("jKoYp");
function $59349e43bbd01749$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $8nd05.default)({}, ownProps, stateProps, dispatchProps);
}
function $59349e43bbd01749$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $59349e43bbd01749$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === "function" ? $59349e43bbd01749$export$5b105939c84b5234(mergeProps) : undefined;
}
function $59349e43bbd01749$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $59349e43bbd01749$export$691c327fc30bc857;
    } : undefined;
}
var $59349e43bbd01749$export$2e2bcd8739ae039 = [
    $59349e43bbd01749$export$d61b680184bc3f00,
    $59349e43bbd01749$export$a13ba70ef50dda6d
];

});

parcelRegister("40Fxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eb761e6a8ffbe36$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");
parcelRequire("d6Wo0");
var $2eb761e6a8ffbe36$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $2eb761e6a8ffbe36$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $2eb761e6a8ffbe36$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $2eb761e6a8ffbe36$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $1En50.default)(_ref2, $2eb761e6a8ffbe36$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $2eb761e6a8ffbe36$export$d20c0c2ca6eb2b6f : $2eb761e6a8ffbe36$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("d6Wo0", function(module, exports) {

var $7CByU = parcelRequire("7CByU");
function $98b92028b84cbd13$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $7CByU.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $98b92028b84cbd13$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $98b92028b84cbd13$var$verify(mapStateToProps, "mapStateToProps", displayName);
    $98b92028b84cbd13$var$verify(mapDispatchToProps, "mapDispatchToProps", displayName);
    $98b92028b84cbd13$var$verify(mergeProps, "mergeProps", displayName);
}

});



parcelRegister("2OPjR", function(module, exports) {

$parcel$export(module.exports, "useDispatch", () => $20d80f3cecee513e$export$8ad76b76a4c905f8);

var $7iEsg = parcelRequire("7iEsg");

var $4TSkt = parcelRequire("4TSkt");
function $20d80f3cecee513e$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $7iEsg.ReactReduxContext);
    var useStore = context === (0, $7iEsg.ReactReduxContext) ? (0, $4TSkt.useStore) : (0, $4TSkt.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $20d80f3cecee513e$export$8ad76b76a4c905f8 = /*#__PURE__*/ $20d80f3cecee513e$export$bc9b55530897c558();

});
parcelRegister("4TSkt", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", () => $391671225302c365$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $391671225302c365$export$6ccbb43953eebf8);

var $acw62 = parcelRequire("acw62");

var $7iEsg = parcelRequire("7iEsg");

var $1ubyh = parcelRequire("1ubyh");
function $391671225302c365$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $7iEsg.ReactReduxContext);
    var useReduxContext = context === (0, $7iEsg.ReactReduxContext) ? (0, $1ubyh.useReduxContext) : function() {
        return (0, $acw62.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $391671225302c365$export$6ccbb43953eebf8 = /*#__PURE__*/ $391671225302c365$export$671dba69185d0304();

});
parcelRegister("1ubyh", function(module, exports) {

$parcel$export(module.exports, "useReduxContext", () => $11518dc3bb05d381$export$c1275ca9a6fd3ec5);

var $acw62 = parcelRequire("acw62");

var $7iEsg = parcelRequire("7iEsg");
function $11518dc3bb05d381$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $acw62.useContext)((0, $7iEsg.ReactReduxContext));
    return contextValue;
}

});



parcelRegister("iD0SF", function(module, exports) {

$parcel$export(module.exports, "useSelector", () => $d8fc8d639f906efc$export$2105062e25df4afe);

var $acw62 = parcelRequire("acw62");

var $1ubyh = parcelRequire("1ubyh");

var $j4jJy = parcelRequire("j4jJy");

var $atMb1 = parcelRequire("atMb1");

var $7iEsg = parcelRequire("7iEsg");
var $d8fc8d639f906efc$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $d8fc8d639f906efc$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $acw62.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $acw62.useMemo)(function() {
        return (0, $j4jJy.createSubscription)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $acw62.useRef)();
    var latestSelector = (0, $acw62.useRef)();
    var latestStoreState = (0, $acw62.useRef)();
    var latestSelectedState = (0, $acw62.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $atMb1.useIsomorphicLayoutEffect)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $atMb1.useIsomorphicLayoutEffect)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $d8fc8d639f906efc$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $7iEsg.ReactReduxContext);
    var useReduxContext = context === (0, $7iEsg.ReactReduxContext) ? (0, $1ubyh.useReduxContext) : function() {
        return (0, $acw62.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $d8fc8d639f906efc$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $d8fc8d639f906efc$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $acw62.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $d8fc8d639f906efc$export$2105062e25df4afe = /*#__PURE__*/ $d8fc8d639f906efc$export$2b53f90d2bd1cbfb();

});


parcelRegister("7c7i6", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("1u0KT")).unstable_batchedUpdates);
/* eslint-disable import/no-unresolved */ 
var $1u0KT = parcelRequire("1u0KT");

});


parcelRegister("54Psn", function(module, exports) {

$parcel$export(module.exports, "selectSession", () => $d2bd6fba9d45a460$export$ca779d385d6ad982);
$parcel$export(module.exports, "selectAccessToken", () => $d2bd6fba9d45a460$export$4f201c21d4cbccc3);
$parcel$export(module.exports, "selectRefreshToken", () => $d2bd6fba9d45a460$export$dc0ee201a4b8c0b0);
$parcel$export(module.exports, "selectIdToken", () => $d2bd6fba9d45a460$export$52051a828121a197);
$parcel$export(module.exports, "selectIsLoggedIn", () => $d2bd6fba9d45a460$export$c0af6229cce1f6c3);
$parcel$export(module.exports, "selectCurrentTenant", () => $d2bd6fba9d45a460$export$af3171a561b31363);
$parcel$export(module.exports, "selectUserName", () => $d2bd6fba9d45a460$export$efa5dad00574e9df);
function $d2bd6fba9d45a460$export$ca779d385d6ad982(state) {
    return state.session;
}
function $d2bd6fba9d45a460$export$4f201c21d4cbccc3(state) {
    return state.session.accessToken;
}
function $d2bd6fba9d45a460$export$dc0ee201a4b8c0b0(state) {
    return state.session.refreshToken;
}
function $d2bd6fba9d45a460$export$52051a828121a197(state) {
    return state.session.idToken;
}
function $d2bd6fba9d45a460$export$c0af6229cce1f6c3(state) {
    return state.session.isLoggedIn;
}
function $d2bd6fba9d45a460$export$af3171a561b31363(state) {
    return state.session.user != null ? state.session.user.tenant : null;
}
function $d2bd6fba9d45a460$export$efa5dad00574e9df(state) {
    return state.session.user != null ? state.session.user.subject : null;
}

});

parcelRegister("bsVS2", function(module, exports) {

$parcel$export(module.exports, "isNullish", () => $322f828652ff1315$export$b931b78cbb3caf86);
function $322f828652ff1315$export$b931b78cbb3caf86(dataSet) {
    if (dataSet === "") return true;
    if (dataSet === null) return true;
    if (dataSet === undefined) return true;
    if (typeof dataSet === "object" && Object.keys(dataSet).length === 0) return true;
    if (Array.isArray(dataSet) && dataSet.length === 0) return true;
    return false;
}

});

parcelRegister("je6jq", function(module, exports) {

$parcel$export(module.exports, "Loader", () => $1eae313b8b65f7a8$export$3b0d6d7590275603);

var $acw62 = parcelRequire("acw62");
const $1eae313b8b65f7a8$export$3b0d6d7590275603 = ({ embedded: embedded })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "app-loader",
        style: {
            position: embedded === true ? "initial" : "fixed"
        }
    });
};

});

parcelRegister("1XNui", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");


module.exports = Promise.all([
    (parcelRequire("fFMZG"))((parcelRequire("27Lyk")).resolve("cKesg")),
    $Gr8vk("hFPGr"),
    $Gr8vk("eWA6t"),
    $Gr8vk("jurcF")
]).then(()=>parcelRequire("865eE"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});

parcelRegister("fFMZG", function(module, exports) {
"use strict";

var $lovBw = parcelRequire("lovBw");
module.exports = $lovBw(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});
parcelRegister("lovBw", function(module, exports) {
"use strict";
var $f9345ad2c034f768$var$cachedBundles = {};
var $f9345ad2c034f768$var$cachedPreloads = {};
var $f9345ad2c034f768$var$cachedPrefetches = {};
function $f9345ad2c034f768$var$getCache(type) {
    switch(type){
        case "preload":
            return $f9345ad2c034f768$var$cachedPreloads;
        case "prefetch":
            return $f9345ad2c034f768$var$cachedPrefetches;
        default:
            return $f9345ad2c034f768$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $f9345ad2c034f768$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("13hm9", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("50O7k").then(()=>parcelRequire("4nFQs"));

});

parcelRegister("dpkRc", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7wGDn").then(()=>parcelRequire("6UU52"));

});

parcelRegister("2QUhJ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6iCqf").then(()=>parcelRequire("l3qO2"));

});

parcelRegister("kajJd", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("b0Owg").then(()=>parcelRequire("gA1gM"));

});

parcelRegister("1WN2x", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");


module.exports = Promise.all([
    $Gr8vk("iVAka"),
    (parcelRequire("fFMZG"))((parcelRequire("27Lyk")).resolve("9aaK7")),
    $Gr8vk("1XSjb"),
    $Gr8vk("hiQ7S"),
    $Gr8vk("hFPGr"),
    $Gr8vk("eWA6t"),
    $Gr8vk("8dWJ4"),
    $Gr8vk("5hWth")
]).then(()=>parcelRequire("7wFz3"));

});

parcelRegister("4ZdJS", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("eWA6t"),
    $Gr8vk("1VxAW")
]).then(()=>parcelRequire("6EcZf"));

});

parcelRegister("5Unhi", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("iVAka"),
    $Gr8vk("eWA6t"),
    $Gr8vk("aZ1mC")
]).then(()=>parcelRequire("3pz6I"));

});

parcelRegister("93YUF", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("hFPGr"),
    $Gr8vk("eWA6t"),
    $Gr8vk("bX7Df")
]).then(()=>parcelRequire("4xmDR"));

});

parcelRegister("1wN72", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("iVAka"),
    $Gr8vk("1XSjb"),
    $Gr8vk("hiQ7S"),
    $Gr8vk("hFPGr"),
    $Gr8vk("eWA6t"),
    $Gr8vk("224Aa")
]).then(()=>parcelRequire("aq6lF"));

});

parcelRegister("6V1yt", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("eWA6t"),
    $Gr8vk("9afRl")
]).then(()=>parcelRequire("4grjb"));

});

parcelRegister("jBElC", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("eWA6t"),
    $Gr8vk("8dWJ4")
]).then(()=>parcelRequire("cb4KN"));

});

parcelRegister("xNz5h", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("eWA6t"),
    $Gr8vk("bFVdc")
]).then(()=>parcelRequire("1LN5D"));

});

parcelRegister("i7Fkb", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("1XSjb"),
    $Gr8vk("eWA6t"),
    $Gr8vk("kla21")
]).then(()=>parcelRequire("8Bnbj"));

});

parcelRegister("lm1CN", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("eWA6t"),
    $Gr8vk("6rM5I")
]).then(()=>parcelRequire("4xlkS"));

});

parcelRegister("eShmq", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $ad4393542232627c$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $ad4393542232627c$export$66e4520cdb265d18);
$parcel$export(module.exports, "compose", () => $ad4393542232627c$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $ad4393542232627c$export$9ff26e0402cc7b7);

var $d49SP = parcelRequire("d49SP");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $ad4393542232627c$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $ad4393542232627c$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $ad4393542232627c$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $ad4393542232627c$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $ad4393542232627c$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $ad4393542232627c$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $ad4393542232627c$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $ad4393542232627c$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $ad4393542232627c$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($ad4393542232627c$var$isDate(val)) return "date";
    if ($ad4393542232627c$var$isError(val)) return "error";
    var constructorName = $ad4393542232627c$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $ad4393542232627c$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $ad4393542232627c$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $ad4393542232627c$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $ad4393542232627c$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $ad4393542232627c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($ad4393542232627c$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($ad4393542232627c$var$formatProdErrorMessage(1));
        return enhancer($ad4393542232627c$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($ad4393542232627c$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($ad4393542232627c$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$ad4393542232627c$var$isPlainObject(action)) throw new Error($ad4393542232627c$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($ad4393542232627c$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($ad4393542232627c$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $ad4393542232627c$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$ad4393542232627c$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $ad4393542232627c$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$ad4393542232627c$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $ad4393542232627c$export$8928921ea2d3b126 = $ad4393542232627c$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $ad4393542232627c$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $ad4393542232627c$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $ad4393542232627c$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$ad4393542232627c$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $ad4393542232627c$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $ad4393542232627c$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $ad4393542232627c$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($ad4393542232627c$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($ad4393542232627c$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $ad4393542232627c$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $ad4393542232627c$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $ad4393542232627c$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $ad4393542232627c$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $ad4393542232627c$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $ad4393542232627c$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $ad4393542232627c$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $d49SP.default)((0, $d49SP.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("d49SP", function(module, exports) {

$parcel$export(module.exports, "default", () => $983350b7b3960a26$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");
function $983350b7b3960a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983350b7b3960a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $kSlfw.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983350b7b3960a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("kSlfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f329557dcab6d0bb$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $4ZreY.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("4ZreY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a21fd50cbcd11cf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $cXkjo = parcelRequire("cXkjo");
function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $cXkjo.default)(t, "string");
    return "symbol" == (0, $fSwVM.default)(i) ? i : i + "";
}

});
parcelRegister("fSwVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f57191916382d3$export$2e2bcd8739ae039);
function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}

});

parcelRegister("cXkjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $96eac03571e01dbf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");
function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $fSwVM.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $fSwVM.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("gCWjV", function(module, exports) {
"use strict";
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AuthorizationRequest = void 0;

var $72afL = parcelRequire("72afL");

var $YQWls = parcelRequire("YQWls");
/**
 * Generates a cryptographically random new state. Useful for CSRF protection.
 */ var $c1ad6f2f3e864719$var$SIZE = 10; // 10 bytes
var $c1ad6f2f3e864719$var$newState = function(crypto) {
    return crypto.generateRandom($c1ad6f2f3e864719$var$SIZE);
};
/**
 * Represents the AuthorizationRequest.
 * For more information look at
 * https://tools.ietf.org/html/rfc6749#section-4.1.1
 */ var $c1ad6f2f3e864719$var$AuthorizationRequest = /** @class */ function() {
    /**
     * Constructs a new AuthorizationRequest.
     * Use a `undefined` value for the `state` parameter, to generate a random
     * state for CSRF protection.
     */ function AuthorizationRequest(request, crypto, usePkce) {
        if (crypto === void 0) crypto = new $72afL.DefaultCrypto();
        if (usePkce === void 0) usePkce = true;
        this.crypto = crypto;
        this.usePkce = usePkce;
        this.clientId = request.client_id;
        this.redirectUri = request.redirect_uri;
        this.scope = request.scope;
        this.responseType = request.response_type || AuthorizationRequest.RESPONSE_TYPE_CODE;
        this.state = request.state || $c1ad6f2f3e864719$var$newState(crypto);
        this.extras = request.extras;
        // read internal properties if available
        this.internal = request.internal;
    }
    AuthorizationRequest.prototype.setupCodeVerifier = function() {
        var _this = this;
        if (!this.usePkce) return Promise.resolve();
        else {
            var codeVerifier_1 = this.crypto.generateRandom(128);
            var challenge = this.crypto.deriveChallenge(codeVerifier_1).catch(function(error) {
                (0, $YQWls.log)("Unable to generate PKCE challenge. Not using PKCE", error);
                return undefined;
            });
            return challenge.then(function(result) {
                if (result) {
                    // keep track of the code used.
                    _this.internal = _this.internal || {};
                    _this.internal["code_verifier"] = codeVerifier_1;
                    _this.extras = _this.extras || {};
                    _this.extras["code_challenge"] = result;
                    // We always use S256. Plain is not good enough.
                    _this.extras["code_challenge_method"] = "S256";
                }
            });
        }
    };
    /**
     * Serializes the AuthorizationRequest to a JavaScript Object.
     */ AuthorizationRequest.prototype.toJson = function() {
        var _this = this;
        // Always make sure that the code verifier is setup when toJson() is called.
        return this.setupCodeVerifier().then(function() {
            return {
                response_type: _this.responseType,
                client_id: _this.clientId,
                redirect_uri: _this.redirectUri,
                scope: _this.scope,
                state: _this.state,
                extras: _this.extras,
                internal: _this.internal
            };
        });
    };
    AuthorizationRequest.RESPONSE_TYPE_TOKEN = "token";
    AuthorizationRequest.RESPONSE_TYPE_CODE = "code";
    return AuthorizationRequest;
}();
module.exports.AuthorizationRequest = $c1ad6f2f3e864719$var$AuthorizationRequest;

});
parcelRegister("72afL", function(module, exports) {
"use strict";
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultCrypto = module.exports.textEncodeLite = module.exports.urlSafe = module.exports.bufferToString = void 0;

var $kuxul = parcelRequire("kuxul");

var $229yo = parcelRequire("229yo");
var $51f0ac65535b46c7$var$HAS_CRYPTO = typeof window !== "undefined" && !!window.crypto;
var $51f0ac65535b46c7$var$HAS_SUBTLE_CRYPTO = $51f0ac65535b46c7$var$HAS_CRYPTO && !!window.crypto.subtle;
var $51f0ac65535b46c7$var$CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
function $51f0ac65535b46c7$var$bufferToString(buffer) {
    var state = [];
    for(var i = 0; i < buffer.byteLength; i += 1){
        var index = buffer[i] % $51f0ac65535b46c7$var$CHARSET.length;
        state.push($51f0ac65535b46c7$var$CHARSET[index]);
    }
    return state.join("");
}
module.exports.bufferToString = $51f0ac65535b46c7$var$bufferToString;
function $51f0ac65535b46c7$var$urlSafe(buffer) {
    var encoded = $kuxul.fromByteArray(new Uint8Array(buffer));
    return encoded.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
module.exports.urlSafe = $51f0ac65535b46c7$var$urlSafe;
// adapted from source: http://stackoverflow.com/a/11058858
// this is used in place of TextEncode as the api is not yet
// well supported: https://caniuse.com/#search=TextEncoder
function $51f0ac65535b46c7$var$textEncodeLite(str) {
    var buf = new ArrayBuffer(str.length);
    var bufView = new Uint8Array(buf);
    for(var i = 0; i < str.length; i++)bufView[i] = str.charCodeAt(i);
    return bufView;
}
module.exports.textEncodeLite = $51f0ac65535b46c7$var$textEncodeLite;
/**
 * The default implementation of the `Crypto` interface.
 * This uses the capabilities of the browser.
 */ var $51f0ac65535b46c7$var$DefaultCrypto = /** @class */ function() {
    function DefaultCrypto() {}
    DefaultCrypto.prototype.generateRandom = function(size) {
        var buffer = new Uint8Array(size);
        if ($51f0ac65535b46c7$var$HAS_CRYPTO) window.crypto.getRandomValues(buffer);
        else // fall back to Math.random() if nothing else is available
        for(var i = 0; i < size; i += 1)buffer[i] = Math.random() * $51f0ac65535b46c7$var$CHARSET.length | 0;
        return $51f0ac65535b46c7$var$bufferToString(buffer);
    };
    DefaultCrypto.prototype.deriveChallenge = function(code) {
        if (code.length < 43 || code.length > 128) return Promise.reject(new $229yo.AppAuthError("Invalid code length."));
        if (!$51f0ac65535b46c7$var$HAS_SUBTLE_CRYPTO) return Promise.reject(new $229yo.AppAuthError("window.crypto.subtle is unavailable."));
        return new Promise(function(resolve, reject) {
            crypto.subtle.digest("SHA-256", $51f0ac65535b46c7$var$textEncodeLite(code)).then(function(buffer) {
                return resolve($51f0ac65535b46c7$var$urlSafe(new Uint8Array(buffer)));
            }, function(error) {
                return reject(error);
            });
        });
    };
    return DefaultCrypto;
}();
module.exports.DefaultCrypto = $51f0ac65535b46c7$var$DefaultCrypto;

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("229yo", function(module, exports) {
"use strict";
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AppAuthError = void 0;
/**
 * Represents the AppAuthError type.
 */ var $17b32dda6688a975$var$AppAuthError = /** @class */ function() {
    function AppAuthError(message, extras) {
        this.message = message;
        this.extras = extras;
    }
    return AppAuthError;
}();
module.exports.AppAuthError = $17b32dda6688a975$var$AppAuthError;

});


parcelRegister("YQWls", function(module, exports) {
"use strict";
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0b6eab80b93377f9$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.profile = module.exports.log = void 0;

var $envZT = parcelRequire("envZT");
function $0b6eab80b93377f9$var$log(message) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if ($envZT.Flags.IS_LOG) {
        var length_1 = args ? args.length : 0;
        if (length_1 > 0) console.log.apply(console, $0b6eab80b93377f9$var$__spreadArray([
            message
        ], args, false));
        else console.log(message);
    }
}
module.exports.log = $0b6eab80b93377f9$var$log;
// check to see if native support for profiling is available.
var $0b6eab80b93377f9$var$NATIVE_PROFILE_SUPPORT = typeof window !== "undefined" && !!window.performance && !!console.profile;
/**
 * A decorator that can profile a function.
 */ function $0b6eab80b93377f9$var$profile(target, propertyKey, descriptor) {
    if ($envZT.Flags.IS_PROFILE) return $0b6eab80b93377f9$var$performProfile(target, propertyKey, descriptor);
    else // return as-is
    return descriptor;
}
module.exports.profile = $0b6eab80b93377f9$var$profile;
function $0b6eab80b93377f9$var$performProfile(target, propertyKey, descriptor) {
    var originalCallable = descriptor.value;
    // name must exist
    var name = originalCallable.name;
    if (!name) name = "anonymous function";
    if ($0b6eab80b93377f9$var$NATIVE_PROFILE_SUPPORT) descriptor.value = function(args) {
        console.profile(name);
        var startTime = window.performance.now();
        var result = originalCallable.call.apply(originalCallable, $0b6eab80b93377f9$var$__spreadArray([
            this || window
        ], args, false));
        var duration = window.performance.now() - startTime;
        console.log("".concat(name, " took ").concat(duration, " ms"));
        console.profileEnd();
        return result;
    };
    else descriptor.value = function(args) {
        $0b6eab80b93377f9$var$log("Profile start ".concat(name));
        var start = Date.now();
        var result = originalCallable.call.apply(originalCallable, $0b6eab80b93377f9$var$__spreadArray([
            this || window
        ], args, false));
        var duration = Date.now() - start;
        $0b6eab80b93377f9$var$log("Profile end ".concat(name, " took ").concat(duration, " ms."));
        return result;
    };
    return descriptor;
}

});
parcelRegister("envZT", function(module, exports) {
"use strict";
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IS_PROFILE = module.exports.IS_LOG = module.exports.setFlag = module.exports.Flags = void 0;
/* Global flags that control the behavior of App Auth JS. */ module.exports.Flags = {
    /* Logging turned on ? */ IS_LOG: true,
    /* Profiling turned on ? */ IS_PROFILE: false
};
/** Set a value for the specified global control flags.  */ function $a77c08a990f51d0f$var$setFlag(flag, value) {
    module.exports.Flags[flag] = value;
}
module.exports.setFlag = $a77c08a990f51d0f$var$setFlag;
module.exports.IS_LOG = module.exports.Flags.IS_LOG, module.exports.IS_PROFILE = module.exports.Flags.IS_PROFILE;

});



parcelRegister("aJrNS", function(module, exports) {
"use strict";
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AuthorizationRequestHandler = module.exports.BUILT_IN_PARAMETERS = module.exports.AuthorizationNotifier = void 0;

var $YQWls = parcelRequire("YQWls");

var $vIA80 = parcelRequire("vIA80");
/**
 * Authorization Service notifier.
 * This manages the communication of the AuthorizationResponse to the 3p client.
 */ var $7d03ac861d915ae5$var$AuthorizationNotifier = /** @class */ function() {
    function AuthorizationNotifier() {
        this.listener = null;
    }
    AuthorizationNotifier.prototype.setAuthorizationListener = function(listener) {
        this.listener = listener;
    };
    /**
     * The authorization complete callback.
     */ AuthorizationNotifier.prototype.onAuthorizationComplete = function(request, response, error) {
        if (this.listener) // complete authorization request
        this.listener(request, response, error);
    };
    return AuthorizationNotifier;
}();
module.exports.AuthorizationNotifier = $7d03ac861d915ae5$var$AuthorizationNotifier;
// TODO(rahulrav@): add more built in parameters.
/* built in parameters. */ module.exports.BUILT_IN_PARAMETERS = [
    "redirect_uri",
    "client_id",
    "response_type",
    "state",
    "scope"
];
/**
 * Defines the interface which is capable of handling an authorization request
 * using various methods (iframe / popup / different process etc.).
 */ var $7d03ac861d915ae5$var$AuthorizationRequestHandler = /** @class */ function() {
    function AuthorizationRequestHandler(utils, crypto) {
        this.utils = utils;
        this.crypto = crypto;
        // notifier send the response back to the client.
        this.notifier = null;
    }
    /**
     * A utility method to be able to build the authorization request URL.
     */ AuthorizationRequestHandler.prototype.buildRequestUrl = function(configuration, request) {
        // build the query string
        // coerce to any type for convenience
        var requestMap = {
            "redirect_uri": request.redirectUri,
            "client_id": request.clientId,
            "response_type": request.responseType,
            "state": request.state,
            "scope": request.scope
        };
        // copy over extras
        if (request.extras) for(var extra in request.extras){
            if (request.extras.hasOwnProperty(extra)) // check before inserting to requestMap
            {
                if (module.exports.BUILT_IN_PARAMETERS.indexOf(extra) < 0) requestMap[extra] = request.extras[extra];
            }
        }
        var query = this.utils.stringify(requestMap);
        var baseUrl = (0, $vIA80.requireValidUrl)(configuration.authorizationEndpoint);
        var url = "".concat(baseUrl, "?").concat(query);
        return url;
    };
    /**
     * Completes the authorization request if necessary & when possible.
     */ AuthorizationRequestHandler.prototype.completeAuthorizationRequestIfPossible = function() {
        var _this = this;
        // call complete authorization if possible to see there might
        // be a response that needs to be delivered.
        (0, $YQWls.log)("Checking to see if there is an authorization response to be delivered.");
        if (!this.notifier) (0, $YQWls.log)("Notifier is not present on AuthorizationRequest handler.\n          No delivery of result will be possible");
        return this.completeAuthorizationRequest().then(function(result) {
            if (!result) (0, $YQWls.log)("No result is available yet.");
            if (result && _this.notifier) _this.notifier.onAuthorizationComplete(result.request, result.response, result.error);
        });
    };
    /**
     * Sets the default Authorization Service notifier.
     */ AuthorizationRequestHandler.prototype.setAuthorizationNotifier = function(notifier) {
        this.notifier = notifier;
        return this;
    };
    return AuthorizationRequestHandler;
}();
module.exports.AuthorizationRequestHandler = $7d03ac861d915ae5$var$AuthorizationRequestHandler;

});
parcelRegister("vIA80", function(module, exports) {
"use strict";
/*
 * Copyright 2024 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.requireValidUrl = void 0;

var $229yo = parcelRequire("229yo");
function $05f57a5d52b05e82$var$requireValidUrl(input) {
    try {
        new URL(input);
        return input;
    } catch (error) {
        throw new $229yo.AppAuthError("Invalid input url ".concat(input));
    }
}
module.exports.requireValidUrl = $05f57a5d52b05e82$var$requireValidUrl;

});


parcelRegister("2ZGFJ", function(module, exports) {
"use strict";
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AuthorizationError = module.exports.AuthorizationResponse = void 0;
/**
 * Represents the Authorization Response type.
 * For more information look at
 * https://tools.ietf.org/html/rfc6749#section-4.1.2
 */ var $22e2610f4634e7ff$var$AuthorizationResponse = /** @class */ function() {
    function AuthorizationResponse(response) {
        this.code = response.code;
        this.state = response.state;
    }
    AuthorizationResponse.prototype.toJson = function() {
        return {
            code: this.code,
            state: this.state
        };
    };
    return AuthorizationResponse;
}();
module.exports.AuthorizationResponse = $22e2610f4634e7ff$var$AuthorizationResponse;
/**
 * Represents the Authorization error response.
 * For more information look at:
 * https://tools.ietf.org/html/rfc6749#section-4.1.2.1
 */ var $22e2610f4634e7ff$var$AuthorizationError = /** @class */ function() {
    function AuthorizationError(error) {
        this.error = error.error;
        this.errorDescription = error.error_description;
        this.errorUri = error.error_uri;
        this.state = error.state;
    }
    AuthorizationError.prototype.toJson = function() {
        return {
            error: this.error,
            error_description: this.errorDescription,
            error_uri: this.errorUri,
            state: this.state
        };
    };
    return AuthorizationError;
}();
module.exports.AuthorizationError = $22e2610f4634e7ff$var$AuthorizationError;

});

parcelRegister("28Jyf", function(module, exports) {
"use strict";
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AuthorizationServiceConfiguration = void 0;

var $cZQm7 = parcelRequire("cZQm7");
/**
 * The standard base path for well-known resources on domains.
 * See https://tools.ietf.org/html/rfc5785 for more information.
 */ var $18efa9aae1340857$var$WELL_KNOWN_PATH = ".well-known";
/**
 * The standard resource under the well known path at which an OpenID Connect
 * discovery document can be found under an issuer's base URI.
 */ var $18efa9aae1340857$var$OPENID_CONFIGURATION = "openid-configuration";
/**
 * Configuration details required to interact with an authorization service.
 *
 * More information at https://openid.net/specs/openid-connect-discovery-1_0-17.html
 */ var $18efa9aae1340857$var$AuthorizationServiceConfiguration = /** @class */ function() {
    function AuthorizationServiceConfiguration(request) {
        this.authorizationEndpoint = request.authorization_endpoint;
        this.tokenEndpoint = request.token_endpoint;
        this.revocationEndpoint = request.revocation_endpoint;
        this.userInfoEndpoint = request.userinfo_endpoint;
        this.endSessionEndpoint = request.end_session_endpoint;
    }
    AuthorizationServiceConfiguration.prototype.toJson = function() {
        return {
            authorization_endpoint: this.authorizationEndpoint,
            token_endpoint: this.tokenEndpoint,
            revocation_endpoint: this.revocationEndpoint,
            end_session_endpoint: this.endSessionEndpoint,
            userinfo_endpoint: this.userInfoEndpoint
        };
    };
    AuthorizationServiceConfiguration.fetchFromIssuer = function(openIdIssuerUrl, requestor) {
        var fullUrl = "".concat(openIdIssuerUrl, "/").concat($18efa9aae1340857$var$WELL_KNOWN_PATH, "/").concat($18efa9aae1340857$var$OPENID_CONFIGURATION);
        var requestorToUse = requestor || new $cZQm7.JQueryRequestor();
        return requestorToUse.xhr({
            url: fullUrl,
            dataType: "json",
            method: "GET"
        }).then(function(json) {
            return new AuthorizationServiceConfiguration(json);
        });
    };
    return AuthorizationServiceConfiguration;
}();
module.exports.AuthorizationServiceConfiguration = $18efa9aae1340857$var$AuthorizationServiceConfiguration;

});
parcelRegister("cZQm7", function(module, exports) {
"use strict";
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9763cb4bafc7c1ab$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TestRequestor = module.exports.FetchRequestor = module.exports.JQueryRequestor = module.exports.Requestor = void 0;

var $229yo = parcelRequire("229yo");
/**
 * An class that abstracts away the ability to make an XMLHttpRequest.
 */ var $9763cb4bafc7c1ab$var$Requestor = /** @class */ function() {
    function Requestor() {}
    return Requestor;
}();
module.exports.Requestor = $9763cb4bafc7c1ab$var$Requestor;
/**
 * Uses $.ajax to makes the Ajax requests.
 */ var $9763cb4bafc7c1ab$var$JQueryRequestor = /** @class */ function(_super) {
    $9763cb4bafc7c1ab$var$__extends(JQueryRequestor, _super);
    function JQueryRequestor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    JQueryRequestor.prototype.xhr = function(settings) {
        // NOTE: using jquery to make XHR's as whatwg-fetch requires
        // that I target ES6.
        var xhr = $.ajax(settings);
        return new Promise(function(resolve, reject) {
            xhr.then(function(data, textStatus, jqXhr) {
                resolve(data);
            }, function(jqXhr, textStatus, error) {
                reject(new $229yo.AppAuthError(error));
            });
        });
    };
    return JQueryRequestor;
}($9763cb4bafc7c1ab$var$Requestor);
module.exports.JQueryRequestor = $9763cb4bafc7c1ab$var$JQueryRequestor;
/**
 * Uses fetch API to make Ajax requests
 */ var $9763cb4bafc7c1ab$var$FetchRequestor = /** @class */ function(_super) {
    $9763cb4bafc7c1ab$var$__extends(FetchRequestor, _super);
    function FetchRequestor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FetchRequestor.prototype.xhr = function(settings) {
        if (!settings.url) return Promise.reject(new $229yo.AppAuthError("A URL must be provided."));
        var url = new URL(settings.url);
        var requestInit = {};
        requestInit.method = settings.method;
        requestInit.mode = "cors";
        if (settings.data) {
            if (settings.method && settings.method.toUpperCase() === "POST") requestInit.body = settings.data;
            else {
                var searchParams = new URLSearchParams(settings.data);
                searchParams.forEach(function(value, key) {
                    url.searchParams.append(key, value);
                });
            }
        }
        // Set the request headers
        requestInit.headers = {};
        if (settings.headers) {
            for(var i in settings.headers)if (settings.headers.hasOwnProperty(i)) requestInit.headers[i] = settings.headers[i];
        }
        var isJsonDataType = settings.dataType && settings.dataType.toLowerCase() === "json";
        // Set 'Accept' header value for json requests (Taken from
        // https://github.com/jquery/jquery/blob/e0d941156900a6bff7c098c8ea7290528e468cf8/src/ajax.js#L644
        // )
        if (isJsonDataType) requestInit.headers["Accept"] = "application/json, text/javascript, */*; q=0.01";
        return fetch(url.toString(), requestInit).then(function(response) {
            if (response.status >= 200 && response.status < 300) {
                var contentType = response.headers.get("content-type");
                if (isJsonDataType || contentType && contentType.indexOf("application/json") !== -1) return response.json();
                else return response.text();
            } else return Promise.reject(new $229yo.AppAuthError(response.status.toString(), response.statusText));
        });
    };
    return FetchRequestor;
}($9763cb4bafc7c1ab$var$Requestor);
module.exports.FetchRequestor = $9763cb4bafc7c1ab$var$FetchRequestor;
/**
 * Should be used only in the context of testing. Just uses the underlying
 * Promise to mock the behavior of the Requestor.
 */ var $9763cb4bafc7c1ab$var$TestRequestor = /** @class */ function(_super) {
    $9763cb4bafc7c1ab$var$__extends(TestRequestor, _super);
    function TestRequestor(promise) {
        var _this = _super.call(this) || this;
        _this.promise = promise;
        return _this;
    }
    TestRequestor.prototype.xhr = function(settings) {
        return this.promise; // unsafe cast
    };
    return TestRequestor;
}($9763cb4bafc7c1ab$var$Requestor);
module.exports.TestRequestor = $9763cb4bafc7c1ab$var$TestRequestor;

});


parcelRegister("8seOQ", function(module, exports) {
"use strict";
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BasicQueryStringUtils = void 0;
var $627c6f008191b17e$var$BasicQueryStringUtils = /** @class */ function() {
    function BasicQueryStringUtils() {}
    BasicQueryStringUtils.prototype.parse = function(input, useHash) {
        if (useHash) return this.parseQueryString(input.hash);
        else return this.parseQueryString(input.search);
    };
    BasicQueryStringUtils.prototype.parseQueryString = function(query) {
        var result = {};
        // if anything starts with ?, # or & remove it
        query = query.trim().replace(/^(\?|#|&)/, "");
        var params = query.split("&");
        for(var i = 0; i < params.length; i += 1){
            var param = params[i]; // looks something like a=b
            var parts = param.split("=");
            if (parts.length >= 2) {
                var key = decodeURIComponent(parts.shift());
                var value = parts.length > 0 ? parts.join("=") : null;
                if (value) result[key] = decodeURIComponent(value);
            }
        }
        return result;
    };
    BasicQueryStringUtils.prototype.stringify = function(input) {
        var encoded = [];
        for(var key in input)if (input.hasOwnProperty(key) && input[key]) encoded.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(input[key])));
        return encoded.join("&");
    };
    return BasicQueryStringUtils;
}();
module.exports.BasicQueryStringUtils = $627c6f008191b17e$var$BasicQueryStringUtils;

});

parcelRegister("jxSlf", function(module, exports) {
"use strict";
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $e3ab40830bf4e3a0$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RedirectRequestHandler = void 0;

var $gCWjV = parcelRequire("gCWjV");

var $aJrNS = parcelRequire("aJrNS");

var $2ZGFJ = parcelRequire("2ZGFJ");

var $72afL = parcelRequire("72afL");

var $YQWls = parcelRequire("YQWls");

var $8seOQ = parcelRequire("8seOQ");

var $9AiGw = parcelRequire("9AiGw");
/** key for authorization request. */ var $e3ab40830bf4e3a0$var$authorizationRequestKey = function(handle) {
    return "".concat(handle, "_appauth_authorization_request");
};
/** key for authorization service configuration */ var $e3ab40830bf4e3a0$var$authorizationServiceConfigurationKey = function(handle) {
    return "".concat(handle, "_appauth_authorization_service_configuration");
};
/** key in local storage which represents the current authorization request. */ var $e3ab40830bf4e3a0$var$AUTHORIZATION_REQUEST_HANDLE_KEY = "appauth_current_authorization_request";
/**
 * Represents an AuthorizationRequestHandler which uses a standard
 * redirect based code flow.
 */ var $e3ab40830bf4e3a0$var$RedirectRequestHandler = /** @class */ function(_super) {
    $e3ab40830bf4e3a0$var$__extends(RedirectRequestHandler, _super);
    function RedirectRequestHandler(// use the provided storage backend
    // or initialize local storage with the default storage backend which
    // uses window.localStorage
    storageBackend, utils, locationLike, crypto) {
        if (storageBackend === void 0) storageBackend = new $9AiGw.LocalStorageBackend();
        if (utils === void 0) utils = new $8seOQ.BasicQueryStringUtils();
        if (locationLike === void 0) locationLike = window.location;
        if (crypto === void 0) crypto = new $72afL.DefaultCrypto();
        var _this = _super.call(this, utils, crypto) || this;
        _this.storageBackend = storageBackend;
        _this.locationLike = locationLike;
        return _this;
    }
    RedirectRequestHandler.prototype.performAuthorizationRequest = function(configuration, request) {
        var _this = this;
        var handle = this.crypto.generateRandom(10);
        // before you make request, persist all request related data in local storage.
        var persisted = Promise.all([
            this.storageBackend.setItem($e3ab40830bf4e3a0$var$AUTHORIZATION_REQUEST_HANDLE_KEY, handle),
            // Calling toJson() adds in the code & challenge when possible
            request.toJson().then(function(result) {
                return _this.storageBackend.setItem($e3ab40830bf4e3a0$var$authorizationRequestKey(handle), JSON.stringify(result));
            }),
            this.storageBackend.setItem($e3ab40830bf4e3a0$var$authorizationServiceConfigurationKey(handle), JSON.stringify(configuration.toJson()))
        ]);
        persisted.then(function() {
            // make the redirect request
            var url = _this.buildRequestUrl(configuration, request);
            (0, $YQWls.log)("Making a request to ", request, url);
            _this.locationLike.assign(url);
        });
    };
    /**
     * Attempts to introspect the contents of storage backend and completes the
     * request.
     */ RedirectRequestHandler.prototype.completeAuthorizationRequest = function() {
        var _this = this;
        // TODO(rahulrav@): handle authorization errors.
        return this.storageBackend.getItem($e3ab40830bf4e3a0$var$AUTHORIZATION_REQUEST_HANDLE_KEY).then(function(handle) {
            if (handle) // we have a pending request.
            // fetch authorization request, and check state
            return _this.storageBackend.getItem($e3ab40830bf4e3a0$var$authorizationRequestKey(handle))// requires a corresponding instance of result
            // TODO(rahulrav@): check for inconsitent state here
            .then(function(result) {
                return JSON.parse(result);
            }).then(function(json) {
                return new $gCWjV.AuthorizationRequest(json);
            }).then(function(request) {
                // check redirect_uri and state
                var currentUri = "".concat(_this.locationLike.origin).concat(_this.locationLike.pathname);
                var queryParams = _this.utils.parse(_this.locationLike, true);
                var state = queryParams["state"];
                var code = queryParams["code"];
                var error = queryParams["error"];
                (0, $YQWls.log)("Potential authorization request ", currentUri, queryParams, state, code, error);
                var shouldNotify = state === request.state;
                var authorizationResponse = null;
                var authorizationError = null;
                if (shouldNotify) {
                    if (error) {
                        // get additional optional info.
                        var errorUri = queryParams["error_uri"];
                        var errorDescription = queryParams["error_description"];
                        authorizationError = new $2ZGFJ.AuthorizationError({
                            error: error,
                            error_description: errorDescription,
                            error_uri: errorUri,
                            state: state
                        });
                    } else authorizationResponse = new $2ZGFJ.AuthorizationResponse({
                        code: code,
                        state: state
                    });
                    // cleanup state
                    return Promise.all([
                        _this.storageBackend.removeItem($e3ab40830bf4e3a0$var$AUTHORIZATION_REQUEST_HANDLE_KEY),
                        _this.storageBackend.removeItem($e3ab40830bf4e3a0$var$authorizationRequestKey(handle)),
                        _this.storageBackend.removeItem($e3ab40830bf4e3a0$var$authorizationServiceConfigurationKey(handle))
                    ]).then(function() {
                        (0, $YQWls.log)("Delivering authorization response");
                        return {
                            request: request,
                            response: authorizationResponse,
                            error: authorizationError
                        };
                    });
                } else {
                    (0, $YQWls.log)("Mismatched request (state and request_uri) dont match.");
                    return Promise.resolve(null);
                }
            });
            else return null;
        });
    };
    return RedirectRequestHandler;
}($aJrNS.AuthorizationRequestHandler);
module.exports.RedirectRequestHandler = $e3ab40830bf4e3a0$var$RedirectRequestHandler;

});
parcelRegister("9AiGw", function(module, exports) {
"use strict";
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6fa5f84b849b99a9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LocalStorageBackend = module.exports.StorageBackend = void 0;
/**
 * Asynchronous storage APIs. All methods return a `Promise`.
 * All methods take the `DOMString`
 * IDL type (as it is the lowest common denominator).
 */ var $6fa5f84b849b99a9$var$StorageBackend = /** @class */ function() {
    function StorageBackend() {}
    return StorageBackend;
}();
module.exports.StorageBackend = $6fa5f84b849b99a9$var$StorageBackend;
/**
 * A `StorageBackend` backed by `localstorage`.
 */ var $6fa5f84b849b99a9$var$LocalStorageBackend = /** @class */ function(_super) {
    $6fa5f84b849b99a9$var$__extends(LocalStorageBackend, _super);
    function LocalStorageBackend(storage) {
        var _this = _super.call(this) || this;
        _this.storage = storage || window.localStorage;
        return _this;
    }
    LocalStorageBackend.prototype.getItem = function(name) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var value = _this.storage.getItem(name);
            if (value) resolve(value);
            else resolve(null);
        });
    };
    LocalStorageBackend.prototype.removeItem = function(name) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            _this.storage.removeItem(name);
            resolve();
        });
    };
    LocalStorageBackend.prototype.clear = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            _this.storage.clear();
            resolve();
        });
    };
    LocalStorageBackend.prototype.setItem = function(name, value) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            _this.storage.setItem(name, value);
            resolve();
        });
    };
    return LocalStorageBackend;
}($6fa5f84b849b99a9$var$StorageBackend);
module.exports.LocalStorageBackend = $6fa5f84b849b99a9$var$LocalStorageBackend;

});


parcelRegister("4F33G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RevokeTokenRequest = void 0;
/**
 * Represents a revoke token request.
 * For more information look at:
 * https://tools.ietf.org/html/rfc7009#section-2.1
 */ var $364d5d151457c49b$var$RevokeTokenRequest = /** @class */ function() {
    function RevokeTokenRequest(request) {
        this.token = request.token;
        this.tokenTypeHint = request.token_type_hint;
        this.clientId = request.client_id;
        this.clientSecret = request.client_secret;
    }
    /**
     * Serializes a TokenRequest to a JavaScript object.
     */ RevokeTokenRequest.prototype.toJson = function() {
        var json = {
            token: this.token
        };
        if (this.tokenTypeHint) json["token_type_hint"] = this.tokenTypeHint;
        if (this.clientId) json["client_id"] = this.clientId;
        if (this.clientSecret) json["client_secret"] = this.clientSecret;
        return json;
    };
    RevokeTokenRequest.prototype.toStringMap = function() {
        var json = this.toJson();
        // :(
        return json;
    };
    return RevokeTokenRequest;
}();
module.exports.RevokeTokenRequest = $364d5d151457c49b$var$RevokeTokenRequest;

});

parcelRegister("ah4qu", function(module, exports) {
"use strict";
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenRequest = module.exports.GRANT_TYPE_REFRESH_TOKEN = module.exports.GRANT_TYPE_AUTHORIZATION_CODE = void 0;
module.exports.GRANT_TYPE_AUTHORIZATION_CODE = "authorization_code";
module.exports.GRANT_TYPE_REFRESH_TOKEN = "refresh_token";
/**
 * Represents an Access Token request.
 * For more information look at:
 * https://tools.ietf.org/html/rfc6749#section-4.1.3
 */ var $77aeecdbba61ec1b$var$TokenRequest = /** @class */ function() {
    function TokenRequest(request) {
        this.clientId = request.client_id;
        this.redirectUri = request.redirect_uri;
        this.grantType = request.grant_type;
        this.code = request.code;
        this.refreshToken = request.refresh_token;
        this.extras = request.extras;
    }
    /**
     * Serializes a TokenRequest to a JavaScript object.
     */ TokenRequest.prototype.toJson = function() {
        return {
            grant_type: this.grantType,
            code: this.code,
            refresh_token: this.refreshToken,
            redirect_uri: this.redirectUri,
            client_id: this.clientId,
            extras: this.extras
        };
    };
    TokenRequest.prototype.toStringMap = function() {
        var map = {
            grant_type: this.grantType,
            client_id: this.clientId,
            redirect_uri: this.redirectUri
        };
        if (this.code) map["code"] = this.code;
        if (this.refreshToken) map["refresh_token"] = this.refreshToken;
        // copy over extras
        if (this.extras) {
            for(var extra in this.extras)if (this.extras.hasOwnProperty(extra) && !map.hasOwnProperty(extra)) // check before inserting to requestMap
            map[extra] = this.extras[extra];
        }
        return map;
    };
    return TokenRequest;
}();
module.exports.TokenRequest = $77aeecdbba61ec1b$var$TokenRequest;

});

parcelRegister("9cKgj", function(module, exports) {
"use strict";
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseTokenRequestHandler = void 0;

var $229yo = parcelRequire("229yo");

var $8seOQ = parcelRequire("8seOQ");

var $2akUG = parcelRequire("2akUG");

var $cZQm7 = parcelRequire("cZQm7");
/**
 * The default token request handler.
 */ var $6b391ebd7424bc5d$var$BaseTokenRequestHandler = /** @class */ function() {
    function BaseTokenRequestHandler(requestor, utils) {
        if (requestor === void 0) requestor = new $cZQm7.JQueryRequestor();
        if (utils === void 0) utils = new $8seOQ.BasicQueryStringUtils();
        this.requestor = requestor;
        this.utils = utils;
    }
    BaseTokenRequestHandler.prototype.isTokenResponse = function(response) {
        return response.error === undefined;
    };
    BaseTokenRequestHandler.prototype.performRevokeTokenRequest = function(configuration, request) {
        var revokeTokenResponse = this.requestor.xhr({
            url: configuration.revocationEndpoint,
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            data: this.utils.stringify(request.toStringMap())
        });
        return revokeTokenResponse.then(function(response) {
            return true;
        });
    };
    BaseTokenRequestHandler.prototype.performTokenRequest = function(configuration, request) {
        var _this = this;
        var tokenResponse = this.requestor.xhr({
            url: configuration.tokenEndpoint,
            method: "POST",
            dataType: "json",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            data: this.utils.stringify(request.toStringMap())
        });
        return tokenResponse.then(function(response) {
            if (_this.isTokenResponse(response)) return new $2akUG.TokenResponse(response);
            else return Promise.reject(new $229yo.AppAuthError(response.error, new $2akUG.TokenError(response)));
        });
    };
    return BaseTokenRequestHandler;
}();
module.exports.BaseTokenRequestHandler = $6b391ebd7424bc5d$var$BaseTokenRequestHandler;

});
parcelRegister("2akUG", function(module, exports) {
"use strict";
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TokenError = module.exports.TokenResponse = module.exports.nowInSeconds = void 0;
// constants
var $193cbce68b5942e5$var$AUTH_EXPIRY_BUFFER = -600; // 10 mins in seconds
/**
 * Returns the instant of time in seconds.
 */ var $193cbce68b5942e5$var$nowInSeconds = function() {
    return Math.round(new Date().getTime() / 1000);
};
module.exports.nowInSeconds = $193cbce68b5942e5$var$nowInSeconds;
/**
 * Represents the Token Response type.
 * For more information look at:
 * https://tools.ietf.org/html/rfc6749#section-5.1
 */ var $193cbce68b5942e5$var$TokenResponse = /** @class */ function() {
    function TokenResponse(response) {
        this.accessToken = response.access_token;
        this.tokenType = response.token_type || "bearer";
        if (response.expires_in) this.expiresIn = parseInt(response.expires_in, 10);
        this.refreshToken = response.refresh_token;
        this.scope = response.scope;
        this.idToken = response.id_token;
        this.issuedAt = response.issued_at || (0, module.exports.nowInSeconds)();
    }
    TokenResponse.prototype.toJson = function() {
        var _a;
        return {
            access_token: this.accessToken,
            id_token: this.idToken,
            refresh_token: this.refreshToken,
            scope: this.scope,
            token_type: this.tokenType,
            issued_at: this.issuedAt,
            expires_in: (_a = this.expiresIn) === null || _a === void 0 ? void 0 : _a.toString()
        };
    };
    TokenResponse.prototype.isValid = function(buffer) {
        if (buffer === void 0) buffer = $193cbce68b5942e5$var$AUTH_EXPIRY_BUFFER;
        if (this.expiresIn) {
            var now = (0, module.exports.nowInSeconds)();
            return now < this.issuedAt + this.expiresIn + buffer;
        } else return true;
    };
    return TokenResponse;
}();
module.exports.TokenResponse = $193cbce68b5942e5$var$TokenResponse;
/**
 * Represents the Token Error type.
 * For more information look at:
 * https://tools.ietf.org/html/rfc6749#section-5.2
 */ var $193cbce68b5942e5$var$TokenError = /** @class */ function() {
    function TokenError(tokenError) {
        this.error = tokenError.error;
        this.errorDescription = tokenError.error_description;
        this.errorUri = tokenError.error_uri;
    }
    TokenError.prototype.toJson = function() {
        return {
            error: this.error,
            error_description: this.errorDescription,
            error_uri: this.errorUri
        };
    };
    return TokenError;
}();
module.exports.TokenError = $193cbce68b5942e5$var$TokenError;

});


parcelRegister("lksdl", function(module, exports) {
"use strict";
/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("aLSdY", function(module, exports) {

$parcel$export(module.exports, "USER_LOGIN_REQUEST_REQUEST", () => $bbfc4b5e4f9b1a8e$export$c8e87f40f6deb51e);
$parcel$export(module.exports, "USER_LOGIN_REQUEST_SUCCESS", () => $bbfc4b5e4f9b1a8e$export$7551f38c2b86237f);
$parcel$export(module.exports, "USER_LOGIN_REQUEST_FAILURE", () => $bbfc4b5e4f9b1a8e$export$7a8286f827735f96);
$parcel$export(module.exports, "USER_LOGOUT_REQUEST_REQUEST", () => $bbfc4b5e4f9b1a8e$export$2fcc2ea42d62bcf6);
$parcel$export(module.exports, "USER_LOGOUT_REQUEST_SUCCESS", () => $bbfc4b5e4f9b1a8e$export$417464d35e63e318);
$parcel$export(module.exports, "USER_LOGOUT_REQUEST_FAILURE", () => $bbfc4b5e4f9b1a8e$export$5d44e35ff7095a7c);
$parcel$export(module.exports, "USER_LOGIN_CHECK_REQUEST", () => $bbfc4b5e4f9b1a8e$export$81f619c3d4b38b35);
$parcel$export(module.exports, "USER_LOGIN_CHECK_SUCCESS", () => $bbfc4b5e4f9b1a8e$export$6fe6322315ae75f);
$parcel$export(module.exports, "USER_LOGIN_CHECK_FAILURE", () => $bbfc4b5e4f9b1a8e$export$aa046a8feace07d4);
$parcel$export(module.exports, "REFRESH_ACCESS_TOKEN_REQUEST", () => $bbfc4b5e4f9b1a8e$export$1b4948e8d44a9f5f);
$parcel$export(module.exports, "REFRESH_ACCESS_TOKEN_SUCCESS", () => $bbfc4b5e4f9b1a8e$export$cf3976caaac7200b);
$parcel$export(module.exports, "REFRESH_ACCESS_TOKEN_FAILURE", () => $bbfc4b5e4f9b1a8e$export$50491979130e20b);
$parcel$export(module.exports, "USER_LOGIN_INFO_REQUEST_SUCCESS", () => $bbfc4b5e4f9b1a8e$export$6c94d46db42e0924);
$parcel$export(module.exports, "USER_LOGIN_INFO_REQUEST_FAILURE", () => $bbfc4b5e4f9b1a8e$export$6ff07876a7a9e104);
$parcel$export(module.exports, "userLoginRequest", () => $bbfc4b5e4f9b1a8e$export$a87cc9961e568037);
$parcel$export(module.exports, "userLogoutRequest", () => $bbfc4b5e4f9b1a8e$export$c09bf3232b6d9fe);
$parcel$export(module.exports, "userLoginCheck", () => $bbfc4b5e4f9b1a8e$export$1b2f7bc690cbbf77);
$parcel$export(module.exports, "refreshAccessToken", () => $bbfc4b5e4f9b1a8e$export$f8f36faf9a051362);
const $bbfc4b5e4f9b1a8e$export$c8e87f40f6deb51e = "USER_LOGIN_REQUEST_REQUEST";
const $bbfc4b5e4f9b1a8e$export$7551f38c2b86237f = "USER_LOGIN_REQUEST_SUCCESS";
const $bbfc4b5e4f9b1a8e$export$7a8286f827735f96 = "USER_LOGIN_REQUEST_FAILURE";
const $bbfc4b5e4f9b1a8e$export$2fcc2ea42d62bcf6 = "USER_LOGOUT_REQUEST_REQUEST";
const $bbfc4b5e4f9b1a8e$export$417464d35e63e318 = "USER_LOGOUT_REQUEST_SUCCESS";
const $bbfc4b5e4f9b1a8e$export$5d44e35ff7095a7c = "USER_LOGOUT_REQUEST_FAILURE";
const $bbfc4b5e4f9b1a8e$export$81f619c3d4b38b35 = "USER_LOGIN_CHECK_REQUEST";
const $bbfc4b5e4f9b1a8e$export$6fe6322315ae75f = "USER_LOGIN_CHECK_SUCCESS";
const $bbfc4b5e4f9b1a8e$export$aa046a8feace07d4 = "USER_LOGIN_CHECK_FAILURE";
const $bbfc4b5e4f9b1a8e$export$1b4948e8d44a9f5f = "REFRESH_ACCESS_TOKEN_REQUEST";
const $bbfc4b5e4f9b1a8e$export$cf3976caaac7200b = "REFRESH_ACCESS_TOKEN_SUCCESS";
const $bbfc4b5e4f9b1a8e$export$50491979130e20b = "REFRESH_ACCESS_TOKEN_FAILURE";
const $bbfc4b5e4f9b1a8e$export$90875d55f02b5623 = "USER_LOGIN_INFO_REQUEST";
const $bbfc4b5e4f9b1a8e$export$6c94d46db42e0924 = "USER_LOGIN_INFO_REQUEST_SUCCESS";
const $bbfc4b5e4f9b1a8e$export$6ff07876a7a9e104 = "USER_LOGIN_INFO_REQUEST_FAILURE";
function $bbfc4b5e4f9b1a8e$export$a87cc9961e568037() {
    return {
        type: $bbfc4b5e4f9b1a8e$export$c8e87f40f6deb51e
    };
}
function $bbfc4b5e4f9b1a8e$export$c09bf3232b6d9fe() {
    return {
        type: $bbfc4b5e4f9b1a8e$export$2fcc2ea42d62bcf6
    };
}
function $bbfc4b5e4f9b1a8e$export$1b2f7bc690cbbf77() {
    return {
        type: $bbfc4b5e4f9b1a8e$export$81f619c3d4b38b35
    };
}
function $bbfc4b5e4f9b1a8e$export$f8f36faf9a051362() {
    return {
        type: $bbfc4b5e4f9b1a8e$export$1b4948e8d44a9f5f
    };
}

});

parcelRegister("2m6N8", function(module, exports) {

$parcel$export(module.exports, "fetchWithCredentials", () => $d57529a8dad16627$export$af596b2cad891c55);

var $jxJwM = parcelRequire("jxJwM");
async function $d57529a8dad16627$export$af596b2cad891c55(idToken, url, init = {}) {
    const params = {
        ...init,
        credentials: "include",
        headers: {
            ...init.headers,
            Authorization: `Bearer ${idToken}`
        }
    };
    const res = await fetch(url, params);
    // Le corps d'une réponse en erreur peut porter un message métier
    // (cf. HandleConflict côté serveur). On le lit sur un clone pour ne pas
    // consommer le flux : l'appelant fait son propre res.json(). Sans cela,
    // l'erreur était levée ici, avant que quiconque ait pu lire le message.
    let result;
    if (!res.ok) try {
        result = await res.clone().json();
    } catch  {
    // Corps absent ou non-JSON : on s'en tient au statut HTTP.
    }
    (0, $jxJwM.assertResponse)(res, result);
    return res;
}

});
parcelRegister("jxJwM", function(module, exports) {

$parcel$export(module.exports, "assertResponse", () => $f38c536f5c2a03c0$export$e9ab0335f56f7771);

var $bVoO3 = parcelRequire("bVoO3");
function $f38c536f5c2a03c0$export$e9ab0335f56f7771(res, result) {
    switch(res.status){
        case 400:
            // Le serveur peut joindre un message métier dans data.message (cf. route
            // HandleConflict). On préfère alors InvalidRequestWithMessageError qui
            // expose getUserMessage() dédié.
            if (result?.error?.data?.message) throw new (0, $bVoO3.InvalidRequestWithMessageError)(result);
            throw new (0, $bVoO3.InvalidRequestError)(result);
        case 401:
            throw new (0, $bVoO3.UnauthorizedRequestError)(res);
        case 404:
            throw new (0, $bVoO3.NotFoundRequestError)(res);
        case 403:
            throw new (0, $bVoO3.ForbiddenRequestError)(res);
    }
    if (res.status >= 500) throw new (0, $bVoO3.ServerError)(res);
}

});
parcelRegister("bVoO3", function(module, exports) {

$parcel$export(module.exports, "InvalidRequestError", () => $b97a41ce2083f4c7$export$2adbfa76b71ba748);
$parcel$export(module.exports, "NotFoundRequestError", () => $b97a41ce2083f4c7$export$8e2f7b7db21a17b);
$parcel$export(module.exports, "UnauthorizedRequestError", () => $b97a41ce2083f4c7$export$ac2513ff47a88869);
$parcel$export(module.exports, "FailedTokenRefreshError", () => $b97a41ce2083f4c7$export$5b121381d02fa40e);
$parcel$export(module.exports, "ForbiddenRequestError", () => $b97a41ce2083f4c7$export$352632e37f2f15b8);
$parcel$export(module.exports, "ServerError", () => $b97a41ce2083f4c7$export$ea52035eac03daf0);
$parcel$export(module.exports, "InvalidRequestWithMessageError", () => $b97a41ce2083f4c7$export$1c44caf8c57d9993);
class $b97a41ce2083f4c7$export$af7e1a58631a7dcb extends Error {
    constructor(message){
        super(message);
        Object.setPrototypeOf(this, $b97a41ce2083f4c7$export$af7e1a58631a7dcb.prototype);
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}
class $b97a41ce2083f4c7$export$2adbfa76b71ba748 extends $b97a41ce2083f4c7$export$af7e1a58631a7dcb {
    constructor(response){
        super("Invalid request");
        Object.setPrototypeOf(this, $b97a41ce2083f4c7$export$2adbfa76b71ba748.prototype);
        this.response = response;
    }
    getResponse() {
        return this.response;
    }
    getUserMessage() {
        return `Le serveur a indiqu\xe9 que la requ\xeate \xe9tait invalide !`;
    }
}
class $b97a41ce2083f4c7$export$8e2f7b7db21a17b extends $b97a41ce2083f4c7$export$af7e1a58631a7dcb {
    constructor(response){
        super("Not found");
        Object.setPrototypeOf(this, $b97a41ce2083f4c7$export$8e2f7b7db21a17b.prototype);
        this.response = response;
    }
    getResponse() {
        return this.response;
    }
    getUserMessage() {
        return `Le serveur a indiqu\xe9 que la ressource n'avait pas pu \xeatre trouv\xe9e !`;
    }
}
class $b97a41ce2083f4c7$export$ac2513ff47a88869 extends $b97a41ce2083f4c7$export$af7e1a58631a7dcb {
    constructor(response){
        super("Unauthorized request");
        Object.setPrototypeOf(this, $b97a41ce2083f4c7$export$ac2513ff47a88869.prototype);
        this.response = response;
    }
    getResponse() {
        return this.response;
    }
    getUserMessage() {
        return `Le serveur a indiqu\xe9 que l'utilisateur n'\xe9tait pas authentifi\xe9 !`;
    }
}
class $b97a41ce2083f4c7$export$5b121381d02fa40e extends $b97a41ce2083f4c7$export$af7e1a58631a7dcb {
    constructor(){
        super("Token refresh failed");
        Object.setPrototypeOf(this, $b97a41ce2083f4c7$export$5b121381d02fa40e.prototype);
    }
    getUserMessage() {
        return `Le renouvellement du jeton d'authentification a \xe9chou\xe9 !`;
    }
}
class $b97a41ce2083f4c7$export$352632e37f2f15b8 extends $b97a41ce2083f4c7$export$af7e1a58631a7dcb {
    constructor(response){
        super("Forbidden request");
        Object.setPrototypeOf(this, $b97a41ce2083f4c7$export$352632e37f2f15b8.prototype);
        this.response = response;
    }
    getResponse() {
        return this.response;
    }
    getUserMessage() {
        return `Le serveur a indiqu\xe9 que l'op\xe9ration \xe9tait interdite \xe0 l'utilisateur !`;
    }
}
class $b97a41ce2083f4c7$export$ea52035eac03daf0 extends $b97a41ce2083f4c7$export$af7e1a58631a7dcb {
    constructor(response){
        super(`Server Error: ${response.status} - ${response.statusText}`);
        Object.setPrototypeOf(this, $b97a41ce2083f4c7$export$ea52035eac03daf0.prototype);
        this.response = response;
    }
    getResponse() {
        return this.response;
    }
    getUserMessage() {
        return `Une erreur est survenue lors de l'interrogation du serveur ! (${this.response.status} - ${this.response.statusText})`;
    }
}
class $b97a41ce2083f4c7$export$1c44caf8c57d9993 extends $b97a41ce2083f4c7$export$af7e1a58631a7dcb {
    constructor(response){
        super("Invalid request with message");
        Object.setPrototypeOf(this, $b97a41ce2083f4c7$export$1c44caf8c57d9993.prototype);
        this.response = response;
    }
    getResponse() {
        return this.response;
    }
    getMessage() {
        const msg = this.response?.error?.data?.message;
        return typeof msg === "string" && msg.length > 0 ? msg : null;
    }
    getUserMessage() {
        return this.getMessage() ?? `Le serveur a indiqu\xe9 que la requ\xeate \xe9tait invalide !`;
    }
}

});



parcelRegister("5Jfnn", function(module, exports) {

$parcel$export(module.exports, "ADD_NOTIFICATION", () => $2a9693b6e5125c18$export$20799cff59e85f52);
$parcel$export(module.exports, "REMOVE_NOTIFICATION", () => $2a9693b6e5125c18$export$378adf661eb575f4);
$parcel$export(module.exports, "addNotification", () => $2a9693b6e5125c18$export$c7def531c087da85);
$parcel$export(module.exports, "removeNotification", () => $2a9693b6e5125c18$export$92eb0ea44f8c9242);
const $2a9693b6e5125c18$export$20799cff59e85f52 = "ADD_NOTIFICATION";
const $2a9693b6e5125c18$export$378adf661eb575f4 = "REMOVE_NOTIFICATION";
function $2a9693b6e5125c18$export$c7def531c087da85(notification) {
    return {
        type: $2a9693b6e5125c18$export$20799cff59e85f52,
        notification: notification
    };
}
const $2a9693b6e5125c18$export$92eb0ea44f8c9242 = (notificationId)=>({
        type: $2a9693b6e5125c18$export$378adf661eb575f4,
        notificationId: notificationId
    });

});

parcelRegister("dSjLu", function(module, exports) {

$parcel$export(module.exports, "NOTIFICATION_STATUS_SUCCESS", () => $3a836ce41b890951$export$9ea6c247cd980361);
$parcel$export(module.exports, "NOTIFICATION_STATUS_WARNING", () => $3a836ce41b890951$export$56c02480601c3f37);
$parcel$export(module.exports, "NOTIFICATION_STATUS_ERROR", () => $3a836ce41b890951$export$991b18529a56d5f3);
$parcel$export(module.exports, "NOTIFICATION_STATUS_INFO", () => $3a836ce41b890951$export$6ad3e25e6218515d);
$parcel$export(module.exports, "NotificationStatus", () => $3a836ce41b890951$export$ff1b23e7fbed6ad5);
$parcel$export(module.exports, "NotificationIcons", () => $3a836ce41b890951$export$6517fa4ac543284);

var $3xGt8 = parcelRequire("3xGt8");

var $jmLDw = parcelRequire("jmLDw");

var $bxx9u = parcelRequire("bxx9u");

var $kejYu = parcelRequire("kejYu");
const $3a836ce41b890951$export$9ea6c247cd980361 = "success";
const $3a836ce41b890951$export$56c02480601c3f37 = "warning";
const $3a836ce41b890951$export$991b18529a56d5f3 = "error";
const $3a836ce41b890951$export$6ad3e25e6218515d = "info";
const $3a836ce41b890951$export$ff1b23e7fbed6ad5 = {
    success: $3a836ce41b890951$export$9ea6c247cd980361,
    info: $3a836ce41b890951$export$6ad3e25e6218515d,
    warning: $3a836ce41b890951$export$56c02480601c3f37,
    error: $3a836ce41b890951$export$991b18529a56d5f3
};
const $3a836ce41b890951$export$6517fa4ac543284 = {
    success: (0, (/*@__PURE__*/$parcel$interopDefault($3xGt8))),
    warning: (0, (/*@__PURE__*/$parcel$interopDefault($jmLDw))),
    error: (0, (/*@__PURE__*/$parcel$interopDefault($bxx9u))),
    info: (0, (/*@__PURE__*/$parcel$interopDefault($kejYu)))
};

});
parcelRegister("3xGt8", function(module, exports) {
module.exports = new URL("success.2749c686.svg", import.meta.url).toString();

});

parcelRegister("jmLDw", function(module, exports) {
module.exports = new URL("warning.aa99ebdf.svg", import.meta.url).toString();

});

parcelRegister("bxx9u", function(module, exports) {
module.exports = new URL("error.6046a6ba.svg", import.meta.url).toString();

});

parcelRegister("kejYu", function(module, exports) {
module.exports = new URL("info.811fe966.svg", import.meta.url).toString();

});


parcelRegister("aAq0B", function(module, exports) {

$parcel$export(module.exports, "QUERY_OBJECTS_REQUEST", () => $60de5a698cb5ea83$export$1ff4a3fc2b906e99);
$parcel$export(module.exports, "QUERY_OBJECTS_SUCCESS", () => $60de5a698cb5ea83$export$98a2eee27f09bcb8);
$parcel$export(module.exports, "QUERY_OBJECTS_FAILURE", () => $60de5a698cb5ea83$export$3effe3e34cc11ea5);
$parcel$export(module.exports, "queryObjects", () => $60de5a698cb5ea83$export$6a3fc9d6e7c14c6f);
$parcel$export(module.exports, "FETCH_OBJECT_REQUEST", () => $60de5a698cb5ea83$export$1078583012728e5a);
$parcel$export(module.exports, "FETCH_OBJECT_SUCCESS", () => $60de5a698cb5ea83$export$ba8a74ea9178bd30);
$parcel$export(module.exports, "FETCH_OBJECT_FAILURE", () => $60de5a698cb5ea83$export$f5de1ccf558776ad);
$parcel$export(module.exports, "fetchObject", () => $60de5a698cb5ea83$export$4ed815e9384c6644);
$parcel$export(module.exports, "CREATE_OBJECT_REQUEST", () => $60de5a698cb5ea83$export$550be2ac501935ab);
$parcel$export(module.exports, "CREATE_OBJECT_SUCCESS", () => $60de5a698cb5ea83$export$21b228cb7abc606c);
$parcel$export(module.exports, "CREATE_OBJECT_FAILURE", () => $60de5a698cb5ea83$export$7c4feb8a792769b6);
$parcel$export(module.exports, "createObject", () => $60de5a698cb5ea83$export$79c7e160a7743efd);
$parcel$export(module.exports, "UPDATE_OBJECT_REQUEST", () => $60de5a698cb5ea83$export$4f45d5039ab0b46a);
$parcel$export(module.exports, "UPDATE_OBJECT_SUCCESS", () => $60de5a698cb5ea83$export$aa7d66b25db8c620);
$parcel$export(module.exports, "UPDATE_OBJECT_FAILURE", () => $60de5a698cb5ea83$export$c95a0fbeb7f7f63b);
$parcel$export(module.exports, "updateObject", () => $60de5a698cb5ea83$export$41b06075337cb84b);
$parcel$export(module.exports, "DELETE_OBJECT_REQUEST", () => $60de5a698cb5ea83$export$58a52b006966d4fb);
$parcel$export(module.exports, "DELETE_OBJECT_SUCCESS", () => $60de5a698cb5ea83$export$e20cb9ea8e1e410c);
$parcel$export(module.exports, "DELETE_OBJECT_FAILURE", () => $60de5a698cb5ea83$export$f369e5ffe7c24ceb);
$parcel$export(module.exports, "deleteObject", () => $60de5a698cb5ea83$export$39c5ed4ec960eade);
$parcel$export(module.exports, "FETCH_OBJECT_EVENT_SUCCESS", () => $60de5a698cb5ea83$export$7d5e2d7b9827fbee);
$parcel$export(module.exports, "FETCH_OBJECT_EVENT_FAILURE", () => $60de5a698cb5ea83$export$9b37574d8a1f4406);
const $60de5a698cb5ea83$export$1ff4a3fc2b906e99 = "QUERY_OBJECTS_REQUEST";
const $60de5a698cb5ea83$export$98a2eee27f09bcb8 = "QUERY_OBJECTS_SUCCESS";
const $60de5a698cb5ea83$export$3effe3e34cc11ea5 = "QUERY_OBJECTS_FAILURE";
function $60de5a698cb5ea83$export$6a3fc9d6e7c14c6f(namespace, privacyDomain, filter, options) {
    return {
        type: $60de5a698cb5ea83$export$1ff4a3fc2b906e99,
        namespace: namespace,
        privacyDomain: privacyDomain,
        filter: filter,
        options: options
    };
}
const $60de5a698cb5ea83$export$1078583012728e5a = "FETCH_OBJECT_REQUEST";
const $60de5a698cb5ea83$export$ba8a74ea9178bd30 = "FETCH_OBJECT_SUCCESS";
const $60de5a698cb5ea83$export$f5de1ccf558776ad = "FETCH_OBJECT_FAILURE";
function $60de5a698cb5ea83$export$4ed815e9384c6644(namespace, privacyDomain, id, options) {
    return {
        type: $60de5a698cb5ea83$export$1078583012728e5a,
        namespace: namespace,
        privacyDomain: privacyDomain,
        id: id,
        options: options
    };
}
const $60de5a698cb5ea83$export$550be2ac501935ab = "CREATE_OBJECT_REQUEST";
const $60de5a698cb5ea83$export$21b228cb7abc606c = "CREATE_OBJECT_SUCCESS";
const $60de5a698cb5ea83$export$7c4feb8a792769b6 = "CREATE_OBJECT_FAILURE";
function $60de5a698cb5ea83$export$79c7e160a7743efd(namespace, privacyDomain, object, options) {
    return {
        type: $60de5a698cb5ea83$export$550be2ac501935ab,
        namespace: namespace,
        privacyDomain: privacyDomain,
        object: object,
        options: options
    };
}
const $60de5a698cb5ea83$export$4f45d5039ab0b46a = "UPDATE_OBJECT_REQUEST";
const $60de5a698cb5ea83$export$aa7d66b25db8c620 = "UPDATE_OBJECT_SUCCESS";
const $60de5a698cb5ea83$export$c95a0fbeb7f7f63b = "UPDATE_OBJECT_FAILURE";
function $60de5a698cb5ea83$export$41b06075337cb84b(namespace, privacyDomain, id, object, partial = false, options) {
    return {
        type: $60de5a698cb5ea83$export$4f45d5039ab0b46a,
        namespace: namespace,
        privacyDomain: privacyDomain,
        id: id,
        object: object,
        partial: partial,
        options: options
    };
}
const $60de5a698cb5ea83$export$58a52b006966d4fb = "DELETE_OBJECT_REQUEST";
const $60de5a698cb5ea83$export$e20cb9ea8e1e410c = "DELETE_OBJECT_SUCCESS";
const $60de5a698cb5ea83$export$f369e5ffe7c24ceb = "DELETE_OBJECT_FAILURE";
function $60de5a698cb5ea83$export$39c5ed4ec960eade(namespace, privacyDomain, id, options) {
    return {
        type: $60de5a698cb5ea83$export$58a52b006966d4fb,
        namespace: namespace,
        privacyDomain: privacyDomain,
        id: id,
        options: options
    };
}
const $60de5a698cb5ea83$export$1007c57b7a512d58 = "FETCH_OBJECT_EVENT_REQUEST";
const $60de5a698cb5ea83$export$7d5e2d7b9827fbee = "FETCH_OBJECT_EVENT_SUCCESS";
const $60de5a698cb5ea83$export$9b37574d8a1f4406 = "FETCH_OBJECT_EVENT_FAILURE";
function $60de5a698cb5ea83$export$4ed79d78142bae96(namespace, privacyDomain, id, object, options) {
    return {
        type: $60de5a698cb5ea83$export$1007c57b7a512d58,
        namespace: namespace,
        privacyDomain: privacyDomain,
        id: id,
        object: object,
        options: options
    };
}

});

parcelRegister("dPdDj", function(module, exports) {

$parcel$export(module.exports, "PrivacyDomain", () => $3253bfb1615b8c39$export$3b77036965ea10b);
$parcel$export(module.exports, "ObjectServerClient", () => $3253bfb1615b8c39$export$bbb35560c6a153a1);

var $azn4s = parcelRequire("azn4s");

var $2m6N8 = parcelRequire("2m6N8");

var $jxJwM = parcelRequire("jxJwM");
var $3253bfb1615b8c39$export$3b77036965ea10b;
(function(PrivacyDomain) {
    PrivacyDomain["Public"] = "public";
    PrivacyDomain["Private"] = "private";
})($3253bfb1615b8c39$export$3b77036965ea10b || ($3253bfb1615b8c39$export$3b77036965ea10b = {}));
var $3253bfb1615b8c39$export$f7da5656c772f32a;
(function(AggregatorToken) {
    AggregatorToken["And"] = "and";
    AggregatorToken["Or"] = "or";
})($3253bfb1615b8c39$export$f7da5656c772f32a || ($3253bfb1615b8c39$export$f7da5656c772f32a = {}));
var $3253bfb1615b8c39$export$67c45245754b902c;
(function(FilterToken) {
    FilterToken["Eq"] = "eq";
    FilterToken["Neq"] = "neq";
    FilterToken["Gte"] = "gte";
    FilterToken["Gt"] = "gt";
    FilterToken["Lt"] = "lt";
    FilterToken["Lte"] = "lte";
    FilterToken["Like"] = "like";
    FilterToken["Exist"] = "exist";
})($3253bfb1615b8c39$export$67c45245754b902c || ($3253bfb1615b8c39$export$67c45245754b902c = {}));
class $3253bfb1615b8c39$export$bbb35560c6a153a1 {
    constructor(baseUrl, idToken){
        this.baseUrl = baseUrl;
        this.idToken = idToken;
        // Force bind methods to instance
        this.queryObjects = this.queryObjects.bind(this);
        this.fetchObject = this.fetchObject.bind(this);
        this.createObject = this.createObject.bind(this);
        this.updateObject = this.updateObject.bind(this);
        this.deleteObject = this.deleteObject.bind(this);
        this.fetchObjectEvents = this.fetchObjectEvents.bind(this);
    }
    async queryObjects(namespace, privacyDomain, filter, options, tenant) {
        let queryString = [];
        if (filter !== undefined) queryString.push(`filter=${encodeURIComponent(JSON.stringify(filter))}`);
        if (options !== undefined) {
            if (options.hydrate) queryString.push(`hydrate=${encodeURIComponent(true)}`);
            if (options.limit && options.limit > 0) queryString.push(`limit=${encodeURIComponent(options.limit)}`);
            if (options.offset && options.offset >= 0) queryString.push(`offset=${encodeURIComponent(options.offset)}`);
        }
        const url = `${this.baseUrl}/api/v1/${namespace}/${privacyDomain}?${queryString.join("&")}`;
        const headers = {};
        if (tenant) headers["X-Sheila-Tenant"] = tenant;
        const res = await (0, $2m6N8.fetchWithCredentials)(this.idToken, url, {
            headers: headers
        });
        const result = await res.json();
        return result.data.Objects.map((item)=>$3253bfb1615b8c39$var$itemToObject(item));
    }
    async fetchObject(namespace, privacyDomain, id, tenant) {
        const url = `${this.baseUrl}/api/v1/${namespace}/${privacyDomain}/${id}`;
        const headers = {};
        if (tenant) headers["X-Sheila-Tenant"] = tenant;
        const res = await (0, $2m6N8.fetchWithCredentials)(this.idToken, url, {
            headers: headers
        });
        const result = await res.json();
        (0, $jxJwM.assertResponse)(res);
        return $3253bfb1615b8c39$var$itemToObject(result.data.Object);
    }
    async createObject(namespace, privacyDomain, data, tenant) {
        const url = `${this.baseUrl}/api/v1/${namespace}/${privacyDomain}`;
        const headers = {};
        if (tenant) headers["X-Sheila-Tenant"] = tenant;
        const res = await (0, $2m6N8.fetchWithCredentials)(this.idToken, url, {
            method: "POST",
            body: JSON.stringify(data),
            headers: headers
        });
        const result = await res.json();
        (0, $jxJwM.assertResponse)(res, result);
        return $3253bfb1615b8c39$var$itemToObject(result.data.Object);
    }
    async updateObject(namespace, privacyDomain, id, data, partial = false, tenant) {
        const url = `${this.baseUrl}/api/v1/${namespace}/${privacyDomain}/${id}${partial ? "?partial=true" : ""}`;
        const headers = {};
        if (tenant) headers["X-Sheila-Tenant"] = tenant;
        const res = await (0, $2m6N8.fetchWithCredentials)(this.idToken, url, {
            method: "PUT",
            body: JSON.stringify(data),
            headers: headers
        });
        const result = await res.json();
        (0, $jxJwM.assertResponse)(res, result);
        return $3253bfb1615b8c39$var$itemToObject(result.data.Object);
    }
    async deleteObject(namespace, privacyDomain, id, tenant) {
        const url = `${this.baseUrl}/api/v1/${namespace}/${privacyDomain}/${id}`;
        const headers = {};
        if (tenant) headers["X-Sheila-Tenant"] = tenant;
        const res = await (0, $2m6N8.fetchWithCredentials)(this.idToken, url, {
            method: "DELETE",
            headers: headers
        });
        await res.text();
        (0, $jxJwM.assertResponse)(res);
    }
    async fetchObjectEvents(namespace, privacyDomain, id, tenant) {
        const url = `${this.baseUrl}/api/v1/${namespace}/${privacyDomain}/${id}/_events`;
        const headers = {};
        if (tenant) headers["X-Sheila-Tenant"] = tenant;
        const res = await (0, $2m6N8.fetchWithCredentials)(this.idToken, url, {
            headers: headers
        });
        const result = await res.json();
        (0, $jxJwM.assertResponse)(res, result);
        return result.data.Events;
    }
}
function $3253bfb1615b8c39$var$itemToObjectHeader(item) {
    return {
        id: item.ID,
        tenant: item.Tenant,
        createdAt: (0, $azn4s.asDate)(item.CreatedAt),
        updatedAt: (0, $azn4s.asDate)(item.UpdatedAt)
    };
}
function $3253bfb1615b8c39$var$itemToObject(item) {
    const obj = {
        ...$3253bfb1615b8c39$var$itemToObjectHeader(item)
    };
    if (item.Data) obj.data = item.Data;
    return obj;
}

});
parcelRegister("azn4s", function(module, exports) {

$parcel$export(module.exports, "asDate", () => $53207dfe4c21b3df$export$9f2ce0d73c62bfe5);
$parcel$export(module.exports, "DateFormat", () => $53207dfe4c21b3df$export$50a48c78a350e041);
$parcel$export(module.exports, "formatDate", () => $53207dfe4c21b3df$export$3ae94a2503e890a1);
$parcel$export(module.exports, "inlogToISODate", () => $53207dfe4c21b3df$export$228821fc298d797b);
$parcel$export(module.exports, "ISOtoInlogDate", () => $53207dfe4c21b3df$export$c371cfd4c174e8df);

var $bsVS2 = parcelRequire("bsVS2");
function $53207dfe4c21b3df$export$9f2ce0d73c62bfe5(d) {
    if (typeof d === "string") return new Date(d);
    if (d instanceof Date) return d;
    console.warn(`Unexpected date value '${JSON.stringify(d)}' !`);
    return new Date(0);
}
var $53207dfe4c21b3df$export$50a48c78a350e041;
(function(DateFormat) {
    DateFormat["TimeShort"] = "time-short";
    DateFormat["TimeLong"] = "time-long";
    DateFormat["DateShort"] = "date-short";
    DateFormat["DateLong"] = "date-long";
})($53207dfe4c21b3df$export$50a48c78a350e041 || ($53207dfe4c21b3df$export$50a48c78a350e041 = {}));
const $53207dfe4c21b3df$var$dateFormats = {
    ["time-short"]: Intl.DateTimeFormat(navigator.language, {
        month: "numeric",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
    }),
    ["time-long"]: Intl.DateTimeFormat(navigator.language, {
        weekday: "long",
        month: "numeric",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
    }),
    ["date-short"]: Intl.DateTimeFormat(navigator.language, {
        month: "numeric",
        day: "numeric",
        year: "numeric"
    }),
    ["date-long"]: new Intl.DateTimeFormat(navigator.language, {
        weekday: "long",
        month: "numeric",
        day: "numeric",
        year: "numeric"
    })
};
function $53207dfe4c21b3df$export$3ae94a2503e890a1(d, format = "date-short") {
    if (typeof d === "string") d = $53207dfe4c21b3df$export$9f2ce0d73c62bfe5(d);
    if (!$53207dfe4c21b3df$var$isValidDate(d)) return "";
    return $53207dfe4c21b3df$var$dateFormats[format].format(d);
}
function $53207dfe4c21b3df$var$isValidDate(d) {
    return d instanceof Date && !isNaN(d.getTime());
}
function $53207dfe4c21b3df$export$228821fc298d797b(d) {
    if ((0, $bsVS2.isNullish)(d)) return;
    const year = d?.substr(0, 4);
    const month = d?.substr(4, 2);
    const day = d?.substr(6, 2);
    const hours = d?.substr(8, 2);
    const minutes = d?.substr(10, 2);
    const seconds = d?.substr(12, 2);
    const iso = String(year) + "-" + String(month) + "-" + String(day) + "T" + String(hours) + ":" + String(minutes) + ":" + String(seconds);
    return new Date(iso);
}
function $53207dfe4c21b3df$export$c371cfd4c174e8df(d) {
    const myDate = typeof d === "string" ? new Date(d) : d;
    return String(myDate.getFullYear()) + "0" + String(myDate.getMonth() + 1).slice(-2) + "0" + String(myDate.getDate()).slice(-2) + "0" + String(myDate.getHours()) + "0" + String(myDate.getMinutes()) + "00";
}

});


parcelRegister("ifqvT", function(module, exports) {

$parcel$export(module.exports, "WORKLIST_NAMESPACE", () => $9617d33e06ad68ba$export$68ca830f3ef07bf7);
$parcel$export(module.exports, "fetchPublicWorklist", () => $9617d33e06ad68ba$export$90e3dd86a5337280);
$parcel$export(module.exports, "queryPublicWorklists", () => $9617d33e06ad68ba$export$ee4790bc83b60de9);
$parcel$export(module.exports, "updatePublicWorklist", () => $9617d33e06ad68ba$export$260307fa69722933);
$parcel$export(module.exports, "createPublicWorklist", () => $9617d33e06ad68ba$export$ff18b0478878f4ee);
$parcel$export(module.exports, "EXPORT_WORKLIST_REQUEST", () => $9617d33e06ad68ba$export$5dc8c5d018007104);
$parcel$export(module.exports, "EXPORT_WORKLIST_SUCCESS", () => $9617d33e06ad68ba$export$fe02df6910ee232b);
$parcel$export(module.exports, "EXPORT_WORKLIST_FAILURE", () => $9617d33e06ad68ba$export$94e1a50be1ef50ee);
$parcel$export(module.exports, "exportWorklist", () => $9617d33e06ad68ba$export$fbf6ba0ff73808c3);

var $dPdDj = parcelRequire("dPdDj");

var $aAq0B = parcelRequire("aAq0B");
const $9617d33e06ad68ba$export$68ca830f3ef07bf7 = "worklist-v2";
function $9617d33e06ad68ba$export$90e3dd86a5337280(worklistId) {
    return (0, $aAq0B.fetchObject)($9617d33e06ad68ba$export$68ca830f3ef07bf7, (0, $dPdDj.PrivacyDomain).Public, worklistId);
}
function $9617d33e06ad68ba$export$ee4790bc83b60de9(filter, options) {
    return (0, $aAq0B.queryObjects)($9617d33e06ad68ba$export$68ca830f3ef07bf7, (0, $dPdDj.PrivacyDomain).Public, filter, options);
}
function $9617d33e06ad68ba$export$260307fa69722933(workListId, worklist) {
    return (0, $aAq0B.updateObject)($9617d33e06ad68ba$export$68ca830f3ef07bf7, (0, $dPdDj.PrivacyDomain).Public, workListId, worklist);
}
function $9617d33e06ad68ba$export$ff18b0478878f4ee(worklist) {
    return (0, $aAq0B.createObject)($9617d33e06ad68ba$export$68ca830f3ef07bf7, (0, $dPdDj.PrivacyDomain).Public, worklist);
}
function $9617d33e06ad68ba$export$27b8be642e6f5640(worklistId) {
    return (0, $aAq0B.deleteObject)($9617d33e06ad68ba$export$68ca830f3ef07bf7, (0, $dPdDj.PrivacyDomain).Public, worklistId);
}
const $9617d33e06ad68ba$export$5dc8c5d018007104 = "EXPORT_WORKLIST_REQUEST";
const $9617d33e06ad68ba$export$fe02df6910ee232b = "EXPORT_WORKLIST_SUCCESS";
const $9617d33e06ad68ba$export$94e1a50be1ef50ee = "EXPORT_WORKLIST_FAILURE";
function $9617d33e06ad68ba$export$fbf6ba0ff73808c3(worklist) {
    return {
        type: $9617d33e06ad68ba$export$5dc8c5d018007104,
        worklist: worklist
    };
}

});

parcelRegister("1SG9b", function(module, exports) {

$parcel$export(module.exports, "CLEAR_TRANSACTIONS", () => $dec011b2d185bc3c$export$bfde8574b733899);
$parcel$export(module.exports, "useTransactions", () => $dec011b2d185bc3c$export$4127a74fddb92b6f);
$parcel$export(module.exports, "forwardTx", () => $dec011b2d185bc3c$export$aeaf5b051d737c3b);

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $dYZXt = parcelRequire("dYZXt");
const $dec011b2d185bc3c$export$bfde8574b733899 = "CLEAR_TRANSACTIONS";
function $dec011b2d185bc3c$export$f109fcb5579a84c1(txIds) {
    return {
        type: $dec011b2d185bc3c$export$bfde8574b733899,
        txIds: txIds
    };
}
const $dec011b2d185bc3c$var$defaultTransaction = {
    done: false,
    loading: false,
    started: false,
    errors: [],
    results: []
};
function $dec011b2d185bc3c$export$4127a74fddb92b6f() {
    const dispatch = (0, $2OPjR.useDispatch)();
    const ref = (0, $acw62.useRef)({
        txs: []
    });
    const [aggregates, setAggregates] = (0, $acw62.useState)({});
    const [localTransactions, setLocalTransactions] = (0, $acw62.useState)({});
    const withTx = (0, $acw62.useCallback)((name, action)=>{
        setAggregates((aggregates)=>{
            const newAggregates = {
                ...aggregates
            };
            delete newAggregates[name];
            return newAggregates;
        });
        if (Array.isArray(action)) {
            const txIds = [];
            const actionList = action.map((action)=>{
                const txId = (0, $dYZXt.uuid)();
                ref.current?.txs.push(txId);
                txIds.push(txId);
                return {
                    ...action,
                    txId: txId
                };
            });
            setLocalTransactions((localTransactions)=>({
                    ...localTransactions,
                    [name]: txIds
                }));
            return actionList;
        } else {
            const txId = (0, $dYZXt.uuid)();
            ref.current?.txs.push(txId);
            setLocalTransactions((localTransactions)=>({
                    ...localTransactions,
                    [name]: [
                        txId
                    ]
                }));
            return {
                ...action,
                txId: txId
            };
        }
    }, []);
    const transactions = (0, $iD0SF.useSelector)((state)=>state.transactions.byId);
    (0, $acw62.useEffect)(()=>{
        setAggregates((aggregates)=>{
            let changed = false;
            const newAggregates = {
                ...aggregates
            };
            Object.keys(localTransactions).forEach((name)=>{
                const aggr = aggregates[name] || {
                    ...$dec011b2d185bc3c$var$defaultTransaction,
                    ids: localTransactions[name]
                };
                const txs = aggr.ids.reduce((memo, txId)=>{
                    if (!transactions[txId]) return memo;
                    memo.push(transactions[txId]);
                    return memo;
                }, []);
                const newAggr = {
                    ...aggr,
                    started: txs.some((tx)=>tx.started),
                    done: txs.every((tx)=>tx.started && tx.done),
                    loading: txs.some((tx)=>tx.loading),
                    errors: txs.reduce((errors, tx)=>[
                            ...errors,
                            ...Array.isArray(tx.errors) ? tx.errors : []
                        ], []),
                    results: txs.reduce((results, tx)=>[
                            ...results,
                            ...Array.isArray(tx.results) ? tx.results : []
                        ], [])
                };
                const aggrChanged = newAggr.done !== aggr.done || newAggr.loading !== aggr.loading || newAggr.started !== aggr.started || newAggr.errors?.length !== aggr.errors?.length || newAggr.results?.length !== aggr.results?.length;
                if (aggrChanged) {
                    changed = true;
                    newAggregates[name] = newAggr;
                }
            });
            if (!changed) return aggregates;
            return newAggregates;
        });
    }, [
        localTransactions,
        transactions
    ]);
    const txStatus = (0, $acw62.useCallback)((name)=>{
        return aggregates[name] ?? $dec011b2d185bc3c$var$defaultTransaction;
    }, [
        aggregates
    ]);
    const resetTx = (0, $acw62.useCallback)((name)=>{
        setAggregates((aggregates)=>{
            const newAggregates = {
                ...aggregates
            };
            delete newAggregates[name];
            return newAggregates;
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            dispatch($dec011b2d185bc3c$export$f109fcb5579a84c1(ref.current?.txs));
        };
    }, []);
    return {
        withTx: withTx,
        txStatus: txStatus,
        resetTx: resetTx
    };
}
function $dec011b2d185bc3c$export$aeaf5b051d737c3b(origin, action) {
    if (!origin.txId) return action;
    return {
        ...action,
        txId: origin.txId
    };
}

});
parcelRegister("dYZXt", function(module, exports) {

$parcel$export(module.exports, "uuid", () => $e2c7b79da5d8bc63$export$31b40729666a4ae0);
const $e2c7b79da5d8bc63$var$hex = [];
for(let i = 0; i < 256; i++)$e2c7b79da5d8bc63$var$hex[i] = (i < 16 ? "0" : "") + i.toString(16);
function $e2c7b79da5d8bc63$export$31b40729666a4ae0() {
    const r = crypto.getRandomValues(new Uint8Array(16));
    r[6] = r[6] & 0x0f | 0x40;
    r[8] = r[8] & 0x3f | 0x80;
    return $e2c7b79da5d8bc63$var$hex[r[0]] + $e2c7b79da5d8bc63$var$hex[r[1]] + $e2c7b79da5d8bc63$var$hex[r[2]] + $e2c7b79da5d8bc63$var$hex[r[3]] + "-" + $e2c7b79da5d8bc63$var$hex[r[4]] + $e2c7b79da5d8bc63$var$hex[r[5]] + "-" + $e2c7b79da5d8bc63$var$hex[r[6]] + $e2c7b79da5d8bc63$var$hex[r[7]] + "-" + $e2c7b79da5d8bc63$var$hex[r[8]] + $e2c7b79da5d8bc63$var$hex[r[9]] + "-" + $e2c7b79da5d8bc63$var$hex[r[10]] + $e2c7b79da5d8bc63$var$hex[r[11]] + $e2c7b79da5d8bc63$var$hex[r[12]] + $e2c7b79da5d8bc63$var$hex[r[13]] + $e2c7b79da5d8bc63$var$hex[r[14]] + $e2c7b79da5d8bc63$var$hex[r[15]];
}

});


parcelRegister("1zwHA", function(module, exports) {

$parcel$export(module.exports, "RUN_PIPELINE_REQUEST", () => $da6c5eebaa8512ea$export$9e23a5e8947b2188);
$parcel$export(module.exports, "RUN_PIPELINE_SUCCESS", () => $da6c5eebaa8512ea$export$ab5c6c74e2151ebe);
$parcel$export(module.exports, "RUN_PIPELINE_FAILURE", () => $da6c5eebaa8512ea$export$629b810876f5dd1c);
$parcel$export(module.exports, "runPipeline", () => $da6c5eebaa8512ea$export$8ae7a44ba86142d6);
const $da6c5eebaa8512ea$export$9e23a5e8947b2188 = "RUN_PIPELINE_REQUEST";
const $da6c5eebaa8512ea$export$ab5c6c74e2151ebe = "RUN_PIPELINE_SUCCESS";
const $da6c5eebaa8512ea$export$629b810876f5dd1c = "RUN_PIPELINE_FAILURE";
function $da6c5eebaa8512ea$export$8ae7a44ba86142d6(name, input, opts = {}) {
    return {
        type: $da6c5eebaa8512ea$export$9e23a5e8947b2188,
        name: name,
        input: input,
        ...opts
    };
}

});

parcelRegister("2gkyY", function(module, exports) {

$parcel$export(module.exports, "SEARCH_OBJECT_REQUEST", () => $2085b3aedf49c063$export$796c44e9b830cf0);
$parcel$export(module.exports, "SEARCH_OBJECT_REQUEST_SUCCESS", () => $2085b3aedf49c063$export$cc9edb35f465ce1d);
$parcel$export(module.exports, "SEARCH_OBJECT_REQUEST_FAILURE", () => $2085b3aedf49c063$export$6dd65ed1a19a1999);
$parcel$export(module.exports, "searchObjectRequest", () => $2085b3aedf49c063$export$52643ec226f331bf);
$parcel$export(module.exports, "RESET_SEARCH_RESULTS", () => $2085b3aedf49c063$export$ca438e92d01957dc);
$parcel$export(module.exports, "resetSearchResults", () => $2085b3aedf49c063$export$dc60b1e0f93b4b42);
const $2085b3aedf49c063$export$796c44e9b830cf0 = "SEARCH_OBJECT_REQUEST";
const $2085b3aedf49c063$export$cc9edb35f465ce1d = "SEARCH_OBJECT_REQUEST_SUCCESS";
const $2085b3aedf49c063$export$6dd65ed1a19a1999 = "SEARCH_OBJECT_REQUEST_FAILURE";
function $2085b3aedf49c063$export$52643ec226f331bf(...queries) {
    return {
        type: $2085b3aedf49c063$export$796c44e9b830cf0,
        queries: queries
    };
}
const $2085b3aedf49c063$export$ca438e92d01957dc = "RESET_SEARCH_RESULTS";
function $2085b3aedf49c063$export$dc60b1e0f93b4b42() {
    return {
        type: $2085b3aedf49c063$export$ca438e92d01957dc
    };
}

});

parcelRegister("cQJbh", function(module, exports) {

$parcel$export(module.exports, "TENANTS_DATA_REQUEST", () => $6c9686f3e7cdab96$export$117c512ec970b9bd);
$parcel$export(module.exports, "TENANTS_DATA_REQUEST_SUCCESS", () => $6c9686f3e7cdab96$export$7d279b67c9befc4d);
$parcel$export(module.exports, "TENANTS_DATA_REQUEST_FAILURE", () => $6c9686f3e7cdab96$export$ceccf438c1c27602);
$parcel$export(module.exports, "getTenantsData", () => $6c9686f3e7cdab96$export$cfc6de840a272f94);
$parcel$export(module.exports, "TENANT_DATA_REQUEST", () => $6c9686f3e7cdab96$export$128847c4c91034b6);
$parcel$export(module.exports, "TENANT_DATA_REQUEST_SUCCESS", () => $6c9686f3e7cdab96$export$4bf5eab1e066c162);
$parcel$export(module.exports, "TENANT_DATA_REQUEST_FAILURE", () => $6c9686f3e7cdab96$export$32f803c416de7c2e);
$parcel$export(module.exports, "getTenantData", () => $6c9686f3e7cdab96$export$a890745bdfad63ad);
$parcel$export(module.exports, "GET_ROLE_REQUEST", () => $6c9686f3e7cdab96$export$61a3e2d2a3b96d16);
$parcel$export(module.exports, "GET_ROLE_REQUEST_SUCCESS", () => $6c9686f3e7cdab96$export$49e7b6d3919c1ca5);
$parcel$export(module.exports, "GET_ROLE_REQUEST_FAILURE", () => $6c9686f3e7cdab96$export$4801a58140b80d6d);
$parcel$export(module.exports, "getRole", () => $6c9686f3e7cdab96$export$d1c3a5ff834adfa2);
$parcel$export(module.exports, "ADD_ROLE_REQUEST", () => $6c9686f3e7cdab96$export$e2de68b30d8b021b);
$parcel$export(module.exports, "ADD_ROLE_REQUEST_SUCCESS", () => $6c9686f3e7cdab96$export$1b0b0a45cb5c7cf7);
$parcel$export(module.exports, "ADD_ROLE_REQUEST_FAILURE", () => $6c9686f3e7cdab96$export$cc1426497940f2be);
$parcel$export(module.exports, "addRole", () => $6c9686f3e7cdab96$export$987e0c664048adac);
$parcel$export(module.exports, "REMOVE_ROLE_REQUEST", () => $6c9686f3e7cdab96$export$4ab9c474034fe74);
$parcel$export(module.exports, "REMOVE_ROLE_REQUEST_SUCCESS", () => $6c9686f3e7cdab96$export$3f3886efcb9adf11);
$parcel$export(module.exports, "REMOVE_ROLE_REQUEST_FAILURE", () => $6c9686f3e7cdab96$export$94befff945bead7e);
$parcel$export(module.exports, "removeRole", () => $6c9686f3e7cdab96$export$f4d8053c91b38a3a);
$parcel$export(module.exports, "SWITCH_TENANT_REQUEST", () => $6c9686f3e7cdab96$export$b09b2915df034bc8);
$parcel$export(module.exports, "SWITCH_TENANT_REQUEST_SUCCESS", () => $6c9686f3e7cdab96$export$a3efa39bd6eefd72);
$parcel$export(module.exports, "SWITCH_TENANT_REQUEST_FAILURE", () => $6c9686f3e7cdab96$export$4dbed5bcfc133573);
$parcel$export(module.exports, "switchTenant", () => $6c9686f3e7cdab96$export$746ee400bcd9102d);
const $6c9686f3e7cdab96$export$117c512ec970b9bd = "TENANTS_DATA_REQUEST";
const $6c9686f3e7cdab96$export$7d279b67c9befc4d = "TENANTS_DATA_REQUEST_SUCCESS";
const $6c9686f3e7cdab96$export$ceccf438c1c27602 = "TENANTS_DATA_REQUEST_FAILURE";
function $6c9686f3e7cdab96$export$cfc6de840a272f94() {
    return {
        type: $6c9686f3e7cdab96$export$117c512ec970b9bd
    };
}
const $6c9686f3e7cdab96$export$128847c4c91034b6 = "TENANT_DATA_REQUEST";
const $6c9686f3e7cdab96$export$4bf5eab1e066c162 = "TENANT_DATA_REQUEST_SUCCESS";
const $6c9686f3e7cdab96$export$32f803c416de7c2e = "TENANT_DATA_REQUEST_FAILURE";
function $6c9686f3e7cdab96$export$a890745bdfad63ad(tenant) {
    return {
        type: $6c9686f3e7cdab96$export$128847c4c91034b6,
        tenant: tenant
    };
}
const $6c9686f3e7cdab96$export$61a3e2d2a3b96d16 = "GET_ROLE_REQUEST";
const $6c9686f3e7cdab96$export$49e7b6d3919c1ca5 = "GET_ROLE_REQUEST_SUCCESS";
const $6c9686f3e7cdab96$export$4801a58140b80d6d = "GET_ROLE_REQUEST_FAILURE";
function $6c9686f3e7cdab96$export$d1c3a5ff834adfa2(tenant, subject) {
    return {
        type: $6c9686f3e7cdab96$export$61a3e2d2a3b96d16,
        tenant: tenant,
        subject: subject
    };
}
const $6c9686f3e7cdab96$export$e2de68b30d8b021b = "ADD_ROLE_REQUEST";
const $6c9686f3e7cdab96$export$1b0b0a45cb5c7cf7 = "ADD_ROLE_REQUEST_SUCCESS";
const $6c9686f3e7cdab96$export$cc1426497940f2be = "ADD_ROLE_REQUEST_FAILURE";
function $6c9686f3e7cdab96$export$987e0c664048adac(tenant, subject, role) {
    return {
        type: $6c9686f3e7cdab96$export$e2de68b30d8b021b,
        tenant: tenant,
        role: role,
        subject: subject
    };
}
const $6c9686f3e7cdab96$export$4ab9c474034fe74 = "REMOVE_ROLE_REQUEST";
const $6c9686f3e7cdab96$export$3f3886efcb9adf11 = "REMOVE_ROLE_REQUEST_SUCCESS";
const $6c9686f3e7cdab96$export$94befff945bead7e = "REMOVE_ROLE_REQUEST_FAILURE";
function $6c9686f3e7cdab96$export$f4d8053c91b38a3a(tenant, subject, role) {
    return {
        type: $6c9686f3e7cdab96$export$4ab9c474034fe74,
        tenant: tenant,
        role: role,
        subject: subject
    };
}
const $6c9686f3e7cdab96$export$b09b2915df034bc8 = "SWITCH_TENANT_REQUEST";
const $6c9686f3e7cdab96$export$a3efa39bd6eefd72 = "SWITCH_TENANT_REQUEST_SUCCESS";
const $6c9686f3e7cdab96$export$4dbed5bcfc133573 = "SWITCH_TENANT_REQUEST_FAILURE";
function $6c9686f3e7cdab96$export$746ee400bcd9102d(tenant) {
    return {
        type: $6c9686f3e7cdab96$export$b09b2915df034bc8,
        tenant: tenant
    };
}

});

parcelRegister("aLhwe", function(module, exports) {

$parcel$export(module.exports, "AUDIT_REQUEST", () => $b6f65f8c21f22726$export$a300866b83e35bc8);
$parcel$export(module.exports, "AUDIT_REQUEST_SUCCESS", () => $b6f65f8c21f22726$export$e672bd8725b8709a);
$parcel$export(module.exports, "AUDIT_REQUEST_FAILURE", () => $b6f65f8c21f22726$export$f5668fb9a17f3006);
$parcel$export(module.exports, "getAuditLogs", () => $b6f65f8c21f22726$export$1ecb836d228fe1c8);
const $b6f65f8c21f22726$export$a300866b83e35bc8 = "AUDIT_REQUEST";
const $b6f65f8c21f22726$export$e672bd8725b8709a = "AUDIT_REQUEST_SUCCESS";
const $b6f65f8c21f22726$export$f5668fb9a17f3006 = "AUDIT_REQUEST_FAILURE";
function $b6f65f8c21f22726$export$1ecb836d228fe1c8(options, filter) {
    return {
        type: $b6f65f8c21f22726$export$a300866b83e35bc8,
        options: options,
        filter: filter
    };
}

});

parcelRegister("kjFAP", function(module, exports) {

$parcel$export(module.exports, "CHECK_AUTHZ_REQUEST", () => $85444d3c38dfa6b6$export$e4631580a5ad9683);
$parcel$export(module.exports, "CHECK_AUTHZ_REQUEST_SUCCESS", () => $85444d3c38dfa6b6$export$a6a81beb8b1a3558);
$parcel$export(module.exports, "CHECK_AUTHZ_REQUEST_FAILURE", () => $85444d3c38dfa6b6$export$856b6bad9af21afa);
$parcel$export(module.exports, "checkAuthz", () => $85444d3c38dfa6b6$export$fd4feb3e1ad34207);
const $85444d3c38dfa6b6$export$e4631580a5ad9683 = "CHECK_AUTHZ_REQUEST";
const $85444d3c38dfa6b6$export$a6a81beb8b1a3558 = "CHECK_AUTHZ_REQUEST_SUCCESS";
const $85444d3c38dfa6b6$export$856b6bad9af21afa = "CHECK_AUTHZ_REQUEST_FAILURE";
function $85444d3c38dfa6b6$export$fd4feb3e1ad34207(authzAction, authzResource) {
    return {
        type: $85444d3c38dfa6b6$export$e4631580a5ad9683,
        authzAction: authzAction,
        authzResource: authzResource
    };
}

});

parcelRegister("mRUi0", function(module, exports) {

$parcel$export(module.exports, "PipelineServerClient", () => $3b2a66d059599cab$export$2eb9999134e14ef1);

var $2m6N8 = parcelRequire("2m6N8");

var $kpQdM = parcelRequire("kpQdM");

var $jbLey = parcelRequire("jbLey");

var $jxJwM = parcelRequire("jxJwM");
class $3b2a66d059599cab$export$2eb9999134e14ef1 {
    constructor(baseUrl, idToken){
        this.baseUrl = baseUrl;
        this.idToken = idToken;
        // Force bind methods to instance
        this.fetchPipelineByName = this.fetchPipelineByName.bind(this);
        this.fetchPipeline = this.fetchPipeline.bind(this);
        this.runPipeline = this.runPipeline.bind(this);
        this.fetchRun = this.fetchRun.bind(this);
        this.waitForRun = this.waitForRun.bind(this);
    }
    fetchPipeline(id) {
        return (0, $2m6N8.fetchWithCredentials)(this.idToken, `${this.baseUrl}/api/v1/pipelines/${id}`, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            method: "GET"
        }).then((res)=>{
            const result = res.json();
            (0, $jxJwM.assertResponse)(res, result);
            return result;
        }).then((res)=>{
            return res.data;
        });
    }
    fetchPipelineByName(name) {
        return (0, $2m6N8.fetchWithCredentials)(this.idToken, `${this.baseUrl}/api/v1/pipelines?name=${encodeURIComponent(name)}`, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            method: "GET"
        }).then((res)=>{
            const result = res.json();
            (0, $jxJwM.assertResponse)(res, result);
            return result;
        }).then((res)=>{
            if ((res.data || []).length === 0) throw new Error("Pipeline not found");
            return res.data[0];
        });
    }
    runPipeline(pipelineId, input) {
        return (0, $2m6N8.fetchWithCredentials)(this.idToken, `${this.baseUrl}/api/v1/pipelines/${pipelineId}/runs`, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            method: "POST",
            body: JSON.stringify({
                input: input
            })
        }).then((res)=>{
            const result = res.json();
            (0, $jxJwM.assertResponse)(res, result);
            return result;
        }).then((res)=>{
            return res.data.Run;
        });
    }
    fetchRun(pipelineId, pipelineRunId) {
        return (0, $2m6N8.fetchWithCredentials)(this.idToken, `${this.baseUrl}/api/v1/pipelines/${pipelineId}/runs/${pipelineRunId}`, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            method: "GET"
        }).then((res)=>{
            const result = res.json();
            (0, $jxJwM.assertResponse)(res, result);
            return result;
        }).then((res)=>{
            return res.data.Run;
        });
    }
    waitForRun(pipelineId, pipelineRunId) {
        return (0, $jbLey.poll)(()=>this.fetchRun(pipelineId, pipelineRunId), (pipelineRun)=>pipelineRun.State !== (0, $kpQdM.PipelineRunState).Running && pipelineRun.State !== (0, $kpQdM.PipelineRunState).Created, 1000, 600);
    }
}

});
parcelRegister("kpQdM", function(module, exports) {

$parcel$export(module.exports, "PipelineRunState", () => $78ef5b671fa099fe$export$e3a39c8eb9ab4243);
$parcel$export(module.exports, "getPipelineRuneStateLabel", () => $78ef5b671fa099fe$export$bd14282914165f30);
var $78ef5b671fa099fe$export$e3a39c8eb9ab4243;
(function(PipelineRunState) {
    PipelineRunState[PipelineRunState["Created"] = 0] = "Created";
    PipelineRunState[PipelineRunState["Running"] = 1] = "Running";
    PipelineRunState[PipelineRunState["Error"] = 2] = "Error";
    PipelineRunState[PipelineRunState["Success"] = 3] = "Success";
    PipelineRunState[PipelineRunState["Interrupted"] = 4] = "Interrupted";
})($78ef5b671fa099fe$export$e3a39c8eb9ab4243 || ($78ef5b671fa099fe$export$e3a39c8eb9ab4243 = {}));
const $78ef5b671fa099fe$var$PipelineRunStateLabels = {
    [0]: "Created",
    [1]: "Running",
    [2]: "Error",
    [3]: "Success",
    [4]: "Interrupted"
};
function $78ef5b671fa099fe$export$bd14282914165f30(state) {
    return $78ef5b671fa099fe$var$PipelineRunStateLabels[state] ?? `Unknown (${state})`;
}

});

parcelRegister("jbLey", function(module, exports) {

$parcel$export(module.exports, "poll", () => $32163927892cb2ab$export$e0c10349b2c5e1d4);
function $32163927892cb2ab$export$e0c10349b2c5e1d4(pollFn, checkFn, interval, maxAttempts) {
    let attempts = 0;
    const cb = (resolve, reject)=>{
        attempts++;
        pollFn().then((value)=>{
            const ok = checkFn(value);
            if (ok) return resolve(value);
            if (attempts < maxAttempts) {
                setTimeout(cb, interval, resolve, reject);
                return;
            } else return reject(new Error("Poll timed out !"));
        }).catch(reject);
    };
    return new Promise(cb);
}

});


parcelRegister("ksXGV", function(module, exports) {

$parcel$export(module.exports, "ANALYSIS_REQUEST_NAMESPACE", () => $293148f1d9f4f709$export$78053cb4ba2d48ad);
$parcel$export(module.exports, "CONFIRM_CANCEL_EXAM", () => $293148f1d9f4f709$export$2d45e65c33910b7e);
$parcel$export(module.exports, "CONFIRM_CANCEL_EXAM_SUCESS", () => $293148f1d9f4f709$export$40e0a0dbefd97934);
$parcel$export(module.exports, "CONFIRM_CANCEL_EXAM_FAILURE", () => $293148f1d9f4f709$export$5ee58dac3f62e0fb);
$parcel$export(module.exports, "MARK_EXAM_REDO", () => $293148f1d9f4f709$export$28abfbc89e680bc);
$parcel$export(module.exports, "MARK_EXAM_REDO_SUCCESS", () => $293148f1d9f4f709$export$50a84637e6a83c16);
$parcel$export(module.exports, "MARK_EXAM_REDO_FAILURE", () => $293148f1d9f4f709$export$fc134d90cac36f13);
$parcel$export(module.exports, "queryPublicAnalysisRequests", () => $293148f1d9f4f709$export$e25dc117c5878a3);
$parcel$export(module.exports, "queryPendingAnalysisRequests", () => $293148f1d9f4f709$export$29df6c8900996c7e);
$parcel$export(module.exports, "queryPatientAnalysisRequests", () => $293148f1d9f4f709$export$5664f08a484a828);
$parcel$export(module.exports, "updatePublicAnalysisRequest", () => $293148f1d9f4f709$export$f7f0f3ec522c6286);
$parcel$export(module.exports, "confirmCancelExam", () => $293148f1d9f4f709$export$4d754d41a6c11fa0);
$parcel$export(module.exports, "markExamRedo", () => $293148f1d9f4f709$export$ec29e761d7743346);
$parcel$export(module.exports, "ANALYSIS_REQUEST_CODE_NAMESPACE", () => $293148f1d9f4f709$export$1eaefd4ecbcaba63);
$parcel$export(module.exports, "queryPublicAnalysisRequestCodes", () => $293148f1d9f4f709$export$15999307e6af4db7);
$parcel$export(module.exports, "updatePublicAnalysisRequestCode", () => $293148f1d9f4f709$export$4e55859713347687);
$parcel$export(module.exports, "createPublicAnalysisRequestCode", () => $293148f1d9f4f709$export$7363f553b18f86c0);
$parcel$export(module.exports, "deletePublicAnalysisRequestCode", () => $293148f1d9f4f709$export$b18274ea3a0927c1);
$parcel$export(module.exports, "ANALYSIS_REAGENT_PROVIDER_NAMESPACE", () => $293148f1d9f4f709$export$520bd480a0e29bc7);
$parcel$export(module.exports, "queryPublicAnalysisReagentProviders", () => $293148f1d9f4f709$export$e5980af4f87dcaf6);
$parcel$export(module.exports, "updatePublicAnalysisReagentProvider", () => $293148f1d9f4f709$export$894e9499a111a5a7);
$parcel$export(module.exports, "createPublicAnalysisReagentProvider", () => $293148f1d9f4f709$export$58414ca2f94038e8);
$parcel$export(module.exports, "deletePublicAnalysisReagentProvider", () => $293148f1d9f4f709$export$aae7c04434c14418);
$parcel$export(module.exports, "ANALYSIS_REQUEST_CATEGORY_NAMESPACE", () => $293148f1d9f4f709$export$e9b9a841fa7956b9);
$parcel$export(module.exports, "queryPublicAnalysisRequestCategories", () => $293148f1d9f4f709$export$f60c45f3664326ee);
$parcel$export(module.exports, "updatePublicAnalysisCategory", () => $293148f1d9f4f709$export$151de86c5e14f49c);
$parcel$export(module.exports, "createPublicAnalysisCategory", () => $293148f1d9f4f709$export$82c8f224ae3d2cb1);
$parcel$export(module.exports, "deletePublicAnalysisCategory", () => $293148f1d9f4f709$export$a69ca3dff50b9a30);

var $8mxDx = parcelRequire("8mxDx");

var $dPdDj = parcelRequire("dPdDj");

var $aAq0B = parcelRequire("aAq0B");
const $293148f1d9f4f709$export$78053cb4ba2d48ad = "analysis-request-v1";
const $293148f1d9f4f709$export$2d45e65c33910b7e = "confirm_cancel_exam";
const $293148f1d9f4f709$export$40e0a0dbefd97934 = "confirm_cancel_exam_sucess";
const $293148f1d9f4f709$export$5ee58dac3f62e0fb = "confirm_cancel_exam_failure";
const $293148f1d9f4f709$export$28abfbc89e680bc = "mark_exam_redo";
const $293148f1d9f4f709$export$50a84637e6a83c16 = "mark_exam_redo_success";
const $293148f1d9f4f709$export$fc134d90cac36f13 = "mark_exam_redo_failure";
function $293148f1d9f4f709$export$8fb1e645eacea41d(objectId) {
    return (0, $aAq0B.fetchObject)($293148f1d9f4f709$export$78053cb4ba2d48ad, (0, $dPdDj.PrivacyDomain).Public, objectId);
}
function $293148f1d9f4f709$export$e25dc117c5878a3(filter, options) {
    return (0, $aAq0B.queryObjects)($293148f1d9f4f709$export$78053cb4ba2d48ad, (0, $dPdDj.PrivacyDomain).Public, filter, options);
}
function $293148f1d9f4f709$export$29df6c8900996c7e() {
    return (0, $aAq0B.queryObjects)($293148f1d9f4f709$export$78053cb4ba2d48ad, (0, $dPdDj.PrivacyDomain).Public, {
        or: [
            {
                eq: {
                    "types.*": (0, $8mxDx.AnalysisRequestState).TakenIntoAccount
                }
            },
            {
                eq: {
                    "types.*": (0, $8mxDx.AnalysisRequestState).RedoRequested
                }
            }
        ]
    }, {
        hydrate: true
    });
}
function $293148f1d9f4f709$export$5664f08a484a828(inlogId) {
    return (0, $aAq0B.queryObjects)($293148f1d9f4f709$export$78053cb4ba2d48ad, (0, $dPdDj.PrivacyDomain).Public, {
        eq: {
            "ref.patient.inlogId": inlogId
        }
    }, {
        hydrate: true
    });
}
function $293148f1d9f4f709$export$f7f0f3ec522c6286(objectId, analysisRequest) {
    return (0, $aAq0B.updateObject)($293148f1d9f4f709$export$78053cb4ba2d48ad, (0, $dPdDj.PrivacyDomain).Public, objectId, analysisRequest);
}
function $293148f1d9f4f709$export$4d754d41a6c11fa0(cancelExams) {
    return {
        type: $293148f1d9f4f709$export$2d45e65c33910b7e,
        cancelExams: cancelExams
    };
}
function $293148f1d9f4f709$export$ec29e761d7743346(analysisRequestRef, analysisRequestCode) {
    return {
        type: $293148f1d9f4f709$export$28abfbc89e680bc,
        analysisRequestRef: analysisRequestRef,
        analysisRequestCode: analysisRequestCode
    };
}
const $293148f1d9f4f709$export$1eaefd4ecbcaba63 = "analysis-request-code-v1";
function $293148f1d9f4f709$export$2743b182860df8fb(objectId) {
    return (0, $aAq0B.fetchObject)($293148f1d9f4f709$export$1eaefd4ecbcaba63, (0, $dPdDj.PrivacyDomain).Public, objectId);
}
function $293148f1d9f4f709$export$15999307e6af4db7(filter, options) {
    return (0, $aAq0B.queryObjects)($293148f1d9f4f709$export$1eaefd4ecbcaba63, (0, $dPdDj.PrivacyDomain).Public, filter, options);
}
function $293148f1d9f4f709$export$4e55859713347687(objectId, data, partial) {
    return (0, $aAq0B.updateObject)($293148f1d9f4f709$export$1eaefd4ecbcaba63, (0, $dPdDj.PrivacyDomain).Public, objectId, data, partial);
}
function $293148f1d9f4f709$export$7363f553b18f86c0(data) {
    return (0, $aAq0B.createObject)($293148f1d9f4f709$export$1eaefd4ecbcaba63, (0, $dPdDj.PrivacyDomain).Public, data);
}
function $293148f1d9f4f709$export$b18274ea3a0927c1(objectId) {
    return (0, $aAq0B.deleteObject)($293148f1d9f4f709$export$1eaefd4ecbcaba63, (0, $dPdDj.PrivacyDomain).Public, objectId);
}
const $293148f1d9f4f709$export$520bd480a0e29bc7 = "analysis-reagent-provider-v1";
function $293148f1d9f4f709$export$fa0af9e11315fcf5(objectId) {
    return (0, $aAq0B.fetchObject)($293148f1d9f4f709$export$520bd480a0e29bc7, (0, $dPdDj.PrivacyDomain).Public, objectId);
}
function $293148f1d9f4f709$export$e5980af4f87dcaf6(filter, options) {
    return (0, $aAq0B.queryObjects)($293148f1d9f4f709$export$520bd480a0e29bc7, (0, $dPdDj.PrivacyDomain).Public, filter, options);
}
function $293148f1d9f4f709$export$894e9499a111a5a7(objectId, data, partial) {
    return (0, $aAq0B.updateObject)($293148f1d9f4f709$export$520bd480a0e29bc7, (0, $dPdDj.PrivacyDomain).Public, objectId, data, partial);
}
function $293148f1d9f4f709$export$58414ca2f94038e8(data) {
    return (0, $aAq0B.createObject)($293148f1d9f4f709$export$520bd480a0e29bc7, (0, $dPdDj.PrivacyDomain).Public, data);
}
function $293148f1d9f4f709$export$aae7c04434c14418(objectId) {
    return (0, $aAq0B.deleteObject)($293148f1d9f4f709$export$520bd480a0e29bc7, (0, $dPdDj.PrivacyDomain).Public, objectId);
}
const $293148f1d9f4f709$export$e9b9a841fa7956b9 = "analysis-request-category-v1";
function $293148f1d9f4f709$export$7939ae065fd37126(objectId) {
    return (0, $aAq0B.fetchObject)($293148f1d9f4f709$export$e9b9a841fa7956b9, (0, $dPdDj.PrivacyDomain).Public, objectId);
}
function $293148f1d9f4f709$export$f60c45f3664326ee(filter, options) {
    return (0, $aAq0B.queryObjects)($293148f1d9f4f709$export$e9b9a841fa7956b9, (0, $dPdDj.PrivacyDomain).Public, filter, options);
}
function $293148f1d9f4f709$export$151de86c5e14f49c(objectId, data, partial) {
    return (0, $aAq0B.updateObject)($293148f1d9f4f709$export$e9b9a841fa7956b9, (0, $dPdDj.PrivacyDomain).Public, objectId, data, partial);
}
function $293148f1d9f4f709$export$82c8f224ae3d2cb1(data) {
    return (0, $aAq0B.createObject)($293148f1d9f4f709$export$e9b9a841fa7956b9, (0, $dPdDj.PrivacyDomain).Public, data);
}
function $293148f1d9f4f709$export$a69ca3dff50b9a30(objectId) {
    return (0, $aAq0B.deleteObject)($293148f1d9f4f709$export$e9b9a841fa7956b9, (0, $dPdDj.PrivacyDomain).Public, objectId);
}

});
parcelRegister("8mxDx", function(module, exports) {
/** 
 * !!! DO NOT MODIFY !!!
 * 
 * File generated from types definition in project https://forge.cadoles.com/EFS/sheila.
 *
 * See misc/script/generate-type-defs.sh script for more informations.
 **/ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.analysisRequestMatches = module.exports.AnalysisRequestCodeLifecycle = module.exports.ResultCodeDataType = module.exports.AnalysisRequestState = void 0;
// Voir CCTP-IT09.pdf - II. STATUTS ET CYCLES DE VIE, A. STATUTS ET CYCLES DE VIE
var $616a78595276165e$var$AnalysisRequestState;
(function(AnalysisRequestState) {
    // Stade 1 - La demande est prise en compte (reçu d’Inlog Labo server)
    AnalysisRequestState["TakenIntoAccount"] = "taken-into-account";
    // Stade 2 - Les examens de la demande sont intégrés dans des listes de travail qui sont exportés vers les automates
    AnalysisRequestState["IntegratedWorklist"] = "integrated-worklist";
    // Stade 3 - Des résultats sont importés dans le middleware pour chaque examen de cette
    // demande, à partir de HLA-FUSION et / ou Match-it. Ils sont soumis aux algorithmes
    // d'aide à l'interprétation paramétrés par labo
    AnalysisRequestState["ReceivedResults"] = "received-results";
    // Stade 4 - Les résultats de l'examens sont validés techniquement (VT), les résultats
    // peuvent être dévalidés par les profils utilisateurs définis
    AnalysisRequestState["TechValidatedResults"] = "tech-validated-results";
    // Stade 5 - Les résultats de l'examens sont validés avec composante experte (VE) par
    // les profils utilisateurs définis. Les résultats au stade VE ne peuvent être dévalidés et
    // modifiés que par un biologiste médical pour revenir à un stade VT.
    AnalysisRequestState["ExpertValidatedResults"] = "expert-validated-results";
    // Stade 6 - Les résultats sont transférés dans inlog laboserveur en format norme HPRIM
    // les résultats peuvent être dévalidés par un biologiste médical pour repasser au stade
    // pour être modifiable, puis passage en VE, puis réexportable après validation.
    AnalysisRequestState["TransferedResults"] = "transfered-results";
    // Stade 0 - Reprise des demandes données antérieures à la première nouvelle demande
    // validée dans l'outil – non exportable – non dévalidable
    //
    // Précision apportée par @srubier:
    // "C'est pour permettre d'interroger un dossier patient quand celui-ci n'a jamais reçu 
    // une demande analytique. Je précise. On prévoit envoyer un hprim pour un patient avec 
    // un code spécifique qui permet juste de déclencher le pipeline hprim import sans que 
    // ce soit un examen. Une sorte de première intégration pour consultation."
    AnalysisRequestState["Historized"] = "historized";
    // Une demande d'analyse est en attente de résultat si elle fait partie d'une liste de travail dans l'état "exportée"
    AnalysisRequestState["PendingResult"] = "pending-result";
    /**
     * Stade 7 - L'examen est mis « à refaire » (ticket #821) depuis une liste de
     * travail exportée : il réintègre le pot commun des examens sélectionnables
     * pour une nouvelle liste de travail. Accessible depuis les stades 2 à 6,
     * sans limite de répétition.
     */ AnalysisRequestState["RedoRequested"] = "redo-requested";
})($616a78595276165e$var$AnalysisRequestState || (module.exports.AnalysisRequestState = $616a78595276165e$var$AnalysisRequestState = {}));
// Type de donnée associé au code de résultat
// d'examen
// Voir https://nextcloud.cadoles.com/nextcloud/index.php/f/223720
var $616a78595276165e$var$ResultCodeDataType;
(function(ResultCodeDataType) {
    // Groupe de résultats
    ResultCodeDataType["RESULT_GROUP"] = "result-group";
    // MFI CP
    ResultCodeDataType["MFI_CP"] = "mfi-cp";
    // MFI CN
    ResultCodeDataType["MFI_CN"] = "mfi-cn";
    // MFI max (hors CP)
    ResultCodeDataType["MFI_MAX"] = "mfi-max";
    // Synthèse des spécificité positives
    ResultCodeDataType["SYNTH_POS"] = "synth-pos";
    // Commentaire libre
    ResultCodeDataType["COM"] = "com";
    // Catalogue
    ResultCodeDataType["CAT"] = "cat";
    // Seuil classe
    ResultCodeDataType["CLASS_THRESHOLD"] = "class-threshold";
    // MFI DSA
    ResultCodeDataType["MFI_DSA"] = "mfi-dsa";
    // DSA
    ResultCodeDataType["DSA"] = "dsa";
    // Date Serum N-1
    ResultCodeDataType["DATE_SERUM_N1"] = "date-serum-n1";
    // Résultat classe
    ResultCodeDataType["CLASS_RESULT"] = "class-result";
    // Ag classe 1/2
    ResultCodeDataType["AG"] = "ag";
    // Non implémenté
    ResultCodeDataType["NOT_IMPLEMENTED"] = "not-implemented";
})($616a78595276165e$var$ResultCodeDataType || (module.exports.ResultCodeDataType = $616a78595276165e$var$ResultCodeDataType = {}));
var $616a78595276165e$var$AnalysisRequestCodeLifecycle;
(function(AnalysisRequestCodeLifecycle) {
    AnalysisRequestCodeLifecycle["Synthesis"] = "synthesis";
    AnalysisRequestCodeLifecycle["Punctual"] = "punctual";
})($616a78595276165e$var$AnalysisRequestCodeLifecycle || (module.exports.AnalysisRequestCodeLifecycle = $616a78595276165e$var$AnalysisRequestCodeLifecycle = {}));
function $616a78595276165e$var$analysisRequestMatches(r1, r2) {
    return r1.executorSampleId === r2.executorSampleId && r1.requestDate === r2.requestDate && r1.requestorSampleId === r2.requestorSampleId && r1.samplingEndDate === r2.samplingEndDate && r1.samplingStartDate === r2.samplingStartDate && r1.type === r2.type;
}
module.exports.analysisRequestMatches = $616a78595276165e$var$analysisRequestMatches;

});


parcelRegister("bmWbP", function(module, exports) {

$parcel$export(module.exports, "selectAnalysisRequestIndexedObjects", () => $59ab36ad2e41c3e7$export$5c82cd10b62066a);
$parcel$export(module.exports, "selectAnalysisRequestObjects", () => $59ab36ad2e41c3e7$export$1a14cb1aff2e644f);
$parcel$export(module.exports, "selectAnalysisRequestByRef", () => $59ab36ad2e41c3e7$export$daadd718b4b78d97);
$parcel$export(module.exports, "selectAnalysisRequests", () => $59ab36ad2e41c3e7$export$79f4eaa748a6073a);
$parcel$export(module.exports, "selectAnalysisRequestPatientInlogIds", () => $59ab36ad2e41c3e7$export$31efd4363cbe2a22);
$parcel$export(module.exports, "selectInProgressPatientInlogIds", () => $59ab36ad2e41c3e7$export$e27d069ac5f01f66);
$parcel$export(module.exports, "selectPatientPendingAnalysisRequests", () => $59ab36ad2e41c3e7$export$2904fad7933da8d9);
$parcel$export(module.exports, "selectAnalysisReagentProviderObjects", () => $59ab36ad2e41c3e7$export$7a623b906753d889);
$parcel$export(module.exports, "selectAnalysisReagentByCode", () => $59ab36ad2e41c3e7$export$1b6ca92462dc0e3e);
$parcel$export(module.exports, "selectAnalysisReagentProviders", () => $59ab36ad2e41c3e7$export$3e0c6d356fadb370);
$parcel$export(module.exports, "selectAnalysisReagentProviderByCode", () => $59ab36ad2e41c3e7$export$5af8860cb62bae5d);
$parcel$export(module.exports, "selectAnalysisRequestCategoryObjects", () => $59ab36ad2e41c3e7$export$c0444b21aa1c2c17);
$parcel$export(module.exports, "selectAnalysisRequestCategories", () => $59ab36ad2e41c3e7$export$65f255e53a865082);
$parcel$export(module.exports, "selectAnalysisRequestCategoriesIndexedByCode", () => $59ab36ad2e41c3e7$export$e2dc599bd11fc4a);
$parcel$export(module.exports, "selectAnalysisRequestCategoriesByReagent", () => $59ab36ad2e41c3e7$export$41f2283710e98efe);
$parcel$export(module.exports, "selectAnalysisRequestCategoryByCode", () => $59ab36ad2e41c3e7$export$c3ca0462516a7454);
$parcel$export(module.exports, "selectAnalysisRequestCodeObjects", () => $59ab36ad2e41c3e7$export$28580fddc0240228);
$parcel$export(module.exports, "selectAnalysisRequestCodeSynthesis", () => $59ab36ad2e41c3e7$export$69230b698d442035);
$parcel$export(module.exports, "selectAnalysisRequestCodeByReagentAndCategory", () => $59ab36ad2e41c3e7$export$78e1e8c0e60a9e2c);
$parcel$export(module.exports, "selectPendingAnalysisObjectsRequests", () => $59ab36ad2e41c3e7$export$84a051b2c1afc97d);
$parcel$export(module.exports, "selectPendingAnalysisRequestsByReagent", () => $59ab36ad2e41c3e7$export$2d5f4a50aa329c50);
$parcel$export(module.exports, "selectAnalysisRequestByWorklist", () => $59ab36ad2e41c3e7$export$586b81715b07be39);
$parcel$export(module.exports, "selectHandledAnalysisRequestObjects", () => $59ab36ad2e41c3e7$export$c5a7cbd25baee17e);

var $6SpLG = parcelRequire("6SpLG");

var $ksXGV = parcelRequire("ksXGV");

var $8mxDx = parcelRequire("8mxDx");

var $dPdDj = parcelRequire("dPdDj");

var $hx2W4 = parcelRequire("hx2W4");

var $1chCp = parcelRequire("1chCp");

var $kiWpr = parcelRequire("kiWpr");
const $59ab36ad2e41c3e7$export$5c82cd10b62066a = (state)=>{
    return state.objects.byNamespace[0, $ksXGV.ANALYSIS_REQUEST_NAMESPACE]?.byDomain[(0, $dPdDj.PrivacyDomain).Public]?.byId;
};
const $59ab36ad2e41c3e7$export$1a14cb1aff2e644f = (0, $6SpLG.createSelector)([
    $59ab36ad2e41c3e7$export$5c82cd10b62066a
], (objects)=>{
    const analysisRequests = [];
    if (!objects) return analysisRequests;
    return Object.values(objects).reduce((memo, obj)=>{
        if (!("data" in obj)) return memo;
        memo.push(obj);
        return memo;
    }, analysisRequests);
});
const $59ab36ad2e41c3e7$export$daadd718b4b78d97 = (0, $6SpLG.createSelector)([
    $59ab36ad2e41c3e7$export$1a14cb1aff2e644f,
    (state, ref)=>ref
], (objects, ref)=>{
    return objects.find((obj)=>ref?.executorSampleId === obj.data.executorSampleId && ref?.requestDate === obj.data.requestDate && ref?.requestorSampleId === obj.data.requestorSampleId && ref?.samplingStartDate === obj.data.samplingStartDate && ref?.samplingEndDate === obj.data.samplingEndDate && (ref?.type === undefined || Object.keys(obj.data.types).indexOf(ref?.type) !== -1));
});
const $59ab36ad2e41c3e7$export$79f4eaa748a6073a = (0, $6SpLG.createSelector)([
    $59ab36ad2e41c3e7$export$1a14cb1aff2e644f
], (objects)=>{
    const analysisRequests = [];
    if (!objects) return analysisRequests;
    return objects.map((obj)=>obj.data);
});
const $59ab36ad2e41c3e7$export$31efd4363cbe2a22 = (0, $6SpLG.createSelector)([
    $59ab36ad2e41c3e7$export$79f4eaa748a6073a
], (analysisRequests)=>(0, $kiWpr.collectPatientInlogIds)(analysisRequests, {
        inProgressOnly: false
    }));
const $59ab36ad2e41c3e7$export$e27d069ac5f01f66 = (0, $6SpLG.createSelector)([
    $59ab36ad2e41c3e7$export$79f4eaa748a6073a
], (analysisRequests)=>(0, $kiWpr.collectPatientInlogIds)(analysisRequests, {
        inProgressOnly: true
    }));
const $59ab36ad2e41c3e7$export$ec476fcf0bb920a7 = (0, $6SpLG.createSelector)([
    $59ab36ad2e41c3e7$export$79f4eaa748a6073a
], (analysisRequests)=>{
    return analysisRequests.filter((r)=>{
        const analysisRequestCodes = Object.keys(r.types);
        const isPending = analysisRequestCodes.some((typ)=>(0, $1chCp.isSelectableAnalysisState)(r.types[typ]));
        return isPending;
    });
});
const $59ab36ad2e41c3e7$export$afda03cf7d29c99d = (0, $6SpLG.createSelector)([
    $59ab36ad2e41c3e7$export$79f4eaa748a6073a
], (analysisRequests)=>{
    return analysisRequests.filter((r)=>{
        const analysisRequestCodes = Object.keys(r.types);
        const isPending = analysisRequestCodes.some((typ)=>[
                (0, $8mxDx.AnalysisRequestState).TakenIntoAccount,
                (0, $8mxDx.AnalysisRequestState).IntegratedWorklist,
                (0, $8mxDx.AnalysisRequestState).RedoRequested
            ].includes(r.types[typ]));
        return isPending;
    });
});
const $59ab36ad2e41c3e7$export$2904fad7933da8d9 = (0, $6SpLG.createSelector)([
    $59ab36ad2e41c3e7$export$afda03cf7d29c99d,
    (state, inlogId)=>inlogId
], (pendingAnalyses, inlogId)=>{
    const analysisRequest = [];
    if (!pendingAnalyses) return analysisRequest;
    return Object.values(pendingAnalyses).reduce((memo, pending)=>{
        if (pending.ref.patient.inlogId !== inlogId) return memo;
        memo.push(pending);
        return memo;
    }, analysisRequest);
});
const $59ab36ad2e41c3e7$export$38109b313f8c30cd = (state)=>{
    return state.objects.byNamespace[0, $ksXGV.ANALYSIS_REAGENT_PROVIDER_NAMESPACE]?.byDomain[(0, $dPdDj.PrivacyDomain).Public]?.byId;
};
const $59ab36ad2e41c3e7$export$7a623b906753d889 = (0, $6SpLG.createSelector)([
    $59ab36ad2e41c3e7$export$38109b313f8c30cd
], (objects)=>{
    const items = [];
    if (!objects) return items;
    return Object.values(objects).reduce((memo, obj)=>{
        if (!("data" in obj)) return memo;
        memo.push(obj);
        return memo;
    }, items);
});
const $59ab36ad2e41c3e7$export$1b6ca92462dc0e3e = (0, $6SpLG.createSelector)([
    $59ab36ad2e41c3e7$export$7a623b906753d889
], (objects)=>{
    const analysisReagentByCode = {};
    Object.values(objects).map((analysisReagent)=>{
        return analysisReagentByCode[analysisReagent.data.code] = analysisReagent.data.label;
    });
    return analysisReagentByCode;
});
const $59ab36ad2e41c3e7$export$3e0c6d356fadb370 = (0, $6SpLG.createSelector)([
    $59ab36ad2e41c3e7$export$7a623b906753d889
], (objects)=>{
    return objects.map((obj)=>obj.data);
});
const $59ab36ad2e41c3e7$export$5af8860cb62bae5d = (state, code)=>{
    return (0, $hx2W4.selectObjectByAttr)(state, (0, $ksXGV.ANALYSIS_REAGENT_PROVIDER_NAMESPACE), (0, $dPdDj.PrivacyDomain).Public, "code", code);
};
const $59ab36ad2e41c3e7$export$e4e9d88691fd08c = (state)=>{
    return state.objects.byNamespace[0, $ksXGV.ANALYSIS_REQUEST_CATEGORY_NAMESPACE]?.byDomain[(0, $dPdDj.PrivacyDomain).Public]?.byId;
};
const $59ab36ad2e41c3e7$export$c0444b21aa1c2c17 = (0, $6SpLG.createSelector)([
    $59ab36ad2e41c3e7$export$e4e9d88691fd08c
], (objects)=>{
    const items = [];
    if (!objects) return items;
    return Object.values(objects).reduce((memo, obj)=>{
        if (!("data" in obj)) return memo;
        memo.push(obj);
        return memo;
    }, items);
});
const $59ab36ad2e41c3e7$export$65f255e53a865082 = (0, $6SpLG.createSelector)([
    $59ab36ad2e41c3e7$export$c0444b21aa1c2c17
], (objects)=>{
    return objects.map((obj)=>obj.data).sort((arc1, arc2)=>{
        if (arc1.code > arc2.code) return 1;
        if (arc1.code < arc2.code) return -1;
        return 0;
    });
});
const $59ab36ad2e41c3e7$export$e2dc599bd11fc4a = (0, $6SpLG.createSelector)([
    $59ab36ad2e41c3e7$export$c0444b21aa1c2c17
], (objects)=>{
    const analysisRequestCategoriesByCode = {};
    objects.map((category)=>{
        return analysisRequestCategoriesByCode[category.data.code] = category.data.label;
    });
    return analysisRequestCategoriesByCode;
});
const $59ab36ad2e41c3e7$export$41f2283710e98efe = (0, $6SpLG.createSelector)([
    (state, reagentProviderCode)=>$59ab36ad2e41c3e7$export$fa38053b6b0f871a(state, reagentProviderCode),
    $59ab36ad2e41c3e7$export$65f255e53a865082
], (analysisRequestCodes, analysisRequestCategories)=>{
    return analysisRequestCategories.filter((arc)=>analysisRequestCodes?.some((analysisRequestCode)=>analysisRequestCode.ref.analysisRequestCategory.code === arc.code));
});
const $59ab36ad2e41c3e7$export$c3ca0462516a7454 = (state, code)=>{
    return (0, $hx2W4.selectObjectByAttr)(state, (0, $ksXGV.ANALYSIS_REQUEST_CATEGORY_NAMESPACE), (0, $dPdDj.PrivacyDomain).Public, "code", code);
};
const $59ab36ad2e41c3e7$export$fcab5664a2fdda8f = (state)=>{
    return state.objects.byNamespace[0, $ksXGV.ANALYSIS_REQUEST_CODE_NAMESPACE]?.byDomain[(0, $dPdDj.PrivacyDomain).Public]?.byId;
};
const $59ab36ad2e41c3e7$export$28580fddc0240228 = (0, $6SpLG.createSelector)([
    $59ab36ad2e41c3e7$export$fcab5664a2fdda8f
], (objects)=>{
    const items = [];
    if (!objects) return items;
    return Object.values(objects).reduce((memo, obj)=>{
        if (!("data" in obj)) return memo;
        memo.push(obj);
        return memo;
    }, items);
});
const $59ab36ad2e41c3e7$export$69230b698d442035 = (state)=>{
    const objectsById = state.objects.byNamespace[0, $ksXGV.ANALYSIS_REQUEST_CODE_NAMESPACE]?.byDomain[(0, $dPdDj.PrivacyDomain).Public]?.byId;
    if (objectsById) {
        const items = [];
        Object.values(objectsById).reduce((memo, obj)=>{
            if (!("data" in obj)) return memo;
            memo.push(obj);
            return memo;
        }, items);
        const objectsFilter = Object.values(items).filter((obj)=>{
            return obj.data.lifecycle === (0, $8mxDx.AnalysisRequestCodeLifecycle).Synthesis;
        });
        const analysisRequestCode = [];
        return Object.values(objectsFilter).reduce((memo, obj)=>{
            if (!("data" in obj)) return memo;
            memo.push(obj.data.code);
            return memo;
        }, analysisRequestCode);
    }
    return undefined;
};
const $59ab36ad2e41c3e7$export$fa38053b6b0f871a = (0, $6SpLG.createSelector)([
    $59ab36ad2e41c3e7$export$28580fddc0240228,
    (state, reagentProviderCode)=>reagentProviderCode
], (analysisRequestCodes, reagentProviderCode)=>{
    return analysisRequestCodes.reduce((memo, obj)=>{
        if (!("data" in obj)) return memo;
        if (obj.data.ref.analysisReagentProvider.code === reagentProviderCode || !reagentProviderCode) memo.push(obj.data);
        return memo;
    }, []);
});
const $59ab36ad2e41c3e7$export$78e1e8c0e60a9e2c = (0, $6SpLG.createSelector)([
    $59ab36ad2e41c3e7$export$fcab5664a2fdda8f,
    (state, reagent)=>reagent ? $59ab36ad2e41c3e7$export$fa38053b6b0f871a(state, reagent) : undefined,
    (_state, _reagent, category)=>category
], (objectsById, analysisRequestCodes, category)=>{
    if (!objectsById || !analysisRequestCodes) return undefined;
    if (category && category.length > 0) return analysisRequestCodes.filter((code)=>code.ref.analysisRequestCategory.code === category);
    return analysisRequestCodes;
});
const $59ab36ad2e41c3e7$export$84a051b2c1afc97d = (0, $6SpLG.createSelector)([
    $59ab36ad2e41c3e7$export$1a14cb1aff2e644f
], (analysisRequests)=>{
    const analysisRequest = [];
    return analysisRequests.reduce((memo, obj)=>{
        const analysisRequestCodes = Object.keys(obj.data.types);
        const isPending = analysisRequestCodes.some((code)=>(0, $1chCp.isSelectableAnalysisState)(obj.data.types[code]));
        if (!isPending) return memo;
        memo.push(obj);
        return memo;
    }, analysisRequest);
});
const $59ab36ad2e41c3e7$export$2d5f4a50aa329c50 = (0, $6SpLG.createSelector)([
    $59ab36ad2e41c3e7$export$ec476fcf0bb920a7,
    (state, reagentProvider)=>reagentProvider,
    $59ab36ad2e41c3e7$export$fa38053b6b0f871a
], (pendingAnalysisRequests, reagentProvider, analysisRequestCodes)=>{
    return pendingAnalysisRequests.filter((analysisRequest)=>{
        return Object.keys(analysisRequest.types).some((code)=>{
            const analysisRequestCode = analysisRequestCodes?.find((arc)=>arc.code === code);
            if (!analysisRequestCode) return false;
            return analysisRequestCode.ref.analysisReagentProvider.code === reagentProvider;
        });
    });
});
const $59ab36ad2e41c3e7$export$586b81715b07be39 = (0, $6SpLG.createSelector)([
    $59ab36ad2e41c3e7$export$79f4eaa748a6073a,
    (state, worklist)=>worklist
], (analysisRequests, worklist)=>{
    if (!analysisRequests) return [];
    const filtered = new Set();
    worklist.selections.forEach((s)=>{
        const found = analysisRequests.find((r)=>{
            const matches = s.ref.analysisRequest.executorSampleId === r.executorSampleId && s.ref.analysisRequest.requestorSampleId === r.requestorSampleId && s.ref.analysisRequest.requestDate === r.requestDate && s.ref.analysisRequest.samplingEndDate === r.samplingEndDate && s.ref.analysisRequest.samplingStartDate === r.samplingStartDate;
            return matches;
        });
        if (!found) return;
        filtered.add(found);
    });
    return Array.from(filtered);
});
const $59ab36ad2e41c3e7$export$c5a7cbd25baee17e = (0, $6SpLG.createSelector)([
    $59ab36ad2e41c3e7$export$1a14cb1aff2e644f,
    $59ab36ad2e41c3e7$export$28580fddc0240228
], (analysisRequests, requestCodes)=>{
    const codes = new Set();
    requestCodes.forEach((rc)=>codes.add(rc.data.code));
    return analysisRequests.filter((ar)=>{
        const isHandled = Object.keys(ar.data.types).some((c)=>codes.has(c) && ar.data.types[c] !== (0, $8mxDx.AnalysisRequestState).Historized);
        return isHandled;
    });
});

});
parcelRegister("6SpLG", function(module, exports) {

$parcel$export(module.exports, "createSelector", () => $501bc638b8425ea6$export$595d22ed68ca2841);

var $9EdUm = parcelRequire("9EdUm");
function $501bc638b8425ea6$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $501bc638b8425ea6$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $501bc638b8425ea6$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $501bc638b8425ea6$export$595d22ed68ca2841 = /* #__PURE__ */ $501bc638b8425ea6$export$5943f4447f6ef248((0, $9EdUm.defaultMemoize));
var $501bc638b8425ea6$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $501bc638b8425ea6$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

});
parcelRegister("9EdUm", function(module, exports) {

$parcel$export(module.exports, "defaultMemoize", () => $7062a3595350e02d$export$281bff7f05488aa2);
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $7062a3595350e02d$var$NOT_FOUND = "NOT_FOUND";
function $7062a3595350e02d$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $7062a3595350e02d$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $7062a3595350e02d$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $7062a3595350e02d$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $7062a3595350e02d$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $7062a3595350e02d$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $7062a3595350e02d$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $7062a3595350e02d$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $7062a3595350e02d$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $7062a3595350e02d$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $7062a3595350e02d$var$createSingletonCache(comparator) : $7062a3595350e02d$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $7062a3595350e02d$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

});


parcelRegister("hx2W4", function(module, exports) {

$parcel$export(module.exports, "selectObjectByAttr", () => $bb7ef9cf61a2d1b0$export$cc9a5b2c1f89c4e6);
const $bb7ef9cf61a2d1b0$export$95fd90d13ea0ca98 = (state, namespace, domain, attr)=>{
    return state.objects.byNamespace[namespace]?.byDomain[domain]?.byAttr[attr];
};
const $bb7ef9cf61a2d1b0$export$681609bcc988346b = (state, namespace, domain, objectId)=>{
    const objects = state.objects.byNamespace[namespace]?.byDomain[domain]?.byId;
    if (!objects) return;
    return objects[objectId];
};
const $bb7ef9cf61a2d1b0$export$cc9a5b2c1f89c4e6 = (state, namespace, domain, attr, value)=>{
    const index = $bb7ef9cf61a2d1b0$export$95fd90d13ea0ca98(state, namespace, domain, attr);
    if (!index) return;
    const objectId = index[value];
    if (!objectId) return;
    return $bb7ef9cf61a2d1b0$export$681609bcc988346b(state, namespace, domain, objectId);
};

});

parcelRegister("1chCp", function(module, exports) {

$parcel$export(module.exports, "isSelectableAnalysisState", () => $420796e301b98167$export$3bc9464dfde3b2eb);
$parcel$export(module.exports, "findAnalysisRequestByRef", () => $420796e301b98167$export$89b4c3785509d705);
$parcel$export(module.exports, "matchRef", () => $420796e301b98167$export$22dfc04513b3ff1c);
$parcel$export(module.exports, "areRefEquals", () => $420796e301b98167$export$b1743b8f1fd7f319);

var $8mxDx = parcelRequire("8mxDx");
const $420796e301b98167$export$d3576cd54dfa09d2 = [
    (0, $8mxDx.AnalysisRequestState).TakenIntoAccount,
    (0, $8mxDx.AnalysisRequestState).RedoRequested
];
function $420796e301b98167$export$3bc9464dfde3b2eb(state) {
    return state !== undefined && $420796e301b98167$export$d3576cd54dfa09d2.includes(state);
}
function $420796e301b98167$export$7b147bd01058142c(analysisRequests) {
    return analysisRequests.some((ar)=>Object.values(ar.types).some((s)=>$420796e301b98167$export$3bc9464dfde3b2eb(s)));
}
function $420796e301b98167$export$89b4c3785509d705(analysisRequests, ref) {
    return analysisRequests.find((ar)=>$420796e301b98167$export$22dfc04513b3ff1c(ar, ref));
}
function $420796e301b98167$export$22dfc04513b3ff1c(analysisRequest, ref) {
    return analysisRequest.executorSampleId == ref.executorSampleId && analysisRequest.requestorSampleId === ref.requestorSampleId && analysisRequest.requestDate === ref.requestDate && analysisRequest.samplingEndDate === ref.samplingEndDate && analysisRequest.samplingStartDate === ref.samplingStartDate;
}
function $420796e301b98167$export$b1743b8f1fd7f319(ref1, ref2) {
    return ref1.executorSampleId == ref2.executorSampleId && ref1.requestorSampleId === ref2.requestorSampleId && ref1.requestDate === ref2.requestDate && ref1.samplingEndDate === ref2.samplingEndDate && ref1.samplingStartDate === ref2.samplingStartDate;
}

});

parcelRegister("kiWpr", function(module, exports) {

$parcel$export(module.exports, "collectPatientInlogIds", () => $16281f71d30d123b$export$edb26b5c74da9db9);
$parcel$export(module.exports, "formatPatientCount", () => $16281f71d30d123b$export$a9b85fd73617c846);

var $8mxDx = parcelRequire("8mxDx");
// Ticket #894 - Le bouton "Rafraîchir les résultats d'analyse" synchronisait
// tous les patients ayant une demande, soit près d'un millier chez l'EFS, ce
// qui occupe pendant des heures les connexions vers Fusion et MatchIt et
// retarde l'intégration des nouveaux résultats.
//
// Un examen n'attend plus rien de Fusion ou MatchIt une fois ses résultats
// transférés à Inlog (stade 6) ou s'il relève de la reprise de l'historique
// (stade 0). Tout autre stade peut encore voir arriver ou changer un résultat :
// feuille exportée, résultat reçu mais pas encore validé, examen à refaire.
const $16281f71d30d123b$var$SETTLED_STATES = new Set([
    (0, $8mxDx.AnalysisRequestState).TransferedResults,
    (0, $8mxDx.AnalysisRequestState).Historized
]);
function $16281f71d30d123b$export$ea9242e8e8de724f(request) {
    return Object.values(request.types ?? {}).some((state)=>!$16281f71d30d123b$var$SETTLED_STATES.has(state));
}
function $16281f71d30d123b$export$edb26b5c74da9db9(requests, { inProgressOnly: inProgressOnly }) {
    const inlogIds = new Set();
    for (const request of requests){
        if (inProgressOnly && !$16281f71d30d123b$export$ea9242e8e8de724f(request)) continue;
        inlogIds.add(request.ref.patient.inlogId);
    }
    return Array.from(inlogIds);
}
function $16281f71d30d123b$export$a9b85fd73617c846(count) {
    return `${count} patient${count > 1 ? "s" : ""}`;
}

});


parcelRegister("1Jthw", function(module, exports) {

$parcel$export(module.exports, "EVENT_REQUEST", () => $8768da0b029cf958$export$4f8e997e37ea2849);
$parcel$export(module.exports, "EVENT_REQUEST_SUCCESS", () => $8768da0b029cf958$export$e02e5fef77c46e2d);
$parcel$export(module.exports, "EVENT_REQUEST_FAILURE", () => $8768da0b029cf958$export$b3a3fc007b6115b1);
$parcel$export(module.exports, "EVENT_POLLING_START", () => $8768da0b029cf958$export$41d3ef1b2b83afc8);
$parcel$export(module.exports, "EVENT_POLLING_STOP", () => $8768da0b029cf958$export$5b31aedfe9f43e20);
$parcel$export(module.exports, "EVENT_MARK_VIEWED", () => $8768da0b029cf958$export$bac3872386aa1bd);
$parcel$export(module.exports, "fetchEvents", () => $8768da0b029cf958$export$2f6ec72f51ef1792);
$parcel$export(module.exports, "startEventPolling", () => $8768da0b029cf958$export$bb41ab304dca5428);
$parcel$export(module.exports, "stopEventPolling", () => $8768da0b029cf958$export$fd1843d4ce8e855b);
$parcel$export(module.exports, "markViewed", () => $8768da0b029cf958$export$473e07e18bc531cc);
const $8768da0b029cf958$export$4f8e997e37ea2849 = "EVENT_REQUEST";
const $8768da0b029cf958$export$e02e5fef77c46e2d = "EVENT_REQUEST_SUCCESS";
const $8768da0b029cf958$export$b3a3fc007b6115b1 = "EVENT_REQUEST_FAILURE";
const $8768da0b029cf958$export$41d3ef1b2b83afc8 = "EVENT_POLLING_START";
const $8768da0b029cf958$export$5b31aedfe9f43e20 = "EVENT_POLLING_STOP";
const $8768da0b029cf958$export$d9078bd3bafc48aa = "EVENT_POLLING_TICK";
const $8768da0b029cf958$export$bac3872386aa1bd = "EVENT_MARK_VIEWED";
function $8768da0b029cf958$export$2f6ec72f51ef1792(filter, options) {
    return {
        type: $8768da0b029cf958$export$4f8e997e37ea2849,
        options: options,
        filter: filter
    };
}
function $8768da0b029cf958$export$bb41ab304dca5428() {
    return {
        type: $8768da0b029cf958$export$41d3ef1b2b83afc8
    };
}
function $8768da0b029cf958$export$fd1843d4ce8e855b() {
    return {
        type: $8768da0b029cf958$export$5b31aedfe9f43e20
    };
}
function $8768da0b029cf958$export$473e07e18bc531cc() {
    return {
        type: $8768da0b029cf958$export$bac3872386aa1bd
    };
}

});

parcelRegister("9CNaS", function(module, exports) {

$parcel$export(module.exports, "EventObjectType", () => $ca2884de04f532f3$export$9751d6e7204203e);
$parcel$export(module.exports, "EventServerClient", () => $ca2884de04f532f3$export$9d1f0f56b99c66c3);

var $azn4s = parcelRequire("azn4s");

var $2m6N8 = parcelRequire("2m6N8");

var $jxJwM = parcelRequire("jxJwM");
var $ca2884de04f532f3$export$9751d6e7204203e;
(function(EventObjectType) {
    EventObjectType["OBJECT_CREATED"] = "object-created";
    EventObjectType["OBJECT_UPDATED"] = "object-updated";
})($ca2884de04f532f3$export$9751d6e7204203e || ($ca2884de04f532f3$export$9751d6e7204203e = {}));
class $ca2884de04f532f3$export$9d1f0f56b99c66c3 {
    constructor(baseUrl, idToken){
        this.baseUrl = baseUrl;
        this.idToken = idToken;
        this.fetchEvents = this.fetchEvents.bind(this);
    }
    async fetchEvents(filter, options) {
        //     Pour ce qui est du requêtage, tu as les paramètres d'URL suivants:
        // filter pour filtrer via le contenu de la propriété Data des différents évènements;
        // types pour filtrer par type d'évènement (en mode csv)
        // before/after pour filtrer par date de création de l'évènement
        // limit/offset pour la pagination
        let queryString = [];
        if (options?.offset !== undefined) queryString.push(`offset=${options.offset}`);
        if (options?.limit !== undefined) queryString.push(`limit=${options.limit}`);
        if (filter !== undefined) queryString.push(`filter=${encodeURIComponent(JSON.stringify(filter))}`);
        if (options?.before !== undefined) queryString.push(`before=${options.before}`);
        if (options?.after !== undefined) queryString.push(`after=${options.after}`);
        const url = `${this.baseUrl}/api/v1/events?${queryString.join("&")}`;
        const res = await (0, $2m6N8.fetchWithCredentials)(this.idToken, url, {
            method: "GET"
        });
        (0, $jxJwM.assertResponse)(res);
        const result = await res.json();
        return {
            total: result.data.Total,
            events: result.data.Events.map((event)=>$ca2884de04f532f3$var$itemToEventObject(event))
        };
    }
}
function $ca2884de04f532f3$var$itemToObjectHeader(item) {
    return {
        id: item.ID,
        createdAt: (0, $azn4s.asDate)(item.CreatedAt),
        type: item.Type,
        tenant: item.Tenant
    };
}
function $ca2884de04f532f3$var$itemToEventObject(item) {
    const obj = {
        ...$ca2884de04f532f3$var$itemToObjectHeader(item)
    };
    if (item.Data) obj.data = item.Data;
    return obj;
}

});

parcelRegister("8cFcE", function(module, exports) {

$parcel$export(module.exports, "HLA_RESULT_INACTIVATION_NAMESPACE", () => $dbfb63a5ba64a1b4$export$c149679199dcb850);
$parcel$export(module.exports, "queryPatientHLAResultInactivations", () => $dbfb63a5ba64a1b4$export$bc5404fd10ecd5f6);
$parcel$export(module.exports, "DISABLE_HLA_RESULT_REQUEST", () => $dbfb63a5ba64a1b4$export$97d07349fee9ad7f);
$parcel$export(module.exports, "DISABLE_HLA_RESULT_SUCCESS", () => $dbfb63a5ba64a1b4$export$7eaa40e3048314b9);
$parcel$export(module.exports, "DISABLE_HLA_RESULT_FAILURE", () => $dbfb63a5ba64a1b4$export$dadf09f120dee493);
$parcel$export(module.exports, "disableHLAResult", () => $dbfb63a5ba64a1b4$export$1b67fcaeb166dc94);
$parcel$export(module.exports, "ENABLE_HLA_RESULT_REQUEST", () => $dbfb63a5ba64a1b4$export$2564f4b9208df46a);
$parcel$export(module.exports, "ENABLE_HLA_RESULT_SUCCESS", () => $dbfb63a5ba64a1b4$export$4fe0f95368b7d63);
$parcel$export(module.exports, "ENABLE_HLA_RESULT_FAILURE", () => $dbfb63a5ba64a1b4$export$91ba6e18d44496c0);
$parcel$export(module.exports, "enableHLAResult", () => $dbfb63a5ba64a1b4$export$c228525780c21fd4);

var $i77HE = parcelRequire("i77HE");

var $aAq0B = parcelRequire("aAq0B");
const $dbfb63a5ba64a1b4$export$c149679199dcb850 = "hla-result-inactivation-v1";
function $dbfb63a5ba64a1b4$export$b49ea6e26d88e434(filter, options) {
    return (0, $aAq0B.queryObjects)($dbfb63a5ba64a1b4$export$c149679199dcb850, (0, $i77HE.PrivacyDomain).Public, filter, options);
}
function $dbfb63a5ba64a1b4$export$bc5404fd10ecd5f6(inlogId) {
    return (0, $aAq0B.queryObjects)($dbfb63a5ba64a1b4$export$c149679199dcb850, (0, $i77HE.PrivacyDomain).Public, {
        eq: {
            "ref.patient.inlogId": inlogId
        }
    }, {
        hydrate: true
    });
}
const $dbfb63a5ba64a1b4$export$97d07349fee9ad7f = "DISABLE_HLA_RESULT_REQUEST";
const $dbfb63a5ba64a1b4$export$7eaa40e3048314b9 = "DISABLE_HLA_RESULT_SUCCESS";
const $dbfb63a5ba64a1b4$export$dadf09f120dee493 = "DISABLE_HLA_RESULT_FAILURE";
function $dbfb63a5ba64a1b4$export$1b67fcaeb166dc94(inlogId, hlaResult) {
    return {
        type: $dbfb63a5ba64a1b4$export$97d07349fee9ad7f,
        inlogId: inlogId,
        hlaResult: hlaResult
    };
}
const $dbfb63a5ba64a1b4$export$2564f4b9208df46a = "ENABLE_HLA_RESULT_REQUEST";
const $dbfb63a5ba64a1b4$export$4fe0f95368b7d63 = "ENABLE_HLA_RESULT_SUCCESS";
const $dbfb63a5ba64a1b4$export$91ba6e18d44496c0 = "ENABLE_HLA_RESULT_FAILURE";
function $dbfb63a5ba64a1b4$export$c228525780c21fd4(inlogId, hlaResult) {
    return {
        type: $dbfb63a5ba64a1b4$export$2564f4b9208df46a,
        inlogId: inlogId,
        hlaResult: hlaResult
    };
}

});
parcelRegister("i77HE", function(module, exports) {
/** 
 * !!! DO NOT MODIFY !!!
 * 
 * File generated from types definition in project https://forge.cadoles.com/EFS/sheila.
 *
 * See misc/script/generate-type-defs.sh script for more informations.
 **/ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrivacyDomain = void 0;
var $d2fedb1738862763$var$PrivacyDomain;
(function(PrivacyDomain) {
    PrivacyDomain["Public"] = "public";
    PrivacyDomain["Private"] = "private";
})($d2fedb1738862763$var$PrivacyDomain || (module.exports.PrivacyDomain = $d2fedb1738862763$var$PrivacyDomain = {}));

});


parcelRegister("9Eclr", function(module, exports) {

$parcel$export(module.exports, "selectPatientHLAResultInactivationObjects", () => $5df99ca709d8a23d$export$40ee5fa45abc56c3);
$parcel$export(module.exports, "selectPatientAndClassHLAResultInactivationObjects", () => $5df99ca709d8a23d$export$7af642c6a98dfc3e);

var $6SpLG = parcelRequire("6SpLG");

var $8cFcE = parcelRequire("8cFcE");

var $i77HE = parcelRequire("i77HE");
const $5df99ca709d8a23d$export$3acf9924354c725f = (state)=>{
    return state.objects.byNamespace[0, $8cFcE.HLA_RESULT_INACTIVATION_NAMESPACE]?.byDomain[(0, $i77HE.PrivacyDomain).Public]?.byId;
};
const $5df99ca709d8a23d$export$3e9093310cb8fc17 = (0, $6SpLG.createSelector)($5df99ca709d8a23d$export$3acf9924354c725f, (items)=>{
    if (!items) return [];
    return Object.values(items).reduce((arr, object)=>{
        if ("data" in object) arr.push(object);
        return arr;
    }, []);
});
const $5df99ca709d8a23d$export$40ee5fa45abc56c3 = (0, $6SpLG.createSelector)([
    $5df99ca709d8a23d$export$3e9093310cb8fc17,
    (state, inlogId)=>inlogId
], (hlaResultInactivations, inlogId)=>{
    return hlaResultInactivations.filter((obj)=>obj.data.ref.patient.inlogId === inlogId);
});
const $5df99ca709d8a23d$export$7af642c6a98dfc3e = (0, $6SpLG.createSelector)([
    $5df99ca709d8a23d$export$40ee5fa45abc56c3,
    (state, inlogId, classname)=>classname
], (hlaResultInactivations, classname)=>{
    return hlaResultInactivations.filter((obj)=>obj.data.ref.hlaResult.class === classname);
});

});

parcelRegister("8fy6i", function(module, exports) {

$parcel$export(module.exports, "flattenWorkspaceResults", () => $1f6bf38537f5469a$export$8cd07b44b64bf52d);
$parcel$export(module.exports, "getDefaultInterpretations", () => $1f6bf38537f5469a$export$ffd19f44d027b941);
$parcel$export(module.exports, "extractAutoTranscodingComment", () => $1f6bf38537f5469a$export$e6950371748456ed);
$parcel$export(module.exports, "matchHLAResultRef", () => $1f6bf38537f5469a$export$7866f3dd3363f6db);
$parcel$export(module.exports, "areHLAResultRefEquals", () => $1f6bf38537f5469a$export$d44ab56244e7475d);
$parcel$export(module.exports, "EmptyHLAResultRef", () => $1f6bf38537f5469a$export$9dcf32bd2202d48f);
$parcel$export(module.exports, "toOptionalHLAResultRef", () => $1f6bf38537f5469a$export$6e6000a42f427e4d);

var $bsVS2 = parcelRequire("bsVS2");

var $69Qch = parcelRequire("69Qch");

var $bsdpf = parcelRequire("bsdpf");

var $ixNXR = parcelRequire("ixNXR");

var $iWAuu = parcelRequire("iWAuu");

var $6y0qB = parcelRequire("6y0qB");
function $1f6bf38537f5469a$export$8cd07b44b64bf52d(results) {
    const workspace = {};
    Object.keys(results.byClass).forEach((className)=>{
        Object.keys(results.byClass[className]).forEach((key)=>{
            workspace[`${className}-${key}`] = results.byClass[className][key];
        });
    });
    return workspace;
}
function $1f6bf38537f5469a$export$c9de1ec7c168d1c0(result) {
    let ordered = [
        ...result.data
    ];
    ordered = ordered.sort((a, b)=>a.normalValue !== null && b.normalValue !== null ? (0, $ixNXR.parseRound)(b.normalValue) - (0, $ixNXR.parseRound)(a.normalValue) : -1);
    return (0, $ixNXR.parseRound)(ordered[0].normalValue);
}
function $1f6bf38537f5469a$export$ffd19f44d027b941(hlaResults, hlaEngineResult, hlaEngineResultGroups) {
    const interpretations = {
        [(0, $69Qch.ClassName).CLASS1]: {},
        [(0, $69Qch.ClassName).CLASS2]: {}
    };
    Object.keys(hlaResults.byClass).forEach((className)=>{
        Object.values(hlaResults.byClass[className]).forEach((result)=>{
            result.data.data.forEach((d)=>{
                const specificitiesKey = (0, $iWAuu.toSpecificitiesKey)(d.specificities);
                if (!specificitiesKey) return;
                let best;
                if ((0, $bsVS2.isNullish)(interpretations[className][specificitiesKey])) interpretations[className][specificitiesKey] = {
                    allelic: specificitiesKey,
                    generic: d.specAbBr,
                    visible: d.visible
                };
                const synthesisGroupCode = hlaEngineResult.data.beads[specificitiesKey]?.resultGroups?.synthesis;
                if (!synthesisGroupCode) return;
                const synthesisGroup = hlaEngineResultGroups.find((g)=>g.data.type === (0, $6y0qB.HLAEngineResultGroupType).Synthesis && g.data.code === synthesisGroupCode);
                if (!synthesisGroup) return;
                interpretations[className][specificitiesKey].synthesis = synthesisGroup;
            });
        });
    });
    return interpretations;
}
function $1f6bf38537f5469a$export$b572f11f846ca8b1(interpretations) {
    const thresholdIdToInlogId = {
        forbidden: "AC1INT",
        neither: "AC1ZG",
        allowed: "AG1PER"
    };
    const thresholdIdToConcatInlogId = {
        neither: "ACTZG",
        allowed: "AGTPER"
    };
    const synthesis = {
        AC1INT: [],
        AC1ZG: [],
        ACTZG: [],
        AG1PER: [],
        AGTPER: []
    };
    const finalInterpretations = {};
    Object.keys(interpretations).forEach((className)=>{
        Object.keys(interpretations[className]).forEach((key)=>{
            if ((0, $bsVS2.isNullish)(finalInterpretations[interpretations[className][key].generic])) finalInterpretations[interpretations[className][key].generic] = interpretations[className][key].synthesis;
            if (!(0, $bsVS2.isNullish)(finalInterpretations[interpretations[className][key].generic]) && finalInterpretations[interpretations[className][key].generic] !== interpretations[className][key].synthesis) {
                if (finalInterpretations[interpretations[className][key].generic] === "allowed") finalInterpretations[interpretations[className][key].generic] = interpretations[className][key].synthesis;
                if (finalInterpretations[interpretations[className][key].generic] === "neither" && interpretations[className][key].synthesis === "forbidden") finalInterpretations[interpretations[className][key].generic] = interpretations[className][key].synthesis;
            }
        });
    });
    Object.keys(finalInterpretations).forEach((key)=>{
        if (synthesis[thresholdIdToInlogId[finalInterpretations[key]]].includes(key) === false) synthesis[thresholdIdToInlogId[finalInterpretations[key]]].push(key);
        if (!(0, $bsVS2.isNullish)(thresholdIdToConcatInlogId[finalInterpretations[key]]) && synthesis[thresholdIdToConcatInlogId[finalInterpretations[key]]].includes(key) === false) synthesis[thresholdIdToConcatInlogId[finalInterpretations[key]]].push(key);
    });
    return synthesis;
}
function $1f6bf38537f5469a$export$ea807812ba01452f(patient, hlaResults, donor) {
    const crossmatch = {};
    const flatDonorTyping = [];
    const flatPatientTyping = [];
    Object.keys(donor.typings).forEach((key)=>{
        Object.values(donor.typings[key]).forEach((typing)=>{
            flatDonorTyping.push(String(key + "*" + typing));
        });
    });
    Object.values((0, $bsdpf.TypingGroup)).forEach((group)=>{
        Object.keys(patient.flatTypings[(0, $bsdpf.TypingType).TYPAGE_BM]).forEach((tKey)=>{
            if (String(patient.flatTypings[(0, $bsdpf.TypingType).TYPAGE_BM][tKey]).startsWith(group)) flatPatientTyping.push(String(patient.flatTypings[(0, $bsdpf.TypingType).TYPAGE_BM][tKey]));
        });
    });
    flatDonorTyping.forEach((typing, index)=>{
        let fill = false;
        // Si la spé se termine par un tiret, elle est égale à la spé précédente
        const correctTyping = typing.endsWith("*") ? flatDonorTyping[index - 1] : typing;
        // Si la spé est vide dans le typage du patient, on fait sortir la spé dans le tableau
        if ((0, $bsVS2.isNullish)(flatPatientTyping[index])) {
            crossmatch[correctTyping] = {
                maxMFI: 0,
                date: new Date()
            };
            return;
        }
        // On applique le même traitement pour les autres spé comparées que pour la spé du donneur
        const currentPatientTyping = flatPatientTyping[index].endsWith("*") ? flatPatientTyping[index - 1] : flatPatientTyping[index];
        // si la spé est différente de la spé à la même position dans le typage patient, on fait sortir la spé dans le tableau
        if (correctTyping !== currentPatientTyping) fill = true;
        if (index % 2 === 0 && index < flatDonorTyping.length - 1) {
            const nextPatientTyping = flatPatientTyping[index + 1].endsWith("*") ? flatPatientTyping[index] : flatPatientTyping[index + 1];
            // si la spé est la première du locus, on la compare aussi à la 2ème du locus en face et si différente, on fait sortir la spé dans le tableau
            if (correctTyping !== nextPatientTyping) fill = true;
        } else {
            const previousPatientTyping = flatPatientTyping[index - 1].endsWith("*") ? flatPatientTyping[index - 2] : flatPatientTyping[index - 1];
            // si la spé est la deuxième du locus, on la compare aussi à la 1ère du locus en face et si différente, on fait sortir la spé dans le tableau
            if (correctTyping !== previousPatientTyping) fill = true;
        }
        if (fill) crossmatch[correctTyping] = {
            maxMFI: 0,
            date: new Date()
        };
    });
    Object.values(hlaResults.byClass[(0, $69Qch.ClassName).CLASS1]).forEach((result)=>{
        result.data.data.forEach((d)=>{
            const specificitiesKey = (0, $iWAuu.toSpecificitiesKey)(d.specificities);
            if (Object.keys(crossmatch).includes(specificitiesKey)) {
                const value = (0, $ixNXR.parseRound)(d.normalValue);
                crossmatch[specificitiesKey].maxMFI = (0, $bsVS2.isNullish)(crossmatch[specificitiesKey].maxMFI) ? value : Math.max(crossmatch[specificitiesKey].maxMFI, value ?? 0);
                if (crossmatch[specificitiesKey].maxMFI === value) crossmatch[specificitiesKey].date = result.data.ref.analysisRequest.requestDate;
            }
        });
    });
    return crossmatch;
}
const $1f6bf38537f5469a$var$AUTO_COMMENT_SECTION_START = "[AUTO-TRANSCODING]";
const $1f6bf38537f5469a$var$AUTO_COMMENT_SECTION_END = "[/AUTO-TRANSCODING]";
function $1f6bf38537f5469a$export$e6950371748456ed(comment) {
    if (!comment) return undefined;
    const startIdx = comment.indexOf($1f6bf38537f5469a$var$AUTO_COMMENT_SECTION_START);
    const endIdx = comment.indexOf($1f6bf38537f5469a$var$AUTO_COMMENT_SECTION_END);
    if (startIdx === -1 || endIdx === -1 || endIdx <= startIdx) return undefined;
    return comment.slice(startIdx + $1f6bf38537f5469a$var$AUTO_COMMENT_SECTION_START.length, endIdx).trim();
}
function $1f6bf38537f5469a$export$7866f3dd3363f6db(hlaResult, ref) {
    return $1f6bf38537f5469a$export$d44ab56244e7475d((0, $iWAuu.toHLAResultRef)(hlaResult.data), ref);
}
function $1f6bf38537f5469a$export$d44ab56244e7475d(ref1, ref2) {
    return ref1.batchDate === ref2.batchDate && ref1.catalogId === ref2.catalogId && ref1.class === ref2.class && ref1.origin === ref2.origin && ref1.sample === ref2.sample && (ref1.dilutionFactor ?? 0) === (ref2.dilutionFactor ?? 0);
}
const $1f6bf38537f5469a$export$9dcf32bd2202d48f = {
    batchDate: "",
    class: "",
    catalogId: "",
    origin: "",
    sample: "",
    dilutionFactor: 0
};
function $1f6bf38537f5469a$export$6e6000a42f427e4d(hlaResult) {
    return hlaResult ? (0, $iWAuu.toHLAResultRef)(hlaResult.data) : $1f6bf38537f5469a$export$9dcf32bd2202d48f;
}

});
parcelRegister("69Qch", function(module, exports) {
/** 
 * !!! DO NOT MODIFY !!!
 * 
 * File generated from types definition in project https://forge.cadoles.com/EFS/sheila.
 *
 * See misc/script/generate-type-defs.sh script for more informations.
 **/ "use strict";
var $47bc1293da5d14d3$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.classesLabels = module.exports.ClassName = void 0;
var $47bc1293da5d14d3$var$ClassName;
(function(ClassName) {
    ClassName["CLASS1"] = "class1";
    ClassName["CLASS2"] = "class2";
})($47bc1293da5d14d3$var$ClassName || (module.exports.ClassName = $47bc1293da5d14d3$var$ClassName = {}));
module.exports.classesLabels = ($47bc1293da5d14d3$var$_a = {}, $47bc1293da5d14d3$var$_a[$47bc1293da5d14d3$var$ClassName.CLASS1] = "Bilan Classe I", $47bc1293da5d14d3$var$_a[$47bc1293da5d14d3$var$ClassName.CLASS2] = "Bilan Classe 2", $47bc1293da5d14d3$var$_a);

});

parcelRegister("bsdpf", function(module, exports) {
/** 
 * !!! DO NOT MODIFY !!!
 * 
 * File generated from types definition in project https://forge.cadoles.com/EFS/sheila.
 *
 * See misc/script/generate-type-defs.sh script for more informations.
 **/ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TypingGroup = module.exports.TypingType = void 0;
var $856cb56a4b377c1d$var$TypingType;
(function(TypingType) {
    TypingType["TYPAGE_SERO"] = "TYPAGE_SERO";
    TypingType["TYPAGE_BM"] = "TYPAGE_BM";
})($856cb56a4b377c1d$var$TypingType || (module.exports.TypingType = $856cb56a4b377c1d$var$TypingType = {}));
var $856cb56a4b377c1d$var$TypingGroup;
(function(TypingGroup) {
    TypingGroup["A"] = "A";
    TypingGroup["B"] = "B";
    TypingGroup["Bw"] = "Bw";
    TypingGroup["C"] = "C";
    TypingGroup["DR"] = "DR";
    TypingGroup["DRB1"] = "DRB1";
    TypingGroup["DRB2"] = "DRB2";
    TypingGroup["DRB3"] = "DRB3";
    TypingGroup["DRB4"] = "DRB4";
    TypingGroup["DRB5"] = "DRB5";
    TypingGroup["DQ"] = "DQ";
    TypingGroup["DQB1"] = "DQB1";
    TypingGroup["DQA1"] = "DQA1";
    TypingGroup["DP"] = "DP";
    TypingGroup["DPB1"] = "DPB1";
    TypingGroup["DPA1"] = "DPA1";
})($856cb56a4b377c1d$var$TypingGroup || (module.exports.TypingGroup = $856cb56a4b377c1d$var$TypingGroup = {}));

});

parcelRegister("ixNXR", function(module, exports) {

$parcel$export(module.exports, "parseRound", () => $fb12499c5930ea0c$export$a931b96199c840a9);
function $fb12499c5930ea0c$export$a931b96199c840a9(raw) {
    return Math.round(parseFloat(raw));
}

});

parcelRegister("iWAuu", function(module, exports) {
/** 
 * !!! DO NOT MODIFY !!!
 * 
 * File generated from types definition in project https://forge.cadoles.com/EFS/sheila.
 *
 * See misc/script/generate-type-defs.sh script for more informations.
 **/ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toSpecificitiesKey = module.exports.toHLAResultRef = void 0;
function $dca9f31b0386c5ae$var$toHLAResultRef(hlaResult) {
    return {
        batchDate: hlaResult.batchDate,
        class: hlaResult.class,
        catalogId: hlaResult.catalogId,
        origin: hlaResult.origin,
        sample: hlaResult.sample,
        dilutionFactor: hlaResult.dilutionFactor
    };
}
module.exports.toHLAResultRef = $dca9f31b0386c5ae$var$toHLAResultRef;
function $dca9f31b0386c5ae$var$toSpecificitiesKey(specificities) {
    return specificities.filter(function(s) {
        return !!s;
    }).join("-");
}
module.exports.toSpecificitiesKey = $dca9f31b0386c5ae$var$toSpecificitiesKey;

});

parcelRegister("6y0qB", function(module, exports) {
/** 
 * !!! DO NOT MODIFY !!!
 * 
 * File generated from types definition in project https://forge.cadoles.com/EFS/sheila.
 *
 * See misc/script/generate-type-defs.sh script for more informations.
 **/ "use strict";
var $4c46400cf60139b4$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.matchInterpolatedThresholds = module.exports.matchThresholds = module.exports.interpolateThresholds = module.exports.sortGroupByFrameMax = module.exports.getThresholdFrame = module.exports.findBestMatchingGroup = module.exports.flattenVariables = module.exports.HLAEngineResultGroupThresholdOperator = module.exports.HLAEngineResultGroupType = void 0;

var $8Ijrh = parcelRequire("8Ijrh");
var $4c46400cf60139b4$var$HLAEngineResultGroupType;
(function(HLAEngineResultGroupType) {
    HLAEngineResultGroupType["Punctual"] = "punctual";
    HLAEngineResultGroupType["Binary"] = "binary";
    HLAEngineResultGroupType["Synthesis"] = "synthesis";
    HLAEngineResultGroupType["DSA"] = "dsa";
    HLAEngineResultGroupType["Crossmatch"] = "crossmatch";
})($4c46400cf60139b4$var$HLAEngineResultGroupType || (module.exports.HLAEngineResultGroupType = $4c46400cf60139b4$var$HLAEngineResultGroupType = {}));
var $4c46400cf60139b4$var$HLAEngineResultGroupThresholdOperator;
(function(HLAEngineResultGroupThresholdOperator) {
    HLAEngineResultGroupThresholdOperator["GT"] = ">";
    HLAEngineResultGroupThresholdOperator["GTE"] = ">=";
    HLAEngineResultGroupThresholdOperator["LT"] = "<";
    HLAEngineResultGroupThresholdOperator["LTE"] = "<=";
})($4c46400cf60139b4$var$HLAEngineResultGroupThresholdOperator || (module.exports.HLAEngineResultGroupThresholdOperator = $4c46400cf60139b4$var$HLAEngineResultGroupThresholdOperator = {}));
var $4c46400cf60139b4$var$thresholdFuncs = ($4c46400cf60139b4$var$_a = {}, $4c46400cf60139b4$var$_a[$4c46400cf60139b4$var$HLAEngineResultGroupThresholdOperator.GT] = function(v, t) {
    return v > t;
}, $4c46400cf60139b4$var$_a[$4c46400cf60139b4$var$HLAEngineResultGroupThresholdOperator.GTE] = function(v, t) {
    return v >= t;
}, $4c46400cf60139b4$var$_a[$4c46400cf60139b4$var$HLAEngineResultGroupThresholdOperator.LT] = function(v, t) {
    return v < t;
}, $4c46400cf60139b4$var$_a[$4c46400cf60139b4$var$HLAEngineResultGroupThresholdOperator.LTE] = function(v, t) {
    return v <= t;
}, $4c46400cf60139b4$var$_a);
function $4c46400cf60139b4$var$flattenVariables(variables) {
    var types = [];
    for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
    var flatten = {};
    variables.forEach(function(v) {
        if (types.length > 0 && types.indexOf(v.type) === -1) return;
        flatten[v.name] = v.value;
    });
    return flatten;
}
module.exports.flattenVariables = $4c46400cf60139b4$var$flattenVariables;
// Retourne le groupe de résultat le plus spécifiquement proche de la valeur données
// i.e. qui encadre de manière la plus précise celle ci.
function $4c46400cf60139b4$var$findBestMatchingGroup(groups, variables, value) {
    var flattened = $4c46400cf60139b4$var$flattenVariables(variables, $8Ijrh.HLAEngineVariableType.Number);
    var matches = groups.filter(function(group) {
        return $4c46400cf60139b4$var$matchThresholds(group.thresholds, flattened, value);
    });
    // On recherche le groupe le plus spécifique i.e.
    // celui avec les plus de seuils définis
    matches.sort(function(g1, g2) {
        var i1 = $4c46400cf60139b4$var$interpolateThresholds(g1.thresholds, flattened);
        var i2 = $4c46400cf60139b4$var$interpolateThresholds(g2.thresholds, flattened);
        var f1 = $4c46400cf60139b4$var$getThresholdFrame(i1);
        var f2 = $4c46400cf60139b4$var$getThresholdFrame(i2);
        var r1 = f1[1] - f1[0];
        var r2 = f2[1] - f2[0];
        if (r1 > r2) return 1;
        if (r1 < r2) return -1;
        return 0;
    });
    return matches[0];
}
module.exports.findBestMatchingGroup = $4c46400cf60139b4$var$findBestMatchingGroup;
function $4c46400cf60139b4$var$getThresholdFrame(thresholds) {
    var min = thresholds[$4c46400cf60139b4$var$HLAEngineResultGroupThresholdOperator.GT] || thresholds[$4c46400cf60139b4$var$HLAEngineResultGroupThresholdOperator.GTE] || Number.MIN_SAFE_INTEGER;
    var max = thresholds[$4c46400cf60139b4$var$HLAEngineResultGroupThresholdOperator.LT] || thresholds[$4c46400cf60139b4$var$HLAEngineResultGroupThresholdOperator.LTE] || Number.MAX_SAFE_INTEGER;
    return [
        min,
        max
    ];
}
module.exports.getThresholdFrame = $4c46400cf60139b4$var$getThresholdFrame;
function $4c46400cf60139b4$var$sortGroupByFrameMax(t1, t2) {
    var _a = $4c46400cf60139b4$var$getThresholdFrame(t1), min1 = _a[0], max1 = _a[1];
    var _b = $4c46400cf60139b4$var$getThresholdFrame(t2), min2 = _b[0], max2 = _b[1];
    // First compare by minimum (the lower bound determines the "level")
    // OK < ZG < NOK because OK has min=MIN, ZG has min=MIN, NOK has min=1000
    if (min1 > min2) return 1;
    if (min1 < min2) return -1;
    // If minimums are equal, compare by maximum as secondary criteria
    if (max1 > max2) return 1;
    if (max1 < max2) return -1;
    return 0;
}
module.exports.sortGroupByFrameMax = $4c46400cf60139b4$var$sortGroupByFrameMax;
function $4c46400cf60139b4$var$interpolateThresholds(thresholds, vars) {
    var interpolated = {};
    Object.keys(thresholds).forEach(function(op) {
        interpolated[op] = vars[thresholds[op]];
    });
    return interpolated;
}
module.exports.interpolateThresholds = $4c46400cf60139b4$var$interpolateThresholds;
function $4c46400cf60139b4$var$matchThresholds(thresholds, vars, value) {
    var interpolated = $4c46400cf60139b4$var$interpolateThresholds(thresholds, vars);
    return $4c46400cf60139b4$var$matchInterpolatedThresholds(interpolated, value);
}
module.exports.matchThresholds = $4c46400cf60139b4$var$matchThresholds;
function $4c46400cf60139b4$var$matchInterpolatedThresholds(thresholds, value) {
    var operators = Object.keys(thresholds);
    if (operators.length === 0) return true;
    for(var i = 0; i < operators.length; i++){
        var op = operators[i];
        if ($4c46400cf60139b4$var$thresholdFuncs[op] === undefined) throw new Error("Could not find threshold function associated to operator '".concat(op, "' !"));
        var match = $4c46400cf60139b4$var$thresholdFuncs[op](value, thresholds[op]);
        if (!match) return false;
    }
    return true;
}
module.exports.matchInterpolatedThresholds = $4c46400cf60139b4$var$matchInterpolatedThresholds;

});
parcelRegister("8Ijrh", function(module, exports) {
/** 
 * !!! DO NOT MODIFY !!!
 * 
 * File generated from types definition in project https://forge.cadoles.com/EFS/sheila.
 *
 * See misc/script/generate-type-defs.sh script for more informations.
 **/ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HLAEngineVariableType = void 0;
var $658182f9019db521$var$HLAEngineVariableType;
(function(HLAEngineVariableType) {
    HLAEngineVariableType["Text"] = "text";
    HLAEngineVariableType["Number"] = "number";
    HLAEngineVariableType["Boolean"] = "boolean";
})($658182f9019db521$var$HLAEngineVariableType || (module.exports.HLAEngineVariableType = $658182f9019db521$var$HLAEngineVariableType = {}));

});



parcelRegister("6pLjA", function(module, exports) {

$parcel$export(module.exports, "HLA_ENGINE_RULE_NAMESPACE", () => $c98f00e378c22ba8$export$2b38f66ae9e6bf2f);
$parcel$export(module.exports, "queryPublicHLAEngineRules", () => $c98f00e378c22ba8$export$2346169c2047714e);
$parcel$export(module.exports, "updatePublicHLAEngineRule", () => $c98f00e378c22ba8$export$46d14e766a5e08f8);
$parcel$export(module.exports, "createPublicHLAEngineRule", () => $c98f00e378c22ba8$export$997f5d0e2119cb7b);
$parcel$export(module.exports, "deletePublicHLAEngineRule", () => $c98f00e378c22ba8$export$a2343832b901ea01);
$parcel$export(module.exports, "HLA_ENGINE_VARIABLE_NAMESPACE", () => $c98f00e378c22ba8$export$a122d3ffe10e5a12);
$parcel$export(module.exports, "queryPublicHLAEngineVariables", () => $c98f00e378c22ba8$export$181617ddb2eba513);
$parcel$export(module.exports, "queryPatientHLAEngineVariables", () => $c98f00e378c22ba8$export$378dfdc19f967b7a);
$parcel$export(module.exports, "updatePublicHLAEngineVariable", () => $c98f00e378c22ba8$export$ce43f1301cb3c37e);
$parcel$export(module.exports, "createPublicHLAEngineVariable", () => $c98f00e378c22ba8$export$db4b32a4221c8e57);
$parcel$export(module.exports, "deletePublicHLAEngineVariable", () => $c98f00e378c22ba8$export$3a194df353de32bd);
$parcel$export(module.exports, "HLA_ENGINE_RUNE_INACTIVATION_NAMESPACE", () => $c98f00e378c22ba8$export$df8856f3c8a0c3e5);
$parcel$export(module.exports, "queryPublicHLAEngineRuleInactivations", () => $c98f00e378c22ba8$export$700c01da14b8871d);
$parcel$export(module.exports, "updatePublicHLAEngineRuleInactivation", () => $c98f00e378c22ba8$export$b7b29c1dce448e26);
$parcel$export(module.exports, "createPublicHLAEngineRuleInactivation", () => $c98f00e378c22ba8$export$e759431720e11042);
$parcel$export(module.exports, "HLA_ENGINE_TRACE_NAMESPACE", () => $c98f00e378c22ba8$export$11aa88635011ecbb);
$parcel$export(module.exports, "queryPublicHLAEngineTraces", () => $c98f00e378c22ba8$export$7b8d0c182575e9b6);
$parcel$export(module.exports, "HLA_ENGINE_RESULT_NAMESPACE", () => $c98f00e378c22ba8$export$4be208a7ef483732);
$parcel$export(module.exports, "queryPublicHLAEngineResults", () => $c98f00e378c22ba8$export$e6dc7efc24021a11);
$parcel$export(module.exports, "queryPatientHLAEngineResults", () => $c98f00e378c22ba8$export$d7dbdb5850e69ecd);
$parcel$export(module.exports, "HLA_ENGINE_RESULT_GROUP_NAMESPACE", () => $c98f00e378c22ba8$export$a66112ae7ccc602f);
$parcel$export(module.exports, "queryPublicHLAEngineResultGroups", () => $c98f00e378c22ba8$export$2ee24e3a14c7bdce);
$parcel$export(module.exports, "updatePublicHLAEngineResultGroup", () => $c98f00e378c22ba8$export$51f189a9085c4a6c);
$parcel$export(module.exports, "createPublicHLAEngineResultGroup", () => $c98f00e378c22ba8$export$ec294f508e244930);
$parcel$export(module.exports, "deletePublicHLAEngineResultGroup", () => $c98f00e378c22ba8$export$dbc5a70ea3997af8);

var $dPdDj = parcelRequire("dPdDj");

var $aAq0B = parcelRequire("aAq0B");
const $c98f00e378c22ba8$export$2b38f66ae9e6bf2f = "hla-engine-rule-v1";
function $c98f00e378c22ba8$export$2346169c2047714e(filter, options) {
    return (0, $aAq0B.queryObjects)($c98f00e378c22ba8$export$2b38f66ae9e6bf2f, (0, $dPdDj.PrivacyDomain).Public, filter, options);
}
function $c98f00e378c22ba8$export$46d14e766a5e08f8(objectId, data, partial) {
    return (0, $aAq0B.updateObject)($c98f00e378c22ba8$export$2b38f66ae9e6bf2f, (0, $dPdDj.PrivacyDomain).Public, objectId, data, partial, {
        tenant: "*"
    });
}
function $c98f00e378c22ba8$export$997f5d0e2119cb7b(data) {
    return (0, $aAq0B.createObject)($c98f00e378c22ba8$export$2b38f66ae9e6bf2f, (0, $dPdDj.PrivacyDomain).Public, data, {
        tenant: "*"
    });
}
function $c98f00e378c22ba8$export$a2343832b901ea01(objectId) {
    return (0, $aAq0B.deleteObject)($c98f00e378c22ba8$export$2b38f66ae9e6bf2f, (0, $dPdDj.PrivacyDomain).Public, objectId, {
        tenant: "*"
    });
}
const $c98f00e378c22ba8$export$a122d3ffe10e5a12 = "hla-engine-variable-v1";
function $c98f00e378c22ba8$export$181617ddb2eba513(filter, options) {
    return (0, $aAq0B.queryObjects)($c98f00e378c22ba8$export$a122d3ffe10e5a12, (0, $dPdDj.PrivacyDomain).Public, filter, options);
}
function $c98f00e378c22ba8$export$378dfdc19f967b7a(inlogId) {
    return (0, $aAq0B.queryObjects)($c98f00e378c22ba8$export$a122d3ffe10e5a12, (0, $dPdDj.PrivacyDomain).Public, {
        or: [
            {
                exist: {
                    "ref.patient.inlogId": false
                }
            },
            {
                eq: {
                    "ref.patient.inlogId": inlogId
                }
            }
        ]
    }, {
        hydrate: true
    });
}
function $c98f00e378c22ba8$export$ce43f1301cb3c37e(objectId, data, partial) {
    return (0, $aAq0B.updateObject)($c98f00e378c22ba8$export$a122d3ffe10e5a12, (0, $dPdDj.PrivacyDomain).Public, objectId, data, partial);
}
function $c98f00e378c22ba8$export$db4b32a4221c8e57(data) {
    return (0, $aAq0B.createObject)($c98f00e378c22ba8$export$a122d3ffe10e5a12, (0, $dPdDj.PrivacyDomain).Public, data);
}
function $c98f00e378c22ba8$export$3a194df353de32bd(objectId) {
    return (0, $aAq0B.deleteObject)($c98f00e378c22ba8$export$a122d3ffe10e5a12, (0, $dPdDj.PrivacyDomain).Public, objectId);
}
const $c98f00e378c22ba8$export$df8856f3c8a0c3e5 = "hla-engine-rule-inactivation-v1";
function $c98f00e378c22ba8$export$700c01da14b8871d(filter, options) {
    return (0, $aAq0B.queryObjects)($c98f00e378c22ba8$export$df8856f3c8a0c3e5, (0, $dPdDj.PrivacyDomain).Public, filter, options);
}
function $c98f00e378c22ba8$export$b7b29c1dce448e26(objectId, data, partial) {
    return (0, $aAq0B.updateObject)($c98f00e378c22ba8$export$df8856f3c8a0c3e5, (0, $dPdDj.PrivacyDomain).Public, objectId, data, partial);
}
function $c98f00e378c22ba8$export$e759431720e11042(data) {
    return (0, $aAq0B.createObject)($c98f00e378c22ba8$export$df8856f3c8a0c3e5, (0, $dPdDj.PrivacyDomain).Public, data);
}
function $c98f00e378c22ba8$export$49c1cd75c92dadf(objectId) {
    return (0, $aAq0B.deleteObject)($c98f00e378c22ba8$export$df8856f3c8a0c3e5, (0, $dPdDj.PrivacyDomain).Public, objectId);
}
const $c98f00e378c22ba8$export$11aa88635011ecbb = "hla-engine-trace-v1";
function $c98f00e378c22ba8$export$7b8d0c182575e9b6(filter, options) {
    return (0, $aAq0B.queryObjects)($c98f00e378c22ba8$export$11aa88635011ecbb, (0, $dPdDj.PrivacyDomain).Public, filter, options);
}
const $c98f00e378c22ba8$export$4be208a7ef483732 = "hla-engine-result-v1";
function $c98f00e378c22ba8$export$e6dc7efc24021a11(filter, options) {
    return (0, $aAq0B.queryObjects)($c98f00e378c22ba8$export$4be208a7ef483732, (0, $dPdDj.PrivacyDomain).Public, filter, options);
}
function $c98f00e378c22ba8$export$d7dbdb5850e69ecd(inlogId) {
    return $c98f00e378c22ba8$export$e6dc7efc24021a11({
        eq: {
            "ref.patient.inlogId": inlogId
        }
    }, {
        hydrate: true
    });
}
const $c98f00e378c22ba8$export$a66112ae7ccc602f = "hla-engine-result-group-v1";
function $c98f00e378c22ba8$export$7e7141e764b008f3(objectId) {
    return (0, $aAq0B.fetchObject)($c98f00e378c22ba8$export$a66112ae7ccc602f, (0, $dPdDj.PrivacyDomain).Public, objectId);
}
function $c98f00e378c22ba8$export$2ee24e3a14c7bdce(filter, options) {
    return (0, $aAq0B.queryObjects)($c98f00e378c22ba8$export$a66112ae7ccc602f, (0, $dPdDj.PrivacyDomain).Public, filter, options);
}
function $c98f00e378c22ba8$export$51f189a9085c4a6c(objectId, data, partial) {
    return (0, $aAq0B.updateObject)($c98f00e378c22ba8$export$a66112ae7ccc602f, (0, $dPdDj.PrivacyDomain).Public, objectId, data, partial);
}
function $c98f00e378c22ba8$export$ec294f508e244930(data) {
    return (0, $aAq0B.createObject)($c98f00e378c22ba8$export$a66112ae7ccc602f, (0, $dPdDj.PrivacyDomain).Public, data);
}
function $c98f00e378c22ba8$export$dbc5a70ea3997af8(objectId) {
    return (0, $aAq0B.deleteObject)($c98f00e378c22ba8$export$a66112ae7ccc602f, (0, $dPdDj.PrivacyDomain).Public, objectId);
}

});

parcelRegister("fVgcf", function(module, exports) {

$parcel$export(module.exports, "HLA_SYNTHESIS_NAMESPACE", () => $a6d4a02ec40dd0e4$export$422992abae55a876);
$parcel$export(module.exports, "fetchPublicHLASynthesis", () => $a6d4a02ec40dd0e4$export$70b58b307296fe56);
$parcel$export(module.exports, "queryPatientHLASynthesis", () => $a6d4a02ec40dd0e4$export$f16a5180731caf57);
$parcel$export(module.exports, "updateHLASynthesis", () => $a6d4a02ec40dd0e4$export$c718a28b1d053980);

var $dPdDj = parcelRequire("dPdDj");

var $aAq0B = parcelRequire("aAq0B");
const $a6d4a02ec40dd0e4$export$422992abae55a876 = "hla-synthesis-v1";
function $a6d4a02ec40dd0e4$export$70b58b307296fe56(objectId) {
    return (0, $aAq0B.fetchObject)($a6d4a02ec40dd0e4$export$422992abae55a876, (0, $dPdDj.PrivacyDomain).Public, objectId);
}
function $a6d4a02ec40dd0e4$export$2522f009c7f76b37(filter, options) {
    return (0, $aAq0B.queryObjects)($a6d4a02ec40dd0e4$export$422992abae55a876, (0, $dPdDj.PrivacyDomain).Public, filter, options);
}
function $a6d4a02ec40dd0e4$export$f16a5180731caf57(inlogId) {
    return $a6d4a02ec40dd0e4$export$2522f009c7f76b37({
        eq: {
            "ref.patient.inlogId": inlogId
        }
    }, {
        hydrate: true
    });
}
function $a6d4a02ec40dd0e4$export$c718a28b1d053980(objectId, hlaSynthesis, partial = false) {
    return (0, $aAq0B.updateObject)($a6d4a02ec40dd0e4$export$422992abae55a876, (0, $dPdDj.PrivacyDomain).Public, objectId, hlaSynthesis, partial);
}

});

parcelRegister("jPTl4", function(module, exports) {

$parcel$export(module.exports, "isNotificationSupported", () => $52f18144586d69fc$export$cb0eb2864361d1dd);
$parcel$export(module.exports, "getNotificationPermission", () => $52f18144586d69fc$export$a341f17b69d740b0);
$parcel$export(module.exports, "isNotificationEnabled", () => $52f18144586d69fc$export$c89921b0744a8ce5);
$parcel$export(module.exports, "requestNotificationPermission", () => $52f18144586d69fc$export$16e7a388eb6d6d1);
$parcel$export(module.exports, "showDesktopNotification", () => $52f18144586d69fc$export$182169276665e208);

var $dSjLu = parcelRequire("dSjLu");
function $52f18144586d69fc$export$cb0eb2864361d1dd() {
    return "Notification" in window;
}
function $52f18144586d69fc$export$a341f17b69d740b0() {
    if (!$52f18144586d69fc$export$cb0eb2864361d1dd()) return "denied";
    return Notification.permission;
}
function $52f18144586d69fc$export$c89921b0744a8ce5() {
    return $52f18144586d69fc$export$a341f17b69d740b0() === "granted";
}
async function $52f18144586d69fc$export$16e7a388eb6d6d1() {
    if (!$52f18144586d69fc$export$cb0eb2864361d1dd()) {
        console.warn("Browser does not support notifications");
        return "denied";
    }
    try {
        const permission = await Notification.requestPermission();
        return permission;
    } catch (error) {
        console.error("Error requesting notification permission:", error);
        return "denied";
    }
}
/**
 * Map notification status to HTML5 notification options
 */ function $52f18144586d69fc$var$getNotificationOptions(notification) {
    const options = {
        body: notification.message,
        icon: $52f18144586d69fc$var$getIconForStatus(notification.status),
        tag: `notification-${Date.now()}`,
        requireInteraction: notification.status === (0, $dSjLu.NotificationStatus).error
    };
    if (notification.detail) options.body = `${notification.message}\n${notification.detail}`;
    return options;
}
/**
 * Get the appropriate icon for the notification status
 */ function $52f18144586d69fc$var$getIconForStatus(status) {
    // Return undefined to use browser default icons
    // In a production app, you might want to use absolute URLs to your icons
    switch(status){
        case (0, $dSjLu.NotificationStatus).success:
            return undefined;
        case (0, $dSjLu.NotificationStatus).warning:
            return undefined;
        case (0, $dSjLu.NotificationStatus).error:
            return undefined;
        case (0, $dSjLu.NotificationStatus).info:
            return undefined;
        default:
            return undefined;
    }
}
function $52f18144586d69fc$export$182169276665e208(notification) {
    if (!$52f18144586d69fc$export$cb0eb2864361d1dd()) {
        console.warn("Browser does not support notifications");
        return null;
    }
    if (!$52f18144586d69fc$export$c89921b0744a8ce5()) {
        console.warn("Notifications are not enabled. Permission status:", $52f18144586d69fc$export$a341f17b69d740b0());
        return null;
    }
    try {
        const options = $52f18144586d69fc$var$getNotificationOptions(notification);
        const desktopNotification = new Notification(notification.message, options);
        // Auto-close after 5 seconds for non-error notifications
        if (notification.status !== (0, $dSjLu.NotificationStatus).error) setTimeout(()=>{
            desktopNotification.close();
        }, 5000);
        return desktopNotification;
    } catch (error) {
        console.error("Error showing desktop notification:", error);
        return null;
    }
}
function $52f18144586d69fc$export$b85261bb6d0aba67(notification, onClick, onClose) {
    const desktopNotification = $52f18144586d69fc$export$182169276665e208(notification);
    if (desktopNotification && onClick) desktopNotification.onclick = ()=>{
        onClick();
        desktopNotification.close();
        // Focus the window when notification is clicked
        window.focus();
    };
    if (desktopNotification && onClose) desktopNotification.onclose = onClose;
    return desktopNotification;
}

});

parcelRegister("6zmIz", function(module, exports) {

$parcel$export(module.exports, "PATIENT_NAMESPACE", () => $d75a4309befa023f$export$441e1139049e1abe);
$parcel$export(module.exports, "queryPublicPatients", () => $d75a4309befa023f$export$ac193d34f085bd5f);
$parcel$export(module.exports, "fetchPatientByInlogId", () => $d75a4309befa023f$export$4d38e7def69815c);

var $dPdDj = parcelRequire("dPdDj");

var $aAq0B = parcelRequire("aAq0B");
const $d75a4309befa023f$export$654265b17e31dffb = "PATIENT_SET_CURRENT";
const $d75a4309befa023f$export$e908d123e30baf6 = "PATIENT_SET_CURRENT_PROPS";
function $d75a4309befa023f$export$5100c5006017d982(patient) {
    return {
        type: $d75a4309befa023f$export$654265b17e31dffb,
        patient: patient
    };
}
function $d75a4309befa023f$export$4e393c45f2abf63e(props) {
    return {
        type: $d75a4309befa023f$export$e908d123e30baf6,
        props: props
    };
}
const $d75a4309befa023f$export$441e1139049e1abe = "patient-v2";
function $d75a4309befa023f$export$cd79bcec2114a5e5(patientId) {
    return (0, $aAq0B.fetchObject)($d75a4309befa023f$export$441e1139049e1abe, (0, $dPdDj.PrivacyDomain).Public, patientId);
}
function $d75a4309befa023f$export$ac193d34f085bd5f(filter, options) {
    return (0, $aAq0B.queryObjects)($d75a4309befa023f$export$441e1139049e1abe, (0, $dPdDj.PrivacyDomain).Public, filter, options);
}
function $d75a4309befa023f$export$44aa8a58b7633ea1(objectId, patient) {
    return (0, $aAq0B.updateObject)($d75a4309befa023f$export$441e1139049e1abe, (0, $dPdDj.PrivacyDomain).Public, objectId, patient);
}
function $d75a4309befa023f$export$2596bcc20f9b30ba(patient) {
    return (0, $aAq0B.createObject)($d75a4309befa023f$export$441e1139049e1abe, (0, $dPdDj.PrivacyDomain).Public, patient);
}
function $d75a4309befa023f$export$299393b2b025b4d7(patientId) {
    return (0, $aAq0B.deleteObject)($d75a4309befa023f$export$441e1139049e1abe, (0, $dPdDj.PrivacyDomain).Public, patientId);
}
const $d75a4309befa023f$export$b427775f60507005 = "SAVE_EXPORTED_SAMPLE_REQUEST";
const $d75a4309befa023f$export$a983321ac5a394ce = "SAVE_EXPORTED_SAMPLE_REQUEST_SUCCESS";
const $d75a4309befa023f$export$80d4759d0b252673 = "SAVE_EXPORTED_SAMPLE_REQUEST_FAILURE";
function $d75a4309befa023f$export$b19d5b302359df53(patient) {
    return {
        type: $d75a4309befa023f$export$b427775f60507005,
        patient: patient
    };
}
const $d75a4309befa023f$export$7b963b262edde5d2 = "SAVE_PATIENT_TO_OBJECT_SERVER_REQUEST";
const $d75a4309befa023f$export$1a8375318a1fa480 = "SAVE_PATIENT_TO_OBJECT_SERVER_REQUEST_SUCCESS";
const $d75a4309befa023f$export$af91f6d14616b0f5 = "SAVE_PATIENT_TO_OBJECT_SERVER_REQUEST_FAILURE";
function $d75a4309befa023f$export$4d38e7def69815c(inlogId) {
    return (0, $aAq0B.queryObjects)($d75a4309befa023f$export$441e1139049e1abe, (0, $dPdDj.PrivacyDomain).Public, {
        eq: {
            inlogId: inlogId
        }
    }, {
        limit: 1,
        hydrate: true
    });
}

});

parcelRegister("7Asxf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $586207b015d42b2f$export$1e511d4a378977f5, (v) => $586207b015d42b2f$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $586207b015d42b2f$export$2e2bcd8739ae039, (v) => $586207b015d42b2f$export$2e2bcd8739ae039 = v);
var $586207b015d42b2f$export$1e511d4a378977f5;
var $586207b015d42b2f$export$2e2bcd8739ae039;
"use strict";
$586207b015d42b2f$export$1e511d4a378977f5 = true;
$586207b015d42b2f$export$2e2bcd8739ae039 = $586207b015d42b2f$var$createWebStorage;

var $586207b015d42b2f$var$_getStorage = $586207b015d42b2f$var$_interopRequireDefault((parcelRequire("kagwK")));
function $586207b015d42b2f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $586207b015d42b2f$var$createWebStorage(type) {
    var storage = (0, $586207b015d42b2f$var$_getStorage.default)(type);
    return {
        getItem: function getItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.getItem(key));
            });
        },
        setItem: function setItem(key, item) {
            return new Promise(function(resolve, reject) {
                resolve(storage.setItem(key, item));
            });
        },
        removeItem: function removeItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.removeItem(key));
            });
        }
    };
}

});
parcelRegister("kagwK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $eae18fc1294d0f44$export$1e511d4a378977f5, (v) => $eae18fc1294d0f44$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $eae18fc1294d0f44$export$2e2bcd8739ae039, (v) => $eae18fc1294d0f44$export$2e2bcd8739ae039 = v);
var $eae18fc1294d0f44$export$1e511d4a378977f5;
var $eae18fc1294d0f44$export$2e2bcd8739ae039;
"use strict";
$eae18fc1294d0f44$export$1e511d4a378977f5 = true;
$eae18fc1294d0f44$export$2e2bcd8739ae039 = $eae18fc1294d0f44$var$getStorage;
function $eae18fc1294d0f44$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $eae18fc1294d0f44$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $eae18fc1294d0f44$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $eae18fc1294d0f44$var$_typeof(obj);
}
function $eae18fc1294d0f44$var$noop() {}
var $eae18fc1294d0f44$var$noopStorage = {
    getItem: $eae18fc1294d0f44$var$noop,
    setItem: $eae18fc1294d0f44$var$noop,
    removeItem: $eae18fc1294d0f44$var$noop
};
function $eae18fc1294d0f44$var$hasStorage(storageType) {
    if ((typeof self === "undefined" ? "undefined" : $eae18fc1294d0f44$var$_typeof(self)) !== "object" || !(storageType in self)) return false;
    try {
        var storage = self[storageType];
        var testKey = "redux-persist ".concat(storageType, " test");
        storage.setItem(testKey, "test");
        storage.getItem(testKey);
        storage.removeItem(testKey);
    } catch (e) {
        return false;
    }
    return true;
}
function $eae18fc1294d0f44$var$getStorage(type) {
    var storageType = "".concat(type, "Storage");
    if ($eae18fc1294d0f44$var$hasStorage(storageType)) return self[storageType];
    else return $eae18fc1294d0f44$var$noopStorage;
}

});







var $683b40dd964971f3$exports = {};
$683b40dd964971f3$exports = new URL("favicon.91ab5aae.png", import.meta.url).toString();


window.__CONFIG__ = {
    debug: false,
    reduxLogger: false,
    sentryDSN: undefined,
    sentryEnvironment: undefined,
    appVersion: "2026.10.23-develop.1611.78c4233",
    assetsBasePath: undefined,
    pipelineServerURL: undefined,
    recordServerURL: undefined,
    converterServerURL: undefined,
    objectServerURL: undefined,
    oidcClientID: undefined,
    oidcBaseURL: undefined,
    oidcLogoutURL: undefined,
    oidcPostLoginRedirectURL: undefined,
    oidcPostLogoutRedirectURL: undefined,
    maxEntriesPerWorkList: undefined,
    ...window.__CONFIG__ || {}
};
window.__APP__ = {
    metadata: {
        version: "2026.10.23-develop.1611.78c4233"
    },
    ...window.__APP__ || {}
};



var $3OncY = parcelRequire("3OncY");

var $kGYVh = parcelRequire("kGYVh");

var $fKzCQ = parcelRequire("fKzCQ");

var $hi47i = parcelRequire("hi47i");
const $fbb22756c9507e85$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $fbb22756c9507e85$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $fbb22756c9507e85$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    const finalIntegrations = $fbb22756c9507e85$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = finalIntegrations.findIndex((integration)=>integration.name === "Debug");
    if (debugIndex > -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $fbb22756c9507e85$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $fbb22756c9507e85$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $fbb22756c9507e85$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $fbb22756c9507e85$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($fbb22756c9507e85$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $fbb22756c9507e85$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $fbb22756c9507e85$export$2d8f5188773bcddd(integration) {
    const client = (0, $kGYVh.getClient)();
    if (!client) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $fbb22756c9507e85$export$2323046b9414659f(fn) {
    return fn;
}


var $4H7Y8 = parcelRequire("4H7Y8");
var $hi47i = parcelRequire("hi47i");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $7b8b500cb80621bc$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



var $kGYVh = parcelRequire("kGYVh");
var $hi47i = parcelRequire("hi47i");
var $4H7Y8 = parcelRequire("4H7Y8");
var $6OKHc = parcelRequire("6OKHc");
var $6OhB9 = parcelRequire("6OhB9");


var $6OhB9 = parcelRequire("6OhB9");
var $l1oVX = parcelRequire("l1oVX");
var $kQ0sT = parcelRequire("kQ0sT");
var $2fKhD = parcelRequire("2fKhD");
var $kGYVh = parcelRequire("kGYVh");
const $9130afac94f0b7c9$export$56d8a8a25bd48b81 = (0, $2fKhD.GLOBAL_OBJ);
let $9130afac94f0b7c9$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $9130afac94f0b7c9$export$b79738ab10c590b2() {
    return $9130afac94f0b7c9$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $9130afac94f0b7c9$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $9130afac94f0b7c9$var$ignoreOnError++;
    setTimeout(()=>{
        $9130afac94f0b7c9$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $9130afac94f0b7c9$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === "function";
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === "function") return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $l1oVX.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$9130afac94f0b7c9$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $9130afac94f0b7c9$export$1265a142ff5ba165();
            (0, $kGYVh.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $6OhB9.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $6OhB9.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $kQ0sT.captureException)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (e2) {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $l1oVX.markFunctionWrapped)(sentryWrapped, fn);
    (0, $l1oVX.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    } catch (e3) {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}



var $6OKHc = parcelRequire("6OKHc");
var $4Baka = parcelRequire("4Baka");
var $24aKj = parcelRequire("24aKj");

var $hi47i = parcelRequire("hi47i");
/** Regular expression used to parse a Dsn. */ const $9171e4713e443b9b$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $9171e4713e443b9b$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $9171e4713e443b9b$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $9171e4713e443b9b$export$b892860177f70a30(str) {
    const match = $9171e4713e443b9b$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $hi47i.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $9171e4713e443b9b$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $9171e4713e443b9b$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $9171e4713e443b9b$var$validateDsn(dsn) {
    if (!(0, $24aKj.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $hi47i.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $hi47i.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$9171e4713e443b9b$var$isValidProtocol(protocol)) {
        (0, $hi47i.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $hi47i.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $9171e4713e443b9b$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $9171e4713e443b9b$export$b892860177f70a30(from) : $9171e4713e443b9b$var$dsnFromComponents(from);
    if (!components || !$9171e4713e443b9b$var$validateDsn(components)) return undefined;
    return components;
}



var $886wr = parcelRequire("886wr");

var $l1oVX = parcelRequire("l1oVX");

var $2fKhD = parcelRequire("2fKhD");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $f5682b06913d5b03$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $f5682b06913d5b03$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $f5682b06913d5b03$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $f5682b06913d5b03$export$604a45d95a155e2b(envelope, types) {
    return $f5682b06913d5b03$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $f5682b06913d5b03$var$encodeUTF8(input) {
    return (0, $2fKhD.GLOBAL_OBJ).__SENTRY__ && (0, $2fKhD.GLOBAL_OBJ).__SENTRY__.encodePolyfill ? (0, $2fKhD.GLOBAL_OBJ).__SENTRY__.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $f5682b06913d5b03$var$decodeUTF8(input) {
    return (0, $2fKhD.GLOBAL_OBJ).__SENTRY__ && (0, $2fKhD.GLOBAL_OBJ).__SENTRY__.decodePolyfill ? (0, $2fKhD.GLOBAL_OBJ).__SENTRY__.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $f5682b06913d5b03$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $f5682b06913d5b03$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $f5682b06913d5b03$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $886wr.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $f5682b06913d5b03$var$concatBuffers(parts);
}
function $f5682b06913d5b03$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $f5682b06913d5b03$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $f5682b06913d5b03$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($f5682b06913d5b03$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $f5682b06913d5b03$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $f5682b06913d5b03$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $f5682b06913d5b03$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        (0, $l1oVX.dropUndefinedKeys)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $f5682b06913d5b03$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket",
    raw_security: "security"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $f5682b06913d5b03$export$b11169581eeaf237(type) {
    return $f5682b06913d5b03$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $f5682b06913d5b03$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $f5682b06913d5b03$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $l1oVX.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}


var $kGYVh = parcelRequire("kGYVh");
var $1pGI9 = parcelRequire("1pGI9");
var $hi47i = parcelRequire("hi47i");
var $4H7Y8 = parcelRequire("4H7Y8");
var $6OhB9 = parcelRequire("6OhB9");


const $4e4f527f8c97dcab$var$MS_TO_NS = 1e6;
// Use 0 as main thread id which is identical to threadId in node:worker_threads
// where main logs 0 and workers seem to log in increments of 1
const $4e4f527f8c97dcab$var$THREAD_ID_STRING = String(0);
const $4e4f527f8c97dcab$var$THREAD_NAME = "main";
// Machine properties (eval only once)
let $4e4f527f8c97dcab$var$OS_PLATFORM = "";
let $4e4f527f8c97dcab$var$OS_PLATFORM_VERSION = "";
let $4e4f527f8c97dcab$var$OS_ARCH = "";
let $4e4f527f8c97dcab$var$OS_BROWSER = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator.userAgent || "";
let $4e4f527f8c97dcab$var$OS_MODEL = "";
const $4e4f527f8c97dcab$var$OS_LOCALE = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator.language || (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator.languages && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator.languages[0] || "";
function $4e4f527f8c97dcab$var$isUserAgentData(data) {
    return typeof data === "object" && data !== null && "getHighEntropyValues" in data;
}
// @ts-expect-error userAgentData is not part of the navigator interface yet
const $4e4f527f8c97dcab$var$userAgentData = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator.userAgentData;
if ($4e4f527f8c97dcab$var$isUserAgentData($4e4f527f8c97dcab$var$userAgentData)) $4e4f527f8c97dcab$var$userAgentData.getHighEntropyValues([
    "architecture",
    "model",
    "platform",
    "platformVersion",
    "fullVersionList"
]).then((ua)=>{
    $4e4f527f8c97dcab$var$OS_PLATFORM = ua.platform || "";
    $4e4f527f8c97dcab$var$OS_ARCH = ua.architecture || "";
    $4e4f527f8c97dcab$var$OS_MODEL = ua.model || "";
    $4e4f527f8c97dcab$var$OS_PLATFORM_VERSION = ua.platformVersion || "";
    if (ua.fullVersionList && ua.fullVersionList.length > 0) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const firstUa = ua.fullVersionList[ua.fullVersionList.length - 1];
        $4e4f527f8c97dcab$var$OS_BROWSER = `${firstUa.brand} ${firstUa.version}`;
    }
}).catch((e)=>void 0);
function $4e4f527f8c97dcab$var$isProcessedJSSelfProfile(profile) {
    return !("thread_metadata" in profile);
}
// Enriches the profile with threadId of the current thread.
// This is done in node as we seem to not be able to get the info from C native code.
/**
 *
 */ function $4e4f527f8c97dcab$export$7cbe6c4f12ea8325(profile) {
    if (!$4e4f527f8c97dcab$var$isProcessedJSSelfProfile(profile)) return profile;
    return $4e4f527f8c97dcab$export$f4122c775dfac1c2(profile);
}
// Profile is marked as optional because it is deleted from the metadata
// by the integration before the event is processed by other integrations.
function $4e4f527f8c97dcab$var$getTraceId(event) {
    const traceId = event && event.contexts && event.contexts["trace"] && event.contexts["trace"]["trace_id"];
    // Log a warning if the profile has an invalid traceId (should be uuidv4).
    // All profiles and transactions are rejected if this is the case and we want to
    // warn users that this is happening if they enable debug flag
    if (typeof traceId === "string" && traceId.length !== 32) {
        if (0, $7b8b500cb80621bc$export$16a28057038b10ef) (0, $hi47i.logger).log(`[Profiling] Invalid traceId: ${traceId} on profiled event`);
    }
    if (typeof traceId !== "string") return "";
    return traceId;
}
/**
 * Creates a profiling event envelope from a Sentry event. If profile does not pass
 * validation, returns null.
 * @param event
 * @param dsn
 * @param metadata
 * @param tunnel
 * @returns {EventEnvelope | null}
 */ /**
 * Creates a profiling event envelope from a Sentry event.
 */ function $4e4f527f8c97dcab$export$5c9f6e262288b7db(profile_id, start_timestamp, processed_profile, event) {
    if (event.type !== "transaction") // createProfilingEventEnvelope should only be called for transactions,
    // we type guard this behavior with isProfiledTransactionEvent.
    throw new TypeError("Profiling events may only be attached to transactions, this should never occur.");
    if (processed_profile === undefined || processed_profile === null) throw new TypeError(`Cannot construct profiling event envelope without a valid profile. Got ${processed_profile} instead.`);
    const traceId = $4e4f527f8c97dcab$var$getTraceId(event);
    const enrichedThreadProfile = $4e4f527f8c97dcab$export$7cbe6c4f12ea8325(processed_profile);
    const transactionStartMs = start_timestamp ? start_timestamp : typeof event.start_timestamp === "number" ? event.start_timestamp * 1000 : (0, $6OKHc.timestampInSeconds)() * 1000;
    const transactionEndMs = typeof event.timestamp === "number" ? event.timestamp * 1000 : (0, $6OKHc.timestampInSeconds)() * 1000;
    const profile = {
        event_id: profile_id,
        timestamp: new Date(transactionStartMs).toISOString(),
        platform: "javascript",
        version: "1",
        release: event.release || "",
        environment: event.environment || (0, $4Baka.DEFAULT_ENVIRONMENT),
        runtime: {
            name: "javascript",
            version: (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator.userAgent
        },
        os: {
            name: $4e4f527f8c97dcab$var$OS_PLATFORM,
            version: $4e4f527f8c97dcab$var$OS_PLATFORM_VERSION,
            build_number: $4e4f527f8c97dcab$var$OS_BROWSER
        },
        device: {
            locale: $4e4f527f8c97dcab$var$OS_LOCALE,
            model: $4e4f527f8c97dcab$var$OS_MODEL,
            manufacturer: $4e4f527f8c97dcab$var$OS_BROWSER,
            architecture: $4e4f527f8c97dcab$var$OS_ARCH,
            is_emulator: false
        },
        debug_meta: {
            images: $4e4f527f8c97dcab$export$4c0b0d8ee0d018b5(processed_profile.resources)
        },
        profile: enrichedThreadProfile,
        transactions: [
            {
                name: event.transaction || "",
                id: event.event_id || (0, $6OhB9.uuid4)(),
                trace_id: traceId,
                active_thread_id: $4e4f527f8c97dcab$var$THREAD_ID_STRING,
                relative_start_ns: "0",
                relative_end_ns: ((transactionEndMs - transactionStartMs) * 1e6).toFixed(0)
            }
        ]
    };
    return profile;
}
/*
  See packages/browser-utils/src/browser/router.ts
*/ /**
 *
 */ function $4e4f527f8c97dcab$export$563404c5f9ee31f6(span) {
    return (0, $4H7Y8.spanToJSON)(span).op === "pageload";
}
/**
 * Converts a JSSelfProfile to a our sampled format.
 * Does not currently perform stack indexing.
 */ function $4e4f527f8c97dcab$export$f4122c775dfac1c2(input) {
    let EMPTY_STACK_ID = undefined;
    let STACK_ID = 0;
    // Initialize the profile that we will fill with data
    const profile = {
        samples: [],
        stacks: [],
        frames: [],
        thread_metadata: {
            [$4e4f527f8c97dcab$var$THREAD_ID_STRING]: {
                name: $4e4f527f8c97dcab$var$THREAD_NAME
            }
        }
    };
    const firstSample = input.samples[0];
    if (!firstSample) return profile;
    // We assert samples.length > 0 above and timestamp should always be present
    const start = firstSample.timestamp;
    // The JS SDK might change it's time origin based on some heuristic (see See packages/utils/src/time.ts)
    // when that happens, we need to ensure we are correcting the profile timings so the two timelines stay in sync.
    // Since JS self profiling time origin is always initialized to performance.timeOrigin, we need to adjust for
    // the drift between the SDK selected value and our profile time origin.
    const origin = typeof performance.timeOrigin === "number" ? performance.timeOrigin : (0, $6OKHc.browserPerformanceTimeOrigin) || 0;
    const adjustForOriginChange = origin - ((0, $6OKHc.browserPerformanceTimeOrigin) || origin);
    input.samples.forEach((jsSample, i)=>{
        // If sample has no stack, add an empty sample
        if (jsSample.stackId === undefined) {
            if (EMPTY_STACK_ID === undefined) {
                EMPTY_STACK_ID = STACK_ID;
                profile.stacks[EMPTY_STACK_ID] = [];
                STACK_ID++;
            }
            profile["samples"][i] = {
                // convert ms timestamp to ns
                elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * $4e4f527f8c97dcab$var$MS_TO_NS).toFixed(0),
                stack_id: EMPTY_STACK_ID,
                thread_id: $4e4f527f8c97dcab$var$THREAD_ID_STRING
            };
            return;
        }
        let stackTop = input.stacks[jsSample.stackId];
        // Functions in top->down order (root is last)
        // We follow the stackTop.parentId trail and collect each visited frameId
        const stack = [];
        while(stackTop){
            stack.push(stackTop.frameId);
            const frame = input.frames[stackTop.frameId];
            // If our frame has not been indexed yet, index it
            if (frame && profile.frames[stackTop.frameId] === undefined) profile.frames[stackTop.frameId] = {
                function: frame.name,
                abs_path: typeof frame.resourceId === "number" ? input.resources[frame.resourceId] : undefined,
                lineno: frame.line,
                colno: frame.column
            };
            stackTop = stackTop.parentId === undefined ? undefined : input.stacks[stackTop.parentId];
        }
        const sample = {
            // convert ms timestamp to ns
            elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * $4e4f527f8c97dcab$var$MS_TO_NS).toFixed(0),
            stack_id: STACK_ID,
            thread_id: $4e4f527f8c97dcab$var$THREAD_ID_STRING
        };
        profile["stacks"][STACK_ID] = stack;
        profile["samples"][i] = sample;
        STACK_ID++;
    });
    return profile;
}
/**
 * Adds items to envelope if they are not already present - mutates the envelope.
 * @param envelope
 */ function $4e4f527f8c97dcab$export$4df36760a75f76bc(envelope, profiles) {
    if (!profiles.length) return envelope;
    for (const profile of profiles)envelope[1].push([
        {
            type: "profile"
        },
        profile
    ]);
    return envelope;
}
/**
 * Finds transactions with profile_id context in the envelope
 * @param envelope
 * @returns
 */ function $4e4f527f8c97dcab$export$df9bb0fc214ff8cd(envelope) {
    const events = [];
    (0, $f5682b06913d5b03$export$c56c55acf0136fd3)(envelope, (item, type)=>{
        if (type !== "transaction") return;
        for(let j = 1; j < item.length; j++){
            const event = item[j];
            if (event && event.contexts && event.contexts["profile"] && event.contexts["profile"]["profile_id"]) events.push(item[j]);
        }
    });
    return events;
}
/**
 * Applies debug meta data to an event from a list of paths to resources (sourcemaps)
 */ function $4e4f527f8c97dcab$export$4c0b0d8ee0d018b5(resource_paths) {
    const client = (0, $kGYVh.getClient)();
    const options = client && client.getOptions();
    const stackParser = options && options.stackParser;
    if (!stackParser) return [];
    return (0, $1pGI9.getDebugImagesForResources)(stackParser, resource_paths);
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $4e4f527f8c97dcab$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    if (typeof rate !== "number" && typeof rate !== "boolean" || typeof rate === "number" && isNaN(rate)) {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $hi47i.logger).warn(`[Profiling] Invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // Boolean sample rates are always valid
    if (rate === true || rate === false) return true;
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $hi47i.logger).warn(`[Profiling] Invalid sample rate. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}
function $4e4f527f8c97dcab$var$isValidProfile(profile) {
    if (profile.samples.length < 2) {
        if (0, $7b8b500cb80621bc$export$16a28057038b10ef) // Log a warning if the profile has less than 2 samples so users can know why
        // they are not seeing any profiling data and we cant avoid the back and forth
        // of asking them to provide us with a dump of the profile data.
        (0, $hi47i.logger).log("[Profiling] Discarding profile because it contains less than 2 samples");
        return false;
    }
    if (!profile.frames.length) {
        if (0, $7b8b500cb80621bc$export$16a28057038b10ef) (0, $hi47i.logger).log("[Profiling] Discarding profile because it contains no frames");
        return false;
    }
    return true;
}
// Keep a flag value to avoid re-initializing the profiler constructor. If it fails
// once, it will always fail and this allows us to early return.
let $4e4f527f8c97dcab$var$PROFILING_CONSTRUCTOR_FAILED = false;
const $4e4f527f8c97dcab$export$8640c0b5c7d98a81 = 30000;
/**
 * Check if profiler constructor is available.
 * @param maybeProfiler
 */ function $4e4f527f8c97dcab$var$isJSProfilerSupported(maybeProfiler) {
    return typeof maybeProfiler === "function";
}
/**
 * Starts the profiler and returns the profiler instance.
 */ function $4e4f527f8c97dcab$export$9f4f648547a4284f() {
    // Feature support check first
    const JSProfilerConstructor = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).Profiler;
    if (!$4e4f527f8c97dcab$var$isJSProfilerSupported(JSProfilerConstructor)) {
        if (0, $7b8b500cb80621bc$export$16a28057038b10ef) (0, $hi47i.logger).log("[Profiling] Profiling is not supported by this browser, Profiler interface missing on window object.");
        return;
    }
    // From initial testing, it seems that the minimum value for sampleInterval is 10ms.
    const samplingIntervalMS = 10;
    // Start the profiler
    const maxSamples = Math.floor($4e4f527f8c97dcab$export$8640c0b5c7d98a81 / samplingIntervalMS);
    // Attempt to initialize the profiler constructor, if it fails, we disable profiling for the current user session.
    // This is likely due to a missing 'Document-Policy': 'js-profiling' header. We do not want to throw an error if this happens
    // as we risk breaking the user's application, so just disable profiling and log an error.
    try {
        return new JSProfilerConstructor({
            sampleInterval: samplingIntervalMS,
            maxBufferSize: maxSamples
        });
    } catch (e) {
        if (0, $7b8b500cb80621bc$export$16a28057038b10ef) {
            (0, $hi47i.logger).log("[Profiling] Failed to initialize the Profiling constructor, this is likely due to a missing 'Document-Policy': 'js-profiling' header.");
            (0, $hi47i.logger).log("[Profiling] Disabling profiling for current user session.");
        }
        $4e4f527f8c97dcab$var$PROFILING_CONSTRUCTOR_FAILED = true;
    }
    return;
}
/**
 * Determine if a profile should be profiled.
 */ function $4e4f527f8c97dcab$export$fa7ef36a2032fde9(span) {
    // If constructor failed once, it will always fail, so we can early return.
    if ($4e4f527f8c97dcab$var$PROFILING_CONSTRUCTOR_FAILED) {
        if (0, $7b8b500cb80621bc$export$16a28057038b10ef) (0, $hi47i.logger).log("[Profiling] Profiling has been disabled for the duration of the current user session.");
        return false;
    }
    if (!span.isRecording()) {
        if (0, $7b8b500cb80621bc$export$16a28057038b10ef) (0, $hi47i.logger).log("[Profiling] Discarding profile because transaction was not sampled.");
        return false;
    }
    const client = (0, $kGYVh.getClient)();
    const options = client && client.getOptions();
    if (!options) {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $hi47i.logger).log("[Profiling] Profiling disabled, no options found.");
        return false;
    }
    // @ts-expect-error profilesSampleRate is not part of the browser options yet
    const profilesSampleRate = options.profilesSampleRate;
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$4e4f527f8c97dcab$export$2603c8d332a51c42(profilesSampleRate)) {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $hi47i.logger).warn("[Profiling] Discarding profile because of invalid sample rate.");
        return false;
    }
    // if the function returned 0 (or false), or if `profileSampleRate` is 0, it's a sign the profile should be dropped
    if (!profilesSampleRate) {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $hi47i.logger).log("[Profiling] Discarding profile because a negative sampling decision was inherited or profileSampleRate is set to 0");
        return false;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    const sampled = profilesSampleRate === true ? true : Math.random() < profilesSampleRate;
    // Check if we should sample this profile
    if (!sampled) {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $hi47i.logger).log(`[Profiling] Discarding profile because it's not included in the random sample (sampling rate = ${Number(profilesSampleRate)})`);
        return false;
    }
    return true;
}
/**
 * Creates a profiling envelope item, if the profile does not pass validation, returns null.
 * @param event
 * @returns {Profile | null}
 */ function $4e4f527f8c97dcab$export$5c2c5e805edd874f(profile_id, start_timestamp, profile, event) {
    if (!$4e4f527f8c97dcab$var$isValidProfile(profile)) return null;
    return $4e4f527f8c97dcab$export$5c9f6e262288b7db(profile_id, start_timestamp, profile, event);
}
// TODO (v8): We need to obtain profile ids in @sentry-internal/tracing,
// but we don't have access to this map because importing this map would
// cause a circular dependency. We need to resolve this in v8.
const $4e4f527f8c97dcab$var$PROFILE_MAP = new Map();
/**
 *
 */ function $4e4f527f8c97dcab$export$9d723f414195854a() {
    return $4e4f527f8c97dcab$var$PROFILE_MAP.size;
}
/**
 * Retrieves profile from global cache and removes it.
 */ function $4e4f527f8c97dcab$export$6285310796363de1(profile_id) {
    const profile = $4e4f527f8c97dcab$var$PROFILE_MAP.get(profile_id);
    if (profile) $4e4f527f8c97dcab$var$PROFILE_MAP.delete(profile_id);
    return profile;
}
/**
 * Adds profile to global cache and evicts the oldest profile if the cache is full.
 */ function $4e4f527f8c97dcab$export$7ddae68097f7e530(profile_id, profile) {
    $4e4f527f8c97dcab$var$PROFILE_MAP.set(profile_id, profile);
    if ($4e4f527f8c97dcab$var$PROFILE_MAP.size > 30) {
        const last = $4e4f527f8c97dcab$var$PROFILE_MAP.keys().next().value;
        $4e4f527f8c97dcab$var$PROFILE_MAP.delete(last);
    }
}


/**
 * Wraps startTransaction and stopTransaction with profiling related logic.
 * startProfileForTransaction is called after the call to startTransaction in order to avoid our own code from
 * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
 */ function $72b4b64800512791$export$83bcc43b6a2cf5e7(span) {
    // Start the profiler and get the profiler instance.
    let startTimestamp;
    if ((0, $4e4f527f8c97dcab$export$563404c5f9ee31f6)(span)) startTimestamp = (0, $6OKHc.timestampInSeconds)() * 1000;
    const profiler = (0, $4e4f527f8c97dcab$export$9f4f648547a4284f)();
    // We failed to construct the profiler, so we skip.
    // No need to log anything as this has already been logged in startProfile.
    if (!profiler) return;
    if (0, $7b8b500cb80621bc$export$16a28057038b10ef) (0, $hi47i.logger).log(`[Profiling] started profiling span: ${(0, $4H7Y8.spanToJSON)(span).description}`);
    // We create "unique" span names to avoid concurrent spans with same names
    // from being ignored by the profiler. From here on, only this span name should be used when
    // calling the profiler methods. Note: we log the original name to the user to avoid confusion.
    const profileId = (0, $6OhB9.uuid4)();
    (0, $kGYVh.getCurrentScope)().setContext("profile", {
        profile_id: profileId,
        start_timestamp: startTimestamp
    });
    /**
   * Idempotent handler for profile stop
   */ async function onProfileHandler() {
        // Check if the profile exists and return it the behavior has to be idempotent as users may call span.finish multiple times.
        if (!span) return;
        // Satisfy the type checker, but profiler will always be defined here.
        if (!profiler) return;
        return profiler.stop().then((profile)=>{
            if (maxDurationTimeoutID) {
                (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).clearTimeout(maxDurationTimeoutID);
                maxDurationTimeoutID = undefined;
            }
            if (0, $7b8b500cb80621bc$export$16a28057038b10ef) (0, $hi47i.logger).log(`[Profiling] stopped profiling of span: ${(0, $4H7Y8.spanToJSON)(span).description}`);
            // In case of an overlapping span, stopProfiling may return null and silently ignore the overlapping profile.
            if (!profile) {
                if (0, $7b8b500cb80621bc$export$16a28057038b10ef) (0, $hi47i.logger).log(`[Profiling] profiler returned null profile for: ${(0, $4H7Y8.spanToJSON)(span).description}`, "this may indicate an overlapping span or a call to stopProfiling with a profile title that was never started");
                return;
            }
            (0, $4e4f527f8c97dcab$export$7ddae68097f7e530)(profileId, profile);
        }).catch((error)=>{
            if (0, $7b8b500cb80621bc$export$16a28057038b10ef) (0, $hi47i.logger).log("[Profiling] error while stopping profiler:", error);
        });
    }
    // Enqueue a timeout to prevent profiles from running over max duration.
    let maxDurationTimeoutID = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).setTimeout(()=>{
        if (0, $7b8b500cb80621bc$export$16a28057038b10ef) (0, $hi47i.logger).log("[Profiling] max profile duration elapsed, stopping profiling for:", (0, $4H7Y8.spanToJSON)(span).description);
        // If the timeout exceeds, we want to stop profiling, but not finish the span
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        onProfileHandler();
    }, (0, $4e4f527f8c97dcab$export$8640c0b5c7d98a81));
    // We need to reference the original end call to avoid creating an infinite loop
    const originalEnd = span.end.bind(span);
    /**
   * Wraps span `end()` with profiling related logic.
   * startProfiling is called after the call to spanStart in order to avoid our own code from
   * being profiled. Because of that same reason, stopProfiling is called before the call to spanEnd.
   */ function profilingWrappedSpanEnd() {
        if (!span) return originalEnd();
        // onProfileHandler should always return the same profile even if this is called multiple times.
        // Always call onProfileHandler to ensure stopProfiling is called and the timeout is cleared.
        onProfileHandler().then(()=>{
            originalEnd();
        }, ()=>{
            // If onProfileHandler fails, we still want to call the original finish method.
            originalEnd();
        });
        return span;
    }
    span.end = profilingWrappedSpanEnd;
}



const $8042c6839aeabaab$var$INTEGRATION_NAME = "BrowserProfiling";
const $8042c6839aeabaab$var$_browserProfilingIntegration = ()=>{
    return {
        name: $8042c6839aeabaab$var$INTEGRATION_NAME,
        setup (client) {
            const activeSpan = (0, $4H7Y8.getActiveSpan)();
            const rootSpan = activeSpan && (0, $4H7Y8.getRootSpan)(activeSpan);
            if (rootSpan && (0, $4e4f527f8c97dcab$export$563404c5f9ee31f6)(rootSpan)) {
                if ((0, $4e4f527f8c97dcab$export$fa7ef36a2032fde9)(rootSpan)) (0, $72b4b64800512791$export$83bcc43b6a2cf5e7)(rootSpan);
            }
            client.on("spanStart", (span)=>{
                if (span === (0, $4H7Y8.getRootSpan)(span) && (0, $4e4f527f8c97dcab$export$fa7ef36a2032fde9)(span)) (0, $72b4b64800512791$export$83bcc43b6a2cf5e7)(span);
            });
            client.on("beforeEnvelope", (envelope)=>{
                // if not profiles are in queue, there is nothing to add to the envelope.
                if (!(0, $4e4f527f8c97dcab$export$9d723f414195854a)()) return;
                const profiledTransactionEvents = (0, $4e4f527f8c97dcab$export$df9bb0fc214ff8cd)(envelope);
                if (!profiledTransactionEvents.length) return;
                const profilesToAddToEnvelope = [];
                for (const profiledTransaction of profiledTransactionEvents){
                    const context = profiledTransaction && profiledTransaction.contexts;
                    const profile_id = context && context["profile"] && context["profile"]["profile_id"];
                    const start_timestamp = context && context["profile"] && context["profile"]["start_timestamp"];
                    if (typeof profile_id !== "string") {
                        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $hi47i.logger).log("[Profiling] cannot find profile for a span without a profile context");
                        continue;
                    }
                    if (!profile_id) {
                        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $hi47i.logger).log("[Profiling] cannot find profile for a span without a profile context");
                        continue;
                    }
                    // Remove the profile from the span context before sending, relay will take care of the rest.
                    if (context && context["profile"]) delete context.profile;
                    const profile = (0, $4e4f527f8c97dcab$export$6285310796363de1)(profile_id);
                    if (!profile) {
                        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $hi47i.logger).log(`[Profiling] Could not retrieve profile for span: ${profile_id}`);
                        continue;
                    }
                    const profileEvent = (0, $4e4f527f8c97dcab$export$5c2c5e805edd874f)(profile_id, start_timestamp, profile, profiledTransaction);
                    if (profileEvent) profilesToAddToEnvelope.push(profileEvent);
                }
                (0, $4e4f527f8c97dcab$export$4df36760a75f76bc)(envelope, profilesToAddToEnvelope);
            });
        }
    };
};
const $8042c6839aeabaab$export$2c7b5d6dd5622f23 = (0, $fbb22756c9507e85$export$2323046b9414659f)($8042c6839aeabaab$var$_browserProfilingIntegration);


var $24aKj = parcelRequire("24aKj");

var $hi47i = parcelRequire("hi47i");

var $5v1oS = parcelRequire("5v1oS");
// We keep the handlers globally
const $f079126c500c7ea2$var$handlers = {};
const $f079126c500c7ea2$var$instrumented = {};
/** Add a handler function. */ function $f079126c500c7ea2$export$a4e09611e30da72e(type, handler) {
    $f079126c500c7ea2$var$handlers[type] = $f079126c500c7ea2$var$handlers[type] || [];
    $f079126c500c7ea2$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $f079126c500c7ea2$export$b17eab759a1cb5fe() {
    Object.keys($f079126c500c7ea2$var$handlers).forEach((key)=>{
        $f079126c500c7ea2$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $f079126c500c7ea2$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$f079126c500c7ea2$var$instrumented[type]) {
        $f079126c500c7ea2$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $24aKj.DEBUG_BUILD) && (0, $hi47i.logger).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $f079126c500c7ea2$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $f079126c500c7ea2$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $24aKj.DEBUG_BUILD) && (0, $hi47i.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $5v1oS.getFunctionName)(handler)}\nError:`, e);
    }
}


var $l1oVX = parcelRequire("l1oVX");
var $2fKhD = parcelRequire("2fKhD");
// Based on https://github.com/angular/angular.js/pull/13945/files
// The MIT License
const $210880305d43071a$var$WINDOW = (0, $2fKhD.GLOBAL_OBJ);
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $210880305d43071a$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    // TODO(v9): Remove this custom check, it is pretty old and likely not needed anymore
    const chromeVar = $210880305d43071a$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    const hasHistoryApi = "history" in $210880305d43071a$var$WINDOW && !!$210880305d43071a$var$WINDOW.history.pushState && !!$210880305d43071a$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



var $2fKhD = parcelRequire("2fKhD");
const $955496f5d3029976$export$56d8a8a25bd48b81 = (0, $2fKhD.GLOBAL_OBJ);


let $3d87653da885c31c$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $3d87653da885c31c$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $3d87653da885c31c$var$instrumentHistory);
}
function $3d87653da885c31c$var$instrumentHistory() {
    if (!(0, $210880305d43071a$export$67fc34576016d6ec)()) return;
    const oldOnPopState = (0, $955496f5d3029976$export$56d8a8a25bd48b81).onpopstate;
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).onpopstate = function(...args) {
        const to = (0, $955496f5d3029976$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $3d87653da885c31c$var$lastHref;
        $3d87653da885c31c$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $f079126c500c7ea2$export$b18c893e424d3127)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $3d87653da885c31c$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $3d87653da885c31c$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $f079126c500c7ea2$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $l1oVX.fill)((0, $955496f5d3029976$export$56d8a8a25bd48b81).history, "pushState", historyReplacementFunction);
    (0, $l1oVX.fill)((0, $955496f5d3029976$export$56d8a8a25bd48b81).history, "replaceState", historyReplacementFunction);
}


var $6OKHc = parcelRequire("6OKHc");
var $4H7Y8 = parcelRequire("4H7Y8");
var $hA6iJ = parcelRequire("hA6iJ");/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $2bf5ed435a4428b5$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $2bf5ed435a4428b5$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 *
 * @deprecated This function will be removed in the next major version.
 */ // TODO(v9): Hoist this function into the places where we use it. (as it stands only react router v6 instrumentation)
function $2bf5ed435a4428b5$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $2bf5ed435a4428b5$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}


var $yQUXg = parcelRequire("yQUXg");
var $fKzCQ = parcelRequire("fKzCQ");

var $yQUXg = parcelRequire("yQUXg");

var $hi47i = parcelRequire("hi47i");

var $4H7Y8 = parcelRequire("4H7Y8");
/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $3ed76239c787a980$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $4H7Y8.getActiveSpan)()) {
    const rootSpan = activeSpan && (0, $4H7Y8.getRootSpan)(activeSpan);
    if (rootSpan) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE)]: value,
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT)]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function $3ed76239c787a980$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
        const value = attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}




var $6OKHc = parcelRequire("6OKHc");
var $l1oVX = parcelRequire("l1oVX");
var $4H7Y8 = parcelRequire("4H7Y8");
var $kGYVh = parcelRequire("kGYVh");
var $hA6iJ = parcelRequire("hA6iJ");
var $hi47i = parcelRequire("hi47i");
var $yQUXg = parcelRequire("yQUXg");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e0c2e3106e46caa2$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



var $5v1oS = parcelRequire("5v1oS");
var $hi47i = parcelRequire("hi47i");

const $7f25ffc87954188c$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return "poor";
    if (value > thresholds[0]) return "needs-improvement";
    return "good";
};
const $7f25ffc87954188c$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $7f25ffc87954188c$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $dd0ab4bb8fd34918$export$407ea409d1f3b539 = ()=>{
    return `v4-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // sentry-specific change:
// add optional param to not check for responseStart (see comment below)
const $44a719e67f846077$export$6431553786c94949 = (checkResponseStart = true)=>{
    const navigationEntry = (0, $955496f5d3029976$export$56d8a8a25bd48b81).performance && (0, $955496f5d3029976$export$56d8a8a25bd48b81).performance.getEntriesByType && (0, $955496f5d3029976$export$56d8a8a25bd48b81).performance.getEntriesByType("navigation")[0];
    // Check to ensure the `responseStart` property is present and valid.
    // In some cases no value is reported by the browser (for
    // privacy/security reasons), and in other cases (bugs) the value is
    // negative or is larger than the current page time. Ignore these cases:
    // https://github.com/GoogleChrome/web-vitals/issues/137
    // https://github.com/GoogleChrome/web-vitals/issues/162
    // https://github.com/GoogleChrome/web-vitals/issues/275
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $087abae3f457004d$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $44a719e67f846077$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $21249b77f35afbbd$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $44a719e67f846077$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.prerendering || (0, $087abae3f457004d$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.wasDiscarded) navigationType = "restore";
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, "-");
    }
    // Use `entries` type specific for the metric.
    const entries = [];
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: entries,
        id: (0, $dd0ab4bb8fd34918$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $3c3fb26ba7f6478b$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                // Delay by a microtask to workaround a bug in Safari where the
                // callback is invoked immediately, rather than in a separate task.
                // See: https://github.com/GoogleChrome/web-vitals/issues/277
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Sentry-specific change:
// This function's logic was NOT updated to web-vitals 4.2.4 but we continue
// to use the web-vitals 3.5.2 due to us having stricter browser support.
// PR with context that made the changes: https://github.com/GoogleChrome/web-vitals/pull/442/files#r1530492402
// The PR removed listening to the `pagehide` event, in favour of only listening to `visibilitychange` event.
// This is "more correct" but some browsers we still support (Safari 12.1-14.0) don't fully support `visibilitychange`
// or have known bugs w.r.t the `visibilitychange` event.
// TODO (v9): If we decide to drop support for Safari 12.1-14.0, we can use the logic from web-vitals 4.2.4
// In this case, we also need to update the integration tests that currently trigger the `pagehide` event to
// simulate the page being hidden.
const $02a4610d4ee5af80$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.visibilityState === "hidden") cb(event);
    };
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document) {
        addEventListener("visibilitychange", onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener("pagehide", onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d9bb6b2adff68632$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $bf61d7f7ca9bd10a$var$firstHiddenTime = -1;
const $bf61d7f7ca9bd10a$var$initHiddenTime = ()=>{
    // If the document is hidden when this code runs, assume it was always
    // hidden and the page was loaded in the background, with the one exception
    // that visibility state is always 'hidden' during prerendering, so we have
    // to ignore that case until prerendering finishes (see: `prerenderingchange`
    // event logic below).
    return (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && !(0, $955496f5d3029976$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $bf61d7f7ca9bd10a$var$onVisibilityUpdate = (event)=>{
    // If the document is 'hidden' and no previous hidden timestamp has been
    // set, update it based on the current event data.
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && $bf61d7f7ca9bd10a$var$firstHiddenTime > -1) {
        // If the event is a 'visibilitychange' event, it means the page was
        // visible prior to this change, so the event timestamp is the first
        // hidden time.
        // However, if the event is not a 'visibilitychange' event, then it must
        // be a 'prerenderingchange' event, and the fact that the document is
        // still 'hidden' from the above check means the tab was activated
        // in a background state and so has always been hidden.
        $bf61d7f7ca9bd10a$var$firstHiddenTime = event.type === "visibilitychange" ? event.timeStamp : 0;
        // Remove all listeners now that a `firstHiddenTime` value has been set.
        $bf61d7f7ca9bd10a$var$removeChangeListeners();
    }
};
const $bf61d7f7ca9bd10a$var$addChangeListeners = ()=>{
    addEventListener("visibilitychange", $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
    // IMPORTANT: when a page is prerendering, its `visibilityState` is
    // 'hidden', so in order to account for cases where this module checks for
    // visibility during prerendering, an additional check after prerendering
    // completes is also required.
    addEventListener("prerenderingchange", $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
};
const $bf61d7f7ca9bd10a$var$removeChangeListeners = ()=>{
    removeEventListener("visibilitychange", $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
    removeEventListener("prerenderingchange", $bf61d7f7ca9bd10a$var$onVisibilityUpdate, true);
};
const $bf61d7f7ca9bd10a$export$443f86b2c77012c4 = ()=>{
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && $bf61d7f7ca9bd10a$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $bf61d7f7ca9bd10a$var$firstHiddenTime = $bf61d7f7ca9bd10a$var$initHiddenTime();
        $bf61d7f7ca9bd10a$var$addChangeListeners();
    }
    return {
        get firstHiddenTime () {
            return $bf61d7f7ca9bd10a$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $6f9bc735dd2b9313$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.prerendering) addEventListener("prerenderingchange", ()=>callback(), true);
    else callback();
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FCP. See https://web.dev/articles/fcp#what_is_a_good_fcp_score */ const $c372737293087726$export$e610c735b5510cec = [
    1800,
    3000
];
/**
 * Calculates the [FCP](https://web.dev/articles/fcp) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `paint` performance entry used to determine the value. The reported
 * value is a `DOMHighResTimeStamp`.
 */ const $c372737293087726$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $bf61d7f7ca9bd10a$export$443f86b2c77012c4)();
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)("FCP");
        let report;
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.name === "first-contentful-paint") {
                    po.disconnect();
                    // Only report if the page wasn't hidden prior to the first paint.
                    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                        // The activationStart reference is used because FCP should be
                        // relative to page activation rather than navigation start if the
                        // page was prerendered. But in cases where `activationStart` occurs
                        // after the FCP, this time should be clamped at 0.
                        metric.value = Math.max(entry.startTime - (0, $087abae3f457004d$export$d3e828b3c7b5b845)(), 0);
                        metric.entries.push(entry);
                        report(true);
                    }
                }
            });
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)("paint", handleEntries);
        if (po) report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $c372737293087726$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for CLS. See https://web.dev/articles/cls#what_is_a_good_cls_score */ const $c8cc3356aaa35be1$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
/**
 * Calculates the [CLS](https://web.dev/articles/cls) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/articles/cls#layout_shift_score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $c8cc3356aaa35be1$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    // Start monitoring FCP so we can only report CLS if FCP is also reported.
    // Note: this is done to match the current behavior of CrUX.
    (0, $c372737293087726$export$fe3c86b74e15d5de)((0, $d9bb6b2adff68632$export$b841d51e31c12bab)(()=>{
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)("CLS", 0);
        let report;
        let sessionValue = 0;
        let sessionEntries = [];
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                // Only count layout shifts without recent user input.
                if (!entry.hadRecentInput) {
                    const firstSessionEntry = sessionEntries[0];
                    const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                    // If the entry occurred less than 1 second after the previous entry
                    // and less than 5 seconds after the first entry in the session,
                    // include the entry in the current session. Otherwise, start a new
                    // session.
                    if (sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                        sessionValue += entry.value;
                        sessionEntries.push(entry);
                    } else {
                        sessionValue = entry.value;
                        sessionEntries = [
                            entry
                        ];
                    }
                }
            });
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (sessionValue > metric.value) {
                metric.value = sessionValue;
                metric.entries = sessionEntries;
                report();
            }
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)("layout-shift", handleEntries);
        if (po) {
            report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $c8cc3356aaa35be1$export$3f20d8e089ac35b2, opts.reportAllChanges);
            (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            // Queue a task to report (if nothing else triggers a report first).
            // This allows CLS to be reported as soon as FCP fires when
            // `reportAllChanges` is true.
            setTimeout(report, 0);
        }
    }));
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FID. See https://web.dev/articles/fid#what_is_a_good_fid_score */ const $88c48014ef58cf68$export$8f7f3c48ca6fbe34 = [
    100,
    300
];
/**
 * Calculates the [FID](https://web.dev/articles/fid) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $88c48014ef58cf68$export$39705a25c49af873 = (onReport, opts = {})=>{
    (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $bf61d7f7ca9bd10a$export$443f86b2c77012c4)();
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)("FID");
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntry = (entry)=>{
            // Only report if the page wasn't hidden prior to the first input.
            if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                metric.value = entry.processingStart - entry.startTime;
                metric.entries.push(entry);
                report(true);
            }
        };
        const handleEntries = (entries)=>{
            entries.forEach(handleEntry);
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)("first-input", handleEntries);
        report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $88c48014ef58cf68$export$8f7f3c48ca6fbe34, opts.reportAllChanges);
        if (po) (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)((0, $d9bb6b2adff68632$export$b841d51e31c12bab)(()=>{
            handleEntries(po.takeRecords());
            po.disconnect();
        }));
    });
};






/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $cc83e22cb516f528$var$interactionCountEstimate = 0;
let $cc83e22cb516f528$var$minKnownInteractionId = Infinity;
let $cc83e22cb516f528$var$maxKnownInteractionId = 0;
const $cc83e22cb516f528$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $cc83e22cb516f528$var$minKnownInteractionId = Math.min($cc83e22cb516f528$var$minKnownInteractionId, e.interactionId);
            $cc83e22cb516f528$var$maxKnownInteractionId = Math.max($cc83e22cb516f528$var$maxKnownInteractionId, e.interactionId);
            $cc83e22cb516f528$var$interactionCountEstimate = $cc83e22cb516f528$var$maxKnownInteractionId ? ($cc83e22cb516f528$var$maxKnownInteractionId - $cc83e22cb516f528$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $cc83e22cb516f528$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $cc83e22cb516f528$export$8a962f2683a476d1 = ()=>{
    return $cc83e22cb516f528$var$po ? $cc83e22cb516f528$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $cc83e22cb516f528$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $cc83e22cb516f528$var$po) return;
    $cc83e22cb516f528$var$po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)("event", $cc83e22cb516f528$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER long.
const $6ba5ec799590141e$export$fbb6a65efb09cd7a = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $6ba5ec799590141e$export$7b86959c9ded44e2 = new Map();
// The default `durationThreshold` used across this library for observing
// `event` entries via PerformanceObserver.
const $6ba5ec799590141e$export$9cebd8cf5d8d3416 = 40;
// Used to store the interaction count after a bfcache restore, since p98
// interaction latencies should only consider the current navigation.
let $6ba5ec799590141e$var$prevInteractionCount = 0;
/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $6ba5ec799590141e$var$getInteractionCountForNavigation = ()=>{
    return (0, $cc83e22cb516f528$export$8a962f2683a476d1)() - $6ba5ec799590141e$var$prevInteractionCount;
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $6ba5ec799590141e$export$70cf089971ed4f82 = ()=>{
    const candidateInteractionIndex = Math.min($6ba5ec799590141e$export$fbb6a65efb09cd7a.length - 1, Math.floor($6ba5ec799590141e$var$getInteractionCountForNavigation() / 50));
    return $6ba5ec799590141e$export$fbb6a65efb09cd7a[candidateInteractionIndex];
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $6ba5ec799590141e$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
/**
 * A list of callback functions to run before each entry is processed.
 * Exposing this list allows the attribution build to hook into the
 * entry processing pipeline.
 */ const $6ba5ec799590141e$export$1c74e929da1e189d = [];
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $6ba5ec799590141e$export$6a7a48c2c643798f = (entry)=>{
    $6ba5ec799590141e$export$1c74e929da1e189d.forEach((cb)=>cb(entry));
    // Skip further processing for entries that cannot be INP candidates.
    if (!(entry.interactionId || entry.entryType === "first-input")) return;
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $6ba5ec799590141e$export$fbb6a65efb09cd7a[$6ba5ec799590141e$export$fbb6a65efb09cd7a.length - 1];
    const existingInteraction = $6ba5ec799590141e$export$7b86959c9ded44e2.get(entry.interactionId);
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $6ba5ec799590141e$export$fbb6a65efb09cd7a.length < $6ba5ec799590141e$var$MAX_INTERACTIONS_TO_CONSIDER || minLongestInteraction && entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            // If the new entry has a longer duration, replace the old entries,
            // otherwise add to the array.
            if (entry.duration > existingInteraction.latency) {
                existingInteraction.entries = [
                    entry
                ];
                existingInteraction.latency = entry.duration;
            } else if (entry.duration === existingInteraction.latency && entry.startTime === (existingInteraction.entries[0] && existingInteraction.entries[0].startTime)) existingInteraction.entries.push(entry);
        } else {
            const interaction = {
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $6ba5ec799590141e$export$7b86959c9ded44e2.set(interaction.id, interaction);
            $6ba5ec799590141e$export$fbb6a65efb09cd7a.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $6ba5ec799590141e$export$fbb6a65efb09cd7a.sort((a, b)=>b.latency - a.latency);
        if ($6ba5ec799590141e$export$fbb6a65efb09cd7a.length > $6ba5ec799590141e$var$MAX_INTERACTIONS_TO_CONSIDER) $6ba5ec799590141e$export$fbb6a65efb09cd7a.splice($6ba5ec799590141e$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>$6ba5ec799590141e$export$7b86959c9ded44e2.delete(i.id));
    }
};









/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs the passed callback during the next idle period, or immediately
 * if the browser's visibility state is (or becomes) hidden.
 */ const $25236b21f8c05ee3$export$4d9952dcbf5b2792 = (cb)=>{
    const rIC = (0, $955496f5d3029976$export$56d8a8a25bd48b81).requestIdleCallback || (0, $955496f5d3029976$export$56d8a8a25bd48b81).setTimeout;
    let handle = -1;
    // eslint-disable-next-line no-param-reassign
    cb = (0, $d9bb6b2adff68632$export$b841d51e31c12bab)(cb);
    // If the document is hidden, run the callback immediately, otherwise
    // race an idle callback with the next `visibilitychange` event.
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.visibilityState === "hidden") cb();
    else {
        handle = rIC(cb);
        (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)(cb);
    }
    return handle;
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for INP. See https://web.dev/articles/inp#what_is_a_good_inp_score */ const $c2ceebba2f8f4181$export$7f4cb060ded9173c = [
    200,
    500
];
/**
 * Calculates the [INP](https://web.dev/articles/inp) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/articles/inp#what_is_a_good_inp_score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $c2ceebba2f8f4181$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    // Return if the browser doesn't support all APIs needed to measure INP.
    if (!("PerformanceEventTiming" in (0, $955496f5d3029976$export$56d8a8a25bd48b81) && "interactionId" in PerformanceEventTiming.prototype)) return;
    (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>{
        // TODO(philipwalton): remove once the polyfill is no longer needed.
        (0, $cc83e22cb516f528$export$67d90cda6b78a2eb)();
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)("INP");
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntries = (entries)=>{
            // Queue the `handleEntries()` callback in the next idle task.
            // This is needed to increase the chances that all event entries that
            // occurred between the user interaction and the next paint
            // have been dispatched. Note: there is currently an experiment
            // running in Chrome (EventTimingKeypressAndCompositionInteractionId)
            // 123+ that if rolled out fully may make this no longer necessary.
            (0, $25236b21f8c05ee3$export$4d9952dcbf5b2792)(()=>{
                entries.forEach((0, $6ba5ec799590141e$export$6a7a48c2c643798f));
                const inp = (0, $6ba5ec799590141e$export$70cf089971ed4f82)();
                if (inp && inp.latency !== metric.value) {
                    metric.value = inp.latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)("event", handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold != null ? opts.durationThreshold : (0, $6ba5ec799590141e$export$9cebd8cf5d8d3416)
        });
        report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $c2ceebba2f8f4181$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            // Also observe entries of type `first-input`. This is useful in cases
            // where the first interaction is less than the `durationThreshold`.
            po.observe({
                type: "first-input",
                buffered: true
            });
            (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};












/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for LCP. See https://web.dev/articles/lcp#what_is_a_good_lcp_score */ const $c89cf1e13796625e$export$948521ca5b0e1b17 = [
    2500,
    4000
];
const $c89cf1e13796625e$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/articles/lcp) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called any time a new `largest-contentful-paint`
 * performance entry is dispatched, or once the final value of the metric has
 * been determined.
 */ const $c89cf1e13796625e$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $bf61d7f7ca9bd10a$export$443f86b2c77012c4)();
        const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)("LCP");
        let report;
        const handleEntries = (entries)=>{
            // If reportAllChanges is set then call this function for each entry,
            // otherwise only consider the last one.
            if (!opts.reportAllChanges) // eslint-disable-next-line no-param-reassign
            entries = entries.slice(-1);
            entries.forEach((entry)=>{
                // Only report if the page wasn't hidden prior to LCP.
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    // The startTime attribute returns the value of the renderTime if it is
                    // not 0, and the value of the loadTime otherwise. The activationStart
                    // reference is used because LCP should be relative to page activation
                    // rather than navigation start if the page was pre-rendered. But in cases
                    // where `activationStart` occurs after the LCP, this time should be
                    // clamped at 0.
                    metric.value = Math.max(entry.startTime - (0, $087abae3f457004d$export$d3e828b3c7b5b845)(), 0);
                    metric.entries = [
                        entry
                    ];
                    report();
                }
            });
        };
        const po = (0, $3c3fb26ba7f6478b$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
        if (po) {
            report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $c89cf1e13796625e$export$948521ca5b0e1b17, opts.reportAllChanges);
            const stopListening = (0, $d9bb6b2adff68632$export$b841d51e31c12bab)(()=>{
                if (!$c89cf1e13796625e$var$reportedMetricIDs[metric.id]) {
                    handleEntries(po.takeRecords());
                    po.disconnect();
                    $c89cf1e13796625e$var$reportedMetricIDs[metric.id] = true;
                    report(true);
                }
            });
            // Stop listening after input. Note: while scrolling is an input that
            // stops LCP observation, it's unreliable since it can be programmatically
            // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
            [
                "keydown",
                "click"
            ].forEach((type)=>{
                // Wrap in a setTimeout so the callback is run in a separate task
                // to avoid extending the keyboard/click handler to reduce INP impact
                // https://github.com/GoogleChrome/web-vitals/issues/383
                if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document) addEventListener(type, ()=>(0, $25236b21f8c05ee3$export$4d9952dcbf5b2792)(stopListening), {
                    once: true,
                    capture: true
                });
            });
            (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)(stopListening);
        }
    });
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for TTFB. See https://web.dev/articles/ttfb#what_is_a_good_ttfb_score */ const $f3a7825c3a5278be$export$65c59ea8064668fc = [
    800,
    1800
];
/**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $f3a7825c3a5278be$var$whenReady = (callback)=>{
    if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.prerendering) (0, $6f9bc735dd2b9313$export$8bdb38a5671b594e)(()=>$f3a7825c3a5278be$var$whenReady(callback));
    else if ((0, $955496f5d3029976$export$56d8a8a25bd48b81).document && (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.readyState !== "complete") addEventListener("load", ()=>$f3a7825c3a5278be$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/articles/ttfb) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $f3a7825c3a5278be$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $21249b77f35afbbd$export$3c29b44508a0612b)("TTFB");
    const report = (0, $7f25ffc87954188c$export$17679dccdd551979)(onReport, metric, $f3a7825c3a5278be$export$65c59ea8064668fc, opts.reportAllChanges);
    $f3a7825c3a5278be$var$whenReady(()=>{
        const navigationEntry = (0, $44a719e67f846077$export$6431553786c94949)();
        if (navigationEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navigationEntry.responseStart - (0, $087abae3f457004d$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};


const $31f3d198369e5cbf$var$handlers = {};
const $31f3d198369e5cbf$var$instrumented = {};
let $31f3d198369e5cbf$var$_previousCls;
let $31f3d198369e5cbf$var$_previousFid;
let $31f3d198369e5cbf$var$_previousLcp;
let $31f3d198369e5cbf$var$_previousTtfb;
let $31f3d198369e5cbf$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $31f3d198369e5cbf$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $31f3d198369e5cbf$var$addMetricObserver("cls", callback, $31f3d198369e5cbf$var$instrumentCls, $31f3d198369e5cbf$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $31f3d198369e5cbf$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $31f3d198369e5cbf$var$addMetricObserver("lcp", callback, $31f3d198369e5cbf$var$instrumentLcp, $31f3d198369e5cbf$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $31f3d198369e5cbf$export$2707d7471c0b918f(callback) {
    return $31f3d198369e5cbf$var$addMetricObserver("fid", callback, $31f3d198369e5cbf$var$instrumentFid, $31f3d198369e5cbf$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $31f3d198369e5cbf$export$699d9529c099a797(callback) {
    return $31f3d198369e5cbf$var$addMetricObserver("ttfb", callback, $31f3d198369e5cbf$var$instrumentTtfb, $31f3d198369e5cbf$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $31f3d198369e5cbf$export$da3b76aa2022cbd7(callback) {
    return $31f3d198369e5cbf$var$addMetricObserver("inp", callback, $31f3d198369e5cbf$var$instrumentInp, $31f3d198369e5cbf$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $31f3d198369e5cbf$export$69816c1a049f8db6(type, callback) {
    $31f3d198369e5cbf$var$addHandler(type, callback);
    if (!$31f3d198369e5cbf$var$instrumented[type]) {
        $31f3d198369e5cbf$var$instrumentPerformanceObserver(type);
        $31f3d198369e5cbf$var$instrumented[type] = true;
    }
    return $31f3d198369e5cbf$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $31f3d198369e5cbf$var$triggerHandlers(type, data) {
    const typeHandlers = $31f3d198369e5cbf$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $hi47i.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $5v1oS.getFunctionName)(handler)}\nError:`, e);
    }
}
function $31f3d198369e5cbf$var$instrumentCls() {
    return (0, $c8cc3356aaa35be1$export$a7873055838e5ad8)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers("cls", {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $31f3d198369e5cbf$var$instrumentFid() {
    return (0, $88c48014ef58cf68$export$39705a25c49af873)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers("fid", {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousFid = metric;
    });
}
function $31f3d198369e5cbf$var$instrumentLcp() {
    return (0, $c89cf1e13796625e$export$947b1626ab8d5632)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers("lcp", {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $31f3d198369e5cbf$var$instrumentTtfb() {
    return (0, $f3a7825c3a5278be$export$33a01e6c5f2c7e33)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousTtfb = metric;
    });
}
function $31f3d198369e5cbf$var$instrumentInp() {
    return (0, $c2ceebba2f8f4181$export$7df4b36ecaed99e1)((metric)=>{
        $31f3d198369e5cbf$var$triggerHandlers("inp", {
            metric: metric
        });
        $31f3d198369e5cbf$var$_previousInp = metric;
    });
}
function $31f3d198369e5cbf$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $31f3d198369e5cbf$var$addHandler(type, callback);
    let stopListening;
    if (!$31f3d198369e5cbf$var$instrumented[type]) {
        stopListening = instrumentFn();
        $31f3d198369e5cbf$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $31f3d198369e5cbf$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $31f3d198369e5cbf$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, $3c3fb26ba7f6478b$export$d1203567a167490e)(type, (entries)=>{
        $31f3d198369e5cbf$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $31f3d198369e5cbf$var$addHandler(type, handler) {
    $31f3d198369e5cbf$var$handlers[type] = $31f3d198369e5cbf$var$handlers[type] || [];
    $31f3d198369e5cbf$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $31f3d198369e5cbf$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $31f3d198369e5cbf$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
/**
 * Check if a PerformanceEntry is a PerformanceEventTiming by checking for the `duration` property.
 */ function $31f3d198369e5cbf$export$7affb50b622d8714(entry) {
    return "duration" in entry;
}



var $kGYVh = parcelRequire("kGYVh");
var $4H7Y8 = parcelRequire("4H7Y8");
var $iNK7c = parcelRequire("iNK7c");

var $kGYVh = parcelRequire("kGYVh");

var $7YCyf = parcelRequire("7YCyf");

var $fKzCQ = parcelRequire("fKzCQ");

var $yQUXg = parcelRequire("yQUXg");

var $hi47i = parcelRequire("hi47i");

var $iWfxY = parcelRequire("iWfxY");

var $AIi6N = parcelRequire("AIi6N");

var $dfMsQ = parcelRequire("dfMsQ");
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $a328b345a75725bb$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $a328b345a75725bb$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $a328b345a75725bb$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $dfMsQ.isThenable)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}



var $jArAO = parcelRequire("jArAO");

var $dc48k = parcelRequire("dc48k");

var $4H7Y8 = parcelRequire("4H7Y8");

var $jdzJv = parcelRequire("jdzJv");

var $fKzCQ = parcelRequire("fKzCQ");

var $hi47i = parcelRequire("hi47i");

var $4H7Y8 = parcelRequire("4H7Y8");
/**
 * Print a log message for a started span.
 */ function $09ada9a941cee5f6$export$2f3d84e767c9592b(span) {
    if (!(0, $fKzCQ.DEBUG_BUILD)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = (0, $4H7Y8.spanToJSON)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $4H7Y8.spanIsSampled)(span);
    const rootSpan = (0, $4H7Y8.getRootSpan)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $4H7Y8.spanToJSON)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $hi47i.logger).log(`${header}
  ${infoParts.join("\n  ")}`);
}
/**
 * Print a log message for an ended span.
 */ function $09ada9a941cee5f6$export$b77c830667a4d630(span) {
    if (!(0, $fKzCQ.DEBUG_BUILD)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = (0, $4H7Y8.spanToJSON)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $4H7Y8.getRootSpan)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    (0, $hi47i.logger).log(msg);
}



var $kGYVh = parcelRequire("kGYVh");

var $fKzCQ = parcelRequire("fKzCQ");

var $hi47i = parcelRequire("hi47i");

var $jArAO = parcelRequire("jArAO");

var $fKzCQ = parcelRequire("fKzCQ");

var $hi47i = parcelRequire("hi47i");
/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $1053a52e7802e64c$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return undefined;
    }
    return rate;
}


/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $db2bd6d2ef458b60$export$5f833db634b217bb(options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $jArAO.hasTracingEnabled)(options)) return [
        false
    ];
    // Casting this from unknown, as the type of `sdkProcessingMetadata` is only changed in v9 and `normalizedRequest` is set in SentryHttpInstrumentation
    const normalizedRequest = (0, $kGYVh.getIsolationScope)().getScopeData().sdkProcessingMetadata.normalizedRequest;
    const enhancedSamplingContext = {
        ...samplingContext,
        normalizedRequest: samplingContext.normalizedRequest || normalizedRequest
    };
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") sampleRate = options.tracesSampler(enhancedSamplingContext);
    else if (enhancedSamplingContext.parentSampled !== undefined) sampleRate = enhancedSamplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") sampleRate = options.tracesSampleRate;
    else // When `enableTracing === true`, we use a sample rate of 100%
    sampleRate = 1;
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $1053a52e7802e64c$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate
        ];
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    const shouldSample = Math.random() < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return [
            false,
            parsedSampleRate
        ];
    }
    return [
        true,
        parsedSampleRate
    ];
}



var $iWfxY = parcelRequire("iWfxY");

var $4H7Y8 = parcelRequire("4H7Y8");
/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $d899755a957e1f50$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $iWfxY.generateTraceId)();
        this._spanId = spanContext.spanId || (0, $iWfxY.generateSpanId)();
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $4H7Y8.TRACE_FLAG_NONE)
        };
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLink(_link) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}



var $kGYVh = parcelRequire("kGYVh");

var $fKzCQ = parcelRequire("fKzCQ");

var $jdzJv = parcelRequire("jdzJv");






var $4H7Y8 = parcelRequire("4H7Y8");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $b89a3b4f1056006b$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $b89a3b4f1056006b$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $f5682b06913d5b03$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $b89a3b4f1056006b$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $f5682b06913d5b03$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $b89a3b4f1056006b$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $f5682b06913d5b03$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $b89a3b4f1056006b$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $jdzJv.getDynamicSamplingContextFromSpan)(spans[0]);
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)
        }
    };
    const beforeSendSpan = client && client.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = beforeSendSpan((0, $4H7Y8.spanToJSON)(span));
        if (!spanJson) (0, $4H7Y8.showSpanDropWarning)();
        return spanJson;
    } : (span)=>(0, $4H7Y8.spanToJSON)(span);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $f5682b06913d5b03$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(headers, items);
}



var $j7q4e = parcelRequire("j7q4e");

var $yQUXg = parcelRequire("yQUXg");

var $hi47i = parcelRequire("hi47i");

var $l1oVX = parcelRequire("l1oVX");

var $iWfxY = parcelRequire("iWfxY");

var $6OKHc = parcelRequire("6OKHc");

var $4H7Y8 = parcelRequire("4H7Y8");

var $jdzJv = parcelRequire("jdzJv");



var $l1oVX = parcelRequire("l1oVX");
const $4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $4509d165411fd11c$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $l1oVX.addNonEnumerableProperty)(span, $4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $l1oVX.addNonEnumerableProperty)(span, $4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $4509d165411fd11c$export$c08fbc656a245d03(span) {
    return {
        scope: span[$4509d165411fd11c$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$4509d165411fd11c$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}


const $e47c8865bba9bc73$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $e47c8865bba9bc73$export$a92149b045260d9f {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $iWfxY.generateTraceId)();
        this._spanId = spanContext.spanId || (0, $iWfxY.generateSpanId)();
        this._startTime = spanContext.startTimestamp || (0, $6OKHc.timestampInSeconds)();
        this._attributes = {};
        this.setAttributes({
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "manual",
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLink(_link) {
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $4H7Y8.TRACE_FLAG_SAMPLED) : (0, $4H7Y8.TRACE_FLAG_NONE)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $4H7Y8.spanTimeInputToSeconds)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $4H7Y8.spanTimeInputToSeconds)(endTimestamp);
        (0, $09ada9a941cee5f6$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $l1oVX.dropUndefinedKeys)({
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $4H7Y8.getStatusMessage)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            _metrics_summary: (0, $j7q4e.getMetricSummaryJsonForSpan)(this),
            profile_id: this._attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
            measurements: (0, $3ed76239c787a980$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $4H7Y8.getRootSpan)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $4H7Y8.getRootSpan)(this).spanContext().spanId : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log("[Tracing] Adding an event to span:", name);
        const time = $e47c8865bba9bc73$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $6OKHc.timestampInSeconds)();
        const attributes = $e47c8865bba9bc73$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $4H7Y8.spanTimeInputToSeconds)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $kGYVh.getClient)();
        if (client) client.emit("spanEnd", this);
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $4H7Y8.getRootSpan)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $e47c8865bba9bc73$var$sendSpanEnvelope((0, $b89a3b4f1056006b$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $4509d165411fd11c$export$c08fbc656a245d03)(this).scope || (0, $kGYVh.getCurrentScope)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$e47c8865bba9bc73$var$isFullFinishedSpan((0, $4H7Y8.spanToJSON)(this))) return undefined;
        if (!this._name) {
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $4509d165411fd11c$export$c08fbc656a245d03)(this);
        const scope = capturedSpanScope || (0, $kGYVh.getCurrentScope)();
        const client = scope.getClient() || (0, $kGYVh.getClient)();
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $4H7Y8.getSpanDescendants)(this).filter((span)=>span !== this && !$e47c8865bba9bc73$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $4H7Y8.spanToJSON)(span)).filter($e47c8865bba9bc73$var$isFullFinishedSpan);
        const source = this._attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        spans.forEach((span)=>{
            span.data && delete span.data[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = {
            contexts: {
                trace: (0, $4H7Y8.spanToTransactionTraceContext)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $e47c8865bba9bc73$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $e47c8865bba9bc73$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $l1oVX.dropUndefinedKeys)({
                    dynamicSamplingContext: (0, $jdzJv.getDynamicSamplingContextFromSpan)(this)
                })
            },
            _metrics_summary: (0, $j7q4e.getMetricSummaryJsonForSpan)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $3ed76239c787a980$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $e47c8865bba9bc73$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $e47c8865bba9bc73$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $e47c8865bba9bc73$var$isStandaloneSpan(span) {
    return span instanceof $e47c8865bba9bc73$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $e47c8865bba9bc73$var$sendSpanEnvelope(envelope) {
    const client = (0, $kGYVh.getClient)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}



var $02dIh = parcelRequire("02dIh");

const $038737f78c636108$var$SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $038737f78c636108$export$a1bd95187356f372(options, callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $038737f78c636108$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    return (0, $kGYVh.withScope)(options.scope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $038737f78c636108$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $kGYVh.getCurrentScope)();
            const parentSpan = $038737f78c636108$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $d899755a957e1f50$export$d6636b700b76c516)() : $038737f78c636108$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $dc48k._setSpanForScope)(scope, activeSpan);
            return (0, $a328b345a75725bb$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $4H7Y8.spanToJSON)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $02dIh.SPAN_STATUS_ERROR),
                    message: "internal_error"
                });
            }, ()=>activeSpan.end());
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $038737f78c636108$export$c10292ad04b92aea(options, callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $038737f78c636108$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    return (0, $kGYVh.withScope)(options.scope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $038737f78c636108$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $kGYVh.getCurrentScope)();
            const parentSpan = $038737f78c636108$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $d899755a957e1f50$export$d6636b700b76c516)() : $038737f78c636108$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $dc48k._setSpanForScope)(scope, activeSpan);
            function finishAndSetSpan() {
                activeSpan.end();
            }
            return (0, $a328b345a75725bb$export$18ce21a8b7efd7e9)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $4H7Y8.spanToJSON)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $02dIh.SPAN_STATUS_ERROR),
                    message: "internal_error"
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $038737f78c636108$export$63dbba021a6b4047(options) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $038737f78c636108$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $kGYVh.withScope)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$038737f78c636108$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $kGYVh.getCurrentScope)();
        const parentSpan = $038737f78c636108$var$getParentSpan(scope);
        const shouldSkipSpan = options.onlyIfParent && !parentSpan;
        if (shouldSkipSpan) return new (0, $d899755a957e1f50$export$d6636b700b76c516)();
        return $038737f78c636108$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $038737f78c636108$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $iNK7c.getMainCarrier)();
    const acs = (0, $7YCyf.getAsyncContextStrategy)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    return (0, $kGYVh.withScope)((scope)=>{
        const propagationContext = (0, $AIi6N.propagationContextFromHeaders)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $038737f78c636108$export$e57ac09b143d92a2(span, callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $kGYVh.withScope)((scope)=>{
        (0, $dc48k._setSpanForScope)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $038737f78c636108$export$869298f9835abc68(callback) {
    const acs = $038737f78c636108$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $kGYVh.withScope)((scope)=>{
        scope.setSDKProcessingMetadata({
            [$038737f78c636108$var$SUPPRESS_TRACING_KEY]: true
        });
        return callback();
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $038737f78c636108$export$f90b03291402f553(callback) {
    return (0, $kGYVh.withScope)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $iWfxY.generateTraceId)()
        });
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).info(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $038737f78c636108$export$e57ac09b143d92a2(null, callback);
    });
}
function $038737f78c636108$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $jArAO.hasTracingEnabled)()) return new (0, $d899755a957e1f50$export$d6636b700b76c516)();
    const isolationScope = (0, $kGYVh.getIsolationScope)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $038737f78c636108$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $4H7Y8.addChildSpanToSpan)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $jdzJv.getDynamicSamplingContextFromSpan)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $4H7Y8.spanIsSampled)(parentSpan);
        span = $038737f78c636108$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $jdzJv.freezeDscOnSpan)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $038737f78c636108$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $jdzJv.freezeDscOnSpan)(span, dsc);
    }
    (0, $09ada9a941cee5f6$export$2f3d84e767c9592b)(span);
    (0, $4509d165411fd11c$export$cddb4027e3b0dd66)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $038737f78c636108$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $4H7Y8.spanTimeInputToSeconds)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $038737f78c636108$var$getAcs() {
    const carrier = (0, $iNK7c.getMainCarrier)();
    return (0, $7YCyf.getAsyncContextStrategy)(carrier);
}
function $038737f78c636108$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $kGYVh.getClient)();
    const options = client && client.getOptions() || {};
    const { name: name = "", attributes: attributes } = spanArguments;
    const [sampled, sampleRate] = scope.getScopeData().sdkProcessingMetadata[$038737f78c636108$var$SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, $db2bd6d2ef458b60$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: parentSampled,
        attributes: attributes,
        transactionContext: {
            name: name,
            parentSampled: parentSampled
        }
    });
    const rootSpan = new (0, $e47c8865bba9bc73$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "custom",
            ...spanArguments.attributes
        },
        sampled: sampled
    });
    if (sampleRate !== undefined) rootSpan.setAttribute((0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), sampleRate);
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $038737f78c636108$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const sampled = scope.getScopeData().sdkProcessingMetadata[$038737f78c636108$var$SUPPRESS_TRACING_KEY] ? false : (0, $4H7Y8.spanIsSampled)(parentSpan);
    const childSpan = sampled ? new (0, $e47c8865bba9bc73$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $d899755a957e1f50$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $4H7Y8.addChildSpanToSpan)(parentSpan, childSpan);
    const client = (0, $kGYVh.getClient)();
    if (client) {
        client.emit("spanStart", childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit("spanEnd", childSpan);
    }
    return childSpan;
}
function $038737f78c636108$var$getParentSpan(scope) {
    const span = (0, $dc48k._getSpanForScope)(scope);
    if (!span) return undefined;
    const client = (0, $kGYVh.getClient)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $4H7Y8.getRootSpan)(span);
    return span;
}
function $038737f78c636108$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $038737f78c636108$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}



/**
 * Checks if a given value is a valid measurement value.
 */ function $b0d1d845a8fb2673$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $b0d1d845a8fb2673$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, { ...ctx }) {
    const parentStartTime = (0, $4H7Y8.spanToJSON)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) // We can only do this for SentrySpans...
    {
        if (typeof parentSpan.updateStartTime === "function") parentSpan.updateStartTime(startTimeInSeconds);
    }
    // The return value only exists for tests
    return (0, $038737f78c636108$export$e57ac09b143d92a2)(parentSpan, ()=>{
        const span = (0, $038737f78c636108$export$63dbba021a6b4047)({
            startTime: startTimeInSeconds,
            ...ctx
        });
        if (span) span.end(endTime);
        return span;
    });
}
/**
 * Starts an inactive, standalone span used to send web vital values to Sentry.
 * DO NOT use this for arbitrary spans, as these spans require special handling
 * during ingestion to extract metrics.
 *
 * This function adds a bunch of attributes and data to the span that's shared
 * by all web vital standalone spans. However, you need to take care of adding
 * the actual web vital value as an event to the span. Also, you need to assign
 * a transaction name and some other values that are specific to the web vital.
 *
 * Ultimately, you also need to take care of ending the span to send it off.
 *
 * @param options
 *
 * @returns an inactive, standalone and NOT YET ended span
 */ function $b0d1d845a8fb2673$export$b71b9c7b60c5a4aa(options) {
    const client = (0, $kGYVh.getClient)();
    if (!client) return;
    const { name: name, transaction: transaction, attributes: passedAttributes, startTime: startTime } = options;
    const { release: release, environment: environment } = client.getOptions();
    // We need to get the replay, user, and activeTransaction from the current scope
    // so that we can associate replay id, profile id, and a user display to the span
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay && replay.getReplayId();
    const scope = (0, $kGYVh.getCurrentScope)();
    const user = scope.getUser();
    const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
    let profileId;
    try {
        // @ts-expect-error skip optional chaining to save bundle size with try catch
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch (e) {
    // do nothing
    }
    const attributes = {
        release: release,
        environment: environment,
        user: userDisplay || undefined,
        profile_id: profileId || undefined,
        replay_id: replayId || undefined,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        "user_agent.original": (0, $955496f5d3029976$export$56d8a8a25bd48b81).navigator && (0, $955496f5d3029976$export$56d8a8a25bd48b81).navigator.userAgent,
        ...passedAttributes
    };
    return (0, $038737f78c636108$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
/** Get the browser performance API. */ function $b0d1d845a8fb2673$export$f72a13c439a30cab() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $955496f5d3029976$export$56d8a8a25bd48b81) && (0, $955496f5d3029976$export$56d8a8a25bd48b81).addEventListener && (0, $955496f5d3029976$export$56d8a8a25bd48b81).performance;
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $b0d1d845a8fb2673$export$b4785dbd4a81b33f(time) {
    return time / 1000;
}



/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop CLS measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the CLS value is sent as a standalone span and we stop
 * measuring CLS.
 */ function $b444d11e9edd543f$export$585bab03c6c18c45() {
    let standaloneCLsValue = 0;
    let standaloneClsEntry;
    let pageloadSpanId;
    if (!$b444d11e9edd543f$var$supportsLayoutShift()) return;
    let sentSpan = false;
    function _collectClsOnce() {
        if (sentSpan) return;
        sentSpan = true;
        if (pageloadSpanId) $b444d11e9edd543f$var$sendStandaloneClsSpan(standaloneCLsValue, standaloneClsEntry, pageloadSpanId);
        cleanupClsHandler();
    }
    const cleanupClsHandler = (0, $31f3d198369e5cbf$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    // use pagehide event from web-vitals
    (0, $02a4610d4ee5af80$export$91ec2be6fdd8f1b4)(()=>{
        _collectClsOnce();
    });
    // Since the call chain of this function is synchronous and evaluates before the SDK client is created,
    // we need to wait with subscribing to a client hook until the client is created. Therefore, we defer
    // to the next tick after the SDK setup.
    setTimeout(()=>{
        const client = (0, $kGYVh.getClient)();
        if (!client) return;
        const unsubscribeStartNavigation = client.on("startNavigationSpan", ()=>{
            _collectClsOnce();
            unsubscribeStartNavigation && unsubscribeStartNavigation();
        });
        const activeSpan = (0, $4H7Y8.getActiveSpan)();
        const rootSpan = activeSpan && (0, $4H7Y8.getRootSpan)(activeSpan);
        const spanJSON = rootSpan && (0, $4H7Y8.spanToJSON)(rootSpan);
        if (spanJSON && spanJSON.op === "pageload") pageloadSpanId = rootSpan.spanContext().spanId;
    }, 0);
}
function $b444d11e9edd543f$var$sendStandaloneClsSpan(clsValue, entry, pageloadSpanId) {
    (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $hi47i.logger).log(`Sending CLS span (${clsValue})`);
    const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(((0, $6OKHc.browserPerformanceTimeOrigin) || 0) + (entry && entry.startTime || 0));
    const routeName = (0, $kGYVh.getCurrentScope)().getScopeData().transactionName;
    const name = entry ? (0, $hA6iJ.htmlTreeAsString)(entry.sources[0] && entry.sources[0].node) : "Layout shift";
    const attributes = (0, $l1oVX.dropUndefinedKeys)({
        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.http.browser.cls",
        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "ui.webvital.cls",
        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME)]: entry && entry.duration || 0,
        // attach the pageload span id to the CLS span so that we can link them in the UI
        "sentry.pageload.span_id": pageloadSpanId
    });
    const span = (0, $b0d1d845a8fb2673$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("cls", {
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT)]: "",
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE)]: clsValue
        });
        // LayoutShift performance entries always have a duration of 0, so we don't need to add `entry.duration` here
        // see: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEntry/duration
        span.end(startTime);
    }
}
function $b444d11e9edd543f$var$supportsLayoutShift() {
    try {
        return PerformanceObserver.supportedEntryTypes.includes("layout-shift");
    } catch (e) {
        return false;
    }
}







const $4ca18541755f3f2c$var$MAX_INT_AS_BYTES = 2147483647;
let $4ca18541755f3f2c$var$_performanceCursor = 0;
let $4ca18541755f3f2c$var$_measurements = {};
let $4ca18541755f3f2c$var$_lcpEntry;
let $4ca18541755f3f2c$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $4ca18541755f3f2c$export$7c69f0412d101b88({ recordClsStandaloneSpans: recordClsStandaloneSpans }) {
    const performance = (0, $b0d1d845a8fb2673$export$f72a13c439a30cab)();
    if (performance && (0, $6OKHc.browserPerformanceTimeOrigin)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $955496f5d3029976$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const fidCleanupCallback = $4ca18541755f3f2c$var$_trackFID();
        const lcpCleanupCallback = $4ca18541755f3f2c$var$_trackLCP();
        const ttfbCleanupCallback = $4ca18541755f3f2c$var$_trackTtfb();
        const clsCleanupCallback = recordClsStandaloneSpans ? (0, $b444d11e9edd543f$export$585bab03c6c18c45)() : $4ca18541755f3f2c$var$_trackCLS();
        return ()=>{
            fidCleanupCallback();
            lcpCleanupCallback();
            ttfbCleanupCallback();
            clsCleanupCallback && clsCleanupCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $4ca18541755f3f2c$export$f396d19077034ad2() {
    (0, $31f3d198369e5cbf$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        const parent = (0, $4H7Y8.getActiveSpan)();
        if (!parent) return;
        const { op: parentOp, start_timestamp: parentStartTimestamp } = (0, $4H7Y8.spanToJSON)(parent);
        for (const entry of entries){
            const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $6OKHc.browserPerformanceTimeOrigin) + entry.startTime);
            const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.duration);
            if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: "Main UI thread blocked",
                op: "ui.long-task",
                attributes: {
                    [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.ui.browser.metrics"
                }
            });
        }
    });
}
/**
 * Start tracking long animation frames.
 */ function $4ca18541755f3f2c$export$5b823ab2ccbc801d() {
    // NOTE: the current web-vitals version (3.5.2) does not support long-animation-frame, so
    // we directly observe `long-animation-frame` events instead of through the web-vitals
    // `observe` helper function.
    const observer = new PerformanceObserver((list)=>{
        const parent = (0, $4H7Y8.getActiveSpan)();
        if (!parent) return;
        for (const entry of list.getEntries()){
            if (!entry.scripts[0]) continue;
            const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $6OKHc.browserPerformanceTimeOrigin) + entry.startTime);
            const { start_timestamp: parentStartTimestamp, op: parentOp } = (0, $4H7Y8.spanToJSON)(parent);
            if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.duration);
            const attributes = {
                [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.ui.browser.metrics"
            };
            const initialScript = entry.scripts[0];
            const { invoker: invoker, invokerType: invokerType, sourceURL: sourceURL, sourceFunctionName: sourceFunctionName, sourceCharPosition: sourceCharPosition } = initialScript;
            attributes["browser.script.invoker"] = invoker;
            attributes["browser.script.invoker_type"] = invokerType;
            if (sourceURL) attributes["code.filepath"] = sourceURL;
            if (sourceFunctionName) attributes["code.function"] = sourceFunctionName;
            if (sourceCharPosition !== -1) attributes["browser.script.source_char_position"] = sourceCharPosition;
            (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: "Main UI thread blocked",
                op: "ui.long-animation-frame",
                attributes: attributes
            });
        }
    });
    observer.observe({
        type: "long-animation-frame",
        buffered: true
    });
}
/**
 * Start tracking interaction events.
 */ function $4ca18541755f3f2c$export$e27543e0976315e4() {
    (0, $31f3d198369e5cbf$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        const parent = (0, $4H7Y8.getActiveSpan)();
        if (!parent) return;
        for (const entry of entries)if (entry.name === "click") {
            const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $6OKHc.browserPerformanceTimeOrigin) + entry.startTime);
            const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.duration);
            const spanOptions = {
                name: (0, $hA6iJ.htmlTreeAsString)(entry.target),
                op: `ui.interaction.${entry.name}`,
                startTime: startTime,
                attributes: {
                    [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.ui.browser.metrics"
                }
            };
            const componentName = (0, $hA6iJ.getComponentName)(entry.target);
            if (componentName) spanOptions.attributes["ui.component_name"] = componentName;
            (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, spanOptions);
        }
    });
}
/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value and last entry
 * to the `_measurements` object which ultimately is applied to the pageload span's measurements.
 */ function $4ca18541755f3f2c$var$_trackCLS() {
    return (0, $31f3d198369e5cbf$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $4ca18541755f3f2c$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $4ca18541755f3f2c$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $4ca18541755f3f2c$var$_trackLCP() {
    return (0, $31f3d198369e5cbf$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $4ca18541755f3f2c$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $4ca18541755f3f2c$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $4ca18541755f3f2c$var$_trackFID() {
    return (0, $31f3d198369e5cbf$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $6OKHc.browserPerformanceTimeOrigin));
        const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.startTime);
        $4ca18541755f3f2c$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $4ca18541755f3f2c$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
function $4ca18541755f3f2c$var$_trackTtfb() {
    return (0, $31f3d198369e5cbf$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $4ca18541755f3f2c$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
/** Add performance related spans to a transaction */ function $4ca18541755f3f2c$export$5f8fa6b3467a7443(span, options) {
    const performance = (0, $b0d1d845a8fb2673$export$f72a13c439a30cab)();
    if (!performance || !performance.getEntries || !(0, $6OKHc.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    const timeOrigin = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $6OKHc.browserPerformanceTimeOrigin));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $4H7Y8.spanToJSON)(span);
    performanceEntries.slice($4ca18541755f3f2c$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.startTime);
        const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $4ca18541755f3f2c$var$_addNavigationSpans(span, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $4ca18541755f3f2c$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $bf61d7f7ca9bd10a$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) $4ca18541755f3f2c$var$_measurements["fp"] = {
                        value: entry.startTime,
                        unit: "millisecond"
                    };
                    if (entry.name === "first-contentful-paint" && shouldRecord) $4ca18541755f3f2c$var$_measurements["fcp"] = {
                        value: entry.startTime,
                        unit: "millisecond"
                    };
                    break;
                }
            case "resource":
                $4ca18541755f3f2c$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $4ca18541755f3f2c$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $4ca18541755f3f2c$var$_trackNavigator(span);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        $4ca18541755f3f2c$var$_addTtfbRequestTimeToMeasurements($4ca18541755f3f2c$var$_measurements);
        const fidMark = $4ca18541755f3f2c$var$_measurements["mark.fid"];
        if (fidMark && $4ca18541755f3f2c$var$_measurements["fid"]) {
            // create span for FID
            (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, fidMark.value, fidMark.value + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)($4ca18541755f3f2c$var$_measurements["fid"].value), {
                name: "first input delay",
                op: "ui.action",
                attributes: {
                    [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.ui.browser.metrics"
                }
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $4ca18541755f3f2c$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        // TODO: Check if the first condition is still necessary: `onCLS` already only fires once `onFCP` was called.
        if (!("fcp" in $4ca18541755f3f2c$var$_measurements) || !options.recordClsOnPageloadSpan) delete $4ca18541755f3f2c$var$_measurements.cls;
        Object.entries($4ca18541755f3f2c$var$_measurements).forEach(([measurementName, measurement])=>{
            (0, $3ed76239c787a980$export$7cc31b475d33a706)(measurementName, measurement.value, measurement.unit);
        });
        // Set timeOrigin which denotes the timestamp which to base the LCP/FCP/FP/TTFB measurements on
        span.setAttribute("performance.timeOrigin", timeOrigin);
        // In prerendering scenarios, where a page might be prefetched and pre-rendered before the user clicks the link,
        // the navigation starts earlier than when the user clicks it. Web Vitals should always be based on the
        // user-perceived time, so they are not reported from the actual start of the navigation, but rather from the
        // time where the user actively started the navigation, for example by clicking a link.
        // This is user action is called "activation" and the time between navigation and activation is stored in
        // the `activationStart` attribute of the "navigation" PerformanceEntry.
        span.setAttribute("performance.activationStart", (0, $087abae3f457004d$export$d3e828b3c7b5b845)());
        $4ca18541755f3f2c$var$_setWebVitalAttributes(span);
    }
    $4ca18541755f3f2c$var$_lcpEntry = undefined;
    $4ca18541755f3f2c$var$_clsEntry = undefined;
    $4ca18541755f3f2c$var$_measurements = {};
}
/**
 * Create measure related spans.
 * Exported only for tests.
 */ function $4ca18541755f3f2c$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin) {
    const navEntry = (0, $44a719e67f846077$export$6431553786c94949)(false);
    const requestTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(navEntry ? navEntry.requestStart : 0);
    // Because performance.measure accepts arbitrary timestamps it can produce
    // spans that happen before the browser even makes a request for the page.
    //
    // An example of this is the automatically generated Next.js-before-hydration
    // spans created by the Next.js framework.
    //
    // To prevent this we will pin the start timestamp to the request start time
    // This does make duration inaccurate, so if this does happen, we will add
    // an attribute to the span
    const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    const startTimeStamp = timeOrigin + startTime;
    const measureEndTimestamp = startTimeStamp + duration;
    const attributes = {
        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.resource.browser.metrics"
    };
    if (measureStartTimestamp !== startTimeStamp) {
        attributes["sentry.browser.measure_happened_before_request"] = true;
        attributes["sentry.browser.measure_start_time"] = measureStartTimestamp;
    }
    (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ function $4ca18541755f3f2c$var$_addNavigationSpans(span, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, "secureConnection", timeOrigin, "TLS/SSL");
    $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, "fetch", timeOrigin, "cache");
    $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, "domainLookup", timeOrigin, "DNS");
    $4ca18541755f3f2c$var$_addRequest(span, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $4ca18541755f3f2c$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin, name = event) {
    const eventEnd = $4ca18541755f3f2c$var$_getEndPropertyNameForNavigationTiming(event);
    const end = entry[eventEnd];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(start), timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(end), {
        op: `browser.${name}`,
        name: entry.name,
        attributes: {
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.ui.browser.metrics"
        }
    });
}
function $4ca18541755f3f2c$var$_getEndPropertyNameForNavigationTiming(event) {
    if (event === "secureConnection") return "connectEnd";
    if (event === "fetch") return "domainLookupStart";
    return `${event}End`;
}
/** Create request and response related spans */ function $4ca18541755f3f2c$var$_addRequest(span, entry, timeOrigin) {
    const requestStartTimestamp = timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.requestStart);
    const responseEndTimestamp = timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.responseEnd);
    const responseStartTimestamp = timeOrigin + (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(entry.responseStart);
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire span if it contained faulty spans.
        (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, requestStartTimestamp, responseEndTimestamp, {
            op: "browser.request",
            name: entry.name,
            attributes: {
                [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.ui.browser.metrics"
            }
        });
        (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, responseStartTimestamp, responseEndTimestamp, {
            op: "browser.response",
            name: entry.name,
            attributes: {
                [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.ui.browser.metrics"
            }
        });
    }
}
/**
 * Create resource-related spans.
 * Exported only for tests.
 */ function $4ca18541755f3f2c$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const parsedUrl = (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(resourceUrl);
    const attributes = {
        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.resource.browser.metrics"
    };
    $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, "transferSize", "http.response_transfer_size");
    $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, "encodedBodySize", "http.response_content_length");
    $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, "decodedBodySize", "http.decoded_response_content_length");
    // `deliveryType` is experimental and does not exist everywhere
    const deliveryType = entry.deliveryType;
    if (deliveryType != null) attributes["http.response_delivery_type"] = deliveryType;
    // Types do not reflect this property yet
    const renderBlockingStatus = entry.renderBlockingStatus;
    if (renderBlockingStatus) attributes["resource.render_blocking_status"] = renderBlockingStatus;
    if (parsedUrl.protocol) attributes["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) attributes["server.address"] = parsedUrl.host;
    attributes["url.same_origin"] = resourceUrl.includes((0, $955496f5d3029976$export$56d8a8a25bd48b81).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $b0d1d845a8fb2673$export$7567a67bdb69a23d)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $955496f5d3029976$export$56d8a8a25bd48b81).location.origin, ""),
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        attributes: attributes
    });
}
/**
 * Capture the information of the user agent.
 */ function $4ca18541755f3f2c$var$_trackNavigator(span) {
    const navigator = (0, $955496f5d3029976$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute("effectiveConnectionType", connection.effectiveType);
        if (connection.type) span.setAttribute("connectionType", connection.type);
        if ((0, $b0d1d845a8fb2673$export$27169ccae1b439e3)(connection.rtt)) $4ca18541755f3f2c$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $b0d1d845a8fb2673$export$27169ccae1b439e3)(navigator.deviceMemory)) span.setAttribute("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $b0d1d845a8fb2673$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) span.setAttribute("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to span to allow debugging */ function $4ca18541755f3f2c$var$_setWebVitalAttributes(span) {
    if ($4ca18541755f3f2c$var$_lcpEntry) {
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($4ca18541755f3f2c$var$_lcpEntry.element) span.setAttribute("lcp.element", (0, $hA6iJ.htmlTreeAsString)($4ca18541755f3f2c$var$_lcpEntry.element));
        if ($4ca18541755f3f2c$var$_lcpEntry.id) span.setAttribute("lcp.id", $4ca18541755f3f2c$var$_lcpEntry.id);
        if ($4ca18541755f3f2c$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        span.setAttribute("lcp.url", $4ca18541755f3f2c$var$_lcpEntry.url.trim().slice(0, 200));
        if ($4ca18541755f3f2c$var$_lcpEntry.loadTime != null) // loadTime is the time of LCP that's related to receiving the LCP element response..
        span.setAttribute("lcp.loadTime", $4ca18541755f3f2c$var$_lcpEntry.loadTime);
        if ($4ca18541755f3f2c$var$_lcpEntry.renderTime != null) // renderTime is loadTime + rendering time
        // it's 0 if the LCP element is loaded from a 3rd party origin that doesn't send the
        // `Timing-Allow-Origin` header.
        span.setAttribute("lcp.renderTime", $4ca18541755f3f2c$var$_lcpEntry.renderTime);
        span.setAttribute("lcp.size", $4ca18541755f3f2c$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($4ca18541755f3f2c$var$_clsEntry && $4ca18541755f3f2c$var$_clsEntry.sources) $4ca18541755f3f2c$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $hA6iJ.htmlTreeAsString)(source.node)));
}
function $4ca18541755f3f2c$var$setResourceEntrySizeData(attributes, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $4ca18541755f3f2c$var$MAX_INT_AS_BYTES) attributes[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $4ca18541755f3f2c$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $44a719e67f846077$export$6431553786c94949)(false);
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) _measurements["ttfb.requestTime"] = {
        value: responseStart - requestStart,
        unit: "millisecond"
    };
}


var $6OKHc = parcelRequire("6OKHc");
var $l1oVX = parcelRequire("l1oVX");
var $4H7Y8 = parcelRequire("4H7Y8");
var $kGYVh = parcelRequire("kGYVh");
var $hA6iJ = parcelRequire("hA6iJ");
var $yQUXg = parcelRequire("yQUXg");


const $751b596e3029fa17$var$LAST_INTERACTIONS = [];
const $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP = new Map();
/**
 * Start tracking INP webvital events.
 */ function $751b596e3029fa17$export$f17d06681a4744a3() {
    const performance = (0, $b0d1d845a8fb2673$export$f72a13c439a30cab)();
    if (performance && (0, $6OKHc.browserPerformanceTimeOrigin)) {
        const inpCallback = $751b596e3029fa17$var$_trackINP();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
const $751b596e3029fa17$var$INP_ENTRY_MAP = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $751b596e3029fa17$var$_trackINP() {
    return (0, $31f3d198369e5cbf$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        if (metric.value == undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $751b596e3029fa17$var$INP_ENTRY_MAP[entry.name]);
        if (!entry) return;
        const { interactionId: interactionId } = entry;
        const interactionType = $751b596e3029fa17$var$INP_ENTRY_MAP[entry.name];
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)((0, $6OKHc.browserPerformanceTimeOrigin) + entry.startTime);
        const duration = (0, $b0d1d845a8fb2673$export$b4785dbd4a81b33f)(metric.value);
        const activeSpan = (0, $4H7Y8.getActiveSpan)();
        const rootSpan = activeSpan ? (0, $4H7Y8.getRootSpan)(activeSpan) : undefined;
        // We first try to lookup the span from our INTERACTIONS_SPAN_MAP,
        // where we cache the route per interactionId
        const cachedSpan = interactionId != null ? $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.get(interactionId) : undefined;
        const spanToUse = cachedSpan || rootSpan;
        // Else, we try to use the active span.
        // Finally, we fall back to look at the transactionName on the scope
        const routeName = spanToUse ? (0, $4H7Y8.spanToJSON)(spanToUse).description : (0, $kGYVh.getCurrentScope)().getScopeData().transactionName;
        const name = (0, $hA6iJ.htmlTreeAsString)(entry.target);
        const attributes = (0, $l1oVX.dropUndefinedKeys)({
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.http.browser.inp",
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: `ui.interaction.${interactionType}`,
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME)]: entry.duration
        });
        const span = (0, $b0d1d845a8fb2673$export$b71b9c7b60c5a4aa)({
            name: name,
            transaction: routeName,
            attributes: attributes,
            startTime: startTime
        });
        if (span) {
            span.addEvent("inp", {
                [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT)]: "millisecond",
                [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE)]: metric.value
            });
            span.end(startTime + duration);
        }
    });
}
/**
 * Register a listener to cache route information for INP interactions.
 * TODO(v9): `latestRoute` no longer needs to be passed in and will be removed in v9.
 */ function $751b596e3029fa17$export$e4e04d43e223cce2(_latestRoute) {
    const handleEntries = ({ entries: entries })=>{
        const activeSpan = (0, $4H7Y8.getActiveSpan)();
        const activeRootSpan = activeSpan && (0, $4H7Y8.getRootSpan)(activeSpan);
        entries.forEach((entry)=>{
            if (!(0, $31f3d198369e5cbf$export$7affb50b622d8714)(entry) || !activeRootSpan) return;
            const interactionId = entry.interactionId;
            if (interactionId == null) return;
            // If the interaction was already recorded before, nothing more to do
            if ($751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            // We keep max. 10 interactions in the list, then remove the oldest one & clean up
            if ($751b596e3029fa17$var$LAST_INTERACTIONS.length > 10) {
                const last = $751b596e3029fa17$var$LAST_INTERACTIONS.shift();
                $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            // We add the interaction to the list of recorded interactions
            // and store the span for this interaction
            $751b596e3029fa17$var$LAST_INTERACTIONS.push(interactionId);
            $751b596e3029fa17$var$INTERACTIONS_SPAN_MAP.set(interactionId, activeRootSpan);
        });
    };
    (0, $31f3d198369e5cbf$export$69816c1a049f8db6)("event", handleEntries);
    (0, $31f3d198369e5cbf$export$69816c1a049f8db6)("first-input", handleEntries);
}



var $6OKHc = parcelRequire("6OKHc");
var $iWfxY = parcelRequire("iWfxY");
var $4H7Y8 = parcelRequire("4H7Y8");
var $kGYVh = parcelRequire("kGYVh");
var $hA6iJ = parcelRequire("hA6iJ");
var $jdzJv = parcelRequire("jdzJv");
var $2fKhD = parcelRequire("2fKhD");
var $hi47i = parcelRequire("hi47i");
var $AIi6N = parcelRequire("AIi6N");
var $fKzCQ = parcelRequire("fKzCQ");

var $2fKhD = parcelRequire("2fKhD");

let $4d76cdf59d4d2156$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $4d76cdf59d4d2156$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $4d76cdf59d4d2156$var$instrumentError);
}
function $4d76cdf59d4d2156$var$instrumentError() {
    $4d76cdf59d4d2156$var$_oldOnErrorHandler = (0, $2fKhD.GLOBAL_OBJ).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $2fKhD.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $f079126c500c7ea2$export$b18c893e424d3127)("error", handlerData);
        if ($4d76cdf59d4d2156$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $4d76cdf59d4d2156$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $2fKhD.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}



var $2fKhD = parcelRequire("2fKhD");

let $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $7878483f8a9932cd$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $7878483f8a9932cd$var$instrumentUnhandledRejection);
}
function $7878483f8a9932cd$var$instrumentUnhandledRejection() {
    $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler = (0, $2fKhD.GLOBAL_OBJ).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $2fKhD.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $f079126c500c7ea2$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $7878483f8a9932cd$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $2fKhD.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}



var $hi47i = parcelRequire("hi47i");

var $4H7Y8 = parcelRequire("4H7Y8");

var $02dIh = parcelRequire("02dIh");
let $d4be1d52827a3f28$var$errorsInstrumented = false;
/**
 * Ensure that global errors automatically set the active span status.
 */ function $d4be1d52827a3f28$export$b0914730ee1f6c80() {
    if ($d4be1d52827a3f28$var$errorsInstrumented) return;
    $d4be1d52827a3f28$var$errorsInstrumented = true;
    (0, $4d76cdf59d4d2156$export$55b5c3ba2194f0c6)($d4be1d52827a3f28$var$errorCallback);
    (0, $7878483f8a9932cd$export$8bf4fc6858821a4e)($d4be1d52827a3f28$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active root span as failed
 */ function $d4be1d52827a3f28$var$errorCallback() {
    const activeSpan = (0, $4H7Y8.getActiveSpan)();
    const rootSpan = activeSpan && (0, $4H7Y8.getRootSpan)(activeSpan);
    if (rootSpan) {
        const message = "internal_error";
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log(`[Tracing] Root span: ${message} -> Global error occurred`);
        rootSpan.setStatus({
            code: (0, $02dIh.SPAN_STATUS_ERROR),
            message: message
        });
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$d4be1d52827a3f28$var$errorCallback.tag = "sentry_tracingErrorCallback";


var $yQUXg = parcelRequire("yQUXg");
var $kGYVh = parcelRequire("kGYVh");

var $fKzCQ = parcelRequire("fKzCQ");

var $yQUXg = parcelRequire("yQUXg");

var $hi47i = parcelRequire("hi47i");

var $6OKHc = parcelRequire("6OKHc");

var $jArAO = parcelRequire("jArAO");

var $dc48k = parcelRequire("dc48k");

var $4H7Y8 = parcelRequire("4H7Y8");


var $02dIh = parcelRequire("02dIh");

const $fd927ea1b5d85956$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    childSpanTimeout: 15000
};
const $fd927ea1b5d85956$var$FINISH_REASON_HEARTBEAT_FAILED = "heartbeatFailed";
const $fd927ea1b5d85956$var$FINISH_REASON_IDLE_TIMEOUT = "idleTimeout";
const $fd927ea1b5d85956$var$FINISH_REASON_FINAL_TIMEOUT = "finalTimeout";
const $fd927ea1b5d85956$var$FINISH_REASON_EXTERNAL_FINISH = "externalFinish";
/**
 * An idle span is a span that automatically finishes. It does this by tracking child spans as activities.
 * An idle span is always the active span.
 */ function $fd927ea1b5d85956$export$901bffd97bd52797(startSpanOptions, options = {}) {
    // Activities store a list of active spans
    const activities = new Map();
    // We should not use heartbeat if we finished a span
    let _finished = false;
    // Timer that tracks idleTimeout
    let _idleTimeoutID;
    // The reason why the span was finished
    let _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $fd927ea1b5d85956$export$809a2b7987fd5306.idleTimeout, finalTimeout: finalTimeout = $fd927ea1b5d85956$export$809a2b7987fd5306.finalTimeout, childSpanTimeout: childSpanTimeout = $fd927ea1b5d85956$export$809a2b7987fd5306.childSpanTimeout, beforeSpanEnd: beforeSpanEnd } = options;
    const client = (0, $kGYVh.getClient)();
    if (!client || !(0, $jArAO.hasTracingEnabled)()) return new (0, $d899755a957e1f50$export$d6636b700b76c516)();
    const scope = (0, $kGYVh.getCurrentScope)();
    const previousActiveSpan = (0, $4H7Y8.getActiveSpan)();
    const span = $fd927ea1b5d85956$var$_startIdleSpan(startSpanOptions);
    // We patch span.end to ensure we can run some things before the span is ended
    // eslint-disable-next-line @typescript-eslint/unbound-method
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            // Just ensuring that this keeps working, even if we ever have more arguments here
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || (0, $6OKHc.timestampInSeconds)();
            const spanEndTimestamp = (0, $4H7Y8.spanTimeInputToSeconds)(timestamp);
            // Ensure we end with the last span timestamp, if possible
            const spans = (0, $4H7Y8.getSpanDescendants)(span).filter((child)=>child !== span);
            // If we have no spans, we just end, nothing else to do here
            if (!spans.length) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const childEndTimestamps = spans.map((span)=>(0, $4H7Y8.spanToJSON)(span).timestamp).filter((timestamp)=>!!timestamp);
            const latestSpanEndTimestamp = childEndTimestamps.length ? Math.max(...childEndTimestamps) : undefined;
            // In reality this should always exist here, but type-wise it may be undefined...
            const spanStartTimestamp = (0, $4H7Y8.spanToJSON)(span).start_timestamp;
            // The final endTimestamp should:
            // * Never be before the span start timestamp
            // * Be the latestSpanEndTimestamp, if there is one, and it is smaller than the passed span end timestamp
            // * Otherwise be the passed end timestamp
            // Final timestamp can never be after finalTimeout
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1000 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    /**
   * Cancels the existing idle timeout, if there is one.
   */ function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = undefined;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    /**
   * Restarts child span timeout, if there is none running it will start one.
   */ function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = (0, $6OKHc.timestampInSeconds)();
        // We need to add the timeout here to have the real endtimestamp of the idle span
        // Remember timestampInSeconds is in seconds, timeout is in ms
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1000);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = (0, $6OKHc.timestampInSeconds)();
            // We need to add the timeout here to have the real endtimestamp of the idle span
            // Remember timestampInSeconds is in seconds, timeout is in ms
            _restartIdleTimeout(endTimestamp + idleTimeout / 1000);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        (0, $dc48k._setSpanForScope)(scope, previousActiveSpan);
        const spanJSON = (0, $4H7Y8.spanToJSON)(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        // This should never happen, but to make TS happy...
        if (!startTimestamp) return;
        const attributes = spanJSON.data || {};
        if (!attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON]) span.setAttribute((0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), _finishReason);
        (0, $hi47i.logger).log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = (0, $4H7Y8.getSpanDescendants)(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            // We cancel all pending spans with status "cancelled" to indicate the idle span was finished early
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: (0, $02dIh.SPAN_STATUS_ERROR),
                    message: "cancelled"
                });
                childSpan.end(endTimestamp);
                (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log("[Tracing] Cancelling span since span ended early", JSON.stringify(childSpan, undefined, 2));
            }
            const childSpanJSON = (0, $4H7Y8.spanToJSON)(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            // Add a delta with idle timeout so that we prevent false positives
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1000;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if (0, $fKzCQ.DEBUG_BUILD) {
                const stringifiedSpan = JSON.stringify(childSpan, undefined, 2);
                if (!spanStartedBeforeIdleSpanEnd) (0, $hi47i.logger).log("[Tracing] Discarding span since it happened after idle span was finished", stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) (0, $hi47i.logger).log("[Tracing] Discarding span since it finished after idle span final timeout", stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                (0, $4H7Y8.removeChildSpanFromSpan)(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute("sentry.idle_span_discarded_spans", discardedSpans);
    }
    _cleanupHooks.push(client.on("spanStart", (startedSpan)=>{
        // If we already finished the idle span,
        // or if this is the idle span itself being started,
        // or if the started span has already been closed,
        // we don't care about it for activity
        if (_finished || startedSpan === span || !!(0, $4H7Y8.spanToJSON)(startedSpan).timestamp) return;
        const allSpans = (0, $4H7Y8.getSpanDescendants)(span);
        // If the span that was just started is a child of the idle span, we should track it
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("spanEnd", (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("idleSpanEnableAutoFinish", (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    // We only start the initial idle timeout if we are not delaying the auto finish
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: (0, $02dIh.SPAN_STATUS_ERROR),
                message: "deadline_exceeded"
            });
            _finishReason = $fd927ea1b5d85956$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $fd927ea1b5d85956$var$_startIdleSpan(options) {
    const span = (0, $038737f78c636108$export$63dbba021a6b4047)(options);
    (0, $dc48k._setSpanForScope)((0, $kGYVh.getCurrentScope)(), span);
    (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log("[Tracing] Started span is an idle span");
    return span;
}





var $4H7Y8 = parcelRequire("4H7Y8");
var $hi47i = parcelRequire("hi47i");
var $02dIh = parcelRequire("02dIh");


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $755e6178fce08d17$export$6f18f55521af71a1() {
    if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81) && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        const activeSpan = (0, $4H7Y8.getActiveSpan)();
        if (!activeSpan) return;
        const rootSpan = (0, $4H7Y8.getRootSpan)(activeSpan);
        if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.hidden && rootSpan) {
            const cancelledStatus = "cancelled";
            const { op: op, status: status } = (0, $4H7Y8.spanToJSON)(rootSpan);
            if (0, $7b8b500cb80621bc$export$16a28057038b10ef) (0, $hi47i.logger).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) rootSpan.setStatus({
                code: (0, $02dIh.SPAN_STATUS_ERROR),
                message: cancelledStatus
            });
            rootSpan.setAttribute("sentry.cancellation_reason", "document.hidden");
            rootSpan.end();
        }
    });
    else (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $hi47i.logger).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}



var $dfMsQ = parcelRequire("dfMsQ");
var $6OKHc = parcelRequire("6OKHc");

const $63e43e59b4196dc4$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $63e43e59b4196dc4$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $63e43e59b4196dc4$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $63e43e59b4196dc4$export$c67d533bf77cbf54() {
    if (!(0, $955496f5d3029976$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $6OKHc.timestampInSeconds)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $dfMsQ.isString)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $63e43e59b4196dc4$var$parseUrl(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $6OKHc.timestampInSeconds)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $f079126c500c7ea2$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $dfMsQ.isString)(header) && (0, $dfMsQ.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$63e43e59b4196dc4$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $6OKHc.timestampInSeconds)() * 1000,
                xhr: sendThisArg
            };
            (0, $f079126c500c7ea2$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $63e43e59b4196dc4$var$parseUrl(url) {
    if ((0, $dfMsQ.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}



var $dfMsQ = parcelRequire("dfMsQ");

var $l1oVX = parcelRequire("l1oVX");

var $24aKj = parcelRequire("24aKj");

var $hi47i = parcelRequire("hi47i");

var $2fKhD = parcelRequire("2fKhD");
const $020e060e3b422828$var$WINDOW = (0, $2fKhD.GLOBAL_OBJ);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $020e060e3b422828$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $020e060e3b422828$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $020e060e3b422828$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$020e060e3b422828$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($020e060e3b422828$export$d5f608b368e73f38($020e060e3b422828$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $020e060e3b422828$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $020e060e3b422828$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $24aKj.DEBUG_BUILD) && (0, $hi47i.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$531055a6c684a70a() {
    return "ReportingObserver" in $020e060e3b422828$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $020e060e3b422828$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$020e060e3b422828$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}



var $6OKHc = parcelRequire("6OKHc");

var $2fKhD = parcelRequire("2fKhD");

/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $da5e32477400e3c6$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = "fetch";
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, ()=>$da5e32477400e3c6$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $da5e32477400e3c6$export$1a79663eb318fe6a(handler) {
    const type = "fetch-body-resolved";
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, ()=>$da5e32477400e3c6$var$instrumentFetch($da5e32477400e3c6$var$streamHandler));
}
function $da5e32477400e3c6$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $020e060e3b422828$export$c82d238e23c40b21)()) return;
    (0, $l1oVX.fill)((0, $2fKhD.GLOBAL_OBJ), "fetch", function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $da5e32477400e3c6$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $6OKHc.timestampInSeconds)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $f079126c500c7ea2$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $2fKhD.GLOBAL_OBJ), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $f079126c500c7ea2$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $6OKHc.timestampInSeconds)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $f079126c500c7ea2$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $6OKHc.timestampInSeconds)() * 1000,
                    error: error
                });
                if ((0, $dfMsQ.isError)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $l1oVX.addNonEnumerableProperty)(error, "framesToPop", 1);
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $da5e32477400e3c6$var$resolveResponse(res, onFinishedResolving) {
    if (res && res.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $da5e32477400e3c6$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch (e) {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $da5e32477400e3c6$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $f079126c500c7ea2$export$b18c893e424d3127)("fetch-body-resolved", {
            endTimestamp: (0, $6OKHc.timestampInSeconds)() * 1000,
            response: response
        });
    });
}
function $da5e32477400e3c6$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $da5e32477400e3c6$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($da5e32477400e3c6$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $da5e32477400e3c6$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $da5e32477400e3c6$var$getUrlFromResource(url),
            method: $da5e32477400e3c6$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $da5e32477400e3c6$var$getUrlFromResource(arg),
        method: $da5e32477400e3c6$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}


var $6OKHc = parcelRequire("6OKHc");
var $4H7Y8 = parcelRequire("4H7Y8");
var $7YCyf = parcelRequire("7YCyf");

var $iNK7c = parcelRequire("iNK7c");

var $kGYVh = parcelRequire("kGYVh");

var $kQ0sT = parcelRequire("kQ0sT");




var $hi47i = parcelRequire("hi47i");



var $4H7Y8 = parcelRequire("4H7Y8");

var $AIi6N = parcelRequire("AIi6N");

var $jdzJv = parcelRequire("jdzJv");

var $gdhAa = parcelRequire("gdhAa");
/**
 * Extracts trace propagation data from the current span or from the client's scope (via transaction or propagation
 * context) and serializes it to `sentry-trace` and `baggage` values to strings. These values can be used to propagate
 * a trace via our tracing Http headers or Html `<meta>` tags.
 *
 * This function also applies some validation to the generated sentry-trace and baggage values to ensure that
 * only valid strings are returned.
 *
 * @returns an object with the tracing data values. The object keys are the name of the tracing key to be used as header
 * or meta tag name.
 */ function $1ca539d872b9359e$export$dec8f001b9d982cb(options = {}) {
    const client = (0, $kGYVh.getClient)();
    if (!(0, $kQ0sT.isEnabled)() || !client) return {};
    const carrier = (0, $iNK7c.getMainCarrier)();
    const acs = (0, $7YCyf.getAsyncContextStrategy)(carrier);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = (0, $kGYVh.getCurrentScope)();
    const span = options.span || (0, $4H7Y8.getActiveSpan)();
    const sentryTrace = span ? (0, $4H7Y8.spanToTraceHeader)(span) : $1ca539d872b9359e$var$scopeToTraceHeader(scope);
    const dsc = span ? (0, $jdzJv.getDynamicSamplingContextFromSpan)(span) : (0, $jdzJv.getDynamicSamplingContextFromScope)(client, scope);
    const baggage = (0, $gdhAa.dynamicSamplingContextToSentryBaggageHeader)(dsc);
    const isValidSentryTraceHeader = (0, $AIi6N.TRACEPARENT_REGEXP).test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        (0, $hi47i.logger).warn("Invalid sentry-trace data. Cannot generate trace data");
        return {};
    }
    return {
        "sentry-trace": sentryTrace,
        baggage: baggage
    };
}
/**
 * Get a sentry-trace header value for the given scope.
 */ function $1ca539d872b9359e$var$scopeToTraceHeader(scope) {
    // TODO(v9): Use generateSpanId() instead of spanId
    // eslint-disable-next-line deprecation/deprecation
    const { traceId: traceId, sampled: sampled, spanId: spanId } = scope.getPropagationContext();
    return (0, $AIi6N.generateSentryTraceHeader)(traceId, spanId, sampled);
}


var $jArAO = parcelRequire("jArAO");
var $yQUXg = parcelRequire("yQUXg");


var $dfMsQ = parcelRequire("dfMsQ");







var $gdhAa = parcelRequire("gdhAa");


var $jArAO = parcelRequire("jArAO");

var $4H7Y8 = parcelRequire("4H7Y8");


var $02dIh = parcelRequire("02dIh");


/**
 * Create and track fetch request spans for usage in combination with `addFetchInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $0b4497afe5c251f9$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = "auto.http.browser") {
    if (!handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = (0, $jArAO.hasTracingEnabled)() && shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $0b4497afe5c251f9$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $0b4497afe5c251f9$var$getFullURL(url);
    const host = fullUrl ? (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const hasParent = !!(0, $4H7Y8.getActiveSpan)();
    const span = shouldCreateSpanResult && hasParent ? (0, $038737f78c636108$export$63dbba021a6b4047)({
        name: `${method} ${url}`,
        attributes: {
            url: url,
            type: "fetch",
            "http.method": method,
            "http.url": fullUrl,
            "server.address": host,
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin,
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "http.client"
        }
    }) : new (0, $d899755a957e1f50$export$d6636b700b76c516)();
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        const options = handlerData.args[1] || {};
        const headers = $0b4497afe5c251f9$var$_addTracingHeadersToFetchRequest(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        (0, $jArAO.hasTracingEnabled)() && hasParent ? span : undefined);
        if (headers) {
            // Ensure this is actually set, if no options have been passed previously
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers.
 */ function $0b4497afe5c251f9$var$_addTracingHeadersToFetchRequest(request, fetchOptionsObj, span) {
    const traceHeaders = (0, $1ca539d872b9359e$export$dec8f001b9d982cb)({
        span: span
    });
    const sentryTrace = traceHeaders["sentry-trace"];
    const baggage = traceHeaders.baggage;
    // Nothing to do, when we return undefined here, the original headers will be used
    if (!sentryTrace) return undefined;
    const headers = fetchOptionsObj.headers || ($0b4497afe5c251f9$var$isRequest(request) ? request.headers : undefined);
    if (!headers) return {
        ...traceHeaders
    };
    else if ($0b4497afe5c251f9$var$isHeaders(headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.set("sentry-trace", sentryTrace);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get("baggage");
            if (prevBaggageHeader) {
                const prevHeaderStrippedFromSentryBaggage = $0b4497afe5c251f9$var$stripBaggageHeaderOfSentryBaggageValues(prevBaggageHeader);
                newHeaders.set("baggage", // If there are non-sentry entries (i.e. if the stripped string is non-empty/truthy) combine the stripped header and sentry baggage header
                // otherwise just set the sentry baggage header
                prevHeaderStrippedFromSentryBaggage ? `${prevHeaderStrippedFromSentryBaggage},${baggage}` : baggage);
            } else newHeaders.set("baggage", baggage);
        }
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers// Remove any existing sentry-trace headers
            .filter((header)=>{
                return !(Array.isArray(header) && header[0] === "sentry-trace");
            })// Get rid of previous sentry baggage values in baggage header
            .map((header)=>{
                if (Array.isArray(header) && header[0] === "baggage" && typeof header[1] === "string") {
                    const [headerName, headerValue, ...rest] = header;
                    return [
                        headerName,
                        $0b4497afe5c251f9$var$stripBaggageHeaderOfSentryBaggageValues(headerValue),
                        ...rest
                    ];
                } else return header;
            }),
            // Attach the new sentry-trace header
            [
                "sentry-trace",
                sentryTrace
            ]
        ];
        if (baggage) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            "baggage",
            baggage
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        let newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders = existingBaggageHeader.map((headerItem)=>typeof headerItem === "string" ? $0b4497afe5c251f9$var$stripBaggageHeaderOfSentryBaggageValues(headerItem) : headerItem).filter((headerItem)=>headerItem === "");
        else if (existingBaggageHeader) newBaggageHeaders.push($0b4497afe5c251f9$var$stripBaggageHeaderOfSentryBaggageValues(existingBaggageHeader));
        if (baggage) newBaggageHeaders.push(baggage);
        return {
            ...headers,
            "sentry-trace": sentryTrace,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers.
 *
 * @deprecated This function will not be exported anymore in v9.
 */ function $0b4497afe5c251f9$export$6717acf674206871(request, _client, _scope, fetchOptionsObj, span) {
    return $0b4497afe5c251f9$var$_addTracingHeadersToFetchRequest(request, fetchOptionsObj, span);
}
function $0b4497afe5c251f9$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $0b4497afe5c251f9$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $02dIh.setHttpStatus)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: (0, $02dIh.SPAN_STATUS_ERROR),
        message: "internal_error"
    });
    span.end();
}
function $0b4497afe5c251f9$var$stripBaggageHeaderOfSentryBaggageValues(baggageHeader) {
    return baggageHeader.split(",")// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .filter((baggageEntry)=>!baggageEntry.split("=")[0].startsWith((0, $gdhAa.SENTRY_BAGGAGE_KEY_PREFIX))).join(",");
}
function $0b4497afe5c251f9$var$isRequest(request) {
    return typeof Request !== "undefined" && (0, $dfMsQ.isInstanceOf)(request, Request);
}
function $0b4497afe5c251f9$var$isHeaders(headers) {
    return typeof Headers !== "undefined" && (0, $dfMsQ.isInstanceOf)(headers, Headers);
}


var $yQUXg = parcelRequire("yQUXg");
var $02dIh = parcelRequire("02dIh");
var $hLnp0 = parcelRequire("hLnp0");

/** Options for Request Instrumentation */ const $edec20d6c9712df6$var$responseToSpanId = new WeakMap();
const $edec20d6c9712df6$var$spanIdToEndTimestamp = new Map();
const $edec20d6c9712df6$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    trackFetchStreamPerformance: false
};
/** Registers span creators for xhr and fetch requests  */ function $edec20d6c9712df6$export$864489cb3478db3e(client, _options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets } = {
        traceFetch: $edec20d6c9712df6$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $edec20d6c9712df6$export$cc17fb3c0bc95cd7.traceXHR,
        trackFetchStreamPerformance: $edec20d6c9712df6$export$cc17fb3c0bc95cd7.trackFetchStreamPerformance,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$edec20d6c9712df6$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    if (traceFetch) {
        // Keeping track of http requests, whose body payloads resolved later than the initial resolved request
        // e.g. streaming using server sent events (SSE)
        client.addEventProcessor((event)=>{
            if (event.type === "transaction" && event.spans) event.spans.forEach((span)=>{
                if (span.op === "http.client") {
                    const updatedTimestamp = $edec20d6c9712df6$var$spanIdToEndTimestamp.get(span.span_id);
                    if (updatedTimestamp) {
                        span.timestamp = updatedTimestamp / 1000;
                        $edec20d6c9712df6$var$spanIdToEndTimestamp.delete(span.span_id);
                    }
                }
            });
            return event;
        });
        if (trackFetchStreamPerformance) (0, $da5e32477400e3c6$export$1a79663eb318fe6a)((handlerData)=>{
            if (handlerData.response) {
                const span = $edec20d6c9712df6$var$responseToSpanId.get(handlerData.response);
                if (span && handlerData.endTimestamp) $edec20d6c9712df6$var$spanIdToEndTimestamp.set(span, handlerData.endTimestamp);
            }
        });
        (0, $da5e32477400e3c6$export$f75d3c772c923df0)((handlerData)=>{
            const createdSpan = (0, $0b4497afe5c251f9$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
            if (handlerData.response && handlerData.fetchData.__span) $edec20d6c9712df6$var$responseToSpanId.set(handlerData.response, handlerData.fetchData.__span);
            // We cannot use `window.location` in the generic fetch instrumentation,
            // but we need it for reliable `server.address` attribute.
            // so we extend this in here
            if (createdSpan) {
                const fullUrl = $edec20d6c9712df6$var$getFullURL(handlerData.fetchData.url);
                const host = fullUrl ? (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(fullUrl).host : undefined;
                createdSpan.setAttributes({
                    "http.url": fullUrl,
                    "server.address": host
                });
            }
            if (enableHTTPTimings && createdSpan) $edec20d6c9712df6$var$addHTTPTimings(createdSpan);
        });
    }
    if (traceXHR) (0, $63e43e59b4196dc4$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $edec20d6c9712df6$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $edec20d6c9712df6$var$addHTTPTimings(createdSpan);
    });
}
function $edec20d6c9712df6$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $edec20d6c9712df6$var$addHTTPTimings(span) {
    const { url: url } = (0, $4H7Y8.spanToJSON)(span).data || {};
    if (!url || typeof url !== "string") return;
    const cleanup = (0, $31f3d198369e5cbf$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($edec20d6c9712df6$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $edec20d6c9712df6$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $edec20d6c9712df6$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $edec20d6c9712df6$var$getAbsoluteTime(time = 0) {
    return (((0, $6OKHc.browserPerformanceTimeOrigin) || performance.timeOrigin) + time) / 1000;
}
function $edec20d6c9712df6$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $edec20d6c9712df6$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $6OKHc.browserPerformanceTimeOrigin)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $edec20d6c9712df6$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * We only export this function for testing purposes.
 */ function $edec20d6c9712df6$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    // window.location.href not being defined is an edge case in the browser but we need to handle it.
    // Potentially dangerous situations where it may not be defined: Browser Extensions, Web Workers, patching of the location obj
    const href = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href;
    if (!href) {
        // If there is no window.location.origin, we default to only attaching tracing headers to relative requests, i.e. ones that start with `/`
        // BIG DISCLAIMER: Users can call URLs with a double slash (fetch("//example.com/api")), this is a shorthand for "send to the same protocol",
        // so we need a to exclude those requests, because they might be cross origin.
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $hLnp0.stringMatchesSomePattern)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        // URL parsing may fail, we default to not attaching trace headers in that case.
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch (e) {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $hLnp0.stringMatchesSomePattern)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $hLnp0.stringMatchesSomePattern)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ function $edec20d6c9712df6$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $63e43e59b4196dc4$export$55b6bb1e45c6cf59];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = (0, $jArAO.hasTracingEnabled)() && shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $02dIh.setHttpStatus)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const fullUrl = $edec20d6c9712df6$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const hasParent = !!(0, $4H7Y8.getActiveSpan)();
    const span = shouldCreateSpanResult && hasParent ? (0, $038737f78c636108$export$63dbba021a6b4047)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        attributes: {
            type: "xhr",
            "http.method": sentryXhrData.method,
            "http.url": fullUrl,
            url: sentryXhrData.url,
            "server.address": host,
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.http.browser",
            [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "http.client"
        }
    }) : new (0, $d899755a957e1f50$export$d6636b700b76c516)();
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    if (shouldAttachHeaders(sentryXhrData.url)) $edec20d6c9712df6$var$addTracingHeadersToXhrRequest(xhr, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $jArAO.hasTracingEnabled)() && hasParent ? span : undefined);
    return span;
}
function $edec20d6c9712df6$var$addTracingHeadersToXhrRequest(xhr, span) {
    const { "sentry-trace": sentryTrace, baggage: baggage } = (0, $1ca539d872b9359e$export$dec8f001b9d982cb)({
        span: span
    });
    if (sentryTrace) $edec20d6c9712df6$var$setHeaderOnXhr(xhr, sentryTrace, baggage);
}
function $edec20d6c9712df6$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("baggage", sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $edec20d6c9712df6$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e2) {
        return undefined;
    }
}


/* eslint-disable max-lines */ const $400f75f99113439b$export$bbd2089f30bd3708 = "BrowserTracing";
const $400f75f99113439b$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $fd927ea1b5d85956$export$809a2b7987fd5306),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    _experiments: {},
    ...(0, $edec20d6c9712df6$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $400f75f99113439b$export$b4109253475213e9 = (_options = {})=>{
    (0, $d4be1d52827a3f28$export$b0914730ee1f6c80)();
    const { enableInp: enableInp, enableLongTask: enableLongTask, enableLongAnimationFrame: enableLongAnimationFrame, _experiments: { enableInteractions: enableInteractions, enableStandaloneClsSpans: enableStandaloneClsSpans }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation } = {
        ...$400f75f99113439b$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $4ca18541755f3f2c$export$7c69f0412d101b88)({
        recordClsStandaloneSpans: enableStandaloneClsSpans || false
    });
    if (enableInp) (0, $751b596e3029fa17$export$f17d06681a4744a3)();
    if (enableLongAnimationFrame && (0, $2fKhD.GLOBAL_OBJ).PerformanceObserver && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes("long-animation-frame")) (0, $4ca18541755f3f2c$export$5b823ab2ccbc801d)();
    else if (enableLongTask) (0, $4ca18541755f3f2c$export$f396d19077034ad2)();
    if (enableInteractions) (0, $4ca18541755f3f2c$export$e27543e0976315e4)();
    const latestRoute = {
        name: undefined,
        source: undefined
    };
    /** Create routing idle transaction. */ function _createRouteSpan(client, startSpanOptions) {
        const isPageloadTransaction = startSpanOptions.op === "pageload";
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const attributes = finalStartSpanOptions.attributes || {};
        // If `finalStartSpanOptions.name` is different than `startSpanOptions.name`
        // it is because `beforeStartSpan` set a custom name. Therefore we set the source to 'custom'.
        if (startSpanOptions.name !== finalStartSpanOptions.name) {
            attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "custom";
            finalStartSpanOptions.attributes = attributes;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        const idleSpan = (0, $fd927ea1b5d85956$export$901bffd97bd52797)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadTransaction,
            beforeSpanEnd: (span)=>{
                _collectWebVitals();
                (0, $4ca18541755f3f2c$export$5f8fa6b3467a7443)(span, {
                    recordClsOnPageloadSpan: !enableStandaloneClsSpans
                });
            }
        });
        function emitFinish() {
            if ([
                "interactive",
                "complete"
            ].includes((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.readyState)) client.emit("idleSpanEnableAutoFinish", idleSpan);
        }
        if (isPageloadTransaction && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) {
            (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.addEventListener("readystatechange", ()=>{
                emitFinish();
            });
            emitFinish();
        }
        return idleSpan;
    }
    return {
        name: $400f75f99113439b$export$bbd2089f30bd3708,
        afterAllSetup (client) {
            let activeSpan;
            let startingUrl = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href;
            function maybeEndActiveSpan() {
                if (activeSpan && !(0, $4H7Y8.spanToJSON)(activeSpan).timestamp) {
                    (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $hi47i.logger).log(`[Tracing] Finishing current active span with op: ${(0, $4H7Y8.spanToJSON)(activeSpan).op}`);
                    // If there's an open active span, we need to finish it before creating an new one.
                    activeSpan.end();
                }
            }
            client.on("startNavigationSpan", (startSpanOptions)=>{
                if ((0, $kGYVh.getClient)() !== client) return;
                maybeEndActiveSpan();
                activeSpan = _createRouteSpan(client, {
                    op: "navigation",
                    ...startSpanOptions
                });
            });
            client.on("startPageLoadSpan", (startSpanOptions, traceOptions = {})=>{
                if ((0, $kGYVh.getClient)() !== client) return;
                maybeEndActiveSpan();
                const sentryTrace = traceOptions.sentryTrace || $400f75f99113439b$export$f147b32b03c9cf11("sentry-trace");
                const baggage = traceOptions.baggage || $400f75f99113439b$export$f147b32b03c9cf11("baggage");
                const propagationContext = (0, $AIi6N.propagationContextFromHeaders)(sentryTrace, baggage);
                (0, $kGYVh.getCurrentScope)().setPropagationContext(propagationContext);
                activeSpan = _createRouteSpan(client, {
                    op: "pageload",
                    ...startSpanOptions
                });
            });
            // A trace should to stay the consistent over the entire time span of one route.
            // Therefore, when the initial pageload or navigation root span ends, we update the
            // scope's propagation context to keep span-specific attributes like the `sampled` decision and
            // the dynamic sampling context valid, even after the root span has ended.
            // This ensures that the trace data is consistent for the entire duration of the route.
            client.on("spanEnd", (span)=>{
                const op = (0, $4H7Y8.spanToJSON)(span).op;
                if (span !== (0, $4H7Y8.getRootSpan)(span) || op !== "navigation" && op !== "pageload") return;
                const scope = (0, $kGYVh.getCurrentScope)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext({
                    ...oldPropagationContext,
                    sampled: oldPropagationContext.sampled !== undefined ? oldPropagationContext.sampled : (0, $4H7Y8.spanIsSampled)(span),
                    dsc: oldPropagationContext.dsc || (0, $jdzJv.getDynamicSamplingContextFromSpan)(span)
                });
            });
            if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location) {
                if (instrumentPageLoad) $400f75f99113439b$export$aa44a07f82af519f(client, {
                    name: (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTime: (0, $6OKHc.browserPerformanceTimeOrigin) ? (0, $6OKHc.browserPerformanceTimeOrigin) / 1000 : undefined,
                    attributes: {
                        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url",
                        [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.pageload.browser"
                    }
                });
                if (instrumentNavigation) (0, $3d87653da885c31c$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                    /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                        startingUrl = undefined;
                        return;
                    }
                    if (from !== to) {
                        startingUrl = undefined;
                        $400f75f99113439b$export$7d159749bd9969ad(client, {
                            name: (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.pathname,
                            attributes: {
                                [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url",
                                [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.navigation.browser"
                            }
                        });
                    }
                });
            }
            if (markBackgroundSpan) (0, $755e6178fce08d17$export$6f18f55521af71a1)();
            if (enableInteractions) $400f75f99113439b$var$registerInteractionListener(idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            if (enableInp) (0, $751b596e3029fa17$export$e4e04d43e223cce2)();
            (0, $edec20d6c9712df6$export$864489cb3478db3e)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                trackFetchStreamPerformance: trackFetchStreamPerformance,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        }
    };
};
/**
 * Manually start a page load span.
 * This will only do something if a browser tracing integration integration has been setup.
 *
 * If you provide a custom `traceOptions` object, it will be used to continue the trace
 * instead of the default behavior, which is to look it up on the <meta> tags.
 */ function $400f75f99113439b$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit("startPageLoadSpan", spanOptions, traceOptions);
    (0, $kGYVh.getCurrentScope)().setTransactionName(spanOptions.name);
    const span = (0, $4H7Y8.getActiveSpan)();
    const op = span && (0, $4H7Y8.spanToJSON)(span).op;
    return op === "pageload" ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if a browser tracing integration has been setup.
 */ function $400f75f99113439b$export$7d159749bd9969ad(client, spanOptions) {
    (0, $kGYVh.getIsolationScope)().setPropagationContext({
        traceId: (0, $iWfxY.generateTraceId)()
    });
    (0, $kGYVh.getCurrentScope)().setPropagationContext({
        traceId: (0, $iWfxY.generateTraceId)()
    });
    client.emit("startNavigationSpan", spanOptions);
    (0, $kGYVh.getCurrentScope)().setTransactionName(spanOptions.name);
    const span = (0, $4H7Y8.getActiveSpan)();
    const op = span && (0, $4H7Y8.spanToJSON)(span).op;
    return op === "navigation" ? span : undefined;
}
/** Returns the value of a meta tag */ function $400f75f99113439b$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    // eslint-disable-next-line deprecation/deprecation
    const metaTag = (0, $hA6iJ.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}
/** Start listener for interaction transactions */ function $400f75f99113439b$var$registerInteractionListener(idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = "ui.action.click";
        const activeSpan = (0, $4H7Y8.getActiveSpan)();
        const rootSpan = activeSpan && (0, $4H7Y8.getRootSpan)(activeSpan);
        if (rootSpan) {
            const currentRootSpanOp = (0, $4H7Y8.spanToJSON)(rootSpan).op;
            if ([
                "navigation",
                "pageload"
            ].includes(currentRootSpanOp)) {
                (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $hi47i.logger).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return undefined;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), "interactionInterrupted");
            inflightInteractionSpan.end();
            inflightInteractionSpan = undefined;
        }
        if (!latestRoute.name) {
            (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $hi47i.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        inflightInteractionSpan = (0, $fd927ea1b5d85956$export$901bffd97bd52797)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $yQUXg.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: latestRoute.source || "url"
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) addEventListener("click", registerInteractionTransaction, {
        once: false,
        capture: true
    });
}


var $hi47i = parcelRequire("hi47i");

var $fKzCQ = parcelRequire("fKzCQ");

var $hi47i = parcelRequire("hi47i");

var $5v1oS = parcelRequire("5v1oS");
const $b99d5bb3db344fdd$var$INTEGRATION_NAME = "Dedupe";
const $b99d5bb3db344fdd$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $b99d5bb3db344fdd$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($b99d5bb3db344fdd$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $b99d5bb3db344fdd$export$6d39aa44cd0c7567 = (0, $fbb22756c9507e85$export$2323046b9414659f)($b99d5bb3db344fdd$var$_dedupeIntegration);
/** only exported for tests. */ function $b99d5bb3db344fdd$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($b99d5bb3db344fdd$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($b99d5bb3db344fdd$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $b99d5bb3db344fdd$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $b99d5bb3db344fdd$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $b99d5bb3db344fdd$var$_getExceptionFromEvent(previousEvent);
    const currentException = $b99d5bb3db344fdd$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $b99d5bb3db344fdd$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $5v1oS.getFramesFromEvent)(currentEvent);
    let previousFrames = (0, $5v1oS.getFramesFromEvent)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $b99d5bb3db344fdd$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $b99d5bb3db344fdd$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}


var $kGYVh = parcelRequire("kGYVh");


var $l1oVX = parcelRequire("l1oVX");
let $7dd448759c7f5e18$var$originalFunctionToString;
const $7dd448759c7f5e18$var$INTEGRATION_NAME = "FunctionToString";
const $7dd448759c7f5e18$var$SETUP_CLIENTS = new WeakMap();
const $7dd448759c7f5e18$var$_functionToStringIntegration = ()=>{
    return {
        name: $7dd448759c7f5e18$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $7dd448759c7f5e18$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $l1oVX.getOriginalFunction)(this);
                    const context = $7dd448759c7f5e18$var$SETUP_CLIENTS.has((0, $kGYVh.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $7dd448759c7f5e18$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $7dd448759c7f5e18$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $7dd448759c7f5e18$export$7918117e9202e4fb = (0, $fbb22756c9507e85$export$2323046b9414659f)($7dd448759c7f5e18$var$_functionToStringIntegration);


var $kGYVh = parcelRequire("kGYVh");
const $0e303f054920e2b1$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $0e303f054920e2b1$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $0e303f054920e2b1$var$_getIngestEndpoint(dsn) {
    return `${$0e303f054920e2b1$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $0e303f054920e2b1$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $0e303f054920e2b1$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $0e303f054920e2b1$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$0e303f054920e2b1$var$_getIngestEndpoint(dsn)}?${$0e303f054920e2b1$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $0e303f054920e2b1$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $9171e4713e443b9b$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$0e303f054920e2b1$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}


var $fKzCQ = parcelRequire("fKzCQ");


var $hi47i = parcelRequire("hi47i");

var $6OhB9 = parcelRequire("6OhB9");

var $hLnp0 = parcelRequire("hLnp0");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $67b350191b117f2b$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    "undefined is not an object (evaluating 'a.L')",
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/
];
/** Options for the InboundFilters integration */ const $67b350191b117f2b$var$INTEGRATION_NAME = "InboundFilters";
const $67b350191b117f2b$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $67b350191b117f2b$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $67b350191b117f2b$var$_mergeOptions(options, clientOptions);
            return $67b350191b117f2b$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $67b350191b117f2b$export$cb3c5c2ceb9818ba = (0, $fbb22756c9507e85$export$2323046b9414659f)($67b350191b117f2b$var$_inboundFiltersIntegration);
function $67b350191b117f2b$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $67b350191b117f2b$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $67b350191b117f2b$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $67b350191b117f2b$var$_isSentryError(event)) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $6OhB9.getEventDescription)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $6OhB9.getEventDescription)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isUselessError(event)) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $6OhB9.getEventDescription)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $6OhB9.getEventDescription)(event)}`);
        return true;
    }
    if ($67b350191b117f2b$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $6OhB9.getEventDescription)(event)}.\nUrl: ${$67b350191b117f2b$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$67b350191b117f2b$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $6OhB9.getEventDescription)(event)}.\nUrl: ${$67b350191b117f2b$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $67b350191b117f2b$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $67b350191b117f2b$var$_getPossibleEventMessages(event).some((message)=>(0, $hLnp0.stringMatchesSomePattern)(message, ignoreErrors));
}
function $67b350191b117f2b$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $hLnp0.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $67b350191b117f2b$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $67b350191b117f2b$var$_getEventFilterUrl(event);
    return !url ? false : (0, $hLnp0.stringMatchesSomePattern)(url, denyUrls);
}
function $67b350191b117f2b$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $67b350191b117f2b$var$_getEventFilterUrl(event);
    return !url ? true : (0, $hLnp0.stringMatchesSomePattern)(url, allowUrls);
}
function $67b350191b117f2b$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    return possibleMessages;
}
function $67b350191b117f2b$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $67b350191b117f2b$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $67b350191b117f2b$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $67b350191b117f2b$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).error(`Cannot extract url for event ${(0, $6OhB9.getEventDescription)(event)}`);
        return null;
    }
}
function $67b350191b117f2b$var$_isUselessError(event) {
    if (event.type) // event is not an error
    return false;
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception || !event.exception.values || event.exception.values.length === 0) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}


var $kGYVh = parcelRequire("kGYVh");

var $fKzCQ = parcelRequire("fKzCQ");

var $hi47i = parcelRequire("hi47i");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $9af71b6a24a126c8$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $fKzCQ.DEBUG_BUILD) (0, $hi47i.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $hi47i.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $kGYVh.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $9af71b6a24a126c8$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $9af71b6a24a126c8$export$ecb76f41d43c0e43(client) {
    (0, $kGYVh.getCurrentScope)().setClient(client);
}


var $kQ0sT = parcelRequire("kQ0sT");
var $5v1oS = parcelRequire("5v1oS");

var $faPnA = parcelRequire("faPnA");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $605291aa308d4b89$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $faPnA.SDK_VERSION)
            })),
        version: (0, $faPnA.SDK_VERSION)
    };
    options._metadata = metadata;
}



var $kGYVh = parcelRequire("kGYVh");

var $fKzCQ = parcelRequire("fKzCQ");



var $kkdRz = parcelRequire("kkdRz");

var $jdzJv = parcelRequire("jdzJv");


var $6OKHc = parcelRequire("6OKHc");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $bbe8beff1aee2812$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $6OKHc.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}




/** An error emitted by Sentry SDKs and related utilities. */ class $71e03e2f84576ceb$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}



var $dfMsQ = parcelRequire("dfMsQ");

var $hi47i = parcelRequire("hi47i");

var $6OhB9 = parcelRequire("6OhB9");

var $di9R8 = parcelRequire("di9R8");


var $g1WRa = parcelRequire("g1WRa");

var $4H7Y8 = parcelRequire("4H7Y8");
const $4f30d529f2099042$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $4f30d529f2099042$export$4f22f74eddb7716a {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $9171e4713e443b9b$export$128827c3562ec0cb)(options.dsn);
        else (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $0e303f054920e2b1$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        // TODO(v9): Remove this deprecation warning
        const tracingOptions = [
            "enableTracing",
            "tracesSampleRate",
            "tracesSampler"
        ];
        const undefinedOption = tracingOptions.find((option)=>option in options && options[option] == undefined);
        if (undefinedOption) (0, $hi47i.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn(`[Sentry] Deprecation warning: \`${undefinedOption}\` is set to undefined, which leads to tracing being enabled. In v9, a value of \`undefined\` will result in tracing being disabled.`);
        });
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint, scope) {
        const eventId = (0, $6OhB9.uuid4)();
        // ensure we haven't captured this very object before
        if ((0, $6OhB9.checkOrSetAlreadyCaught)(exception)) {
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log($4f30d529f2099042$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $6OhB9.uuid4)(),
            ...hint
        };
        const eventMessage = (0, $dfMsQ.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $dfMsQ.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $6OhB9.uuid4)();
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $6OhB9.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log($4f30d529f2099042$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $kkdRz.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit("flush");
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $di9R8.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit("close");
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $fbb22756c9507e85$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $fbb22756c9507e85$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $b89a3b4f1056006b$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $f5682b06913d5b03$export$d650323442802f6f)(env, (0, $f5682b06913d5b03$export$d8fc80952cc31fa4)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $b89a3b4f1056006b$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === "number" ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * @inheritdoc
   */ sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).error("Error while sending envelope:", reason);
            return reason;
        });
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).error("Transport disabled");
        return (0, $di9R8.resolvedSyncPromise)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $fbb22756c9507e85$export$51abed9797baa598)(this, integrations);
        (0, $fbb22756c9507e85$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $kkdRz.updateSession)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $di9R8.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope = (0, $kGYVh.getCurrentScope)(), isolationScope = (0, $kGYVh.getIsolationScope)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $g1WRa.prepareEvent)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            evt.contexts = {
                trace: (0, $kGYVh.getTraceContextFromScope)(currentScope),
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $jdzJv.getDynamicSamplingContextFromScope)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $fKzCQ.DEBUG_BUILD) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $hi47i.logger).log(sentryError.message);
                else (0, $hi47i.logger).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $4f30d529f2099042$var$isTransactionEvent(event);
        const isError = $4f30d529f2099042$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === "undefined" ? undefined : (0, $1053a52e7802e64c$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === "number" && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $di9R8.rejectedSyncPromise)(new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, currentScope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $4f30d529f2099042$var$processBeforeSend(this, options, prepared, hint);
            return $4f30d529f2099042$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = currentScope && currentScope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).log("Sending outcomes:", outcomes);
        const envelope = (0, $bbe8beff1aee2812$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $9171e4713e443b9b$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $4f30d529f2099042$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $dfMsQ.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $dfMsQ.isPlainObject)(event) && event !== null) throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $dfMsQ.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $4f30d529f2099042$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    if ($4f30d529f2099042$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($4f30d529f2099042$var$isTransactionEvent(event)) {
        if (event.spans && beforeSendSpan) {
            const processedSpans = [];
            for (const span of event.spans){
                const processedSpan = beforeSendSpan(span);
                if (processedSpan) processedSpans.push(processedSpan);
                else {
                    (0, $4H7Y8.showSpanDropWarning)();
                    client.recordDroppedEvent("before_send", "span");
                }
            }
            event.spans = processedSpans;
        }
        if (beforeSendTransaction) {
            if (event.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = event.spans.length;
                event.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(event, hint);
        }
    }
    return event;
}
function $4f30d529f2099042$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $4f30d529f2099042$var$isTransactionEvent(event) {
    return event.type === "transaction";
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $1d72e3a9e632bed3$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $1d72e3a9e632bed3$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return "npm";
}


var $hi47i = parcelRequire("hi47i");


var $6OhB9 = parcelRequire("6OhB9");
var $l1oVX = parcelRequire("l1oVX");
var $kGYVh = parcelRequire("kGYVh");
var $dfMsQ = parcelRequire("dfMsQ");
var $886wr = parcelRequire("886wr");
var $di9R8 = parcelRequire("di9R8");
/**
 * This function creates an exception from a JavaScript Error
 */ function $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $23dde874fe12fd4c$export$2e9ae379995d99e3(ex),
        value: $23dde874fe12fd4c$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $23dde874fe12fd4c$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $kGYVh.getClient)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $23dde874fe12fd4c$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $886wr.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $dfMsQ.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $23dde874fe12fd4c$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $23dde874fe12fd4c$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $23dde874fe12fd4c$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $23dde874fe12fd4c$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $23dde874fe12fd4c$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $23dde874fe12fd4c$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $23dde874fe12fd4c$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $23dde874fe12fd4c$var$getSkipFirstStackStringLines(ex) {
    if (ex && $23dde874fe12fd4c$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $23dde874fe12fd4c$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $23dde874fe12fd4c$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $23dde874fe12fd4c$export$2e9ae379995d99e3(ex) {
    const name = ex && ex.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $23dde874fe12fd4c$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $23dde874fe12fd4c$export$86005d1b62804363(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
    if ($23dde874fe12fd4c$var$isWebAssemblyException(ex) && Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $23dde874fe12fd4c$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $23dde874fe12fd4c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $6OhB9.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $di9R8.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $23dde874fe12fd4c$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $di9R8.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $23dde874fe12fd4c$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $dfMsQ.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $23dde874fe12fd4c$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $dfMsQ.isDOMError)(exception) || (0, $dfMsQ.isDOMException)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $23dde874fe12fd4c$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $dfMsQ.isDOMError)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $6OhB9.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $dfMsQ.isError)(exception)) // we have a real Error object, do nothing
    return $23dde874fe12fd4c$var$eventFromError(stackParser, exception);
    if ((0, $dfMsQ.isPlainObject)(exception) || (0, $dfMsQ.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $23dde874fe12fd4c$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $6OhB9.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $23dde874fe12fd4c$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $6OhB9.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $6OhB9.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $23dde874fe12fd4c$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $23dde874fe12fd4c$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $6OhB9.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $dfMsQ.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $23dde874fe12fd4c$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $l1oVX.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $dfMsQ.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $dfMsQ.isEvent)(exception)) {
        const className = $23dde874fe12fd4c$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $23dde874fe12fd4c$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $23dde874fe12fd4c$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}




/**
 * Creates an envelope from a user feedback.
 */ function $6c3623cb2e9b8dd7$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $9171e4713e443b9b$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $6c3623cb2e9b8dd7$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $f5682b06913d5b03$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $6c3623cb2e9b8dd7$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/core Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $72d27c0252bb80ff$export$1df9218a526d318d extends (0, $4f30d529f2099042$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = {
            // We default this to true, as it is the safer scenario
            parentSpanIsAlwaysRootSpan: true,
            ...options
        };
        const sdkSource = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $1d72e3a9e632bed3$export$8ad33f488b1ab046)();
        (0, $605291aa308d4b89$export$b9f95b027256052c)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        if (opts.sendClientReports && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $23dde874fe12fd4c$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $23dde874fe12fd4c$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   *
   * @deprecated Use `captureFeedback` instead.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $hi47i.logger).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $6c3623cb2e9b8dd7$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
}





var $l1oVX = parcelRequire("l1oVX");
var $6OhB9 = parcelRequire("6OhB9");

const $c79bca128681c716$var$DEBOUNCE_DURATION = 1000;
let $c79bca128681c716$var$debounceTimerID;
let $c79bca128681c716$var$lastCapturedEventType;
let $c79bca128681c716$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c79bca128681c716$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $c79bca128681c716$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $c79bca128681c716$export$3014bbf0af0e1d4a() {
    if (!(0, $955496f5d3029976$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $f079126c500c7ea2$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $c79bca128681c716$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $955496f5d3029976$export$56d8a8a25bd48b81).document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        const globalObject = (0, $955496f5d3029976$export$56d8a8a25bd48b81);
        const targetObj = globalObject[target];
        const proto = targetObj && targetObj.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $l1oVX.fill)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $c79bca128681c716$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $l1oVX.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $c79bca128681c716$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $c79bca128681c716$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $c79bca128681c716$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $c79bca128681c716$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $c79bca128681c716$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $c79bca128681c716$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($c79bca128681c716$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $l1oVX.addNonEnumerableProperty)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $l1oVX.addNonEnumerableProperty)(target, "_sentryId", (0, $6OhB9.uuid4)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$c79bca128681c716$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $c79bca128681c716$var$lastCapturedEventType = event.type;
            $c79bca128681c716$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($c79bca128681c716$var$debounceTimerID);
        $c79bca128681c716$var$debounceTimerID = (0, $955496f5d3029976$export$56d8a8a25bd48b81).setTimeout(()=>{
            $c79bca128681c716$var$lastCapturedEventTargetId = undefined;
            $c79bca128681c716$var$lastCapturedEventType = undefined;
        }, $c79bca128681c716$var$DEBOUNCE_DURATION);
    };
}
function $c79bca128681c716$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}



var $kGYVh = parcelRequire("kGYVh");

var $hi47i = parcelRequire("hi47i");

var $6OKHc = parcelRequire("6OKHc");
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $4d76c9d78abc3a9e$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $4d76c9d78abc3a9e$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $kGYVh.getClient)();
    const isolationScope = (0, $kGYVh.getIsolationScope)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $4d76c9d78abc3a9e$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $6OKHc.dateTimestampInSeconds)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $hi47i.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}


var $hi47i = parcelRequire("hi47i");

var $l1oVX = parcelRequire("l1oVX");

var $2fKhD = parcelRequire("2fKhD");

/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $16d762171e064dbd$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $f079126c500c7ea2$export$a4e09611e30da72e)(type, handler);
    (0, $f079126c500c7ea2$export$e18d6c5462c01368)(type, $16d762171e064dbd$var$instrumentConsole);
}
function $16d762171e064dbd$var$instrumentConsole() {
    if (!("console" in (0, $2fKhD.GLOBAL_OBJ))) return;
    (0, $hi47i.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $2fKhD.GLOBAL_OBJ).console)) return;
        (0, $l1oVX.fill)((0, $2fKhD.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $hi47i.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $f079126c500c7ea2$export$b18c893e424d3127)("console", handlerData);
                const log = (0, $hi47i.originalConsoleMethods)[level];
                log && log.apply((0, $2fKhD.GLOBAL_OBJ).console, args);
            };
        });
    });
}

/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $24280af9d15f06bf$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return undefined;
}


var $kGYVh = parcelRequire("kGYVh");
var $hA6iJ = parcelRequire("hA6iJ");
var $6OhB9 = parcelRequire("6OhB9");
var $hi47i = parcelRequire("hi47i");
var $hLnp0 = parcelRequire("hLnp0");/**
 * @deprecated This variable has been deprecated and will be removed in the next major version.
 */ const $197a1d16f7c0faf5$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $197a1d16f7c0faf5$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $8b5b3242e956e79f$var$INTEGRATION_NAME = "Breadcrumbs";
const $8b5b3242e956e79f$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $8b5b3242e956e79f$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $16d762171e064dbd$export$1d6e0d073f9e6723)($8b5b3242e956e79f$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $c79bca128681c716$export$5aeffd3db2cf9df7)($8b5b3242e956e79f$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $63e43e59b4196dc4$export$26ace48dd54c9aea)($8b5b3242e956e79f$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $da5e32477400e3c6$export$f75d3c772c923df0)($8b5b3242e956e79f$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $3d87653da885c31c$export$3f18c56c58114e75)($8b5b3242e956e79f$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $8b5b3242e956e79f$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $8b5b3242e956e79f$export$c079d904b326663a = (0, $fbb22756c9507e85$export$2323046b9414659f)($8b5b3242e956e79f$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $8b5b3242e956e79f$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $kGYVh.getClient)() !== client) return;
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $6OhB9.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $8b5b3242e956e79f$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $kGYVh.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $hi47i.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $8b5b3242e956e79f$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $8b5b3242e956e79f$var$_isEvent(event) ? event.target : event;
            target = (0, $hA6iJ.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $hA6iJ.getComponentName)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $8b5b3242e956e79f$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $kGYVh.getClient)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $197a1d16f7c0faf5$export$d771ef054122c30a)(handlerData.level),
            message: (0, $hLnp0.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $hLnp0.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $8b5b3242e956e79f$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $kGYVh.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $63e43e59b4196dc4$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const level = (0, $24280af9d15f06bf$export$b8cfcc4175694bcc)(status_code);
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
            category: "xhr",
            data: data,
            type: "http",
            level: level
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $8b5b3242e956e79f$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $kGYVh.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const level = (0, $24280af9d15f06bf$export$b8cfcc4175694bcc)(data.status_code);
            (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                type: "http",
                level: level
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $8b5b3242e956e79f$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $kGYVh.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $2bf5ed435a4428b5$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $8b5b3242e956e79f$var$_isEvent(event) {
    return !!event && !!event.target;
}



var $l1oVX = parcelRequire("l1oVX");
var $5v1oS = parcelRequire("5v1oS");

const $4e018dbe28beb052$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $4e018dbe28beb052$var$INTEGRATION_NAME = "BrowserApiErrors";
const $4e018dbe28beb052$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $4e018dbe28beb052$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $l1oVX.fill)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), "setTimeout", $4e018dbe28beb052$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $l1oVX.fill)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), "setInterval", $4e018dbe28beb052$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $l1oVX.fill)((0, $9130afac94f0b7c9$export$56d8a8a25bd48b81), "requestAnimationFrame", $4e018dbe28beb052$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81)) (0, $l1oVX.fill)(XMLHttpRequest.prototype, "send", $4e018dbe28beb052$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $4e018dbe28beb052$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($4e018dbe28beb052$var$_wrapEventTarget);
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $4e018dbe28beb052$export$59bfe9f1c76150e = (0, $fbb22756c9507e85$export$2323046b9414659f)($4e018dbe28beb052$var$_browserApiErrorsIntegration);
function $4e018dbe28beb052$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $5v1oS.getFunctionName)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
function $4e018dbe28beb052$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $5v1oS.getFunctionName)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $4e018dbe28beb052$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") (0, $l1oVX.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $5v1oS.getFunctionName)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $l1oVX.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $5v1oS.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $4e018dbe28beb052$var$_wrapEventTarget(target) {
    const globalObject = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81);
    const targetObj = globalObject[target];
    const proto = targetObj && targetObj.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $l1oVX.fill)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if ($4e018dbe28beb052$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $5v1oS.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (e2) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                (0, $9130afac94f0b7c9$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $5v1oS.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $l1oVX.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $4e018dbe28beb052$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === "function";
}




var $kQ0sT = parcelRequire("kQ0sT");
var $hi47i = parcelRequire("hi47i");


/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $8a5b32760c0daa50$export$1baa7880e357371c = (0, $fbb22756c9507e85$export$2323046b9414659f)(()=>{
    return {
        name: "BrowserSession",
        setupOnce () {
            if (typeof (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document === "undefined") {
                (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $hi47i.logger).warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $kQ0sT.startSession)({
                ignoreDuration: true
            });
            (0, $kQ0sT.captureSession)();
            // We want to create a session for every navigation as well
            (0, $3d87653da885c31c$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $kQ0sT.startSession)({
                        ignoreDuration: true
                    });
                    (0, $kQ0sT.captureSession)();
                }
            });
        }
    };
});



var $kQ0sT = parcelRequire("kQ0sT");
var $kGYVh = parcelRequire("kGYVh");
var $hA6iJ = parcelRequire("hA6iJ");
var $dfMsQ = parcelRequire("dfMsQ");
var $hi47i = parcelRequire("hi47i");
var $5v1oS = parcelRequire("5v1oS");



const $3920039f2d643754$var$INTEGRATION_NAME = "GlobalHandlers";
const $3920039f2d643754$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $3920039f2d643754$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $3920039f2d643754$var$_installGlobalOnErrorHandler(client);
                $3920039f2d643754$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $3920039f2d643754$var$_installGlobalOnUnhandledRejectionHandler(client);
                $3920039f2d643754$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $3920039f2d643754$export$66acc70e8cf2b71a = (0, $fbb22756c9507e85$export$2323046b9414659f)($3920039f2d643754$var$_globalHandlersIntegration);
function $3920039f2d643754$var$_installGlobalOnErrorHandler(client) {
    (0, $4d76cdf59d4d2156$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $3920039f2d643754$var$getOptions();
        if ((0, $kGYVh.getClient)() !== client || (0, $9130afac94f0b7c9$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $3920039f2d643754$var$_enhanceEventWithInitialFrame((0, $23dde874fe12fd4c$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $kQ0sT.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $3920039f2d643754$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $7878483f8a9932cd$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $3920039f2d643754$var$getOptions();
        if ((0, $kGYVh.getClient)() !== client || (0, $9130afac94f0b7c9$export$b79738ab10c590b2)()) return;
        const error = $3920039f2d643754$var$_getUnhandledRejectionError(e);
        const event = (0, $dfMsQ.isPrimitive)(error) ? $3920039f2d643754$var$_eventFromRejectionWithPrimitive(error) : (0, $23dde874fe12fd4c$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $kQ0sT.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $3920039f2d643754$var$_getUnhandledRejectionError(error) {
    if ((0, $dfMsQ.isPrimitive)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $3920039f2d643754$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $3920039f2d643754$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = (0, $dfMsQ.isString)(url) && url.length > 0 ? url : (0, $hA6iJ.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $5v1oS.UNKNOWN_FUNCTION),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $3920039f2d643754$var$globalHandlerLog(type) {
    (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $hi47i.logger).log(`Global Handler attached: ${type}`);
}
function $3920039f2d643754$var$getOptions() {
    const client = (0, $kGYVh.getClient)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $e873ad23f512125c$export$1378794447170364 = (0, $fbb22756c9507e85$export$2323046b9414659f)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator && !(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && !(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
});



var $dfMsQ = parcelRequire("dfMsQ");

var $hLnp0 = parcelRequire("hLnp0");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $71a9151fcd5ea774$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $dfMsQ.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $71a9151fcd5ea774$var$truncateAggregateExceptions($71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $dfMsQ.isInstanceOf)(error[key], Error)) {
        $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $dfMsQ.isInstanceOf)(childError, Error)) {
            $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $71a9151fcd5ea774$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $71a9151fcd5ea774$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $71a9151fcd5ea774$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $71a9151fcd5ea774$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $hLnp0.truncate)(exception.value, maxValueLength);
        return exception;
    });
}



const $74ac7e452f6a0785$var$DEFAULT_KEY = "cause";
const $74ac7e452f6a0785$var$DEFAULT_LIMIT = 5;
const $74ac7e452f6a0785$var$INTEGRATION_NAME = "LinkedErrors";
const $74ac7e452f6a0785$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $74ac7e452f6a0785$var$DEFAULT_LIMIT;
    const key = options.key || $74ac7e452f6a0785$var$DEFAULT_KEY;
    return {
        name: $74ac7e452f6a0785$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $71a9151fcd5ea774$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $23dde874fe12fd4c$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $74ac7e452f6a0785$export$ebabb00eb7f3a395 = (0, $fbb22756c9507e85$export$2323046b9414659f)($74ac7e452f6a0785$var$_linkedErrorsIntegration);



var $5v1oS = parcelRequire("5v1oS");
// This was originally forked from https://github.com/csnover/TraceKit, and was largely
// re - written as part of raven - js.
//
// This code was later copied to the JavaScript mono - repo and further modified and
// refactored over the years.
const $e103414b28380d9b$var$OPERA10_PRIORITY = 10;
const $e103414b28380d9b$var$OPERA11_PRIORITY = 20;
const $e103414b28380d9b$var$CHROME_PRIORITY = 30;
const $e103414b28380d9b$var$WINJS_PRIORITY = 40;
const $e103414b28380d9b$var$GECKO_PRIORITY = 50;
function $e103414b28380d9b$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $5v1oS.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $e103414b28380d9b$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $e103414b28380d9b$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $e103414b28380d9b$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $e103414b28380d9b$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $e103414b28380d9b$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $e103414b28380d9b$var$createFrame(filename, (0, $5v1oS.UNKNOWN_FUNCTION), +line, +col);
    }
    const parts = $e103414b28380d9b$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $e103414b28380d9b$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $e103414b28380d9b$var$extractSafariExtensionDetails(parts[1] || (0, $5v1oS.UNKNOWN_FUNCTION), parts[2]);
        return $e103414b28380d9b$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $e103414b28380d9b$export$263a749fff749872 = [
    $e103414b28380d9b$var$CHROME_PRIORITY,
    $e103414b28380d9b$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $e103414b28380d9b$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $e103414b28380d9b$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $e103414b28380d9b$var$gecko = (line)=>{
    const parts = $e103414b28380d9b$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $e103414b28380d9b$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $5v1oS.UNKNOWN_FUNCTION);
        [func, filename] = $e103414b28380d9b$var$extractSafariExtensionDetails(func, filename);
        return $e103414b28380d9b$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $e103414b28380d9b$export$cdba47a5dd2804d = [
    $e103414b28380d9b$var$GECKO_PRIORITY,
    $e103414b28380d9b$var$gecko
];
const $e103414b28380d9b$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $e103414b28380d9b$var$winjs = (line)=>{
    const parts = $e103414b28380d9b$var$winjsRegex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[2], parts[1] || (0, $5v1oS.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $e103414b28380d9b$export$179460296da408e8 = [
    $e103414b28380d9b$var$WINJS_PRIORITY,
    $e103414b28380d9b$var$winjs
];
const $e103414b28380d9b$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $e103414b28380d9b$var$opera10 = (line)=>{
    const parts = $e103414b28380d9b$var$opera10Regex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[2], parts[3] || (0, $5v1oS.UNKNOWN_FUNCTION), +parts[1]) : undefined;
};
const $e103414b28380d9b$export$f892b52c880ffc7a = [
    $e103414b28380d9b$var$OPERA10_PRIORITY,
    $e103414b28380d9b$var$opera10
];
const $e103414b28380d9b$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $e103414b28380d9b$var$opera11 = (line)=>{
    const parts = $e103414b28380d9b$var$opera11Regex.exec(line);
    return parts ? $e103414b28380d9b$var$createFrame(parts[5], parts[3] || parts[4] || (0, $5v1oS.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : undefined;
};
const $e103414b28380d9b$export$af11af13f09fb0dc = [
    $e103414b28380d9b$var$OPERA11_PRIORITY,
    $e103414b28380d9b$var$opera11
];
const $e103414b28380d9b$export$7197c0fe6554c079 = [
    $e103414b28380d9b$export$263a749fff749872,
    $e103414b28380d9b$export$cdba47a5dd2804d
];
const $e103414b28380d9b$export$2b2b997d81bf3907 = (0, $5v1oS.createStackParser)(...$e103414b28380d9b$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $e103414b28380d9b$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $5v1oS.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};



var $hi47i = parcelRequire("hi47i");


/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $d09fa7e5070984b9$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $d09fa7e5070984b9$export$e464f4a514ac28a8(name) {
    const cached = $d09fa7e5070984b9$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $955496f5d3029976$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $020e060e3b422828$export$d5f608b368e73f38)(impl)) return $d09fa7e5070984b9$var$cachedImplementations[name] = impl.bind((0, $955496f5d3029976$export$56d8a8a25bd48b81));
    const document = (0, $955496f5d3029976$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $e0c2e3106e46caa2$export$16a28057038b10ef) && (0, $hi47i.logger).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $d09fa7e5070984b9$var$cachedImplementations[name] = impl.bind((0, $955496f5d3029976$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $d09fa7e5070984b9$export$8aa36702e8c8978(name) {
    $d09fa7e5070984b9$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $d09fa7e5070984b9$export$e7aa7bc5c1b3cfb3(...rest) {
    return $d09fa7e5070984b9$export$e464f4a514ac28a8("fetch")(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $d09fa7e5070984b9$export$831dc9f2ab0a617b(...rest) {
    return $d09fa7e5070984b9$export$e464f4a514ac28a8("setTimeout")(...rest);
}



var $fKzCQ = parcelRequire("fKzCQ");



var $hi47i = parcelRequire("hi47i");


var $di9R8 = parcelRequire("di9R8");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $f3cbf180d3404fe0$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $di9R8.rejectedSyncPromise)(new (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $di9R8.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $di9R8.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $5325f8e04d3d0467$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $5325f8e04d3d0467$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $5325f8e04d3d0467$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $5325f8e04d3d0467$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $5325f8e04d3d0467$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $5325f8e04d3d0467$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $5325f8e04d3d0467$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $5325f8e04d3d0467$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



var $di9R8 = parcelRequire("di9R8");
const $edfbff9038a67171$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $edfbff9038a67171$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $f3cbf180d3404fe0$export$85a4f67f852183e6)(options.bufferSize || $edfbff9038a67171$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $f5682b06913d5b03$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $f5682b06913d5b03$export$b11169581eeaf237)(type);
            if ((0, $5325f8e04d3d0467$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $edfbff9038a67171$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $di9R8.resolvedSyncPromise)({});
        const filteredEnvelope = (0, $f5682b06913d5b03$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $f5682b06913d5b03$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $edfbff9038a67171$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $f5682b06913d5b03$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $f5682b06913d5b03$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $5325f8e04d3d0467$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $71e03e2f84576ceb$export$5949942ba2a7c0e2)) {
                (0, $fKzCQ.DEBUG_BUILD) && (0, $hi47i.logger).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $di9R8.resolvedSyncPromise)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
function $edfbff9038a67171$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}


var $di9R8 = parcelRequire("di9R8");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $296be0c65ac1edb3$export$b2311068c46d7cc8(options, nativeFetch = (0, $d09fa7e5070984b9$export$e464f4a514ac28a8)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $d09fa7e5070984b9$export$8aa36702e8c8978)("fetch");
            return (0, $di9R8.rejectedSyncPromise)("No fetch implementation available");
        }
        try {
            // TODO: This may need a `suppressTracing` call in the future when we switch the browser SDK to OTEL
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $d09fa7e5070984b9$export$8aa36702e8c8978)("fetch");
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $di9R8.rejectedSyncPromise)(e);
        }
    }
    return (0, $edfbff9038a67171$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** Get the default integrations for the browser SDK. */ function $928f566aa50bb77a$export$5783b2920b1d62b9(options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ const integrations = [
        (0, $67b350191b117f2b$export$cb3c5c2ceb9818ba)(),
        (0, $7dd448759c7f5e18$export$7918117e9202e4fb)(),
        (0, $4e018dbe28beb052$export$59bfe9f1c76150e)(),
        (0, $8b5b3242e956e79f$export$c079d904b326663a)(),
        (0, $3920039f2d643754$export$66acc70e8cf2b71a)(),
        (0, $74ac7e452f6a0785$export$ebabb00eb7f3a395)(),
        (0, $b99d5bb3db344fdd$export$6d39aa44cd0c7567)(),
        (0, $e873ad23f512125c$export$1378794447170364)()
    ];
    // eslint-disable-next-line deprecation/deprecation
    if (options.autoSessionTracking !== false) integrations.push((0, $8a5b32760c0daa50$export$1baa7880e357371c)());
    return integrations;
}
function $928f566aa50bb77a$var$applyDefaultOptions(optionsArg = {}) {
    const defaultOptions = {
        defaultIntegrations: $928f566aa50bb77a$export$5783b2920b1d62b9(optionsArg),
        release: typeof __SENTRY_RELEASE__ === "string" // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_RELEASE.id // This supports the variable that sentry-webpack-plugin injects
         ? (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).SENTRY_RELEASE.id : undefined,
        autoSessionTracking: true,
        sendClientReports: true
    };
    // TODO: Instead of dropping just `defaultIntegrations`, we should simply
    // call `dropUndefinedKeys` on the entire `optionsArg`.
    // However, for this to work we need to adjust the `hasTracingEnabled()` logic
    // first as it differentiates between `undefined` and the key not being in the object.
    if (optionsArg.defaultIntegrations == null) delete optionsArg.defaultIntegrations;
    return {
        ...defaultOptions,
        ...optionsArg
    };
}
function $928f566aa50bb77a$var$shouldShowBrowserExtensionError() {
    const windowWithMaybeExtension = typeof (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).window !== "undefined" && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81);
    if (!windowWithMaybeExtension) // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const extensionKey = windowWithMaybeExtension.chrome ? "chrome" : "browser";
    const extensionObject = windowWithMaybeExtension[extensionKey];
    const runtimeId = extensionObject && extensionObject.runtime && extensionObject.runtime.id;
    const href = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).location.href || "";
    const extensionProtocols = [
        "chrome-extension:",
        "moz-extension:",
        "ms-browser-extension:",
        "safari-web-extension:"
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = !!runtimeId && (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81) === (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}//`));
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    const isNWjs = typeof windowWithMaybeExtension.nw !== "undefined";
    return !!runtimeId && !isDedicatedExtensionPage && !isNWjs;
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $928f566aa50bb77a$export$2cd8252107eb640b(browserOptions = {}) {
    const options = $928f566aa50bb77a$var$applyDefaultOptions(browserOptions);
    if (!options.skipBrowserExtensionCheck && $928f566aa50bb77a$var$shouldShowBrowserExtensionError()) {
        (0, $hi47i.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error("[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return;
    }
    if (0, $7b8b500cb80621bc$export$16a28057038b10ef) {
        if (!(0, $020e060e3b422828$export$edf3cb81fd7d2a3e)()) (0, $hi47i.logger).warn("No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.");
    }
    const clientOptions = {
        ...options,
        stackParser: (0, $5v1oS.stackParserFromStackParserOptions)(options.stackParser || (0, $e103414b28380d9b$export$2b2b997d81bf3907)),
        integrations: (0, $fbb22756c9507e85$export$68bc4c01ab8ae766)(options),
        transport: options.transport || (0, $296be0c65ac1edb3$export$b2311068c46d7cc8)
    };
    return (0, $9af71b6a24a126c8$export$5333c3f1c58d9bc1)((0, $72d27c0252bb80ff$export$1df9218a526d318d), clientOptions);
}
/**
 * All properties the report dialog supports
 */ /**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $928f566aa50bb77a$export$3a8fd680da42627b(options = {}) {
    // doesn't work without a document (React Native)
    if (!(0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document) {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $hi47i.logger).error("Global document not defined in showReportDialog call");
        return;
    }
    const scope = (0, $kGYVh.getCurrentScope)();
    const client = scope.getClient();
    const dsn = client && client.getDsn();
    if (!dsn) {
        (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $hi47i.logger).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) {
        const eventId = (0, $kQ0sT.lastEventId)();
        if (eventId) options.eventId = eventId;
    }
    const script = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $0e303f054920e2b1$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.head || (0, $9130afac94f0b7c9$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $7b8b500cb80621bc$export$16a28057038b10ef) && (0, $hi47i.logger).error("Not injecting report dialog. No injection point found in HTML");
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $928f566aa50bb77a$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $928f566aa50bb77a$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Captures user feedback and sends it to Sentry.
 *
 * @deprecated Use `captureFeedback` instead.
 */ function $928f566aa50bb77a$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $kGYVh.getClient)();
    if (client) // eslint-disable-next-line deprecation/deprecation
    client.captureUserFeedback(feedback);
}


var $kQ0sT = parcelRequire("kQ0sT");


var $acw62 = parcelRequire("acw62");
/**
 * Inits the React SDK
 */ function $07b303fd558e140e$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $605291aa308d4b89$export$b9f95b027256052c)(opts, "react");
    (0, $kQ0sT.setContext)("react", {
        version: $acw62.version
    });
    return (0, $928f566aa50bb77a$export$2cd8252107eb640b)(opts);
}


// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
/** JSDoc */ function $0b9b1e630e66b2d2$var$normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    let up = 0;
    for(let i = parts.length - 1; i >= 0; i--){
        const last = parts[i];
        if (last === ".") parts.splice(i, 1);
        else if (last === "..") {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) for(; up--; up)parts.unshift("..");
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const $0b9b1e630e66b2d2$var$splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
/** JSDoc */ function $0b9b1e630e66b2d2$var$splitPath(filename) {
    // Truncate files names greater than 1024 characters to avoid regex dos
    // https://github.com/getsentry/sentry-javascript/pull/8737#discussion_r1285719172
    const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
    const parts = $0b9b1e630e66b2d2$var$splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */ function $0b9b1e630e66b2d2$export$f7ad0328861e2f03(...args) {
    let resolvedPath = "";
    let resolvedAbsolute = false;
    for(let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        const path = i >= 0 ? args[i] : "/";
        // Skip empty entries
        if (!path) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charAt(0) === "/";
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = $0b9b1e630e66b2d2$var$normalizeArray(resolvedPath.split("/").filter((p)=>!!p), !resolvedAbsolute).join("/");
    return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
}
/** JSDoc */ function $0b9b1e630e66b2d2$var$trim(arr) {
    let start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== "") break;
    }
    let end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== "") break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */ function $0b9b1e630e66b2d2$export$f0e7d1106eeabbe6(from, to) {
    /* eslint-disable no-param-reassign */ from = $0b9b1e630e66b2d2$export$f7ad0328861e2f03(from).slice(1);
    to = $0b9b1e630e66b2d2$export$f7ad0328861e2f03(to).slice(1);
    /* eslint-enable no-param-reassign */ const fromParts = $0b9b1e630e66b2d2$var$trim(from.split("/"));
    const toParts = $0b9b1e630e66b2d2$var$trim(to.split("/"));
    const length = Math.min(fromParts.length, toParts.length);
    let samePartsLength = length;
    for(let i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    let outputParts = [];
    for(let i = samePartsLength; i < fromParts.length; i++)outputParts.push("..");
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join("/");
}
// path.normalize(path)
// posix version
/** JSDoc */ function $0b9b1e630e66b2d2$export$6af368f973c74c5(path) {
    const isPathAbsolute = $0b9b1e630e66b2d2$export$e434c7255acda994(path);
    const trailingSlash = path.slice(-1) === "/";
    // Normalize the path
    let normalizedPath = $0b9b1e630e66b2d2$var$normalizeArray(path.split("/").filter((p)=>!!p), !isPathAbsolute).join("/");
    if (!normalizedPath && !isPathAbsolute) normalizedPath = ".";
    if (normalizedPath && trailingSlash) normalizedPath += "/";
    return (isPathAbsolute ? "/" : "") + normalizedPath;
}
// posix version
/** JSDoc */ function $0b9b1e630e66b2d2$export$e434c7255acda994(path) {
    return path.charAt(0) === "/";
}
// posix version
/** JSDoc */ function $0b9b1e630e66b2d2$export$f7e2c8231c57a8bd(...args) {
    return $0b9b1e630e66b2d2$export$6af368f973c74c5(args.join("/"));
}
/** JSDoc */ function $0b9b1e630e66b2d2$export$7f7b8152cc673abe(path) {
    const result = $0b9b1e630e66b2d2$var$splitPath(path);
    const root = result[0] || "";
    let dir = result[1];
    if (!root && !dir) // No dirname whatsoever
    return ".";
    if (dir) // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
/** JSDoc */ function $0b9b1e630e66b2d2$export$9bf319d8f74f51d1(path, ext) {
    let f = $0b9b1e630e66b2d2$var$splitPath(path)[2] || "";
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}



var $2fKhD = parcelRequire("2fKhD");
const $864e8fb5870202bb$var$INTEGRATION_NAME = "RewriteFrames";
/**
 * Rewrite event frames paths.
 */ const $864e8fb5870202bb$export$5ed0db6416cb6ea2 = (0, $fbb22756c9507e85$export$2323046b9414659f)((options = {})=>{
    const root = options.root;
    const prefix = options.prefix || "app:///";
    const isBrowser = "window" in (0, $2fKhD.GLOBAL_OBJ) && (0, $2fKhD.GLOBAL_OBJ).window !== undefined;
    const iteratee = options.iteratee || $864e8fb5870202bb$export$96f9867e17282d04({
        isBrowser: isBrowser,
        root: root,
        prefix: prefix
    });
    /** Process an exception event. */ function _processExceptionsEvent(event) {
        try {
            return {
                ...event,
                exception: {
                    ...event.exception,
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map((value)=>({
                            ...value,
                            ...value.stacktrace && {
                                stacktrace: _processStacktrace(value.stacktrace)
                            }
                        }))
                }
            };
        } catch (_oO) {
            return event;
        }
    }
    /** Process a stack trace. */ function _processStacktrace(stacktrace) {
        return {
            ...stacktrace,
            frames: stacktrace && stacktrace.frames && stacktrace.frames.map((f)=>iteratee(f))
        };
    }
    return {
        name: $864e8fb5870202bb$var$INTEGRATION_NAME,
        processEvent (originalEvent) {
            let processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
});
/**
 * Exported only for tests.
 */ function $864e8fb5870202bb$export$96f9867e17282d04({ isBrowser: isBrowser, root: root, prefix: prefix }) {
    return (frame)=>{
        if (!frame.filename) return frame;
        // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
        const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes("\\") && !frame.filename.includes("/");
        // Check if the frame filename begins with `/`
        const startsWithSlash = /^\//.test(frame.filename);
        if (isBrowser) {
            if (root) {
                const oldFilename = frame.filename;
                if (oldFilename.indexOf(root) === 0) frame.filename = oldFilename.replace(root, prefix);
            }
        } else if (isWindowsFrame || startsWithSlash) {
            const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, "") // remove Windows-style prefix
            .replace(/\\/g, "/") // replace all `\\` instances with `/`
             : frame.filename;
            const base = root ? (0, $0b9b1e630e66b2d2$export$f0e7d1106eeabbe6)(root, filename) : (0, $0b9b1e630e66b2d2$export$9bf319d8f74f51d1)(filename);
            frame.filename = `${prefix}${base}`;
        }
        return frame;
    };
}



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $kGYVh = parcelRequire("kGYVh");

var $hi47i = parcelRequire("hi47i");

var $9ORqK = parcelRequire("9ORqK");

var $acw62 = parcelRequire("acw62");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $fe334ae3892c74f1$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



var $kQ0sT = parcelRequire("kQ0sT");

var $dfMsQ = parcelRequire("dfMsQ");

var $acw62 = parcelRequire("acw62");
/**
 * See if React major version is 17+ by parsing version string.
 */ function $262dc4fd22993153$export$a87138b73900f5b(reactVersion) {
    const reactMajor = reactVersion.match(/^([^.]+)/);
    return reactMajor !== null && parseInt(reactMajor[0]) >= 17;
}
/**
 * Recurse through `error.cause` chain to set cause on an error.
 */ function $262dc4fd22993153$export$bc95048bc211a673(error, cause) {
    const seenErrors = new WeakSet();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.add(error);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * Captures an error that was thrown by a React ErrorBoundary or React root.
 *
 * @param error The error to capture.
 * @param errorInfo The errorInfo provided by React.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $262dc4fd22993153$export$270be4195468cda9(// eslint-disable-next-line @typescript-eslint/no-explicit-any
error, { componentStack: componentStack }, hint) {
    // If on React version >= 17, create stack trace from componentStack param and links
    // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
    // Linking errors requires the `LinkedErrors` integration be enabled.
    // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
    //
    // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
    // with non-error objects. This is why we need to check if the error is an error-like object.
    // See: https://github.com/getsentry/sentry-javascript/issues/6167
    if ($262dc4fd22993153$export$a87138b73900f5b((0, $acw62.version)) && (0, $dfMsQ.isError)(error) && componentStack) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
        errorBoundaryError.stack = componentStack;
        // Using the `LinkedErrors` integration to link the errors together.
        $262dc4fd22993153$export$bc95048bc211a673(error, errorBoundaryError);
    }
    return (0, $kQ0sT.captureException)(error, {
        ...hint,
        captureContext: {
            contexts: {
                react: {
                    componentStack: componentStack
                }
            }
        }
    });
}
/**
 * Creates an error handler that can be used with the `onCaughtError`, `onUncaughtError`,
 * and `onRecoverableError` options in `createRoot` and `hydrateRoot` React DOM methods.
 *
 * @param callback An optional callback that will be called after the error is captured.
 * Use this to add custom handling for errors.
 *
 * @example
 *
 * ```JavaScript
 * const root = createRoot(container, {
 *  onCaughtError: Sentry.reactErrorHandler(),
 *  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
 *    console.warn('Caught error', error, errorInfo.componentStack);
 *  });
 * });
 * ```
 */ function $262dc4fd22993153$export$1e6f045b27b3cfb1(// eslint-disable-next-line @typescript-eslint/no-explicit-any
callback) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error, errorInfo)=>{
        const eventId = $262dc4fd22993153$export$270be4195468cda9(error, errorInfo);
        if (callback) callback(error, errorInfo, eventId);
    };
}


const $8921079907ea55d7$export$6ef4c0367e27f2d5 = "unknown";
const $8921079907ea55d7$var$INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
/**
 * A ErrorBoundary component that logs errors to Sentry.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ class $8921079907ea55d7$export$e926676385687eaf extends $acw62.Component {
    constructor(props){
        super(props);
        $8921079907ea55d7$export$e926676385687eaf.prototype.__init.call(this);
        this.state = $8921079907ea55d7$var$INITIAL_STATE;
        this._openFallbackReportDialog = true;
        const client = (0, $kGYVh.getClient)();
        if (client && props.showDialog) {
            this._openFallbackReportDialog = false;
            this._cleanupHook = client.on("afterSendEvent", (event)=>{
                if (!event.type && this._lastEventId && event.event_id === this._lastEventId) (0, $928f566aa50bb77a$export$3a8fd680da42627b)({
                    ...props.dialogOptions,
                    eventId: this._lastEventId
                });
            });
        }
    }
    componentDidCatch(error, errorInfo) {
        const { componentStack: componentStack } = errorInfo;
        // TODO(v9): Remove this check and type `componentStack` to be React.ErrorInfo['componentStack'].
        const passedInComponentStack = componentStack == null ? undefined : componentStack;
        const { beforeCapture: beforeCapture, onError: onError, showDialog: showDialog, dialogOptions: dialogOptions } = this.props;
        (0, $kGYVh.withScope)((scope)=>{
            if (beforeCapture) beforeCapture(scope, error, passedInComponentStack);
            const handled = this.props.handled != null ? this.props.handled : !!this.props.fallback;
            const eventId = (0, $262dc4fd22993153$export$270be4195468cda9)(error, errorInfo, {
                mechanism: {
                    handled: handled
                }
            });
            if (onError) onError(error, passedInComponentStack, eventId);
            if (showDialog) {
                this._lastEventId = eventId;
                if (this._openFallbackReportDialog) (0, $928f566aa50bb77a$export$3a8fd680da42627b)({
                    ...dialogOptions,
                    eventId: eventId
                });
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            this.setState({
                error: error,
                componentStack: componentStack,
                eventId: eventId
            });
        });
    }
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentWillUnmount() {
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) onUnmount(error, componentStack, eventId);
        if (this._cleanupHook) {
            this._cleanupHook();
            this._cleanupHook = undefined;
        }
    }
    __init() {
        this.resetErrorBoundary = ()=>{
            const { onReset: onReset } = this.props;
            const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
            if (onReset) onReset(error, componentStack, eventId);
            this.setState($8921079907ea55d7$var$INITIAL_STATE);
        };
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const state = this.state;
        if (state.error) {
            let element = undefined;
            if (typeof fallback === "function") element = $acw62.createElement(fallback, {
                error: state.error,
                componentStack: state.componentStack,
                resetError: this.resetErrorBoundary,
                eventId: state.eventId
            });
            else element = fallback;
            if ($acw62.isValidElement(element)) return element;
            if (fallback) (0, $fe334ae3892c74f1$export$16a28057038b10ef) && (0, $hi47i.logger).warn("fallback did not produce a valid ReactElement");
            // Fail gracefully if no fallback provided or is not valid
            return null;
        }
        if (typeof children === "function") return children();
        return children;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8921079907ea55d7$export$f0c7a449e0cfaec7(WrappedComponent, errorBoundaryOptions) {
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || $8921079907ea55d7$export$6ef4c0367e27f2d5;
    const Wrapped = (props)=>$acw62.createElement($8921079907ea55d7$export$e926676385687eaf, {
            ...errorBoundaryOptions
        }, $acw62.createElement(WrappedComponent, {
            ...props
        }));
    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(Wrapped, WrappedComponent);
    return Wrapped;
}



var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");parcelRequire("4fGPb");
var $kfZjc = parcelRequire("kfZjc");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $kfZjc = parcelRequire("kfZjc");

var $54Psn = parcelRequire("54Psn");

var $bsVS2 = parcelRequire("bsVS2");
const $afeab18ffadbfe8d$export$ce9a57d0e5a7c4f5 = ({ component: component, ...rest })=>{
    const isLoggedIn = (0, $iD0SF.useSelector)((0, $54Psn.selectIsLoggedIn));
    (0, $acw62.useEffect)(()=>{
        sessionStorage.setItem("lastPath", !(0, $bsVS2.isNullish)(rest.location) && rest.location !== undefined ? `${rest.location.pathname}${rest.location.search}` : "");
    }, [
        rest.location
    ]);
    const Comp = component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.Route), {
        ...rest,
        render: (props)=>isLoggedIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Comp, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.Redirect), {
                to: {
                    pathname: "/login",
                    state: {
                        from: props.location
                    }
                }
            })
    });
};



var $je6jq = parcelRequire("je6jq");

var $3np4r = parcelRequire("3np4r");

var $3OncY = parcelRequire("3OncY");
const $6a6beb7a652533e8$export$55abd4691b317664 = (0, $3np4r.createBrowserHistory)({
    basename: (0, $3OncY.Config).basePath
});



const $6840e8b44f75a905$var$LazyHomePage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(async ()=>await (parcelRequire("1XNui")));

const $6840e8b44f75a905$var$LazyNotFoundPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(async ()=>await (parcelRequire("13hm9")));

const $6840e8b44f75a905$var$LazyLoginPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(async ()=>await (parcelRequire("dpkRc")));

const $6840e8b44f75a905$var$LazyLogoutPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(async ()=>await (parcelRequire("2QUhJ")));

const $6840e8b44f75a905$var$LazyLoginCallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(async ()=>await (parcelRequire("kajJd")));

const $6840e8b44f75a905$var$LazyPatientPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(async ()=>await (parcelRequire("1WN2x")));

const $6840e8b44f75a905$var$LazyWorkListDashboardPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(async ()=>await (parcelRequire("4ZdJS")));

const $6840e8b44f75a905$var$LazyWorkListEditPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(async ()=>await (parcelRequire("5Unhi")));

const $6840e8b44f75a905$var$LazyCrossmatchPatientSelectorPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(async ()=>await (parcelRequire("93YUF")));

const $6840e8b44f75a905$var$LazyCrossmatchPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(async ()=>await (parcelRequire("1wN72")));

const $6840e8b44f75a905$var$LazyAuditPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(async ()=>await (parcelRequire("6V1yt")));

const $6840e8b44f75a905$var$LazyErrorPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(async ()=>await (parcelRequire("jBElC")));

const $6840e8b44f75a905$var$LazyExamDashboardPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(async ()=>await (parcelRequire("xNz5h")));

const $6840e8b44f75a905$var$LazySettingsPage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(async ()=>await (parcelRequire("i7Fkb")));

const $6840e8b44f75a905$var$LazyTimelinePage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).lazy(async ()=>await (parcelRequire("lm1CN")));
const $6840e8b44f75a905$export$86fbec116b87613f = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $je6jq.Loader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.Router), {
        history: (0, $6a6beb7a652533e8$export$55abd4691b317664)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8921079907ea55d7$export$e926676385687eaf), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($6840e8b44f75a905$var$LazyErrorPage, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.Switch), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $afeab18ffadbfe8d$export$ce9a57d0e5a7c4f5), {
        path: "/",
        exact: true,
        component: $6840e8b44f75a905$var$LazyHomePage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.Route), {
        path: "/callback",
        exact: true,
        component: $6840e8b44f75a905$var$LazyLoginCallback
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.Route), {
        path: "/login",
        exact: true,
        component: $6840e8b44f75a905$var$LazyLoginPage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.Route), {
        path: "/logout",
        exact: true,
        component: $6840e8b44f75a905$var$LazyLogoutPage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $afeab18ffadbfe8d$export$ce9a57d0e5a7c4f5), {
        path: "/patient/:inlogID/:subRoute",
        exact: true,
        component: $6840e8b44f75a905$var$LazyPatientPage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $afeab18ffadbfe8d$export$ce9a57d0e5a7c4f5), {
        path: "/patient/:inlogID",
        exact: true,
        component: $6840e8b44f75a905$var$LazyPatientPage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $afeab18ffadbfe8d$export$ce9a57d0e5a7c4f5), {
        path: "/patient",
        exact: true,
        component: $6840e8b44f75a905$var$LazyHomePage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $afeab18ffadbfe8d$export$ce9a57d0e5a7c4f5), {
        path: "/worklists",
        exact: true,
        component: $6840e8b44f75a905$var$LazyWorkListDashboardPage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $afeab18ffadbfe8d$export$ce9a57d0e5a7c4f5), {
        path: "/worklists/:worklistId",
        exact: true,
        component: $6840e8b44f75a905$var$LazyWorkListEditPage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $afeab18ffadbfe8d$export$ce9a57d0e5a7c4f5), {
        path: "/exam",
        exact: true,
        component: $6840e8b44f75a905$var$LazyExamDashboardPage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $afeab18ffadbfe8d$export$ce9a57d0e5a7c4f5), {
        path: "/crossmatch",
        exact: true,
        component: $6840e8b44f75a905$var$LazyCrossmatchPatientSelectorPage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $afeab18ffadbfe8d$export$ce9a57d0e5a7c4f5), {
        path: "/crossmatch/:inlogID",
        exact: true,
        component: $6840e8b44f75a905$var$LazyCrossmatchPage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $afeab18ffadbfe8d$export$ce9a57d0e5a7c4f5), {
        path: "/audit",
        exact: true,
        component: $6840e8b44f75a905$var$LazyAuditPage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $afeab18ffadbfe8d$export$ce9a57d0e5a7c4f5), {
        path: "/settings",
        component: $6840e8b44f75a905$var$LazySettingsPage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $afeab18ffadbfe8d$export$ce9a57d0e5a7c4f5), {
        path: "/timeline",
        component: $6840e8b44f75a905$var$LazyTimelinePage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.Route), {
        component: $6840e8b44f75a905$var$LazyNotFoundPage
    }))))));
};



var $eShmq = parcelRequire("eShmq");
var $44241fd6c875387f$var$createSymbol = function createSymbol(name) {
    return "@@redux-saga/" + name;
};
var $44241fd6c875387f$export$2b10f4b30fb65583 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol("CANCEL_PROMISE");
var $44241fd6c875387f$export$3281fbb3edc9dee3 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol("CHANNEL_END");
var $44241fd6c875387f$export$8f8422ac5947a789 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol("IO");
var $44241fd6c875387f$export$5a1a83be8f503735 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol("MATCH");
var $44241fd6c875387f$export$9074c4e62c4e51bb = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol("MULTICAST");
var $44241fd6c875387f$export$7d963e45ecdffba1 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol("SAGA_ACTION");
var $44241fd6c875387f$export$3f4d38f8b89bfda7 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol("SELF_CANCELLATION");
var $44241fd6c875387f$export$9355e489ad16f98e = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol("TASK");
var $44241fd6c875387f$export$a47f788ef0b36709 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol("TASK_CANCEL");
var $44241fd6c875387f$export$d966e43d90bf4c05 = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol("TERMINATE");
var $44241fd6c875387f$export$bdae2c4f4f03305d = /*#__PURE__*/ $44241fd6c875387f$var$createSymbol("LOCATION");



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $15093a965cf6fe1c$export$c7b6444af1f098df = function undef(v) {
    return v === null || v === undefined;
};
var $15093a965cf6fe1c$export$1352885233577768 = function notUndef(v) {
    return v !== null && v !== undefined;
};
var $15093a965cf6fe1c$export$86951950244e2001 = function func(f) {
    return typeof f === "function";
};
var $15093a965cf6fe1c$export$98e628dec113755e = function number(n) {
    return typeof n === "number";
};
var $15093a965cf6fe1c$export$22b082955e083ec3 = function string(s) {
    return typeof s === "string";
};
var $15093a965cf6fe1c$export$2f23118c22fb2630 = Array.isArray;
var $15093a965cf6fe1c$export$be5493f9613cbbe = function object(obj) {
    return obj && !$15093a965cf6fe1c$export$2f23118c22fb2630(obj) && typeof obj === "object";
};
var $15093a965cf6fe1c$export$c957ef27a0ebfd4 = function promise(p) {
    return p && $15093a965cf6fe1c$export$86951950244e2001(p.then);
};
var $15093a965cf6fe1c$export$6f58e2338da23f4d = function iterator(it) {
    return it && $15093a965cf6fe1c$export$86951950244e2001(it.next) && $15093a965cf6fe1c$export$86951950244e2001(it.throw);
};
var $15093a965cf6fe1c$export$8e2ddbe84aff549 = function iterable(it) {
    return it && $15093a965cf6fe1c$export$86951950244e2001(Symbol) ? $15093a965cf6fe1c$export$86951950244e2001(it[Symbol.iterator]) : $15093a965cf6fe1c$export$2f23118c22fb2630(it);
};
var $15093a965cf6fe1c$export$94e939b87ca64fb4 = function task(t) {
    return t && t[0, $44241fd6c875387f$export$9355e489ad16f98e];
};
var $15093a965cf6fe1c$export$2ce8c19c8dfba715 = function sagaAction(a) {
    return Boolean(a && a[0, $44241fd6c875387f$export$7d963e45ecdffba1]);
};
var $15093a965cf6fe1c$export$5ab46cbf6120b33a = function observable(ob) {
    return ob && $15093a965cf6fe1c$export$86951950244e2001(ob.subscribe);
};
var $15093a965cf6fe1c$export$ab1029bcae9ddb4a = function buffer(buf) {
    return buf && $15093a965cf6fe1c$export$86951950244e2001(buf.isEmpty) && $15093a965cf6fe1c$export$86951950244e2001(buf.take) && $15093a965cf6fe1c$export$86951950244e2001(buf.put);
};
var $15093a965cf6fe1c$export$24f82734ea047e6f = function pattern(pat) {
    return pat && ($15093a965cf6fe1c$export$22b082955e083ec3(pat) || $15093a965cf6fe1c$export$8f701197936bc2a6(pat) || $15093a965cf6fe1c$export$86951950244e2001(pat) || $15093a965cf6fe1c$export$2f23118c22fb2630(pat) && pat.every(pattern));
};
var $15093a965cf6fe1c$export$1f95fbd68d964d36 = function channel(ch) {
    return ch && $15093a965cf6fe1c$export$86951950244e2001(ch.take) && $15093a965cf6fe1c$export$86951950244e2001(ch.close);
};
var $15093a965cf6fe1c$export$32b5e46230afa379 = function stringableFunc(f) {
    return $15093a965cf6fe1c$export$86951950244e2001(f) && f.hasOwnProperty("toString");
};
var $15093a965cf6fe1c$export$8f701197936bc2a6 = function symbol(sym) {
    return Boolean(sym) && typeof Symbol === "function" && sym.constructor === Symbol && sym !== Symbol.prototype;
};
var $15093a965cf6fe1c$export$1364843af8d5a963 = function multicast(ch) {
    return $15093a965cf6fe1c$export$1f95fbd68d964d36(ch) && ch[0, $44241fd6c875387f$export$9074c4e62c4e51bb];
};
var $15093a965cf6fe1c$export$dc573d8a6576cdb3 = function effect(eff) {
    return eff && eff[0, $44241fd6c875387f$export$8f8422ac5947a789];
};




var $8nd05 = parcelRequire("8nd05");


var $45b326adf3eff15d$var$MAX_SIGNED_INT = 2147483647;
function $45b326adf3eff15d$var$delayP(ms, val) {
    if (val === void 0) val = true;
    var timeoutId;
    var promise = new Promise(function(resolve) {
        timeoutId = setTimeout(resolve, Math.min($45b326adf3eff15d$var$MAX_SIGNED_INT, ms), val);
    });
    promise[0, $44241fd6c875387f$export$2b10f4b30fb65583] = function() {
        clearTimeout(timeoutId);
    };
    return promise;
}
var $45b326adf3eff15d$export$2e2bcd8739ae039 = $45b326adf3eff15d$var$delayP;


var $ea41bdbb61e4673e$var$konst = function konst(v) {
    return function() {
        return v;
    };
};
var $ea41bdbb61e4673e$export$342063e11d6c3cad = /*#__PURE__*/ $ea41bdbb61e4673e$var$konst(true);
var $ea41bdbb61e4673e$export$625550452a3fa3ec = function noop() {};
var $ea41bdbb61e4673e$export$7f8ddf7c7c20b3cd = function identity(v) {
    return v;
};
var $ea41bdbb61e4673e$var$hasSymbol = typeof Symbol === "function";
var $ea41bdbb61e4673e$export$d141bba7fdc215a3 = $ea41bdbb61e4673e$var$hasSymbol && Symbol.asyncIterator ? Symbol.asyncIterator : "@@asyncIterator";
function $ea41bdbb61e4673e$export$db3b6bfb95261072(value, predicate, error) {
    if (!predicate(value)) throw new Error(error);
}
var $ea41bdbb61e4673e$export$ffb5f4729a158638 = function assignWithSymbols(target, source) {
    (0, $8nd05.default)(target, source);
    if (Object.getOwnPropertySymbols) Object.getOwnPropertySymbols(source).forEach(function(s) {
        target[s] = source[s];
    });
};
var $ea41bdbb61e4673e$export$3b14a55fb2447963 = function flatMap(mapper, arr) {
    var _ref;
    return (_ref = []).concat.apply(_ref, arr.map(mapper));
};
function $ea41bdbb61e4673e$export$43caf9889c228507(array, item) {
    var index = array.indexOf(item);
    if (index >= 0) array.splice(index, 1);
}
function $ea41bdbb61e4673e$export$ae1af26003f05816(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        fn();
    };
}
var $ea41bdbb61e4673e$var$kThrow = function kThrow(err) {
    throw err;
};
var $ea41bdbb61e4673e$var$kReturn = function kReturn(value) {
    return {
        value: value,
        done: true
    };
};
function $ea41bdbb61e4673e$export$9e5f44173e64f162(next, thro, name) {
    if (thro === void 0) thro = $ea41bdbb61e4673e$var$kThrow;
    if (name === void 0) name = "iterator";
    var iterator = {
        meta: {
            name: name
        },
        next: next,
        throw: thro,
        return: $ea41bdbb61e4673e$var$kReturn,
        isSagaIterator: true
    };
    if (typeof Symbol !== "undefined") iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $ea41bdbb61e4673e$export$96f57966bedc81b4(error, _ref2) {
    var sagaStack = _ref2.sagaStack;
    /*eslint-disable no-console*/ console.error(error);
    console.error(sagaStack);
}
var $ea41bdbb61e4673e$export$23f2a1d2818174ef = function internalErr(err) {
    return new Error("\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project's github repo.\n  Error: " + err + "\n");
};
var $ea41bdbb61e4673e$export$efccba1c4a2ef57b = function createSetContextWarning(ctx, props) {
    return (ctx ? ctx + "." : "") + "setContext(props): argument " + props + " is not a plain object";
};
var $ea41bdbb61e4673e$var$FROZEN_ACTION_ERROR = "You can't put (a.k.a. dispatch from saga) frozen actions.\nWe have to define a special non-enumerable property on those actions for scheduling purposes.\nOtherwise you wouldn't be able to communicate properly between sagas & other subscribers (action ordering would become far less predictable).\nIf you are using redux and you care about this behaviour (frozen actions),\nthen you might want to switch to freezing actions in a middleware rather than in action creator.\nExample implementation:\n\nconst freezeActions = store => next => action => next(Object.freeze(action))\n"; // creates empty, but not-holey array
var $ea41bdbb61e4673e$export$953cecd6e717a553 = function createEmptyArray(n) {
    return Array.apply(null, new Array(n));
};
var $ea41bdbb61e4673e$export$a9c23c6ac3fc3eca = function wrapSagaDispatch(dispatch) {
    return function(action) {
        return dispatch(Object.defineProperty(action, (0, $44241fd6c875387f$export$7d963e45ecdffba1), {
            value: true
        }));
    };
};
var $ea41bdbb61e4673e$export$df995fae86a55f06 = function shouldTerminate(res) {
    return res === (0, $44241fd6c875387f$export$d966e43d90bf4c05);
};
var $ea41bdbb61e4673e$export$4a5767248b18ef41 = function shouldCancel(res) {
    return res === (0, $44241fd6c875387f$export$a47f788ef0b36709);
};
var $ea41bdbb61e4673e$export$2408f22a0fab9ae5 = function shouldComplete(res) {
    return $ea41bdbb61e4673e$export$df995fae86a55f06(res) || $ea41bdbb61e4673e$export$4a5767248b18ef41(res);
};
function $ea41bdbb61e4673e$export$882b5998b3b9117c(shape, parentCallback) {
    var keys = Object.keys(shape);
    var totalCount = keys.length;
    var completedCount = 0;
    var completed;
    var results = (0, $15093a965cf6fe1c$export$2f23118c22fb2630)(shape) ? $ea41bdbb61e4673e$export$953cecd6e717a553(totalCount) : {};
    var childCallbacks = {};
    function checkEnd() {
        if (completedCount === totalCount) {
            completed = true;
            parentCallback(results);
        }
    }
    keys.forEach(function(key) {
        var chCbAtKey = function chCbAtKey(res, isErr) {
            if (completed) return;
            if (isErr || $ea41bdbb61e4673e$export$2408f22a0fab9ae5(res)) {
                parentCallback.cancel();
                parentCallback(res, isErr);
            } else {
                results[key] = res;
                completedCount++;
                checkEnd();
            }
        };
        chCbAtKey.cancel = $ea41bdbb61e4673e$export$625550452a3fa3ec;
        childCallbacks[key] = chCbAtKey;
    });
    parentCallback.cancel = function() {
        if (!completed) {
            completed = true;
            keys.forEach(function(key) {
                return childCallbacks[key].cancel();
            });
        }
    };
    return childCallbacks;
}
function $ea41bdbb61e4673e$export$35e795649ee09318(fn) {
    return {
        name: fn.name || "anonymous",
        location: $ea41bdbb61e4673e$export$90a7f3efeed30595(fn)
    };
}
function $ea41bdbb61e4673e$export$90a7f3efeed30595(instrumented) {
    return instrumented[0, $44241fd6c875387f$export$bdae2c4f4f03305d];
}
function $ea41bdbb61e4673e$export$ef35774e6d314e91() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
var $ea41bdbb61e4673e$var$BUFFER_OVERFLOW = "Channel's Buffer overflow!";
var $ea41bdbb61e4673e$var$ON_OVERFLOW_THROW = 1;
var $ea41bdbb61e4673e$var$ON_OVERFLOW_DROP = 2;
var $ea41bdbb61e4673e$var$ON_OVERFLOW_SLIDE = 3;
var $ea41bdbb61e4673e$var$ON_OVERFLOW_EXPAND = 4;
var $ea41bdbb61e4673e$var$zeroBuffer = {
    isEmpty: $ea41bdbb61e4673e$export$342063e11d6c3cad,
    put: $ea41bdbb61e4673e$export$625550452a3fa3ec,
    take: $ea41bdbb61e4673e$export$625550452a3fa3ec
};
function $ea41bdbb61e4673e$var$ringBuffer(limit, overflowAction) {
    if (limit === void 0) limit = 10;
    var arr = new Array(limit);
    var length = 0;
    var pushIndex = 0;
    var popIndex = 0;
    var push = function push(it) {
        arr[pushIndex] = it;
        pushIndex = (pushIndex + 1) % limit;
        length++;
    };
    var take = function take() {
        if (length != 0) {
            var it = arr[popIndex];
            arr[popIndex] = null;
            length--;
            popIndex = (popIndex + 1) % limit;
            return it;
        }
    };
    var flush = function flush() {
        var items = [];
        while(length)items.push(take());
        return items;
    };
    return {
        isEmpty: function isEmpty() {
            return length == 0;
        },
        put: function put(it) {
            if (length < limit) push(it);
            else {
                var doubledLimit;
                switch(overflowAction){
                    case $ea41bdbb61e4673e$var$ON_OVERFLOW_THROW:
                        throw new Error($ea41bdbb61e4673e$var$BUFFER_OVERFLOW);
                    case $ea41bdbb61e4673e$var$ON_OVERFLOW_SLIDE:
                        arr[pushIndex] = it;
                        pushIndex = (pushIndex + 1) % limit;
                        popIndex = pushIndex;
                        break;
                    case $ea41bdbb61e4673e$var$ON_OVERFLOW_EXPAND:
                        doubledLimit = 2 * limit;
                        arr = flush();
                        length = arr.length;
                        pushIndex = arr.length;
                        popIndex = 0;
                        arr.length = doubledLimit;
                        limit = doubledLimit;
                        push(it);
                        break;
                    default:
                }
            }
        },
        take: take,
        flush: flush
    };
}
var $ea41bdbb61e4673e$export$7ccc53e8f1e7dfc5 = function none() {
    return $ea41bdbb61e4673e$var$zeroBuffer;
};
var $ea41bdbb61e4673e$var$fixed = function fixed(limit) {
    return $ea41bdbb61e4673e$var$ringBuffer(limit, $ea41bdbb61e4673e$var$ON_OVERFLOW_THROW);
};
var $ea41bdbb61e4673e$var$dropping = function dropping(limit) {
    return $ea41bdbb61e4673e$var$ringBuffer(limit, $ea41bdbb61e4673e$var$ON_OVERFLOW_DROP);
};
var $ea41bdbb61e4673e$export$e7c866399fa523f5 = function sliding(limit) {
    return $ea41bdbb61e4673e$var$ringBuffer(limit, $ea41bdbb61e4673e$var$ON_OVERFLOW_SLIDE);
};
var $ea41bdbb61e4673e$export$f1e1789686576879 = function expanding(initialSize) {
    return $ea41bdbb61e4673e$var$ringBuffer(initialSize, $ea41bdbb61e4673e$var$ON_OVERFLOW_EXPAND);
};
var $ea41bdbb61e4673e$export$9bb611d729802a56 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    none: $ea41bdbb61e4673e$export$7ccc53e8f1e7dfc5,
    fixed: $ea41bdbb61e4673e$var$fixed,
    dropping: $ea41bdbb61e4673e$var$dropping,
    sliding: $ea41bdbb61e4673e$export$e7c866399fa523f5,
    expanding: $ea41bdbb61e4673e$export$f1e1789686576879
});
var $ea41bdbb61e4673e$export$971d5caa766a69d7 = "TAKE";
var $ea41bdbb61e4673e$export$56c0d5a1e737357d = "PUT";
var $ea41bdbb61e4673e$export$ebd11618f299a286 = "ALL";
var $ea41bdbb61e4673e$export$db202ddc8be9136 = "RACE";
var $ea41bdbb61e4673e$export$e7094788287c5e9b = "CALL";
var $ea41bdbb61e4673e$export$407448d2b89b1813 = "CPS";
var $ea41bdbb61e4673e$export$d66501df72047452 = "FORK";
var $ea41bdbb61e4673e$export$b4171a6734a65d42 = "JOIN";
var $ea41bdbb61e4673e$export$8b22cf2602fb60ce = "CANCEL";
var $ea41bdbb61e4673e$export$25ce5a424b770e84 = "SELECT";
var $ea41bdbb61e4673e$export$4368d992c4eafac0 = "ACTION_CHANNEL";
var $ea41bdbb61e4673e$export$2d1720544b23b823 = "CANCELLED";
var $ea41bdbb61e4673e$export$39b482c5e57630a8 = "FLUSH";
var $ea41bdbb61e4673e$export$2329c99376c9d0a4 = "GET_CONTEXT";
var $ea41bdbb61e4673e$export$dda1d9f60106f0e9 = "SET_CONTEXT";
var $ea41bdbb61e4673e$export$78acf4525d8a74c4 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    TAKE: $ea41bdbb61e4673e$export$971d5caa766a69d7,
    PUT: $ea41bdbb61e4673e$export$56c0d5a1e737357d,
    ALL: $ea41bdbb61e4673e$export$ebd11618f299a286,
    RACE: $ea41bdbb61e4673e$export$db202ddc8be9136,
    CALL: $ea41bdbb61e4673e$export$e7094788287c5e9b,
    CPS: $ea41bdbb61e4673e$export$407448d2b89b1813,
    FORK: $ea41bdbb61e4673e$export$d66501df72047452,
    JOIN: $ea41bdbb61e4673e$export$b4171a6734a65d42,
    CANCEL: $ea41bdbb61e4673e$export$8b22cf2602fb60ce,
    SELECT: $ea41bdbb61e4673e$export$25ce5a424b770e84,
    ACTION_CHANNEL: $ea41bdbb61e4673e$export$4368d992c4eafac0,
    CANCELLED: $ea41bdbb61e4673e$export$2d1720544b23b823,
    FLUSH: $ea41bdbb61e4673e$export$39b482c5e57630a8,
    GET_CONTEXT: $ea41bdbb61e4673e$export$2329c99376c9d0a4,
    SET_CONTEXT: $ea41bdbb61e4673e$export$dda1d9f60106f0e9
});
var $ea41bdbb61e4673e$var$TEST_HINT = "\n(HINT: if you are getting these errors in tests, consider using createMockTask from @redux-saga/testing-utils)";
var $ea41bdbb61e4673e$var$makeEffect = function makeEffect(type, payload) {
    var _ref;
    return _ref = {}, _ref[0, $44241fd6c875387f$export$8f8422ac5947a789] = true, _ref.combinator = false, _ref.type = type, _ref.payload = payload, _ref;
};
var $ea41bdbb61e4673e$var$isForkEffect = function isForkEffect(eff) {
    return (0, $15093a965cf6fe1c$export$dc573d8a6576cdb3)(eff) && eff.type === $ea41bdbb61e4673e$export$d66501df72047452;
};
var $ea41bdbb61e4673e$export$3466f893ebf79586 = function detach(eff) {
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$d66501df72047452, (0, $8nd05.default)({}, eff.payload, {
        detached: true
    }));
};
function $ea41bdbb61e4673e$export$61196ced6d74a310(patternOrChannel, multicastPattern) {
    if (patternOrChannel === void 0) patternOrChannel = "*";
    if ((0, $15093a965cf6fe1c$export$24f82734ea047e6f)(patternOrChannel)) {
        if ((0, $15093a965cf6fe1c$export$1352885233577768)(multicastPattern)) /* eslint-disable no-console */ console.warn("take(pattern) takes one argument but two were provided. Consider passing an array for listening to several action types");
        return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$971d5caa766a69d7, {
            pattern: patternOrChannel
        });
    }
    if ((0, $15093a965cf6fe1c$export$1364843af8d5a963)(patternOrChannel) && (0, $15093a965cf6fe1c$export$1352885233577768)(multicastPattern) && (0, $15093a965cf6fe1c$export$24f82734ea047e6f)(multicastPattern)) return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$971d5caa766a69d7, {
        channel: patternOrChannel,
        pattern: multicastPattern
    });
    if ((0, $15093a965cf6fe1c$export$1f95fbd68d964d36)(patternOrChannel)) {
        if ((0, $15093a965cf6fe1c$export$1352885233577768)(multicastPattern)) /* eslint-disable no-console */ console.warn("take(channel) takes one argument but two were provided. Second argument is ignored.");
        return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$971d5caa766a69d7, {
            channel: patternOrChannel
        });
    }
}
var $ea41bdbb61e4673e$export$8743009a87fcb00f = function takeMaybe() {
    var eff = $ea41bdbb61e4673e$export$61196ced6d74a310.apply(void 0, arguments);
    eff.payload.maybe = true;
    return eff;
};
function $ea41bdbb61e4673e$export$dc98b0b04f4c7758(channel$1, action) {
    if ((0, $15093a965cf6fe1c$export$c7b6444af1f098df)(action)) {
        action = channel$1; // `undefined` instead of `null` to make default parameter work
        channel$1 = undefined;
    }
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$56c0d5a1e737357d, {
        channel: channel$1,
        action: action
    });
}
var $ea41bdbb61e4673e$export$71511d61b312f219 = function putResolve() {
    var eff = $ea41bdbb61e4673e$export$dc98b0b04f4c7758.apply(void 0, arguments);
    eff.payload.resolve = true;
    return eff;
};
function $ea41bdbb61e4673e$export$3d8c2f653ac9d0b9(effects) {
    var eff = $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$ebd11618f299a286, effects);
    eff.combinator = true;
    return eff;
}
function $ea41bdbb61e4673e$export$71cec2538cb2c617(effects) {
    var eff = $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$db202ddc8be9136, effects);
    eff.combinator = true;
    return eff;
} // this match getFnCallDescriptor logic
var $ea41bdbb61e4673e$var$validateFnDescriptor = function validateFnDescriptor(effectName, fnDescriptor) {
    $ea41bdbb61e4673e$export$db3b6bfb95261072(fnDescriptor, (0, $15093a965cf6fe1c$export$1352885233577768), effectName + ": argument fn is undefined or null");
    if ((0, $15093a965cf6fe1c$export$86951950244e2001)(fnDescriptor)) return;
    var context = null;
    var fn;
    if ((0, $15093a965cf6fe1c$export$2f23118c22fb2630)(fnDescriptor)) {
        context = fnDescriptor[0];
        fn = fnDescriptor[1];
        $ea41bdbb61e4673e$export$db3b6bfb95261072(fn, (0, $15093a965cf6fe1c$export$1352885233577768), effectName + ": argument of type [context, fn] has undefined or null `fn`");
    } else if ((0, $15093a965cf6fe1c$export$be5493f9613cbbe)(fnDescriptor)) {
        context = fnDescriptor.context;
        fn = fnDescriptor.fn;
        $ea41bdbb61e4673e$export$db3b6bfb95261072(fn, (0, $15093a965cf6fe1c$export$1352885233577768), effectName + ": argument of type {context, fn} has undefined or null `fn`");
    } else {
        $ea41bdbb61e4673e$export$db3b6bfb95261072(fnDescriptor, (0, $15093a965cf6fe1c$export$86951950244e2001), effectName + ": argument fn is not function");
        return;
    }
    if (context && (0, $15093a965cf6fe1c$export$22b082955e083ec3)(fn)) {
        $ea41bdbb61e4673e$export$db3b6bfb95261072(context[fn], (0, $15093a965cf6fe1c$export$86951950244e2001), effectName + ': context arguments has no such method - "' + fn + '"');
        return;
    }
    $ea41bdbb61e4673e$export$db3b6bfb95261072(fn, (0, $15093a965cf6fe1c$export$86951950244e2001), effectName + ": unpacked fn argument (from [context, fn] or {context, fn}) is not a function");
};
function $ea41bdbb61e4673e$var$getFnCallDescriptor(fnDescriptor, args) {
    var context = null;
    var fn;
    if ((0, $15093a965cf6fe1c$export$86951950244e2001)(fnDescriptor)) fn = fnDescriptor;
    else {
        if ((0, $15093a965cf6fe1c$export$2f23118c22fb2630)(fnDescriptor)) {
            context = fnDescriptor[0];
            fn = fnDescriptor[1];
        } else {
            context = fnDescriptor.context;
            fn = fnDescriptor.fn;
        }
        if (context && (0, $15093a965cf6fe1c$export$22b082955e083ec3)(fn) && (0, $15093a965cf6fe1c$export$86951950244e2001)(context[fn])) fn = context[fn];
    }
    return {
        context: context,
        fn: fn,
        args: args
    };
}
var $ea41bdbb61e4673e$var$isNotDelayEffect = function isNotDelayEffect(fn) {
    return fn !== $ea41bdbb61e4673e$export$3722cfe417b6ed86;
};
function $ea41bdbb61e4673e$export$c4ce752e73470fba(fnDescriptor) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var arg0;
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$e7094788287c5e9b, $ea41bdbb61e4673e$var$getFnCallDescriptor(fnDescriptor, args));
}
function $ea41bdbb61e4673e$export$34aec0b863436764(context, fn, args) {
    if (args === void 0) args = [];
    var fnDescriptor = [
        context,
        fn
    ];
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$e7094788287c5e9b, $ea41bdbb61e4673e$var$getFnCallDescriptor([
        context,
        fn
    ], args));
}
function $ea41bdbb61e4673e$export$3c2fa207a37baaea(fnDescriptor) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$407448d2b89b1813, $ea41bdbb61e4673e$var$getFnCallDescriptor(fnDescriptor, args));
}
function $ea41bdbb61e4673e$export$3a1a48c8f6ef640e(fnDescriptor) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$d66501df72047452, $ea41bdbb61e4673e$var$getFnCallDescriptor(fnDescriptor, args));
}
function $ea41bdbb61e4673e$export$ce26c07117d59d6a(fnDescriptor) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    return $ea41bdbb61e4673e$export$3466f893ebf79586($ea41bdbb61e4673e$export$3a1a48c8f6ef640e.apply(void 0, [
        fnDescriptor
    ].concat(args)));
}
function $ea41bdbb61e4673e$export$6559d589eb85fbb6(taskOrTasks) {
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$b4171a6734a65d42, taskOrTasks);
}
function $ea41bdbb61e4673e$export$a07804094c3ecf2d(taskOrTasks) {
    if (taskOrTasks === void 0) taskOrTasks = (0, $44241fd6c875387f$export$3f4d38f8b89bfda7);
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$8b22cf2602fb60ce, taskOrTasks);
}
function $ea41bdbb61e4673e$export$efca4cbe5dd06740(selector) {
    if (selector === void 0) selector = $ea41bdbb61e4673e$export$7f8ddf7c7c20b3cd;
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$25ce5a424b770e84, {
        selector: selector,
        args: args
    });
}
/**
  channel(pattern, [buffer])    => creates a proxy channel for store actions
**/ function $ea41bdbb61e4673e$export$3a6d5c9ae78a2c08(pattern$1, buffer$1) {
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$4368d992c4eafac0, {
        pattern: pattern$1,
        buffer: buffer$1
    });
}
function $ea41bdbb61e4673e$export$a8550f7dbe79f93a() {
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$2d1720544b23b823, {});
}
function $ea41bdbb61e4673e$export$2e2af4578d910ddf(channel$1) {
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$39b482c5e57630a8, channel$1);
}
function $ea41bdbb61e4673e$export$a93c5207d687da10(prop) {
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$2329c99376c9d0a4, prop);
}
function $ea41bdbb61e4673e$export$c3950d9923825c02(props) {
    return $ea41bdbb61e4673e$var$makeEffect($ea41bdbb61e4673e$export$dda1d9f60106f0e9, props);
}
var $ea41bdbb61e4673e$export$3722cfe417b6ed86 = /*#__PURE__*/ $ea41bdbb61e4673e$export$c4ce752e73470fba.bind(null, (0, $45b326adf3eff15d$export$2e2bcd8739ae039));


function $da7a7b2afd0c6e2b$var$deferred() {
    var def = {};
    def.promise = new Promise(function(resolve, reject) {
        def.resolve = resolve;
        def.reject = reject;
    });
    return def;
}
function $da7a7b2afd0c6e2b$export$368f32fb8739d33c(length) {
    var arr = [];
    for(var i = 0; i < length; i++)arr.push($da7a7b2afd0c6e2b$var$deferred());
    return arr;
}
var $da7a7b2afd0c6e2b$export$2e2bcd8739ae039 = $da7a7b2afd0c6e2b$var$deferred;



var $7c4c83baead83c48$var$queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/ var $7c4c83baead83c48$var$semaphore = 0;
/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/ function $7c4c83baead83c48$var$exec(task) {
    try {
        $7c4c83baead83c48$var$suspend();
        task();
    } finally{
        $7c4c83baead83c48$var$release();
    }
}
/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/ function $7c4c83baead83c48$var$asap(task) {
    $7c4c83baead83c48$var$queue.push(task);
    if (!$7c4c83baead83c48$var$semaphore) {
        $7c4c83baead83c48$var$suspend();
        $7c4c83baead83c48$var$flush();
    }
}
/**
 * Puts the scheduler in a `suspended` state and executes a task immediately.
 */ function $7c4c83baead83c48$var$immediately(task) {
    try {
        $7c4c83baead83c48$var$suspend();
        return task();
    } finally{
        $7c4c83baead83c48$var$flush();
    }
}
/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/ function $7c4c83baead83c48$var$suspend() {
    $7c4c83baead83c48$var$semaphore++;
}
/**
  Puts the scheduler in a `released` state.
**/ function $7c4c83baead83c48$var$release() {
    $7c4c83baead83c48$var$semaphore--;
}
/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/ function $7c4c83baead83c48$var$flush() {
    $7c4c83baead83c48$var$release();
    var task;
    while(!$7c4c83baead83c48$var$semaphore && (task = $7c4c83baead83c48$var$queue.shift()) !== undefined)$7c4c83baead83c48$var$exec(task);
}
var $7c4c83baead83c48$var$array = function array(patterns) {
    return function(input) {
        return patterns.some(function(p) {
            return $7c4c83baead83c48$var$matcher(p)(input);
        });
    };
};
var $7c4c83baead83c48$var$predicate = function predicate(_predicate) {
    return function(input) {
        return _predicate(input);
    };
};
var $7c4c83baead83c48$var$string = function string(pattern) {
    return function(input) {
        return input.type === String(pattern);
    };
};
var $7c4c83baead83c48$var$symbol = function symbol(pattern) {
    return function(input) {
        return input.type === pattern;
    };
};
var $7c4c83baead83c48$var$wildcard = function wildcard() {
    return 0, $ea41bdbb61e4673e$export$342063e11d6c3cad;
};
function $7c4c83baead83c48$var$matcher(pattern) {
    // prettier-ignore
    var matcherCreator = pattern === "*" ? $7c4c83baead83c48$var$wildcard : (0, $15093a965cf6fe1c$export$22b082955e083ec3)(pattern) ? $7c4c83baead83c48$var$string : (0, $15093a965cf6fe1c$export$2f23118c22fb2630)(pattern) ? $7c4c83baead83c48$var$array : (0, $15093a965cf6fe1c$export$32b5e46230afa379)(pattern) ? $7c4c83baead83c48$var$string : (0, $15093a965cf6fe1c$export$86951950244e2001)(pattern) ? $7c4c83baead83c48$var$predicate : (0, $15093a965cf6fe1c$export$8f701197936bc2a6)(pattern) ? $7c4c83baead83c48$var$symbol : null;
    if (matcherCreator === null) throw new Error("invalid pattern: " + pattern);
    return matcherCreator(pattern);
}
var $7c4c83baead83c48$export$32239d68d9c6cb49 = {
    type: (0, $44241fd6c875387f$export$3281fbb3edc9dee3)
};
var $7c4c83baead83c48$export$42af6f45c6e0d09f = function isEnd(a) {
    return a && a.type === (0, $44241fd6c875387f$export$3281fbb3edc9dee3);
};
var $7c4c83baead83c48$var$CLOSED_CHANNEL_WITH_TAKERS = "Cannot have a closed channel with pending takers";
var $7c4c83baead83c48$var$INVALID_BUFFER = "invalid buffer passed to channel factory function";
var $7c4c83baead83c48$var$UNDEFINED_INPUT_ERROR = "Saga or channel was provided with an undefined action\nHints:\n  - check that your Action Creator returns a non-undefined value\n  - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners";
function $7c4c83baead83c48$export$1f95fbd68d964d36(buffer$1) {
    if (buffer$1 === void 0) buffer$1 = (0, $ea41bdbb61e4673e$export$f1e1789686576879)();
    var closed = false;
    var takers = [];
    function checkForbiddenStates() {
        if (closed && takers.length) throw (0, $ea41bdbb61e4673e$export$23f2a1d2818174ef)($7c4c83baead83c48$var$CLOSED_CHANNEL_WITH_TAKERS);
        if (takers.length && !buffer$1.isEmpty()) throw (0, $ea41bdbb61e4673e$export$23f2a1d2818174ef)("Cannot have pending takers with non empty buffer");
    }
    function put(input) {
        if (closed) return;
        if (takers.length === 0) return buffer$1.put(input);
        var cb = takers.shift();
        cb(input);
    }
    function take(cb) {
        if (closed && buffer$1.isEmpty()) cb($7c4c83baead83c48$export$32239d68d9c6cb49);
        else if (!buffer$1.isEmpty()) cb(buffer$1.take());
        else {
            takers.push(cb);
            cb.cancel = function() {
                (0, $ea41bdbb61e4673e$export$43caf9889c228507)(takers, cb);
            };
        }
    }
    function flush(cb) {
        if (closed && buffer$1.isEmpty()) {
            cb($7c4c83baead83c48$export$32239d68d9c6cb49);
            return;
        }
        cb(buffer$1.flush());
    }
    function close() {
        if (closed) return;
        closed = true;
        var arr = takers;
        takers = [];
        for(var i = 0, len = arr.length; i < len; i++){
            var taker = arr[i];
            taker($7c4c83baead83c48$export$32239d68d9c6cb49);
        }
    }
    return {
        take: take,
        put: put,
        flush: flush,
        close: close
    };
}
function $7c4c83baead83c48$export$dfc3101b3180c292(subscribe, buffer) {
    if (buffer === void 0) buffer = (0, $ea41bdbb61e4673e$export$7ccc53e8f1e7dfc5)();
    var closed = false;
    var unsubscribe;
    var chan = $7c4c83baead83c48$export$1f95fbd68d964d36(buffer);
    var close = function close() {
        if (closed) return;
        closed = true;
        if ((0, $15093a965cf6fe1c$export$86951950244e2001)(unsubscribe)) unsubscribe();
        chan.close();
    };
    unsubscribe = subscribe(function(input) {
        if ($7c4c83baead83c48$export$42af6f45c6e0d09f(input)) {
            close();
            return;
        }
        chan.put(input);
    });
    unsubscribe = (0, $ea41bdbb61e4673e$export$ae1af26003f05816)(unsubscribe);
    if (closed) unsubscribe();
    return {
        take: chan.take,
        flush: chan.flush,
        close: close
    };
}
function $7c4c83baead83c48$export$438eddf2fd884f37() {
    var _ref;
    var closed = false;
    var currentTakers = [];
    var nextTakers = currentTakers;
    function checkForbiddenStates() {
        if (closed && nextTakers.length) throw (0, $ea41bdbb61e4673e$export$23f2a1d2818174ef)($7c4c83baead83c48$var$CLOSED_CHANNEL_WITH_TAKERS);
    }
    var ensureCanMutateNextTakers = function ensureCanMutateNextTakers() {
        if (nextTakers !== currentTakers) return;
        nextTakers = currentTakers.slice();
    };
    var close = function close() {
        closed = true;
        var takers = currentTakers = nextTakers;
        nextTakers = [];
        takers.forEach(function(taker) {
            taker($7c4c83baead83c48$export$32239d68d9c6cb49);
        });
    };
    return _ref = {}, _ref[0, $44241fd6c875387f$export$9074c4e62c4e51bb] = true, _ref.put = function put(input) {
        if (closed) return;
        if ($7c4c83baead83c48$export$42af6f45c6e0d09f(input)) {
            close();
            return;
        }
        var takers = currentTakers = nextTakers;
        for(var i = 0, len = takers.length; i < len; i++){
            var taker = takers[i];
            if (taker[0, $44241fd6c875387f$export$5a1a83be8f503735](input)) {
                taker.cancel();
                taker(input);
            }
        }
    }, _ref.take = function take(cb, matcher) {
        if (matcher === void 0) matcher = $7c4c83baead83c48$var$wildcard;
        if (closed) {
            cb($7c4c83baead83c48$export$32239d68d9c6cb49);
            return;
        }
        cb[0, $44241fd6c875387f$export$5a1a83be8f503735] = matcher;
        ensureCanMutateNextTakers();
        nextTakers.push(cb);
        cb.cancel = (0, $ea41bdbb61e4673e$export$ae1af26003f05816)(function() {
            ensureCanMutateNextTakers();
            (0, $ea41bdbb61e4673e$export$43caf9889c228507)(nextTakers, cb);
        });
    }, _ref.close = close, _ref;
}
function $7c4c83baead83c48$export$e987d166a3a4f3ec() {
    var chan = $7c4c83baead83c48$export$438eddf2fd884f37();
    var put = chan.put;
    chan.put = function(input) {
        if (input[0, $44241fd6c875387f$export$7d963e45ecdffba1]) {
            put(input);
            return;
        }
        $7c4c83baead83c48$var$asap(function() {
            put(input);
        });
    };
    return chan;
}
var $7c4c83baead83c48$var$RUNNING = 0;
var $7c4c83baead83c48$var$CANCELLED = 1;
var $7c4c83baead83c48$var$ABORTED = 2;
var $7c4c83baead83c48$var$DONE = 3;
function $7c4c83baead83c48$var$resolvePromise(promise, cb) {
    var cancelPromise = promise[0, $44241fd6c875387f$export$2b10f4b30fb65583];
    if ((0, $15093a965cf6fe1c$export$86951950244e2001)(cancelPromise)) cb.cancel = cancelPromise;
    promise.then(cb, function(error) {
        cb(error, true);
    });
}
var $7c4c83baead83c48$var$current = 0;
var $7c4c83baead83c48$var$nextSagaId = function() {
    return ++$7c4c83baead83c48$var$current;
};
var $7c4c83baead83c48$var$_effectRunnerMap;
function $7c4c83baead83c48$var$getIteratorMetaInfo(iterator, fn) {
    if (iterator.isSagaIterator) return {
        name: iterator.meta.name
    };
    return (0, $ea41bdbb61e4673e$export$35e795649ee09318)(fn);
}
function $7c4c83baead83c48$var$createTaskIterator(_ref) {
    var context = _ref.context, fn = _ref.fn, args = _ref.args;
    // catch synchronous failures; see #152 and #441
    try {
        var result = fn.apply(context, args); // i.e. a generator function returns an iterator
        if ((0, $15093a965cf6fe1c$export$6f58e2338da23f4d)(result)) return result;
        var resolved = false;
        var next = function next(arg) {
            if (!resolved) {
                resolved = true; // Only promises returned from fork will be interpreted. See #1573
                return {
                    value: result,
                    done: !(0, $15093a965cf6fe1c$export$c957ef27a0ebfd4)(result)
                };
            } else return {
                value: arg,
                done: true
            };
        };
        return (0, $ea41bdbb61e4673e$export$9e5f44173e64f162)(next);
    } catch (err) {
        // do not bubble up synchronous failures for detached forks
        // instead create a failed task. See #152 and #441
        return (0, $ea41bdbb61e4673e$export$9e5f44173e64f162)(function() {
            throw err;
        });
    }
}
function $7c4c83baead83c48$var$runPutEffect(env, _ref2, cb) {
    var channel = _ref2.channel, action = _ref2.action, resolve = _ref2.resolve;
    /**
   Schedule the put in case another saga is holding a lock.
   The put will be executed atomically. ie nested puts will execute after
   this put has terminated.
   **/ $7c4c83baead83c48$var$asap(function() {
        var result;
        try {
            result = (channel ? channel.put : env.dispatch)(action);
        } catch (error) {
            cb(error, true);
            return;
        }
        if (resolve && (0, $15093a965cf6fe1c$export$c957ef27a0ebfd4)(result)) $7c4c83baead83c48$var$resolvePromise(result, cb);
        else cb(result);
    }); // Put effects are non cancellables
}
function $7c4c83baead83c48$var$runTakeEffect(env, _ref3, cb) {
    var _ref3$channel = _ref3.channel, channel = _ref3$channel === void 0 ? env.channel : _ref3$channel, pattern = _ref3.pattern, maybe = _ref3.maybe;
    var takeCb = function takeCb(input) {
        if (input instanceof Error) {
            cb(input, true);
            return;
        }
        if ($7c4c83baead83c48$export$42af6f45c6e0d09f(input) && !maybe) {
            cb((0, $44241fd6c875387f$export$d966e43d90bf4c05));
            return;
        }
        cb(input);
    };
    try {
        channel.take(takeCb, (0, $15093a965cf6fe1c$export$1352885233577768)(pattern) ? $7c4c83baead83c48$var$matcher(pattern) : null);
    } catch (err) {
        cb(err, true);
        return;
    }
    cb.cancel = takeCb.cancel;
}
function $7c4c83baead83c48$var$runCallEffect(env, _ref4, cb, _ref5) {
    var context = _ref4.context, fn = _ref4.fn, args = _ref4.args;
    var task = _ref5.task;
    // catch synchronous failures; see #152
    try {
        var result = fn.apply(context, args);
        if ((0, $15093a965cf6fe1c$export$c957ef27a0ebfd4)(result)) {
            $7c4c83baead83c48$var$resolvePromise(result, cb);
            return;
        }
        if ((0, $15093a965cf6fe1c$export$6f58e2338da23f4d)(result)) {
            // resolve iterator
            $7c4c83baead83c48$var$proc(env, result, task.context, $7c4c83baead83c48$var$current, (0, $ea41bdbb61e4673e$export$35e795649ee09318)(fn), /* isRoot */ false, cb);
            return;
        }
        cb(result);
    } catch (error) {
        cb(error, true);
    }
}
function $7c4c83baead83c48$var$runCPSEffect(env, _ref6, cb) {
    var context = _ref6.context, fn = _ref6.fn, args = _ref6.args;
    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb
    // catch synchronous failures; see #152
    try {
        var cpsCb = function cpsCb(err, res) {
            if ((0, $15093a965cf6fe1c$export$c7b6444af1f098df)(err)) cb(res);
            else cb(err, true);
        };
        fn.apply(context, args.concat(cpsCb));
        if (cpsCb.cancel) cb.cancel = cpsCb.cancel;
    } catch (error) {
        cb(error, true);
    }
}
function $7c4c83baead83c48$var$runForkEffect(env, _ref7, cb, _ref8) {
    var context = _ref7.context, fn = _ref7.fn, args = _ref7.args, detached = _ref7.detached;
    var parent = _ref8.task;
    var taskIterator = $7c4c83baead83c48$var$createTaskIterator({
        context: context,
        fn: fn,
        args: args
    });
    var meta = $7c4c83baead83c48$var$getIteratorMetaInfo(taskIterator, fn);
    $7c4c83baead83c48$var$immediately(function() {
        var child = $7c4c83baead83c48$var$proc(env, taskIterator, parent.context, $7c4c83baead83c48$var$current, meta, detached, undefined);
        if (detached) cb(child);
        else {
            if (child.isRunning()) {
                parent.queue.addTask(child);
                cb(child);
            } else if (child.isAborted()) parent.queue.abort(child.error());
            else cb(child);
        }
    }); // Fork effects are non cancellables
}
function $7c4c83baead83c48$var$runJoinEffect(env, taskOrTasks, cb, _ref9) {
    var task = _ref9.task;
    var joinSingleTask = function joinSingleTask(taskToJoin, cb) {
        if (taskToJoin.isRunning()) {
            var joiner = {
                task: task,
                cb: cb
            };
            cb.cancel = function() {
                if (taskToJoin.isRunning()) (0, $ea41bdbb61e4673e$export$43caf9889c228507)(taskToJoin.joiners, joiner);
            };
            taskToJoin.joiners.push(joiner);
        } else if (taskToJoin.isAborted()) cb(taskToJoin.error(), true);
        else cb(taskToJoin.result());
    };
    if ((0, $15093a965cf6fe1c$export$2f23118c22fb2630)(taskOrTasks)) {
        if (taskOrTasks.length === 0) {
            cb([]);
            return;
        }
        var childCallbacks = (0, $ea41bdbb61e4673e$export$882b5998b3b9117c)(taskOrTasks, cb);
        taskOrTasks.forEach(function(t, i) {
            joinSingleTask(t, childCallbacks[i]);
        });
    } else joinSingleTask(taskOrTasks, cb);
}
function $7c4c83baead83c48$var$cancelSingleTask(taskToCancel) {
    if (taskToCancel.isRunning()) taskToCancel.cancel();
}
function $7c4c83baead83c48$var$runCancelEffect(env, taskOrTasks, cb, _ref10) {
    var task = _ref10.task;
    if (taskOrTasks === (0, $44241fd6c875387f$export$3f4d38f8b89bfda7)) $7c4c83baead83c48$var$cancelSingleTask(task);
    else if ((0, $15093a965cf6fe1c$export$2f23118c22fb2630)(taskOrTasks)) taskOrTasks.forEach($7c4c83baead83c48$var$cancelSingleTask);
    else $7c4c83baead83c48$var$cancelSingleTask(taskOrTasks);
    cb(); // cancel effects are non cancellables
}
function $7c4c83baead83c48$var$runAllEffect(env, effects, cb, _ref11) {
    var digestEffect = _ref11.digestEffect;
    var effectId = $7c4c83baead83c48$var$current;
    var keys = Object.keys(effects);
    if (keys.length === 0) {
        cb((0, $15093a965cf6fe1c$export$2f23118c22fb2630)(effects) ? [] : {});
        return;
    }
    var childCallbacks = (0, $ea41bdbb61e4673e$export$882b5998b3b9117c)(effects, cb);
    keys.forEach(function(key) {
        digestEffect(effects[key], effectId, childCallbacks[key], key);
    });
}
function $7c4c83baead83c48$var$runRaceEffect(env, effects, cb, _ref12) {
    var digestEffect = _ref12.digestEffect;
    var effectId = $7c4c83baead83c48$var$current;
    var keys = Object.keys(effects);
    var response = (0, $15093a965cf6fe1c$export$2f23118c22fb2630)(effects) ? (0, $ea41bdbb61e4673e$export$953cecd6e717a553)(keys.length) : {};
    var childCbs = {};
    var completed = false;
    keys.forEach(function(key) {
        var chCbAtKey = function chCbAtKey(res, isErr) {
            if (completed) return;
            if (isErr || (0, $ea41bdbb61e4673e$export$2408f22a0fab9ae5)(res)) {
                // Race Auto cancellation
                cb.cancel();
                cb(res, isErr);
            } else {
                cb.cancel();
                completed = true;
                response[key] = res;
                cb(response);
            }
        };
        chCbAtKey.cancel = (0, $ea41bdbb61e4673e$export$625550452a3fa3ec);
        childCbs[key] = chCbAtKey;
    });
    cb.cancel = function() {
        // prevents unnecessary cancellation
        if (!completed) {
            completed = true;
            keys.forEach(function(key) {
                return childCbs[key].cancel();
            });
        }
    };
    keys.forEach(function(key) {
        if (completed) return;
        digestEffect(effects[key], effectId, childCbs[key], key);
    });
}
function $7c4c83baead83c48$var$runSelectEffect(env, _ref13, cb) {
    var selector = _ref13.selector, args = _ref13.args;
    try {
        var state = selector.apply(void 0, [
            env.getState()
        ].concat(args));
        cb(state);
    } catch (error) {
        cb(error, true);
    }
}
function $7c4c83baead83c48$var$runChannelEffect(env, _ref14, cb) {
    var pattern = _ref14.pattern, buffer = _ref14.buffer;
    var chan = $7c4c83baead83c48$export$1f95fbd68d964d36(buffer);
    var match = $7c4c83baead83c48$var$matcher(pattern);
    var taker = function taker(action) {
        if (!$7c4c83baead83c48$export$42af6f45c6e0d09f(action)) env.channel.take(taker, match);
        chan.put(action);
    };
    var close = chan.close;
    chan.close = function() {
        taker.cancel();
        close();
    };
    env.channel.take(taker, match);
    cb(chan);
}
function $7c4c83baead83c48$var$runCancelledEffect(env, data, cb, _ref15) {
    var task = _ref15.task;
    cb(task.isCancelled());
}
function $7c4c83baead83c48$var$runFlushEffect(env, channel, cb) {
    channel.flush(cb);
}
function $7c4c83baead83c48$var$runGetContextEffect(env, prop, cb, _ref16) {
    var task = _ref16.task;
    cb(task.context[prop]);
}
function $7c4c83baead83c48$var$runSetContextEffect(env, props, cb, _ref17) {
    var task = _ref17.task;
    (0, $ea41bdbb61e4673e$export$ffb5f4729a158638)(task.context, props);
    cb();
}
var $7c4c83baead83c48$var$effectRunnerMap = ($7c4c83baead83c48$var$_effectRunnerMap = {}, $7c4c83baead83c48$var$_effectRunnerMap[0, $ea41bdbb61e4673e$export$971d5caa766a69d7] = $7c4c83baead83c48$var$runTakeEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $ea41bdbb61e4673e$export$56c0d5a1e737357d] = $7c4c83baead83c48$var$runPutEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $ea41bdbb61e4673e$export$ebd11618f299a286] = $7c4c83baead83c48$var$runAllEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $ea41bdbb61e4673e$export$db202ddc8be9136] = $7c4c83baead83c48$var$runRaceEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $ea41bdbb61e4673e$export$e7094788287c5e9b] = $7c4c83baead83c48$var$runCallEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $ea41bdbb61e4673e$export$407448d2b89b1813] = $7c4c83baead83c48$var$runCPSEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $ea41bdbb61e4673e$export$d66501df72047452] = $7c4c83baead83c48$var$runForkEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $ea41bdbb61e4673e$export$b4171a6734a65d42] = $7c4c83baead83c48$var$runJoinEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $ea41bdbb61e4673e$export$8b22cf2602fb60ce] = $7c4c83baead83c48$var$runCancelEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $ea41bdbb61e4673e$export$25ce5a424b770e84] = $7c4c83baead83c48$var$runSelectEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $ea41bdbb61e4673e$export$4368d992c4eafac0] = $7c4c83baead83c48$var$runChannelEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $ea41bdbb61e4673e$export$2d1720544b23b823] = $7c4c83baead83c48$var$runCancelledEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $ea41bdbb61e4673e$export$39b482c5e57630a8] = $7c4c83baead83c48$var$runFlushEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $ea41bdbb61e4673e$export$2329c99376c9d0a4] = $7c4c83baead83c48$var$runGetContextEffect, $7c4c83baead83c48$var$_effectRunnerMap[0, $ea41bdbb61e4673e$export$dda1d9f60106f0e9] = $7c4c83baead83c48$var$runSetContextEffect, $7c4c83baead83c48$var$_effectRunnerMap);
/**
 Used to track a parent task and its forks
 In the fork model, forked tasks are attached by default to their parent
 We model this using the concept of Parent task && main Task
 main task is the main flow of the current Generator, the parent tasks is the
 aggregation of the main tasks + all its forked tasks.
 Thus the whole model represents an execution tree with multiple branches (vs the
 linear execution tree in sequential (non parallel) programming)

 A parent tasks has the following semantics
 - It completes if all its forks either complete or all cancelled
 - If it's cancelled, all forks are cancelled as well
 - It aborts if any uncaught error bubbles up from forks
 - If it completes, the return value is the one returned by the main task
 **/ function $7c4c83baead83c48$var$forkQueue(mainTask, onAbort, cont) {
    var tasks = [];
    var result;
    var completed = false;
    addTask(mainTask);
    var getTasks = function getTasks() {
        return tasks;
    };
    function abort(err) {
        onAbort();
        cancelAll();
        cont(err, true);
    }
    function addTask(task) {
        tasks.push(task);
        task.cont = function(res, isErr) {
            if (completed) return;
            (0, $ea41bdbb61e4673e$export$43caf9889c228507)(tasks, task);
            task.cont = (0, $ea41bdbb61e4673e$export$625550452a3fa3ec);
            if (isErr) abort(res);
            else {
                if (task === mainTask) result = res;
                if (!tasks.length) {
                    completed = true;
                    cont(result);
                }
            }
        };
    }
    function cancelAll() {
        if (completed) return;
        completed = true;
        tasks.forEach(function(t) {
            t.cont = (0, $ea41bdbb61e4673e$export$625550452a3fa3ec);
            t.cancel();
        });
        tasks = [];
    }
    return {
        addTask: addTask,
        cancelAll: cancelAll,
        abort: abort,
        getTasks: getTasks
    };
}
// there can be only a single saga error created at any given moment
function $7c4c83baead83c48$var$formatLocation(fileName, lineNumber) {
    return fileName + "?" + lineNumber;
}
function $7c4c83baead83c48$var$effectLocationAsString(effect) {
    var location = (0, $ea41bdbb61e4673e$export$90a7f3efeed30595)(effect);
    if (location) {
        var code = location.code, fileName = location.fileName, lineNumber = location.lineNumber;
        var source = code + "  " + $7c4c83baead83c48$var$formatLocation(fileName, lineNumber);
        return source;
    }
    return "";
}
function $7c4c83baead83c48$var$sagaLocationAsString(sagaMeta) {
    var name = sagaMeta.name, location = sagaMeta.location;
    if (location) return name + "  " + $7c4c83baead83c48$var$formatLocation(location.fileName, location.lineNumber);
    return name;
}
function $7c4c83baead83c48$var$cancelledTasksAsString(sagaStack) {
    var cancelledTasks = (0, $ea41bdbb61e4673e$export$3b14a55fb2447963)(function(i) {
        return i.cancelledTasks;
    }, sagaStack);
    if (!cancelledTasks.length) return "";
    return [
        "Tasks cancelled due to error:"
    ].concat(cancelledTasks).join("\n");
}
var $7c4c83baead83c48$var$crashedEffect = null;
var $7c4c83baead83c48$var$sagaStack = [];
var $7c4c83baead83c48$var$addSagaFrame = function addSagaFrame(frame) {
    frame.crashedEffect = $7c4c83baead83c48$var$crashedEffect;
    $7c4c83baead83c48$var$sagaStack.push(frame);
};
var $7c4c83baead83c48$var$clear = function clear() {
    $7c4c83baead83c48$var$crashedEffect = null;
    $7c4c83baead83c48$var$sagaStack.length = 0;
}; // this sets crashed effect for the soon-to-be-reported saga frame
// this slightly streatches the singleton nature of this module into wrong direction
// as it's even less obvious what's the data flow here, but it is what it is for now
var $7c4c83baead83c48$var$setCrashedEffect = function setCrashedEffect(effect) {
    $7c4c83baead83c48$var$crashedEffect = effect;
};
/**
  @returns {string}

  @example
  The above error occurred in task errorInPutSaga {pathToFile}
  when executing effect put({type: 'REDUCER_ACTION_ERROR_IN_PUT'}) {pathToFile}
      created by fetchSaga {pathToFile}
      created by rootSaga {pathToFile}
*/ var $7c4c83baead83c48$var$toString = function toString() {
    var firstSaga = $7c4c83baead83c48$var$sagaStack[0], otherSagas = $7c4c83baead83c48$var$sagaStack.slice(1);
    var crashedEffectLocation = firstSaga.crashedEffect ? $7c4c83baead83c48$var$effectLocationAsString(firstSaga.crashedEffect) : null;
    var errorMessage = "The above error occurred in task " + $7c4c83baead83c48$var$sagaLocationAsString(firstSaga.meta) + (crashedEffectLocation ? " \n when executing effect " + crashedEffectLocation : "");
    return [
        errorMessage
    ].concat(otherSagas.map(function(s) {
        return "    created by " + $7c4c83baead83c48$var$sagaLocationAsString(s.meta);
    }), [
        $7c4c83baead83c48$var$cancelledTasksAsString($7c4c83baead83c48$var$sagaStack)
    ]).join("\n");
};
function $7c4c83baead83c48$var$newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont) {
    var _task;
    if (cont === void 0) cont = (0, $ea41bdbb61e4673e$export$625550452a3fa3ec);
    var status = $7c4c83baead83c48$var$RUNNING;
    var taskResult;
    var taskError;
    var deferredEnd = null;
    var cancelledDueToErrorTasks = [];
    var context = Object.create(parentContext);
    var queue = $7c4c83baead83c48$var$forkQueue(mainTask, function onAbort() {
        cancelledDueToErrorTasks.push.apply(cancelledDueToErrorTasks, queue.getTasks().map(function(t) {
            return t.meta.name;
        }));
    }, end);
    /**
   This may be called by a parent generator to trigger/propagate cancellation
   cancel all pending tasks (including the main task), then end the current task.
    Cancellation propagates down to the whole execution tree held by this Parent task
   It's also propagated to all joiners of this task and their execution tree/joiners
    Cancellation is noop for terminated/Cancelled tasks tasks
   **/ function cancel() {
        if (status === $7c4c83baead83c48$var$RUNNING) {
            // Setting status to CANCELLED does not necessarily mean that the task/iterators are stopped
            // effects in the iterator's finally block will still be executed
            status = $7c4c83baead83c48$var$CANCELLED;
            queue.cancelAll(); // Ending with a TASK_CANCEL will propagate the Cancellation to all joiners
            end((0, $44241fd6c875387f$export$a47f788ef0b36709), false);
        }
    }
    function end(result, isErr) {
        if (!isErr) {
            // The status here may be RUNNING or CANCELLED
            // If the status is CANCELLED, then we do not need to change it here
            if (result === (0, $44241fd6c875387f$export$a47f788ef0b36709)) status = $7c4c83baead83c48$var$CANCELLED;
            else if (status !== $7c4c83baead83c48$var$CANCELLED) status = $7c4c83baead83c48$var$DONE;
            taskResult = result;
            deferredEnd && deferredEnd.resolve(result);
        } else {
            status = $7c4c83baead83c48$var$ABORTED;
            $7c4c83baead83c48$var$addSagaFrame({
                meta: meta,
                cancelledTasks: cancelledDueToErrorTasks
            });
            if (task.isRoot) {
                var sagaStack = $7c4c83baead83c48$var$toString(); // we've dumped the saga stack to string and are passing it to user's code
                // we know that it won't be needed anymore and we need to clear it
                $7c4c83baead83c48$var$clear();
                env.onError(result, {
                    sagaStack: sagaStack
                });
            }
            taskError = result;
            deferredEnd && deferredEnd.reject(result);
        }
        task.cont(result, isErr);
        task.joiners.forEach(function(joiner) {
            joiner.cb(result, isErr);
        });
        task.joiners = null;
    }
    function setContext(props) {
        (0, $ea41bdbb61e4673e$export$ffb5f4729a158638)(context, props);
    }
    function toPromise() {
        if (deferredEnd) return deferredEnd.promise;
        deferredEnd = (0, $da7a7b2afd0c6e2b$export$2e2bcd8739ae039)();
        if (status === $7c4c83baead83c48$var$ABORTED) deferredEnd.reject(taskError);
        else if (status !== $7c4c83baead83c48$var$RUNNING) deferredEnd.resolve(taskResult);
        return deferredEnd.promise;
    }
    var task = (_task = {}, _task[0, $44241fd6c875387f$export$9355e489ad16f98e] = true, _task.id = parentEffectId, _task.meta = meta, _task.isRoot = isRoot, _task.context = context, _task.joiners = [], _task.queue = queue, _task.cancel = cancel, _task.cont = cont, _task.end = end, _task.setContext = setContext, _task.toPromise = toPromise, _task.isRunning = function isRunning() {
        return status === $7c4c83baead83c48$var$RUNNING;
    }, _task.isCancelled = function isCancelled() {
        return status === $7c4c83baead83c48$var$CANCELLED || status === $7c4c83baead83c48$var$RUNNING && mainTask.status === $7c4c83baead83c48$var$CANCELLED;
    }, _task.isAborted = function isAborted() {
        return status === $7c4c83baead83c48$var$ABORTED;
    }, _task.result = function result() {
        return taskResult;
    }, _task.error = function error() {
        return taskError;
    }, _task);
    return task;
}
function $7c4c83baead83c48$var$proc(env, iterator$1, parentContext, parentEffectId, meta, isRoot, cont) {
    var finalRunEffect = env.finalizeRunEffect(runEffect);
    /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/ next.cancel = (0, $ea41bdbb61e4673e$export$625550452a3fa3ec);
    /** Creates a main task to track the main flow */ var mainTask = {
        meta: meta,
        cancel: cancelMain,
        status: $7c4c83baead83c48$var$RUNNING
    };
    /**
   Creates a new task descriptor for this generator.
   A task is the aggregation of it's mainTask and all it's forked tasks.
   **/ var task = $7c4c83baead83c48$var$newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont);
    var executingContext = {
        task: task,
        digestEffect: digestEffect
    };
    /**
    cancellation of the main task. We'll simply resume the Generator with a TASK_CANCEL
  **/ function cancelMain() {
        if (mainTask.status === $7c4c83baead83c48$var$RUNNING) {
            mainTask.status = $7c4c83baead83c48$var$CANCELLED;
            next((0, $44241fd6c875387f$export$a47f788ef0b36709));
        }
    }
    /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/ if (cont) cont.cancel = task.cancel;
     // kicks up the generator
    next(); // then return the task descriptor to the caller
    return task;
    /**
   * This is the generator driver
   * It's a recursive async/continuation function which calls itself
   * until the generator terminates or throws
   * @param {internal commands(TASK_CANCEL | TERMINATE) | any} arg - value, generator will be resumed with.
   * @param {boolean} isErr - the flag shows if effect finished with an error
   *
   * receives either (command | effect result, false) or (any thrown thing, true)
   */ function next(arg, isErr) {
        try {
            var result;
            if (isErr) {
                result = iterator$1.throw(arg); // user handled the error, we can clear bookkept values
                $7c4c83baead83c48$var$clear();
            } else if ((0, $ea41bdbb61e4673e$export$4a5767248b18ef41)(arg)) {
                /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/ mainTask.status = $7c4c83baead83c48$var$CANCELLED;
                /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/ next.cancel();
                /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/ result = (0, $15093a965cf6fe1c$export$86951950244e2001)(iterator$1.return) ? iterator$1.return((0, $44241fd6c875387f$export$a47f788ef0b36709)) : {
                    done: true,
                    value: (0, $44241fd6c875387f$export$a47f788ef0b36709)
                };
            } else if ((0, $ea41bdbb61e4673e$export$df995fae86a55f06)(arg)) // We get TERMINATE flag, i.e. by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
            result = (0, $15093a965cf6fe1c$export$86951950244e2001)(iterator$1.return) ? iterator$1.return() : {
                done: true
            };
            else result = iterator$1.next(arg);
            if (!result.done) digestEffect(result.value, parentEffectId, next);
            else {
                /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/ if (mainTask.status !== $7c4c83baead83c48$var$CANCELLED) mainTask.status = $7c4c83baead83c48$var$DONE;
                mainTask.cont(result.value);
            }
        } catch (error) {
            if (mainTask.status === $7c4c83baead83c48$var$CANCELLED) throw error;
            mainTask.status = $7c4c83baead83c48$var$ABORTED;
            mainTask.cont(error, true);
        }
    }
    function runEffect(effect, effectId, currCb) {
        /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      of completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/ if ((0, $15093a965cf6fe1c$export$c957ef27a0ebfd4)(effect)) $7c4c83baead83c48$var$resolvePromise(effect, currCb);
        else if ((0, $15093a965cf6fe1c$export$6f58e2338da23f4d)(effect)) // resolve iterator
        $7c4c83baead83c48$var$proc(env, effect, task.context, effectId, meta, /* isRoot */ false, currCb);
        else if (effect && effect[0, $44241fd6c875387f$export$8f8422ac5947a789]) {
            var effectRunner = $7c4c83baead83c48$var$effectRunnerMap[effect.type];
            effectRunner(env, effect.payload, currCb, executingContext);
        } else // anything else returned as is
        currCb(effect);
    }
    function digestEffect(effect, parentEffectId, cb, label) {
        if (label === void 0) label = "";
        var effectId = $7c4c83baead83c48$var$nextSagaId();
        env.sagaMonitor && env.sagaMonitor.effectTriggered({
            effectId: effectId,
            parentEffectId: parentEffectId,
            label: label,
            effect: effect
        });
        /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/ var effectSettled; // Completion callback passed to the appropriate effect runner
        function currCb(res, isErr) {
            if (effectSettled) return;
            effectSettled = true;
            cb.cancel = (0, $ea41bdbb61e4673e$export$625550452a3fa3ec); // defensive measure
            if (env.sagaMonitor) {
                if (isErr) env.sagaMonitor.effectRejected(effectId, res);
                else env.sagaMonitor.effectResolved(effectId, res);
            }
            if (isErr) $7c4c83baead83c48$var$setCrashedEffect(effect);
            cb(res, isErr);
        } // tracks down the current cancel
        currCb.cancel = (0, $ea41bdbb61e4673e$export$625550452a3fa3ec); // setup cancellation logic on the parent cb
        cb.cancel = function() {
            // prevents cancelling an already completed effect
            if (effectSettled) return;
            effectSettled = true;
            currCb.cancel(); // propagates cancel downward
            currCb.cancel = (0, $ea41bdbb61e4673e$export$625550452a3fa3ec); // defensive measure
            env.sagaMonitor && env.sagaMonitor.effectCancelled(effectId);
        };
        finalRunEffect(effect, effectId, currCb);
    }
}
var $7c4c83baead83c48$var$RUN_SAGA_SIGNATURE = "runSaga(options, saga, ...args)";
var $7c4c83baead83c48$var$NON_GENERATOR_ERR = $7c4c83baead83c48$var$RUN_SAGA_SIGNATURE + ": saga argument must be a Generator function!";
function $7c4c83baead83c48$export$3d8d44bf0c43bb61(_ref, saga) {
    var _ref$channel = _ref.channel, channel = _ref$channel === void 0 ? $7c4c83baead83c48$export$e987d166a3a4f3ec() : _ref$channel, dispatch = _ref.dispatch, getState = _ref.getState, _ref$context = _ref.context, context = _ref$context === void 0 ? {} : _ref$context, sagaMonitor = _ref.sagaMonitor, effectMiddlewares = _ref.effectMiddlewares, _ref$onError = _ref.onError, onError = _ref$onError === void 0 ? (0, $ea41bdbb61e4673e$export$96f57966bedc81b4) : _ref$onError;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var iterator$1 = saga.apply(void 0, args);
    var effectId = $7c4c83baead83c48$var$nextSagaId();
    if (sagaMonitor) {
        // monitors are expected to have a certain interface, let's fill-in any missing ones
        sagaMonitor.rootSagaStarted = sagaMonitor.rootSagaStarted || (0, $ea41bdbb61e4673e$export$625550452a3fa3ec);
        sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || (0, $ea41bdbb61e4673e$export$625550452a3fa3ec);
        sagaMonitor.effectResolved = sagaMonitor.effectResolved || (0, $ea41bdbb61e4673e$export$625550452a3fa3ec);
        sagaMonitor.effectRejected = sagaMonitor.effectRejected || (0, $ea41bdbb61e4673e$export$625550452a3fa3ec);
        sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || (0, $ea41bdbb61e4673e$export$625550452a3fa3ec);
        sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || (0, $ea41bdbb61e4673e$export$625550452a3fa3ec);
        sagaMonitor.rootSagaStarted({
            effectId: effectId,
            saga: saga,
            args: args
        });
    }
    var MIDDLEWARE_TYPE_ERROR;
    var finalizeRunEffect;
    if (effectMiddlewares) {
        var middleware = (0, $ea41bdbb61e4673e$export$ef35774e6d314e91).apply(void 0, effectMiddlewares);
        finalizeRunEffect = function finalizeRunEffect(runEffect) {
            return function(effect, effectId, currCb) {
                var plainRunEffect = function plainRunEffect(eff) {
                    return runEffect(eff, effectId, currCb);
                };
                return middleware(plainRunEffect)(effect);
            };
        };
    } else finalizeRunEffect = (0, $ea41bdbb61e4673e$export$7f8ddf7c7c20b3cd);
    var env = {
        channel: channel,
        dispatch: (0, $ea41bdbb61e4673e$export$a9c23c6ac3fc3eca)(dispatch),
        getState: getState,
        sagaMonitor: sagaMonitor,
        onError: onError,
        finalizeRunEffect: finalizeRunEffect
    };
    return $7c4c83baead83c48$var$immediately(function() {
        var task = $7c4c83baead83c48$var$proc(env, iterator$1, context, effectId, (0, $ea41bdbb61e4673e$export$35e795649ee09318)(saga), /* isRoot */ true, undefined);
        if (sagaMonitor) sagaMonitor.effectResolved(effectId, task);
        return task;
    });
}
function $7c4c83baead83c48$var$sagaMiddlewareFactory(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$context = _ref.context, context = _ref$context === void 0 ? {} : _ref$context, _ref$channel = _ref.channel, channel = _ref$channel === void 0 ? $7c4c83baead83c48$export$e987d166a3a4f3ec() : _ref$channel, sagaMonitor = _ref.sagaMonitor, options = (0, $1En50.default)(_ref, [
        "context",
        "channel",
        "sagaMonitor"
    ]);
    var boundRunSaga;
    function sagaMiddleware(_ref2) {
        var getState = _ref2.getState, dispatch = _ref2.dispatch;
        boundRunSaga = $7c4c83baead83c48$export$3d8d44bf0c43bb61.bind(null, (0, $8nd05.default)({}, options, {
            context: context,
            channel: channel,
            dispatch: dispatch,
            getState: getState,
            sagaMonitor: sagaMonitor
        }));
        return function(next) {
            return function(action) {
                if (sagaMonitor && sagaMonitor.actionDispatched) sagaMonitor.actionDispatched(action);
                var result = next(action); // hit reducers
                channel.put(action);
                return result;
            };
        };
    }
    sagaMiddleware.run = function() {
        return boundRunSaga.apply(void 0, arguments);
    };
    sagaMiddleware.setContext = function(props) {
        (0, $ea41bdbb61e4673e$export$ffb5f4729a158638)(context, props);
    };
    return sagaMiddleware;
}
var $7c4c83baead83c48$export$2e2bcd8739ae039 = $7c4c83baead83c48$var$sagaMiddlewareFactory;


var $bea0a19dd4c5e28d$export$2e2bcd8739ae039 = (0, $7c4c83baead83c48$export$2e2bcd8739ae039);



parcelRequire("8nd05");



var $1e1837559b2734c8$var$done = function done(value) {
    return {
        done: true,
        value: value
    };
};
var $1e1837559b2734c8$var$qEnd = {};
function $1e1837559b2734c8$var$safeName(patternOrChannel) {
    if ((0, $15093a965cf6fe1c$export$1f95fbd68d964d36)(patternOrChannel)) return "channel";
    if ((0, $15093a965cf6fe1c$export$32b5e46230afa379)(patternOrChannel)) return String(patternOrChannel);
    if ((0, $15093a965cf6fe1c$export$86951950244e2001)(patternOrChannel)) return patternOrChannel.name;
    return String(patternOrChannel);
}
function $1e1837559b2734c8$var$fsmIterator(fsm, startState, name) {
    var stateUpdater, errorState, effect, nextState = startState;
    function next(arg, error) {
        if (nextState === $1e1837559b2734c8$var$qEnd) return $1e1837559b2734c8$var$done(arg);
        if (error && !errorState) {
            nextState = $1e1837559b2734c8$var$qEnd;
            throw error;
        } else {
            stateUpdater && stateUpdater(arg);
            var currentState = error ? fsm[errorState](error) : fsm[nextState]();
            nextState = currentState.nextState;
            effect = currentState.effect;
            stateUpdater = currentState.stateUpdater;
            errorState = currentState.errorState;
            return nextState === $1e1837559b2734c8$var$qEnd ? $1e1837559b2734c8$var$done(arg) : effect;
        }
    }
    return (0, $ea41bdbb61e4673e$export$9e5f44173e64f162)(next, function(error) {
        return next(null, error);
    }, name);
}
function $1e1837559b2734c8$var$takeEvery(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)(patternOrChannel)
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $ea41bdbb61e4673e$export$3a1a48c8f6ef640e).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var action, setAction = function setAction(ac) {
        return action = ac;
    };
    return $1e1837559b2734c8$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: "q1",
                effect: yFork(action)
            };
        }
    }, "q1", "takeEvery(" + $1e1837559b2734c8$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $1e1837559b2734c8$var$takeLatest(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)(patternOrChannel)
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $ea41bdbb61e4673e$export$3a1a48c8f6ef640e).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yCancel = function yCancel(task) {
        return {
            done: false,
            value: (0, $ea41bdbb61e4673e$export$a07804094c3ecf2d)(task)
        };
    };
    var task, action;
    var setTask = function setTask(t) {
        return task = t;
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    return $1e1837559b2734c8$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return task ? {
                nextState: "q3",
                effect: yCancel(task)
            } : {
                nextState: "q1",
                effect: yFork(action),
                stateUpdater: setTask
            };
        },
        q3: function q3() {
            return {
                nextState: "q1",
                effect: yFork(action),
                stateUpdater: setTask
            };
        }
    }, "q1", "takeLatest(" + $1e1837559b2734c8$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $1e1837559b2734c8$var$takeLeading(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)(patternOrChannel)
    };
    var yCall = function yCall(ac) {
        return {
            done: false,
            value: (0, $ea41bdbb61e4673e$export$c4ce752e73470fba).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var action;
    var setAction = function setAction(ac) {
        return action = ac;
    };
    return $1e1837559b2734c8$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: "q1",
                effect: yCall(action)
            };
        }
    }, "q1", "takeLeading(" + $1e1837559b2734c8$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $1e1837559b2734c8$var$throttle(delayLength, patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var action, channel$1;
    var yTake = function yTake() {
        return {
            done: false,
            value: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)(channel$1)
        };
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $ea41bdbb61e4673e$export$3a1a48c8f6ef640e).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yDelay = {
        done: false,
        value: (0, $ea41bdbb61e4673e$export$3722cfe417b6ed86)(delayLength)
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    var setChannel = function setChannel(ch) {
        return channel$1 = ch;
    };
    var needsChannel = !(0, $15093a965cf6fe1c$export$1f95fbd68d964d36)(patternOrChannel);
    if (!needsChannel) setChannel(patternOrChannel);
    return $1e1837559b2734c8$var$fsmIterator({
        q1: function q1() {
            var yActionChannel = {
                done: false,
                value: (0, $ea41bdbb61e4673e$export$3a6d5c9ae78a2c08)(patternOrChannel, (0, $ea41bdbb61e4673e$export$e7c866399fa523f5)(1))
            };
            return {
                nextState: "q2",
                effect: yActionChannel,
                stateUpdater: setChannel
            };
        },
        q2: function q2() {
            return {
                nextState: "q3",
                effect: yTake(),
                stateUpdater: setAction
            };
        },
        q3: function q3() {
            return {
                nextState: "q4",
                effect: yFork(action)
            };
        },
        q4: function q4() {
            return {
                nextState: "q2",
                effect: yDelay
            };
        }
    }, needsChannel ? "q1" : "q2", "throttle(" + $1e1837559b2734c8$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
function $1e1837559b2734c8$var$retry(maxTries, delayLength, fn) {
    var counter = maxTries;
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var yCall = {
        done: false,
        value: (0, $ea41bdbb61e4673e$export$c4ce752e73470fba).apply(void 0, [
            fn
        ].concat(args))
    };
    var yDelay = {
        done: false,
        value: (0, $ea41bdbb61e4673e$export$3722cfe417b6ed86)(delayLength)
    };
    return $1e1837559b2734c8$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yCall,
                errorState: "q10"
            };
        },
        q2: function q2() {
            return {
                nextState: $1e1837559b2734c8$var$qEnd
            };
        },
        q10: function q10(error) {
            counter -= 1;
            if (counter <= 0) throw error;
            return {
                nextState: "q1",
                effect: yDelay
            };
        }
    }, "q1", "retry(" + fn.name + ")");
}
function $1e1837559b2734c8$var$debounceHelper(delayLength, patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var action, raceOutput;
    var yTake = {
        done: false,
        value: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)(patternOrChannel)
    };
    var yRace = {
        done: false,
        value: (0, $ea41bdbb61e4673e$export$71cec2538cb2c617)({
            action: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)(patternOrChannel),
            debounce: (0, $ea41bdbb61e4673e$export$3722cfe417b6ed86)(delayLength)
        })
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, $ea41bdbb61e4673e$export$3a1a48c8f6ef640e).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yNoop = function yNoop(value) {
        return {
            done: false,
            value: value
        };
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    var setRaceOutput = function setRaceOutput(ro) {
        return raceOutput = ro;
    };
    return $1e1837559b2734c8$var$fsmIterator({
        q1: function q1() {
            return {
                nextState: "q2",
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: "q3",
                effect: yRace,
                stateUpdater: setRaceOutput
            };
        },
        q3: function q3() {
            return raceOutput.debounce ? {
                nextState: "q1",
                effect: yFork(action)
            } : {
                nextState: "q2",
                effect: yNoop(raceOutput.action),
                stateUpdater: setAction
            };
        }
    }, "q1", "debounce(" + $1e1837559b2734c8$var$safeName(patternOrChannel) + ", " + worker.name + ")");
}
var $1e1837559b2734c8$var$validateTakeEffect = function validateTakeEffect(fn, patternOrChannel, worker) {
    (0, $ea41bdbb61e4673e$export$db3b6bfb95261072)(patternOrChannel, (0, $15093a965cf6fe1c$export$1352885233577768), fn.name + " requires a pattern or channel");
    (0, $ea41bdbb61e4673e$export$db3b6bfb95261072)(worker, (0, $15093a965cf6fe1c$export$1352885233577768), fn.name + " requires a saga parameter");
};
function $1e1837559b2734c8$export$4e24be1e1c9d5c69(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    return (0, $ea41bdbb61e4673e$export$3a1a48c8f6ef640e).apply(void 0, [
        $1e1837559b2734c8$var$takeEvery,
        patternOrChannel,
        worker
    ].concat(args));
}
function $1e1837559b2734c8$export$ca010cea618a298a(patternOrChannel, worker) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
    return (0, $ea41bdbb61e4673e$export$3a1a48c8f6ef640e).apply(void 0, [
        $1e1837559b2734c8$var$takeLatest,
        patternOrChannel,
        worker
    ].concat(args));
}
function $1e1837559b2734c8$export$ab18f80dcccecca4(patternOrChannel, worker) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)args[_key3 - 2] = arguments[_key3];
    return (0, $ea41bdbb61e4673e$export$3a1a48c8f6ef640e).apply(void 0, [
        $1e1837559b2734c8$var$takeLeading,
        patternOrChannel,
        worker
    ].concat(args));
}
function $1e1837559b2734c8$export$de363e709c412c8a(ms, patternOrChannel, worker) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++)args[_key4 - 3] = arguments[_key4];
    return (0, $ea41bdbb61e4673e$export$3a1a48c8f6ef640e).apply(void 0, [
        $1e1837559b2734c8$var$throttle,
        ms,
        patternOrChannel,
        worker
    ].concat(args));
}
function $1e1837559b2734c8$export$9369b12211e1fce4(maxTries, delayLength, worker) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++)args[_key5 - 3] = arguments[_key5];
    return (0, $ea41bdbb61e4673e$export$c4ce752e73470fba).apply(void 0, [
        $1e1837559b2734c8$var$retry,
        maxTries,
        delayLength,
        worker
    ].concat(args));
}
function $1e1837559b2734c8$export$61fc7d43ac8f84b0(delayLength, pattern, worker) {
    for(var _len6 = arguments.length, args = new Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++)args[_key6 - 3] = arguments[_key6];
    return (0, $ea41bdbb61e4673e$export$3a1a48c8f6ef640e).apply(void 0, [
        $1e1837559b2734c8$var$debounceHelper,
        delayLength,
        pattern,
        worker
    ].concat(args));
}






var $3OncY = parcelRequire("3OncY");
var $1ccc230f4c8b676b$exports = {};
"use strict";
var $1ccc230f4c8b676b$var$__createBinding = $1ccc230f4c8b676b$exports && $1ccc230f4c8b676b$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1ccc230f4c8b676b$var$__exportStar = $1ccc230f4c8b676b$exports && $1ccc230f4c8b676b$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1ccc230f4c8b676b$var$__createBinding(exports1, m, p);
};
Object.defineProperty($1ccc230f4c8b676b$exports, "__esModule", {
    value: true
});

$1ccc230f4c8b676b$var$__exportStar((parcelRequire("gCWjV")), $1ccc230f4c8b676b$exports);

$1ccc230f4c8b676b$var$__exportStar((parcelRequire("aJrNS")), $1ccc230f4c8b676b$exports);

$1ccc230f4c8b676b$var$__exportStar((parcelRequire("2ZGFJ")), $1ccc230f4c8b676b$exports);

$1ccc230f4c8b676b$var$__exportStar((parcelRequire("28Jyf")), $1ccc230f4c8b676b$exports);

$1ccc230f4c8b676b$var$__exportStar((parcelRequire("72afL")), $1ccc230f4c8b676b$exports);

$1ccc230f4c8b676b$var$__exportStar((parcelRequire("229yo")), $1ccc230f4c8b676b$exports);

$1ccc230f4c8b676b$var$__exportStar((parcelRequire("envZT")), $1ccc230f4c8b676b$exports);

$1ccc230f4c8b676b$var$__exportStar((parcelRequire("YQWls")), $1ccc230f4c8b676b$exports);

$1ccc230f4c8b676b$var$__exportStar((parcelRequire("8seOQ")), $1ccc230f4c8b676b$exports);

$1ccc230f4c8b676b$var$__exportStar((parcelRequire("jxSlf")), $1ccc230f4c8b676b$exports);

$1ccc230f4c8b676b$var$__exportStar((parcelRequire("4F33G")), $1ccc230f4c8b676b$exports);

$1ccc230f4c8b676b$var$__exportStar((parcelRequire("9AiGw")), $1ccc230f4c8b676b$exports);

$1ccc230f4c8b676b$var$__exportStar((parcelRequire("ah4qu")), $1ccc230f4c8b676b$exports);

$1ccc230f4c8b676b$var$__exportStar((parcelRequire("9cKgj")), $1ccc230f4c8b676b$exports);

$1ccc230f4c8b676b$var$__exportStar((parcelRequire("2akUG")), $1ccc230f4c8b676b$exports);

$1ccc230f4c8b676b$var$__exportStar((parcelRequire("lksdl")), $1ccc230f4c8b676b$exports);

$1ccc230f4c8b676b$var$__exportStar((parcelRequire("cZQm7")), $1ccc230f4c8b676b$exports);


class $d1c5698b289f23f9$export$a49c5cd2ba3b3357 extends (0, $1ccc230f4c8b676b$exports.BasicQueryStringUtils) {
    parse(input, useHash) {
        return super.parse(input, false);
    }
}



var $aLSdY = parcelRequire("aLSdY");


var $54Psn = parcelRequire("54Psn");

var $2m6N8 = parcelRequire("2m6N8");
function* $c53002b6d2544f6a$export$ba167e6966f67fa3() {
    yield (0, $ea41bdbb61e4673e$export$3d8c2f653ac9d0b9)([
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $aLSdY.USER_LOGIN_REQUEST_REQUEST), $c53002b6d2544f6a$export$6fd9d148d59b771),
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $aLSdY.USER_LOGOUT_REQUEST_REQUEST), $c53002b6d2544f6a$export$f8152ca6870a7618),
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $aLSdY.USER_LOGIN_CHECK_REQUEST), $c53002b6d2544f6a$export$34bfc0b04da381e2),
        (0, $1e1837559b2734c8$export$ca010cea618a298a)((0, $aLSdY.REFRESH_ACCESS_TOKEN_REQUEST), $c53002b6d2544f6a$var$refreshAccessTokenSaga),
        (0, $1e1837559b2734c8$export$ca010cea618a298a)((0, $aLSdY.USER_LOGIN_CHECK_SUCCESS), $c53002b6d2544f6a$export$cc368b5da3115ca0)
    ]);
}
function* $c53002b6d2544f6a$export$6fd9d148d59b771(action) {
    let result;
    try {
        const isLoggedIn = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $54Psn.selectIsLoggedIn));
        result = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)($c53002b6d2544f6a$var$userLoginRequest, isLoggedIn);
    } catch (err) {
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $aLSdY.USER_LOGIN_REQUEST_FAILURE),
            err: err
        });
        return;
    }
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $aLSdY.USER_LOGIN_REQUEST_SUCCESS),
        result: result
    });
}
function* $c53002b6d2544f6a$export$f8152ca6870a7618(action) {
    try {
        let idToken = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $54Psn.selectIdToken));
        if (idToken === "") idToken = sessionStorage.getItem("idToken") ?? "";
        try {
            const logoutEndpoint = `${(0, $3OncY.Config).authzServerURL}/logout`;
            yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)((0, $2m6N8.fetchWithCredentials), idToken, logoutEndpoint);
        } catch (err) {
            console.error(err);
        }
        let accessToken = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $54Psn.selectAccessToken));
        if (accessToken === "") accessToken = sessionStorage.getItem("accessToken") ?? "";
        sessionStorage.removeItem("idToken");
        sessionStorage.removeItem("accessToken");
        sessionStorage.removeItem("refreshToken");
        window.location.href = `${(0, $3OncY.Config).oidcLogoutURL}?id_token_hint=${idToken}&post_logout_redirect_uri=${(0, $3OncY.Config).oidcPostLogoutRedirectURL}`;
    } catch (err) {
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $aLSdY.USER_LOGOUT_REQUEST_FAILURE),
            err: err
        });
        return;
    }
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $aLSdY.USER_LOGOUT_REQUEST_SUCCESS)
    });
}
function* $c53002b6d2544f6a$export$34bfc0b04da381e2(action) {
    let result;
    try {
        result = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)($c53002b6d2544f6a$var$userLoginCheck);
    } catch (err) {
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $aLSdY.USER_LOGIN_CHECK_FAILURE),
            err: err
        });
        return;
    }
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $aLSdY.USER_LOGIN_CHECK_SUCCESS),
        result: result
    });
}
function* $c53002b6d2544f6a$var$refreshAccessTokenSaga(action) {
    const refreshToken = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $54Psn.selectRefreshToken));
    let tokenResponse;
    try {
        tokenResponse = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)($c53002b6d2544f6a$var$refreshAccessToken, refreshToken);
    } catch (error) {
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $aLSdY.REFRESH_ACCESS_TOKEN_FAILURE),
            error: error
        });
        return;
    }
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $aLSdY.REFRESH_ACCESS_TOKEN_SUCCESS),
        refreshToken: tokenResponse.refreshToken,
        accessToken: tokenResponse.accessToken
    });
}
function* $c53002b6d2544f6a$export$cc368b5da3115ca0(action) {
    let result;
    try {
        const accessToken = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $54Psn.selectIdToken));
        result = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)($c53002b6d2544f6a$var$getUserSessionInfo, accessToken);
    } catch (error) {
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $aLSdY.USER_LOGIN_INFO_REQUEST_FAILURE),
            error: error
        });
        return;
    }
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $aLSdY.USER_LOGIN_INFO_REQUEST_SUCCESS),
        result: result
    });
}
async function $c53002b6d2544f6a$var$userLoginRequest(isLoggedIn) {
    const promise = new Promise((resolve, reject)=>{
        if (isLoggedIn) resolve();
        const authorizationHandler = new (0, $1ccc230f4c8b676b$exports.RedirectRequestHandler)(new (0, $1ccc230f4c8b676b$exports.LocalStorageBackend)(), new (0, $d1c5698b289f23f9$export$a49c5cd2ba3b3357)(), window.location, new (0, $1ccc230f4c8b676b$exports.DefaultCrypto)());
        const idTokenHint = sessionStorage.getItem("idToken");
        const extras = {};
        if (idTokenHint !== null) extras.id_token_hint = idTokenHint;
        (0, $1ccc230f4c8b676b$exports.AuthorizationServiceConfiguration).fetchFromIssuer((0, $3OncY.Config).oidcBaseURL, new (0, $1ccc230f4c8b676b$exports.FetchRequestor)()).then((response)=>{
            const authRequest = new (0, $1ccc230f4c8b676b$exports.AuthorizationRequest)({
                client_id: (0, $3OncY.Config).oidcClientID,
                redirect_uri: (0, $3OncY.Config).oidcPostLoginRedirectURL,
                scope: "openid profile email roles offline_access",
                response_type: (0, $1ccc230f4c8b676b$exports.AuthorizationRequest).RESPONSE_TYPE_CODE,
                extras: extras,
                state: undefined
            }, new (0, $1ccc230f4c8b676b$exports.DefaultCrypto)(), true);
            authorizationHandler.performAuthorizationRequest(response, authRequest);
            resolve();
        }).catch(reject);
    });
    return await promise;
}
async function $c53002b6d2544f6a$var$userLoginCheck() {
    const tokenHandler = new (0, $1ccc230f4c8b676b$exports.BaseTokenRequestHandler)(new (0, $1ccc230f4c8b676b$exports.FetchRequestor)());
    const authorizationHandler = new (0, $1ccc230f4c8b676b$exports.RedirectRequestHandler)(new (0, $1ccc230f4c8b676b$exports.LocalStorageBackend)(), new (0, $d1c5698b289f23f9$export$a49c5cd2ba3b3357)(), window.location, new (0, $1ccc230f4c8b676b$exports.DefaultCrypto)());
    const notifier = new (0, $1ccc230f4c8b676b$exports.AuthorizationNotifier)();
    const promise = new Promise((resolve, reject)=>{
        authorizationHandler.setAuthorizationNotifier(notifier);
        notifier.setAuthorizationListener((request, response, error)=>{
            if (error) return reject(error);
            if (!response) return reject(new Error("No authentication response !"));
            let extras = {};
            if (request?.internal !== null && request?.internal !== undefined) extras = {
                code_verifier: request.internal.code_verifier
            };
            const tokenRequest = new (0, $1ccc230f4c8b676b$exports.TokenRequest)({
                client_id: (0, $3OncY.Config).oidcClientID,
                redirect_uri: (0, $3OncY.Config).oidcPostLoginRedirectURL,
                grant_type: (0, $1ccc230f4c8b676b$exports.GRANT_TYPE_AUTHORIZATION_CODE),
                code: response.code,
                refresh_token: undefined,
                extras: extras
            });
            (0, $1ccc230f4c8b676b$exports.AuthorizationServiceConfiguration).fetchFromIssuer((0, $3OncY.Config).oidcBaseURL, new (0, $1ccc230f4c8b676b$exports.FetchRequestor)()).then((oResponse)=>{
                const configuration = oResponse;
                return tokenHandler.performTokenRequest(configuration, tokenRequest).then((oResponse)=>{
                    if (oResponse === null) throw new Error("No response from issuer !");
                    if (!oResponse.idToken) throw new Error("Could not find idToken in issuer response !");
                    const info = $c53002b6d2544f6a$var$parseJwt(oResponse.idToken);
                    const result = {
                        isLoggedIn: true,
                        accessToken: oResponse.accessToken,
                        refreshToken: oResponse.refreshToken,
                        idToken: oResponse.idToken,
                        user: {
                            subject: info.email,
                            roles: info.roles ?? []
                        }
                    };
                    console.log("Login Result", JSON.stringify(result, null, 2), JSON.stringify(info, null, 2));
                    sessionStorage.setItem("idToken", oResponse.idToken !== undefined ? oResponse.idToken : "");
                    sessionStorage.setItem("accessToken", oResponse.accessToken !== undefined ? oResponse.accessToken : "");
                    sessionStorage.setItem("refreshToken", oResponse.refreshToken !== undefined ? oResponse.refreshToken : "");
                    return result;
                });
            }).then(resolve).catch(reject);
        });
        authorizationHandler.completeAuthorizationRequestIfPossible().catch(reject);
    });
    return await promise;
}
const $c53002b6d2544f6a$var$refreshAccessToken = async (refreshToken)=>{
    return await (0, $1ccc230f4c8b676b$exports.AuthorizationServiceConfiguration).fetchFromIssuer((0, $3OncY.Config).oidcBaseURL, new (0, $1ccc230f4c8b676b$exports.FetchRequestor)()).then(async (config)=>{
        const tokenHandler = new (0, $1ccc230f4c8b676b$exports.BaseTokenRequestHandler)(new (0, $1ccc230f4c8b676b$exports.FetchRequestor)());
        const tokenRequest = new (0, $1ccc230f4c8b676b$exports.TokenRequest)({
            client_id: (0, $3OncY.Config).oidcClientID,
            grant_type: (0, $1ccc230f4c8b676b$exports.GRANT_TYPE_REFRESH_TOKEN),
            refresh_token: refreshToken,
            redirect_uri: (0, $3OncY.Config).oidcPostLoginRedirectURL
        });
        return await tokenHandler.performTokenRequest(config, tokenRequest);
    });
};
const $c53002b6d2544f6a$var$getUserSessionInfo = (idToken)=>{
    const url = `${(0, $3OncY.Config).authzServerURL}/api/v1/session`;
    return (0, $2m6N8.fetchWithCredentials)(idToken, url, {
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    }).then(async (response)=>await response.json()).then(function(response) {
        return response;
    });
};
function $c53002b6d2544f6a$var$parseJwt(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(window.atob(base64).split("").map(function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));
    return JSON.parse(jsonPayload);
}



var $kQ0sT = parcelRequire("kQ0sT");


var $5Jfnn = parcelRequire("5Jfnn");

var $dSjLu = parcelRequire("dSjLu");

var $bVoO3 = parcelRequire("bVoO3");
function* $d690996a07d9fe3a$export$ce39863be0b3f74c() {
    yield (0, $1e1837559b2734c8$export$ca010cea618a298a)((action)=>/.*_FAILURE$/g.test(action.type), $d690996a07d9fe3a$export$9adf33f0521751a3);
}
function* $d690996a07d9fe3a$export$9adf33f0521751a3(action) {
    const err = action.err !== undefined ? action.err : action.error;
    if (err instanceof (0, $bVoO3.NotFoundRequestError)) {
        console.warn("[404]", err);
        return;
    }
    // Un conflit métier (400 accompagné d'un message dédié) est un refus attendu
    // du serveur, pas un incident : on le notifie à l'utilisateur mais on ne le
    // remonte pas à Sentry, où il ne ferait que du bruit. Le back applique la
    // même règle (logger.Warn plutôt que sentry.CaptureException).
    const isBusinessError = err instanceof (0, $bVoO3.InvalidRequestWithMessageError);
    let eventId;
    if (isBusinessError) console.warn("[400]", err);
    else {
        console.error(err);
        eventId = $kQ0sT.captureException(err);
    }
    // Debounce failure notifications by 500ms
    // If multiples errors come at the same time, takeLatest() will cancel currently running sagas and
    // use only the latest
    yield (0, $ea41bdbb61e4673e$export$3722cfe417b6ed86)(500);
    const message = typeof err?.getUserMessage === "function" ? err?.getUserMessage() : `Une erreur inconnue est survenue ! (ID: ${eventId})`;
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $5Jfnn.addNotification)({
        message: message,
        status: (0, $dSjLu.NOTIFICATION_STATUS_ERROR)
    }));
}




var $aAq0B = parcelRequire("aAq0B");

var $3OncY = parcelRequire("3OncY");

var $54Psn = parcelRequire("54Psn");

var $dPdDj = parcelRequire("dPdDj");


var $aLSdY = parcelRequire("aLSdY");

var $bVoO3 = parcelRequire("bVoO3");
function* $5b496e0bedaa914a$export$c292eea0f5bcd4a4(error, action) {
    if (!(error instanceof (0, $bVoO3.UnauthorizedRequestError))) return;
    // Try to refresh access token
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $aLSdY.refreshAccessToken)());
    // We wait for either success or failure
    const { success: success } = yield (0, $ea41bdbb61e4673e$export$71cec2538cb2c617)({
        success: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)((0, $aLSdY.REFRESH_ACCESS_TOKEN_SUCCESS)),
        failure: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)((0, $aLSdY.REFRESH_ACCESS_TOKEN_FAILURE))
    });
    // If refresh succeeded
    if (success !== undefined) {
        // Replay action
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)(action);
        return true;
    }
    throw new (0, $bVoO3.FailedTokenRefreshError)();
}


function* $dee57c5cdb246743$export$69cdf029f4a41df6() {
    yield (0, $ea41bdbb61e4673e$export$3d8c2f653ac9d0b9)([
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $aAq0B.QUERY_OBJECTS_REQUEST), $dee57c5cdb246743$var$queryObjectsSaga),
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $aAq0B.CREATE_OBJECT_REQUEST), $dee57c5cdb246743$var$createObjectsSaga),
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $aAq0B.UPDATE_OBJECT_REQUEST), $dee57c5cdb246743$var$updateObjectSaga),
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $aAq0B.FETCH_OBJECT_REQUEST), $dee57c5cdb246743$var$fetchObjectsSaga),
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $aAq0B.DELETE_OBJECT_REQUEST), $dee57c5cdb246743$var$deleteObjectSaga)
    ]);
}
function* $dee57c5cdb246743$var$queryObjectsSaga(action) {
    const accessToken = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $54Psn.selectIdToken));
    const client = new (0, $dPdDj.ObjectServerClient)((0, $3OncY.Config).objectServerURL, accessToken);
    let objects;
    try {
        objects = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)(client.queryObjects, action.namespace, action.privacyDomain, action.filter, action.options);
    } catch (error) {
        const handled = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)((0, $5b496e0bedaa914a$export$c292eea0f5bcd4a4), error, action);
        if (handled) return;
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $aAq0B.QUERY_OBJECTS_FAILURE),
            txId: action.txId,
            error: error
        });
        return;
    }
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $aAq0B.QUERY_OBJECTS_SUCCESS),
        txId: action.txId,
        namespace: action.namespace,
        privacyDomain: action.privacyDomain,
        objects: objects
    });
}
function* $dee57c5cdb246743$var$createObjectsSaga(action) {
    const accessToken = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $54Psn.selectIdToken));
    const client = new (0, $dPdDj.ObjectServerClient)((0, $3OncY.Config).objectServerURL, accessToken);
    let object;
    try {
        object = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)(client.createObject, action.namespace, action.privacyDomain, action.object, action.options?.tenant);
    } catch (error) {
        const handled = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)((0, $5b496e0bedaa914a$export$c292eea0f5bcd4a4), error, action);
        if (handled) return;
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $aAq0B.CREATE_OBJECT_FAILURE),
            txId: action.txId,
            error: error
        });
        return;
    }
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $aAq0B.CREATE_OBJECT_SUCCESS),
        txId: action.txId,
        namespace: action.namespace,
        privacyDomain: action.privacyDomain,
        object: object
    });
}
function* $dee57c5cdb246743$var$updateObjectSaga(action) {
    const accessToken = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $54Psn.selectIdToken));
    const client = new (0, $dPdDj.ObjectServerClient)((0, $3OncY.Config).objectServerURL, accessToken);
    let object;
    try {
        object = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)(client.updateObject, action.namespace, action.privacyDomain, action.id, action.object, action.partial, action.options?.tenant);
    } catch (error) {
        const handled = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)((0, $5b496e0bedaa914a$export$c292eea0f5bcd4a4), error, action);
        if (handled) return;
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $aAq0B.UPDATE_OBJECT_FAILURE),
            txId: action.txId,
            error: error
        });
        return;
    }
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $aAq0B.UPDATE_OBJECT_SUCCESS),
        txId: action.txId,
        namespace: action.namespace,
        privacyDomain: action.privacyDomain,
        object: object
    });
}
function* $dee57c5cdb246743$var$fetchObjectsSaga(action) {
    const accessToken = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $54Psn.selectIdToken));
    const client = new (0, $dPdDj.ObjectServerClient)((0, $3OncY.Config).objectServerURL, accessToken);
    let object;
    try {
        object = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)(client.fetchObject, action.namespace, action.privacyDomain, action.id, action.options?.tenant);
    } catch (error) {
        const handled = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)((0, $5b496e0bedaa914a$export$c292eea0f5bcd4a4), error, action);
        if (handled) return;
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $aAq0B.FETCH_OBJECT_FAILURE),
            txId: action.txId,
            error: error
        });
        return;
    }
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $aAq0B.FETCH_OBJECT_SUCCESS),
        txId: action.txId,
        namespace: action.namespace,
        privacyDomain: action.privacyDomain,
        object: object
    });
}
function* $dee57c5cdb246743$var$deleteObjectSaga(action) {
    const accessToken = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $54Psn.selectIdToken));
    const client = new (0, $dPdDj.ObjectServerClient)((0, $3OncY.Config).objectServerURL, accessToken);
    try {
        yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)(client.deleteObject, action.namespace, action.privacyDomain, action.id, action.options?.tenant);
    } catch (error) {
        const handled = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)((0, $5b496e0bedaa914a$export$c292eea0f5bcd4a4), error, action);
        if (handled) return;
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $aAq0B.DELETE_OBJECT_FAILURE),
            txId: action.txId,
            error: error
        });
        return;
    }
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $aAq0B.DELETE_OBJECT_SUCCESS),
        txId: action.txId,
        namespace: action.namespace,
        privacyDomain: action.privacyDomain,
        id: action.id
    });
}
function* $dee57c5cdb246743$var$fetchObjectEventsSaga(action) {
    const accessToken = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $54Psn.selectIdToken));
    const client = new (0, $dPdDj.ObjectServerClient)((0, $3OncY.Config).objectServerURL, accessToken);
    const object = action.object;
    let objects;
    try {
        objects = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)(client.fetchObjectEvents, action.namespace, action.privacyDomain, action.id);
    } catch (error) {
        const handled = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)((0, $5b496e0bedaa914a$export$c292eea0f5bcd4a4), error, action);
        if (handled) return;
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $aAq0B.FETCH_OBJECT_EVENT_FAILURE),
            txId: action.txId,
            error: error
        });
        return;
    }
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $aAq0B.FETCH_OBJECT_EVENT_SUCCESS),
        txId: action.txId,
        namespace: action.namespace,
        privacyDomain: action.privacyDomain,
        objects: objects,
        object: object
    });
}




var $ifqvT = parcelRequire("ifqvT");

var $1SG9b = parcelRequire("1SG9b");

var $1zwHA = parcelRequire("1zwHA");

var $54Psn = parcelRequire("54Psn");

var $2m6N8 = parcelRequire("2m6N8");
class $53bd35e36a32abdb$export$869a5bece61e9e8f {
    constructor(baseUrl, idToken){
        this.baseUrl = baseUrl;
        this.idToken = idToken;
        // Force bind methods to instance
        this.fetchFilesystem = this.fetchFilesystem.bind(this);
        this.queryFilesystems = this.queryFilesystems.bind(this);
        this.queryWatchers = this.queryWatchers.bind(this);
    }
    async fetchFilesystem(name) {
        const url = `${this.baseUrl}/api/v1/filesystems/${name}`;
        const res = await (0, $2m6N8.fetchWithCredentials)(this.idToken, url);
        const result = await res.json();
        return $53bd35e36a32abdb$var$itemToFilesystem(result.data.Filesystem);
    }
    async queryFilesystems() {
        const url = `${this.baseUrl}/api/v1/filesystems`;
        const res = await (0, $2m6N8.fetchWithCredentials)(this.idToken, url);
        const result = await res.json();
        return result.data.Filesystems.map((item)=>$53bd35e36a32abdb$var$itemToFilesystem(item));
    }
    async queryWatchers() {
        const url = `${this.baseUrl}/api/v1/watchers`;
        const res = await (0, $2m6N8.fetchWithCredentials)(this.idToken, url);
        const result = await res.json();
        return result.data.Watchers.map((item)=>$53bd35e36a32abdb$var$itemToWatcher(item));
    }
}
function $53bd35e36a32abdb$var$itemToFilesystem(item) {
    return {
        name: item.Name,
        dsn: item.DSN,
        metadata: item.Metadata
    };
}
function $53bd35e36a32abdb$var$itemToWatcher(item) {
    return {
        filesystemEndpoint: item.FilesystemEndpoint,
        directory: item.Directory,
        events: item.Events,
        pipelineName: item.PipelineName,
        filter: item.Filter,
        interval: item.Interval
    };
}



var $3OncY = parcelRequire("3OncY");

var $aAq0B = parcelRequire("aAq0B");

var $5Jfnn = parcelRequire("5Jfnn");

var $dSjLu = parcelRequire("dSjLu");
function* $f441bc348656247e$export$3fba891cce9bc0fc() {
    yield (0, $ea41bdbb61e4673e$export$3d8c2f653ac9d0b9)([
        (0, $1e1837559b2734c8$export$ca010cea618a298a)((0, $ifqvT.EXPORT_WORKLIST_REQUEST), $f441bc348656247e$export$a94cab9376d1327b)
    ]);
}
const $f441bc348656247e$var$ExportWorklistPipeline = "export-worklist";
function* $f441bc348656247e$export$a94cab9376d1327b(action) {
    // First we save the worklist
    const updateWorkListAction = (0, $ifqvT.updatePublicWorklist)(action.worklist.id, action.worklist.data);
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $1SG9b.forwardTx)(action, updateWorkListAction));
    const updateWorkListResult = yield (0, $ea41bdbb61e4673e$export$71cec2538cb2c617)({
        success: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)((action)=>action.type === (0, $aAq0B.UPDATE_OBJECT_SUCCESS) && action.object?.id === updateWorkListAction.id && action.txId === action.txId),
        failure: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)((action)=>action.type === (0, $aAq0B.UPDATE_OBJECT_FAILURE) && action.object?.id === updateWorkListAction.id && action.txId === action.txId)
    });
    if (updateWorkListResult.failure) {
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $1SG9b.forwardTx)(action, {
            type: (0, $ifqvT.EXPORT_WORKLIST_FAILURE),
            error: updateWorkListResult.failure.error
        }));
        return;
    }
    // Then we run the "export-worklist" pipeline
    const idToken = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $54Psn.selectIdToken));
    const client = new (0, $53bd35e36a32abdb$export$869a5bece61e9e8f)((0, $3OncY.Config).fileServerURL, idToken);
    const filesystems = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)(client.queryFilesystems);
    const input = {
        worklists: [
            action.worklist.id
        ],
        filesystems: filesystems.filter((fs)=>fs.metadata?.worklistExportFormat !== undefined).map((fs)=>fs.name)
    };
    const runPipelineAction = (0, $1zwHA.runPipeline)($f441bc348656247e$var$ExportWorklistPipeline, input);
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $1SG9b.forwardTx)(action, runPipelineAction));
    const runPipelineResult = yield (0, $ea41bdbb61e4673e$export$71cec2538cb2c617)({
        success: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)((action)=>action.type === (0, $1zwHA.RUN_PIPELINE_SUCCESS) && action.name === $f441bc348656247e$var$ExportWorklistPipeline && action.txId === action.txId),
        failure: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)((action)=>action.type === (0, $1zwHA.RUN_PIPELINE_FAILURE) && action.name === $f441bc348656247e$var$ExportWorklistPipeline && action.txId === action.txId)
    });
    // Ticket #880 - C'est le pipeline qui passe la feuille au statut "exportée",
    // côté serveur : le store garde le brouillon enregistré plus haut tant qu'on
    // ne relit pas la feuille. On la relit avant d'annoncer l'issue de l'export,
    // sinon le bouton "Exporter" redevient actif et un second export peut être
    // lancé sur une feuille déjà exportée. En cas d'échec aussi : l'export a pu
    // échouer parce qu'un autre l'avait devancé.
    yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)($f441bc348656247e$var$refreshWorklist, action.worklist.id);
    if (runPipelineResult.success) {
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $1SG9b.forwardTx)(action, {
            type: (0, $ifqvT.EXPORT_WORKLIST_SUCCESS)
        }));
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $5Jfnn.addNotification)({
            status: (0, $dSjLu.NOTIFICATION_STATUS_SUCCESS),
            message: "Feuille de travail export\xe9e !"
        }));
        return;
    }
    if (runPipelineResult.failure) {
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $1SG9b.forwardTx)(action, {
            type: (0, $ifqvT.EXPORT_WORKLIST_FAILURE),
            error: runPipelineResult.failure.error
        }));
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $5Jfnn.addNotification)({
            status: (0, $dSjLu.NOTIFICATION_STATUS_ERROR),
            message: "Erreur lors de l'export de la feuille de travail !"
        }));
        return;
    }
    // Should never happen
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $1SG9b.forwardTx)(action, {
        type: (0, $ifqvT.EXPORT_WORKLIST_FAILURE),
        error: new Error("Saga finished unexpectedly !")
    }));
}
// La relecture n'est pas rattachée à la transaction d'export : son échec ne
// remet pas en cause un export réussi, et la page garde alors la feuille en
// lecture seule d'après son statut local.
function* $f441bc348656247e$var$refreshWorklist(worklistId) {
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $ifqvT.fetchPublicWorklist)(worklistId));
    yield (0, $ea41bdbb61e4673e$export$71cec2538cb2c617)({
        success: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)((a)=>a.type === (0, $aAq0B.FETCH_OBJECT_SUCCESS) && a.object?.id === worklistId),
        failure: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)((0, $aAq0B.FETCH_OBJECT_FAILURE))
    });
}




var $2gkyY = parcelRequire("2gkyY");


var $aAq0B = parcelRequire("aAq0B");
function* $c748ae4cb6ffe618$export$f38b7279d687b980() {
    yield (0, $ea41bdbb61e4673e$export$3d8c2f653ac9d0b9)([
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $2gkyY.SEARCH_OBJECT_REQUEST), $c748ae4cb6ffe618$export$30d88a71a999b8e5)
    ]);
}
function* $c748ae4cb6ffe618$export$30d88a71a999b8e5(action) {
    const results = [];
    const found = new Set();
    const addResult = (obj, namespace, privacyDomain)=>{
        if (found.has(obj.id)) return;
        found.add(obj.id);
        results.push({
            ...obj,
            namespace: namespace,
            privacyDomain: privacyDomain
        });
    };
    try {
        for(let i = 0; i < action.queries.length; i++){
            const query = action.queries[i];
            yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $aAq0B.queryObjects)(query.namespace, query.privacyDomain, query.filter, {
                hydrate: true
            }));
            let req = yield (0, $ea41bdbb61e4673e$export$71cec2538cb2c617)({
                success: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)((0, $aAq0B.QUERY_OBJECTS_SUCCESS)),
                failure: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)((0, $aAq0B.QUERY_OBJECTS_FAILURE))
            });
            if (req.failure) throw req.failure.err;
            let objects = req.success.objects.filter((obj)=>"data" in obj);
            if (!query.asRef) {
                objects.forEach((obj)=>addResult(obj, query.namespace, query.privacyDomain));
                continue;
            }
            if (objects.length === 0) continue;
            const targetNamespace = query.asRef.targetNamespace;
            const targetPrivacyDomain = query.asRef.targetPrivacyDomain;
            const filters = [];
            objects.forEach((obj)=>{
                const op = query.asRef?.targetFilter(obj);
                if (!op) return;
                filters.push(op);
            });
            const queryAction = (0, $aAq0B.queryObjects)(targetNamespace, targetPrivacyDomain, {
                or: filters
            }, {
                hydrate: true
            });
            queryAction.txId = action.txId;
            yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)(queryAction);
            req = yield (0, $ea41bdbb61e4673e$export$71cec2538cb2c617)({
                success: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)((0, $aAq0B.QUERY_OBJECTS_SUCCESS)),
                failure: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)((0, $aAq0B.QUERY_OBJECTS_FAILURE))
            });
            if (req.failure) throw req.failure.err;
            objects = req.success.objects.filter((obj)=>"data" in obj);
            objects.forEach((obj)=>addResult(obj, targetNamespace, targetPrivacyDomain));
        }
    } catch (err) {
        const handled = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)((0, $5b496e0bedaa914a$export$c292eea0f5bcd4a4), err, action);
        if (handled) return;
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $2gkyY.SEARCH_OBJECT_REQUEST_FAILURE),
            txId: action.txId,
            err: err
        });
        return;
    }
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $2gkyY.SEARCH_OBJECT_REQUEST_SUCCESS),
        txId: action.txId,
        results: results
    });
}




var $54Psn = parcelRequire("54Psn");


var $cQJbh = parcelRequire("cQJbh");

var $3OncY = parcelRequire("3OncY");

var $2m6N8 = parcelRequire("2m6N8");

var $jxJwM = parcelRequire("jxJwM");
const $117d48d5de131aea$export$ca5a240534522856 = async (idToken, tenant)=>{
    const url = tenant !== undefined ? `${(0, $3OncY.Config).authzServerURL}/api/v1/tenants/${tenant}` : `${(0, $3OncY.Config).authzServerURL}/api/v1/tenants/`;
    return await (0, $2m6N8.fetchWithCredentials)(idToken, url, {
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    }).then(async (response)=>{
        const result = await response.json();
        (0, $jxJwM.assertResponse)(response, result);
        return result;
    }).then(function(response) {
        return response;
    });
};
const $117d48d5de131aea$export$d378638486bf61f2 = async (idToken, tenant, subject)=>{
    const url = `${(0, $3OncY.Config).authzServerURL}/api/v1/tenants/${tenant}/subjects/${subject}/roles`;
    return await (0, $2m6N8.fetchWithCredentials)(idToken, url, {
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    }).then(async (response)=>{
        const result = await response.json();
        (0, $jxJwM.assertResponse)(response, result);
        return result;
    }).then(function(response) {
        return response;
    });
};
const $117d48d5de131aea$export$9a6cf7aa6abc0293 = async (idToken, tenant, subject, role)=>{
    const url = `${(0, $3OncY.Config).authzServerURL}/api/v1/tenants/${tenant}/subjects/${subject}/roles`;
    return await (0, $2m6N8.fetchWithCredentials)(idToken, url, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            Add: [
                role
            ]
        })
    }).then(async (response)=>{
        const result = await response.json();
        (0, $jxJwM.assertResponse)(response, result);
        return result;
    }).then(function(response) {
        return response;
    });
};
const $117d48d5de131aea$export$d80d5f3df1e48b3a = async (idToken, tenant, subject, role)=>{
    const url = `${(0, $3OncY.Config).authzServerURL}/api/v1/tenants/${tenant}/subjects/${subject}/roles`;
    return await (0, $2m6N8.fetchWithCredentials)(idToken, url, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            Remove: [
                role
            ]
        })
    }).then(async (response)=>{
        const result = await response.json();
        (0, $jxJwM.assertResponse)(response, result);
        return result;
    }).then(function(response) {
        return response;
    });
};
const $117d48d5de131aea$export$3887a500f4effe7f = async (idToken, tenant)=>{
    const url = `${(0, $3OncY.Config).authzServerURL}/api/v1/session/tenant`;
    return await (0, $2m6N8.fetchWithCredentials)(idToken, url, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            tenant: tenant
        })
    }).then(async (response)=>{
        const result = await response.json();
        (0, $jxJwM.assertResponse)(response, result);
        return result;
    }).then(function(response) {
        return response;
    });
};


function* $dc8238234740fdf4$export$5780c4e999337024() {
    yield (0, $ea41bdbb61e4673e$export$3d8c2f653ac9d0b9)([
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $cQJbh.TENANTS_DATA_REQUEST), $dc8238234740fdf4$export$b7b14685de72151e),
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $cQJbh.TENANT_DATA_REQUEST), $dc8238234740fdf4$export$247dc729d04fe068),
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $cQJbh.GET_ROLE_REQUEST), $dc8238234740fdf4$export$58bacabd8027b66f),
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $cQJbh.ADD_ROLE_REQUEST), $dc8238234740fdf4$export$7aa27d973885f740),
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $cQJbh.REMOVE_ROLE_REQUEST), $dc8238234740fdf4$export$4a156073c3c8096e),
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $cQJbh.SWITCH_TENANT_REQUEST), $dc8238234740fdf4$export$f67befa34a9b60),
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $cQJbh.SWITCH_TENANT_REQUEST_SUCCESS), $dc8238234740fdf4$export$4e7bcd7bb66571a6)
    ]);
}
function* $dc8238234740fdf4$export$b7b14685de72151e(action) {
    const accessToken = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $54Psn.selectIdToken));
    let result;
    try {
        result = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)((0, $117d48d5de131aea$export$ca5a240534522856), accessToken);
    } catch (err) {
        const handled = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)((0, $5b496e0bedaa914a$export$c292eea0f5bcd4a4), err, action);
        if (handled) return;
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $cQJbh.TENANTS_DATA_REQUEST_FAILURE),
            err: err
        });
        return;
    }
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $cQJbh.TENANTS_DATA_REQUEST_SUCCESS),
        result: result
    });
}
function* $dc8238234740fdf4$export$247dc729d04fe068(action) {
    const tenant = action.tenant;
    const accessToken = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $54Psn.selectIdToken));
    let result;
    try {
        result = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)((0, $117d48d5de131aea$export$ca5a240534522856), accessToken, tenant);
    } catch (err) {
        const handled = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)((0, $5b496e0bedaa914a$export$c292eea0f5bcd4a4), err, action);
        if (handled) return;
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $cQJbh.TENANT_DATA_REQUEST_FAILURE),
            err: err
        });
        return;
    }
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $cQJbh.TENANT_DATA_REQUEST_SUCCESS),
        result: result
    });
}
function* $dc8238234740fdf4$export$58bacabd8027b66f(action) {
    const tenant = action.tenant;
    const subject = action.subject;
    const accessToken = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $54Psn.selectIdToken));
    let result;
    try {
        result = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)((0, $117d48d5de131aea$export$d378638486bf61f2), accessToken, tenant, subject);
    } catch (err) {
        const handled = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)((0, $5b496e0bedaa914a$export$c292eea0f5bcd4a4), err, action);
        if (handled) return;
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $cQJbh.GET_ROLE_REQUEST_FAILURE),
            err: err
        });
        return;
    }
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $cQJbh.GET_ROLE_REQUEST_SUCCESS),
        result: result,
        subject: subject
    });
}
function* $dc8238234740fdf4$export$4a156073c3c8096e(action) {
    const accessToken = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $54Psn.selectIdToken));
    const subject = action.subject;
    const role = action.role;
    const tenant = action.tenant;
    let result;
    try {
        result = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)((0, $117d48d5de131aea$export$d80d5f3df1e48b3a), accessToken, tenant, subject, role);
    } catch (err) {
        const handled = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)((0, $5b496e0bedaa914a$export$c292eea0f5bcd4a4), err, action);
        if (handled) return;
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $cQJbh.REMOVE_ROLE_REQUEST_FAILURE),
            err: err
        });
        return;
    }
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $cQJbh.REMOVE_ROLE_REQUEST_SUCCESS),
        result: result,
        tenant: tenant,
        subject: subject,
        role: role
    });
}
function* $dc8238234740fdf4$export$7aa27d973885f740(action) {
    const accessToken = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $54Psn.selectIdToken));
    const subject = action.subject;
    const role = action.role;
    const tenant = action.tenant;
    let result;
    try {
        result = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)((0, $117d48d5de131aea$export$9a6cf7aa6abc0293), accessToken, tenant, subject, role);
    } catch (err) {
        const handled = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)((0, $5b496e0bedaa914a$export$c292eea0f5bcd4a4), err, action);
        if (handled) return;
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $cQJbh.ADD_ROLE_REQUEST_FAILURE),
            err: err
        });
        return;
    }
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $cQJbh.ADD_ROLE_REQUEST_SUCCESS),
        result: result,
        tenant: tenant,
        subject: subject,
        role: role
    });
}
function* $dc8238234740fdf4$export$f67befa34a9b60(action) {
    const accessToken = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $54Psn.selectIdToken));
    const tenant = action.tenant;
    let result;
    try {
        result = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)((0, $117d48d5de131aea$export$3887a500f4effe7f), accessToken, tenant);
    } catch (err) {
        const handled = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)((0, $5b496e0bedaa914a$export$c292eea0f5bcd4a4), err, action);
        if (handled) return;
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $cQJbh.SWITCH_TENANT_REQUEST_FAILURE),
            err: err
        });
        return;
    }
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $cQJbh.SWITCH_TENANT_REQUEST_SUCCESS),
        result: result,
        tenant: tenant
    });
}
function $dc8238234740fdf4$export$4e7bcd7bb66571a6() {
    window.location.reload();
}




var $3OncY = parcelRequire("3OncY");

var $54Psn = parcelRequire("54Psn");

var $aLhwe = parcelRequire("aLhwe");

var $bVoO3 = parcelRequire("bVoO3");

var $2m6N8 = parcelRequire("2m6N8");
class $99fbc475bf6c4cd3$export$363589c02a1723ef {
    constructor(baseUrl, idToken){
        this.baseUrl = baseUrl;
        this.idToken = idToken;
        this.queryLogs = this.queryLogs.bind(this);
    }
    async queryLogs(options, filter) {
        let queryString = [];
        if (options?.offset !== undefined) queryString.push(`offset=${options.offset}`);
        if (options?.limit !== undefined) queryString.push(`limit=${options.limit}`);
        if (filter !== undefined) queryString.push(`filter=${encodeURIComponent(JSON.stringify(filter))}`);
        const url = `${this.baseUrl}/api/v1/audit?${queryString.join("&")}`;
        const res = await (0, $2m6N8.fetchWithCredentials)(this.idToken, url, {
            method: "GET"
        });
        if (res.status === 400) throw new (0, $bVoO3.InvalidRequestError)(res);
        if (res.status >= 500) throw new (0, $bVoO3.ServerError)(res);
        const result = await res.json();
        return result;
    }
}



function* $186cfbdb78c1b849$export$191c78fd1f55c48() {
    yield (0, $ea41bdbb61e4673e$export$3d8c2f653ac9d0b9)([
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $aLhwe.AUDIT_REQUEST), $186cfbdb78c1b849$export$e7ff3e9c720950ce)
    ]);
}
function* $186cfbdb78c1b849$export$e7ff3e9c720950ce(action) {
    const session = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $54Psn.selectSession));
    let result;
    const client = new (0, $99fbc475bf6c4cd3$export$363589c02a1723ef)((0, $3OncY.Config).authzServerURL, session.idToken);
    try {
        result = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)(client.queryLogs, action.options, action.filter);
    } catch (err) {
        const handled = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)((0, $5b496e0bedaa914a$export$c292eea0f5bcd4a4), err, action);
        if (handled) return;
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $aLhwe.AUDIT_REQUEST_FAILURE),
            err: err
        });
        return;
    }
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $aLhwe.AUDIT_REQUEST_SUCCESS),
        result: result
    });
}




var $kjFAP = parcelRequire("kjFAP");

var $3OncY = parcelRequire("3OncY");

var $2m6N8 = parcelRequire("2m6N8");

var $bVoO3 = parcelRequire("bVoO3");

var $54Psn = parcelRequire("54Psn");


var $1SG9b = parcelRequire("1SG9b");
function* $7be91130359c23b6$export$fd18071c517ba7ca() {
    yield (0, $ea41bdbb61e4673e$export$3d8c2f653ac9d0b9)([
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $kjFAP.CHECK_AUTHZ_REQUEST), $7be91130359c23b6$export$c8afa76e84b2d61c)
    ]);
}
function* $7be91130359c23b6$export$c8afa76e84b2d61c(action) {
    const authzAction = action.authzAction;
    const authzResource = action.authzResource;
    const idToken = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $54Psn.selectIdToken));
    let result;
    try {
        result = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)($7be91130359c23b6$var$checkRole, idToken, authzAction, authzResource);
    } catch (err) {
        const handled = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)((0, $5b496e0bedaa914a$export$c292eea0f5bcd4a4), err, action);
        if (handled) return;
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $1SG9b.forwardTx)(action, {
            type: (0, $kjFAP.CHECK_AUTHZ_REQUEST_FAILURE),
            err: err
        }));
        return;
    }
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $1SG9b.forwardTx)(action, {
        type: (0, $kjFAP.CHECK_AUTHZ_REQUEST_SUCCESS),
        result: result
    }));
}
const $7be91130359c23b6$var$checkRole = async (idToken, authzAction, authzResource)=>{
    const url = `${(0, $3OncY.Config).authzServerURL}/api/v1/check`;
    const res = await (0, $2m6N8.fetchWithCredentials)(idToken, url, {
        method: "POST",
        body: JSON.stringify({
            action: authzAction,
            resource: authzResource
        })
    });
    if (res.status === 400) throw new (0, $bVoO3.InvalidRequestError)(res);
    const result = await res.json();
    return {
        allowed: result.data.Result,
        authzAction: authzAction,
        authzResource: authzResource
    };
};




var $1zwHA = parcelRequire("1zwHA");

var $1SG9b = parcelRequire("1SG9b");

var $54Psn = parcelRequire("54Psn");

var $3OncY = parcelRequire("3OncY");

var $kpQdM = parcelRequire("kpQdM");

var $mRUi0 = parcelRequire("mRUi0");

var $5Jfnn = parcelRequire("5Jfnn");

var $dSjLu = parcelRequire("dSjLu");
function* $7cf2e6c5d41f0bc8$export$9b4b6fc2ea328ffb() {
    const runPipelineChannel = yield (0, $ea41bdbb61e4673e$export$3a6d5c9ae78a2c08)((0, $1zwHA.RUN_PIPELINE_REQUEST));
    while(true){
        const action = yield (0, $ea41bdbb61e4673e$export$61196ced6d74a310)(runPipelineChannel);
        yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)($7cf2e6c5d41f0bc8$var$runPipelineSaga, action);
    }
}
function* $7cf2e6c5d41f0bc8$var$runPipelineSaga(action) {
    const idToken = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $54Psn.selectIdToken));
    const client = new (0, $mRUi0.PipelineServerClient)((0, $3OncY.Config).pipelineServerURL, idToken);
    let pipelineRun;
    try {
        if (action.startMessage) yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $5Jfnn.addNotification)({
            status: (0, $dSjLu.NotificationStatus).info,
            message: action.startMessage
        }));
        const pipeline = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)(client.fetchPipelineByName, action.name);
        pipelineRun = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)(client.runPipeline, pipeline.ID, action.input);
        pipelineRun = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)(client.waitForRun, pipeline.ID, pipelineRun.ID);
        if (pipelineRun.State !== (0, $kpQdM.PipelineRunState).Success) throw new Error(`Unexpected pipeline run state '${(0, $kpQdM.getPipelineRuneStateLabel)(pipelineRun.State)}' !`);
    } catch (err) {
        const failure = {
            ...action,
            type: (0, $1zwHA.RUN_PIPELINE_FAILURE),
            pipelineRunId: pipelineRun?.ID ?? undefined,
            error: err
        };
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $1SG9b.forwardTx)(action, failure));
        if (action.errorMessage) yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $5Jfnn.addNotification)({
            status: (0, $dSjLu.NotificationStatus).error,
            message: action.errorMessage
        }));
        return;
    }
    const success = {
        ...action,
        type: (0, $1zwHA.RUN_PIPELINE_SUCCESS),
        pipelineRunId: pipelineRun?.ID
    };
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $1SG9b.forwardTx)(action, success));
    if (action.successMessage) yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $5Jfnn.addNotification)({
        status: (0, $dSjLu.NotificationStatus).success,
        message: action.successMessage
    }));
    return;
}




var $ksXGV = parcelRequire("ksXGV");

var $bmWbP = parcelRequire("bmWbP");

var $5Jfnn = parcelRequire("5Jfnn");

var $dSjLu = parcelRequire("dSjLu");

var $8mxDx = parcelRequire("8mxDx");

var $1chCp = parcelRequire("1chCp");
function* $b7b22715ffb14150$export$1caf205f5d983d56() {
    yield (0, $ea41bdbb61e4673e$export$3d8c2f653ac9d0b9)([
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $ksXGV.CONFIRM_CANCEL_EXAM), $b7b22715ffb14150$export$e7972b838d843d66),
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $ksXGV.MARK_EXAM_REDO), $b7b22715ffb14150$export$cd7c0e2129bab7ff)
    ]);
}
function* $b7b22715ffb14150$export$cd7c0e2129bab7ff(action) {
    try {
        const analysisRequestObjects = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $bmWbP.selectAnalysisRequestObjects));
        const analysisRequest = analysisRequestObjects.find((obj)=>(0, $1chCp.matchRef)(obj.data, action.analysisRequestRef));
        if (!analysisRequest) throw new Error(`Demande d'analyse '${action.analysisRequestRef.requestorSampleId}' introuvable !`);
        analysisRequest.data.types[action.analysisRequestCode] = (0, $8mxDx.AnalysisRequestState).RedoRequested;
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $ksXGV.updatePublicAnalysisRequest)(analysisRequest.id, analysisRequest.data));
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $5Jfnn.addNotification)({
            message: `Examen ${action.analysisRequestCode} du pr\xe9l\xe8vement ${analysisRequest.data.requestorSampleId} remis \xe0 refaire.`,
            status: (0, $dSjLu.NOTIFICATION_STATUS_SUCCESS)
        }));
    } catch (err) {
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $5Jfnn.addNotification)({
            message: `La remise \xe0 refaire de l'examen ${action.analysisRequestCode} a \xe9chou\xe9.`,
            status: (0, $dSjLu.NOTIFICATION_STATUS_ERROR)
        }));
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $ksXGV.MARK_EXAM_REDO_FAILURE),
            err: err
        });
        return;
    }
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $ksXGV.MARK_EXAM_REDO_SUCCESS)
    });
}
function* $b7b22715ffb14150$export$e7972b838d843d66(action) {
    try {
        const analysisRequestObjects = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $bmWbP.selectAnalysisRequestIndexedObjects));
        const cancelExams = action.cancelExams;
        const cancelExamKeys = Object.keys(cancelExams);
        for (const cancelExamKey of cancelExamKeys){
            const typesToDelete = cancelExams[cancelExamKey].type;
            for (const type of typesToDelete){
                delete analysisRequestObjects[cancelExamKey].data.types[type];
                yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $ksXGV.updatePublicAnalysisRequest)(analysisRequestObjects[cancelExamKey].id, analysisRequestObjects[cancelExamKey].data));
                yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $5Jfnn.addNotification)({
                    message: `Examen ${type} pour le num\xe9ro de pr\xe9l\xe8vement ${analysisRequestObjects[cancelExamKey].data.requestorSampleId} supprim\xe9s.`,
                    status: (0, $dSjLu.NOTIFICATION_STATUS_SUCCESS)
                }));
            }
        }
    } catch (err) {
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $ksXGV.CONFIRM_CANCEL_EXAM_FAILURE),
            err: err
        });
        return;
    }
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $ksXGV.CONFIRM_CANCEL_EXAM_SUCESS)
    });
}




var $3OncY = parcelRequire("3OncY");

var $54Psn = parcelRequire("54Psn");


var $1Jthw = parcelRequire("1Jthw");

var $9CNaS = parcelRequire("9CNaS");

var $dSjLu = parcelRequire("dSjLu");
const $c3a96f0ef93fb785$export$ee81138de0aef91d = "multiple-analysis";
const $c3a96f0ef93fb785$export$7297fd336d274547 = new Map([
    [
        $c3a96f0ef93fb785$export$ee81138de0aef91d,
        (event)=>({
                status: (0, $dSjLu.NOTIFICATION_STATUS_ERROR),
                message: `Sheila a \xe9t\xe9 dans l'impossibilit\xe9 d'identifier la demande \xe0 l'origine des r\xe9sultats retrouv\xe9s dans ${event?.data?.source}. Voir les notifications pour plus d'informations.`,
                detail: `ID: ${event.id}`
            })
    ]
]);
function $c3a96f0ef93fb785$export$91912c9d8e00ad51(eventType) {
    return $c3a96f0ef93fb785$export$7297fd336d274547.get(eventType);
}
function $c3a96f0ef93fb785$export$735c8dd2537e67df(event) {
    const factory = $c3a96f0ef93fb785$export$91912c9d8e00ad51(event.type);
    return factory ? factory(event) : null;
}
function $c3a96f0ef93fb785$export$25776c5268ffccb7(eventType, factory) {
    $c3a96f0ef93fb785$export$7297fd336d274547.set(eventType, factory);
}
function $c3a96f0ef93fb785$export$26c5cefda4ae9854(event) {
    return event.type === $c3a96f0ef93fb785$export$ee81138de0aef91d && event?.data?.legacyAmbiguity === true;
}
function $c3a96f0ef93fb785$export$8baea1a839b7ee69(events, notifiedSampleIds) {
    const ambiguous = events.filter($c3a96f0ef93fb785$export$26c5cefda4ae9854);
    if (ambiguous.length === 0) return null;
    // Un même prélèvement peut produire plusieurs événements (une classe, un
    // catalogue) : c'est bien un nombre de prélèvements qui est annoncé.
    const batchSampleIds = Array.from(new Set(ambiguous.map((event)=>event?.data?.sampleIndex).filter((sampleIndex)=>typeof sampleIndex === "string" && sampleIndex !== "")));
    const sampleIds = batchSampleIds.filter((sampleId)=>!notifiedSampleIds?.has(sampleId));
    // Tous les prélèvements du lot ont déjà été annoncés : rien de neuf à dire.
    if (batchSampleIds.length > 0 && sampleIds.length === 0) return null;
    sampleIds.forEach((sampleId)=>notifiedSampleIds?.add(sampleId));
    // Fallback historique quand aucun événement ne porte de numéro de
    // prélèvement : on compte les événements (déjà dédoublonnés par id en
    // amont), faute de mieux.
    const count = sampleIds.length > 0 ? sampleIds.length : ambiguous.length;
    return {
        status: (0, $dSjLu.NOTIFICATION_STATUS_INFO),
        message: `${count} pr\xe9l\xe8vement${count > 1 ? "s" : ""} non import\xe9${count > 1 ? "s" : ""}`,
        detail: sampleIds.length > 0 ? `N\xb0 de pr\xe9l\xe8vement : ${sampleIds.join(", ")}` : undefined
    };
}
function $c3a96f0ef93fb785$export$fd2b5f868e700628(events, notifiedSampleIds) {
    const notifications = [];
    for (const event of events){
        if ($c3a96f0ef93fb785$export$26c5cefda4ae9854(event)) continue;
        const notification = $c3a96f0ef93fb785$export$735c8dd2537e67df(event);
        if (notification) notifications.push(notification);
    }
    const aggregated = $c3a96f0ef93fb785$export$8baea1a839b7ee69(events, notifiedSampleIds);
    if (aggregated) notifications.push(aggregated);
    return notifications;
}



var $5Jfnn = parcelRequire("5Jfnn");
function* $cb60ede53fc5d9a1$export$d1d27484fd27faac() {
    yield (0, $ea41bdbb61e4673e$export$3d8c2f653ac9d0b9)([
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $1Jthw.EVENT_REQUEST), $cb60ede53fc5d9a1$export$dd8845938767afb3),
        (0, $1e1837559b2734c8$export$ca010cea618a298a)((0, $1Jthw.EVENT_POLLING_START), $cb60ede53fc5d9a1$export$30c28e92ed566a67)
    ]);
}
function* $cb60ede53fc5d9a1$export$dd8845938767afb3(action) {
    const session = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $54Psn.selectSession));
    let result;
    const client = new (0, $9CNaS.EventServerClient)((0, $3OncY.Config).eventServerURL, session.idToken);
    try {
        result = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)(client.fetchEvents, action.filter, action.options);
    } catch (error) {
        const handled = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)((0, $5b496e0bedaa914a$export$c292eea0f5bcd4a4), error, action);
        if (handled) return;
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $1Jthw.EVENT_REQUEST_FAILURE),
            txId: action.txId,
            error: error
        });
        return;
    }
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $1Jthw.EVENT_REQUEST_SUCCESS),
        txId: action.txId,
        reset: action.options?.reset,
        ...result
    });
}
function* $cb60ede53fc5d9a1$export$30c28e92ed566a67() {
    // Track which event IDs we've already notified about
    const notifiedEventIds = new Set();
    // Ticket #822 - Numéros de prélèvement déjà annoncés par une notification
    // « X prélèvements non importés » : les événements d'un même import peuvent
    // tomber sur plusieurs cycles de polling, on ne ré-annonce pas un
    // prélèvement déjà signalé.
    const notifiedLegacySampleIds = new Set();
    while(true){
        try {
            const session = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((0, $54Psn.selectSession));
            const lastViewedAt = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((state)=>state.events.lastViewedAt);
            const existingEventIds = Object.keys((yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((state)=>state.events.byId)));
            const client = new (0, $9CNaS.EventServerClient)((0, $3OncY.Config).eventServerURL, session.idToken);
            // Fetch events created after the last viewed timestamp
            const options = {
                limit: 100
            };
            if (lastViewedAt) options.after = lastViewedAt.toISOString();
            const result = yield (0, $ea41bdbb61e4673e$export$c4ce752e73470fba)(client.fetchEvents, undefined, options);
            // Find new events that we haven't seen or notified about
            const newEvents = result.events.filter((event)=>!existingEventIds.includes(event.id) && !notifiedEventIds.has(event.id));
            // Mark the whole batch as notified
            for (const event of newEvents)notifiedEventIds.add(event.id);
            // Create and dispatch notifications for new events. Le lot est traité en
            // bloc plutôt qu'événement par événement : certains types se regroupent
            // en un message unique (cf. "X prélèvements non importés", ticket #822).
            const notifications = (0, $c3a96f0ef93fb785$export$fd2b5f868e700628)(newEvents, notifiedLegacySampleIds);
            for (const notification of notifications)yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $5Jfnn.addNotification)(notification));
            yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
                type: (0, $1Jthw.EVENT_REQUEST_SUCCESS),
                ...result
            });
        } catch (error) {
            // Silently handle polling errors - we'll retry on next interval
            console.error("Event polling error:", error);
        }
        // Wait for the next polling interval or stop action
        const raceResult = yield (0, $ea41bdbb61e4673e$export$71cec2538cb2c617)({
            delay: (0, $ea41bdbb61e4673e$export$3722cfe417b6ed86)((0, $3OncY.Config).eventPollInterval * 1000),
            stopped: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)((0, $1Jthw.EVENT_POLLING_STOP))
        });
        if (raceResult.stopped) break;
    }
}




var $aAq0B = parcelRequire("aAq0B");

var $1zwHA = parcelRequire("1zwHA");
function* $e6abd374566586d9$export$eec980169f6ce9() {
    yield (0, $ea41bdbb61e4673e$export$3d8c2f653ac9d0b9)([
        // Re-exec the hla rule engine on modification of patient's variables
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((action)=>action.namespace === "hla-engine-variable-v1" && (action.type === (0, $aAq0B.UPDATE_OBJECT_SUCCESS) || action.type === (0, $aAq0B.CREATE_OBJECT_SUCCESS)), $e6abd374566586d9$var$runPatientRuleEngineFromHLAEngineVariable)
    ]);
}
function* $e6abd374566586d9$var$runPatientRuleEngineFromHLAEngineVariable(action) {
    const hlaEngineVariable = action.object;
    const inlogId = hlaEngineVariable?.data?.ref?.patient?.inlogId;
    if (!inlogId) return;
    yield $e6abd374566586d9$export$b537f2699739800a(inlogId);
}
function* $e6abd374566586d9$export$b537f2699739800a(inlogId) {
    let result;
    try {
        const input = {
            inlogId: inlogId
        };
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $1zwHA.runPipeline)("exec-rule-engine", input, {
            startMessage: `Le moteur de r\xe8gles a \xe9t\xe9 relanc\xe9 pour le patient '${inlogId}'...`,
            successMessage: `Le moteur de r\xe8gles a \xe9t\xe9 r\xe9ex\xe9cut\xe9 pour le patient '${inlogId}'.`,
            errorMessage: `Erreur lors de la r\xe9ex\xe9cution du moteur de r\xe8gles pour le patient '${inlogId}' !`
        }));
        result = yield (0, $ea41bdbb61e4673e$export$71cec2538cb2c617)({
            success: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)((action)=>action.type === (0, $1zwHA.RUN_PIPELINE_SUCCESS) && action.input === input),
            failure: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)((action)=>action.type === (0, $1zwHA.RUN_PIPELINE_FAILURE) && action.input === input)
        });
    } catch (err) {
        return;
    }
    if (result.failure) return;
}




var $8cFcE = parcelRequire("8cFcE");

var $9Eclr = parcelRequire("9Eclr");

var $dPdDj = parcelRequire("dPdDj");

var $aAq0B = parcelRequire("aAq0B");


var $8fy6i = parcelRequire("8fy6i");
function* $afbfb079054e0ce7$export$8bf88ef8899c92ed() {
    yield (0, $ea41bdbb61e4673e$export$3d8c2f653ac9d0b9)([
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $8cFcE.DISABLE_HLA_RESULT_REQUEST), $afbfb079054e0ce7$export$1b67fcaeb166dc94),
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $8cFcE.ENABLE_HLA_RESULT_REQUEST), $afbfb079054e0ce7$export$c228525780c21fd4),
        (0, $1e1837559b2734c8$export$ca010cea618a298a)((action)=>action.type === (0, $8cFcE.DISABLE_HLA_RESULT_SUCCESS) || action.type === (0, $8cFcE.ENABLE_HLA_RESULT_SUCCESS), $afbfb079054e0ce7$export$8211d37f6972d66b)
    ]);
}
function* $afbfb079054e0ce7$export$1b67fcaeb166dc94(action) {
    const inlogId = action.inlogId;
    const hlaResult = action.hlaResult;
    const hlaResultInactivations = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((state)=>(0, $9Eclr.selectPatientAndClassHLAResultInactivationObjects)(state, inlogId, hlaResult.class));
    const match = hlaResultInactivations.find((inactivation)=>{
        return (0, $8fy6i.areHLAResultRefEquals)(hlaResult, inactivation.data.ref.hlaResult);
    });
    let result = {};
    try {
        if (!match) {
            yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $aAq0B.createObject)((0, $8cFcE.HLA_RESULT_INACTIVATION_NAMESPACE), (0, $dPdDj.PrivacyDomain).Public, {
                ref: {
                    hlaResult: hlaResult,
                    patient: {
                        inlogId: inlogId
                    }
                },
                disabled: true
            }));
            result = yield (0, $ea41bdbb61e4673e$export$71cec2538cb2c617)({
                success: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)((action)=>action.type === (0, $aAq0B.CREATE_OBJECT_SUCCESS) && action.namespace === (0, $8cFcE.HLA_RESULT_INACTIVATION_NAMESPACE)),
                failure: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)((action)=>action.type === (0, $aAq0B.CREATE_OBJECT_FAILURE) && action.namespace === (0, $8cFcE.HLA_RESULT_INACTIVATION_NAMESPACE))
            });
        } else {
            yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $aAq0B.updateObject)((0, $8cFcE.HLA_RESULT_INACTIVATION_NAMESPACE), (0, $dPdDj.PrivacyDomain).Public, match.id, {
                disabled: true
            }, true));
            result = yield (0, $ea41bdbb61e4673e$export$71cec2538cb2c617)({
                success: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)((action)=>action.type === (0, $aAq0B.UPDATE_OBJECT_SUCCESS) && action.namespace === (0, $8cFcE.HLA_RESULT_INACTIVATION_NAMESPACE)),
                failure: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)((action)=>action.type === (0, $aAq0B.UPDATE_OBJECT_FAILURE) && action.namespace === (0, $8cFcE.HLA_RESULT_INACTIVATION_NAMESPACE))
            });
        }
    } catch (err) {
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $8cFcE.DISABLE_HLA_RESULT_FAILURE),
            txId: action.txId,
            hlaResult: hlaResult,
            inlogId: inlogId,
            error: err
        });
        return;
    }
    if (result.success) yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $8cFcE.DISABLE_HLA_RESULT_SUCCESS),
        txId: action.txId,
        hlaResult: hlaResult,
        inlogId: inlogId
    });
    else yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
        type: (0, $8cFcE.DISABLE_HLA_RESULT_FAILURE),
        txId: action.txId,
        hlaResult: hlaResult,
        inlogId: inlogId,
        error: result.failure?.error ?? new Error(`Could not disable hla result '${JSON.stringify(hlaResult)}' for patient '${inlogId}' !`)
    });
}
function* $afbfb079054e0ce7$export$c228525780c21fd4(action) {
    const inlogId = action.inlogId;
    const hlaResult = action.hlaResult;
    const hlaResultInactivations = yield (0, $ea41bdbb61e4673e$export$efca4cbe5dd06740)((state)=>(0, $9Eclr.selectPatientAndClassHLAResultInactivationObjects)(state, inlogId, hlaResult.class));
    const match = hlaResultInactivations.find((inactivation)=>{
        return (0, $8fy6i.areHLAResultRefEquals)(hlaResult, inactivation.data.ref.hlaResult);
    });
    if (!match) {
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $8cFcE.ENABLE_HLA_RESULT_SUCCESS),
            txId: action.txId,
            hlaResult: hlaResult,
            inlogId: inlogId
        });
        return;
    }
    let result = {};
    try {
        if (match) {
            yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $aAq0B.deleteObject)((0, $8cFcE.HLA_RESULT_INACTIVATION_NAMESPACE), (0, $dPdDj.PrivacyDomain).Public, match.id));
            result = yield (0, $ea41bdbb61e4673e$export$71cec2538cb2c617)({
                success: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)((action)=>action.type === (0, $aAq0B.DELETE_OBJECT_SUCCESS) && action.namespace === (0, $8cFcE.HLA_RESULT_INACTIVATION_NAMESPACE)),
                failure: (0, $ea41bdbb61e4673e$export$61196ced6d74a310)((action)=>action.type === (0, $aAq0B.DELETE_OBJECT_FAILURE) && action.namespace === (0, $8cFcE.HLA_RESULT_INACTIVATION_NAMESPACE))
            });
        }
    } catch (err) {
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $8cFcE.ENABLE_HLA_RESULT_FAILURE),
            txId: action.txId,
            hlaResult: hlaResult,
            inlogId: inlogId,
            error: err
        });
        return;
    }
    if (result.success) {
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $8cFcE.ENABLE_HLA_RESULT_SUCCESS),
            txId: action.txId,
            hlaResult: hlaResult,
            inlogId: inlogId
        });
        return;
    } else {
        yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)({
            type: (0, $8cFcE.ENABLE_HLA_RESULT_FAILURE),
            txId: action.txId,
            hlaResult: hlaResult,
            inlogId: inlogId,
            error: result.failure?.error ?? new Error(`Could not enable hla result '${JSON.stringify(hlaResult)}' for patient '${inlogId}' !`)
        });
        return;
    }
}
function* $afbfb079054e0ce7$export$8211d37f6972d66b(action) {
    const inlogId = action.inlogId;
    if (!inlogId) return;
    yield (0, $e6abd374566586d9$export$b537f2699739800a)(inlogId);
}




var $1zwHA = parcelRequire("1zwHA");

var $6pLjA = parcelRequire("6pLjA");

var $fVgcf = parcelRequire("fVgcf");
function* $2aa02ba6fff16504$export$b15451a8fc765f2d() {
    yield (0, $ea41bdbb61e4673e$export$3d8c2f653ac9d0b9)([
        // On "exec-rule-engine" pipeline success, automatically refresh patient hla data
        (0, $1e1837559b2734c8$export$ca010cea618a298a)((action)=>action.type === (0, $1zwHA.RUN_PIPELINE_SUCCESS) && action.name === "exec-rule-engine", $2aa02ba6fff16504$var$refresPatientHLAData)
    ]);
}
function* $2aa02ba6fff16504$var$refresPatientHLAData(action) {
    if (!action.input?.inlogId) return;
    const inlogId = action.input?.inlogId;
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $6pLjA.queryPatientHLAEngineResults)(inlogId));
    yield (0, $ea41bdbb61e4673e$export$dc98b0b04f4c7758)((0, $fVgcf.queryPatientHLASynthesis)(inlogId));
}




var $5Jfnn = parcelRequire("5Jfnn");

var $jPTl4 = parcelRequire("jPTl4");
function* $7ce4b66052df5153$export$3b3a1f44ff32d7da() {
    yield (0, $ea41bdbb61e4673e$export$3d8c2f653ac9d0b9)([
        (0, $1e1837559b2734c8$export$4e24be1e1c9d5c69)((0, $5Jfnn.ADD_NOTIFICATION), $7ce4b66052df5153$export$d8b42f389907c15c)
    ]);
}
function* $7ce4b66052df5153$export$d8b42f389907c15c(action) {
    const notification = action.notification;
    // Show desktop notification if enabled
    if (!(0, $jPTl4.isNotificationEnabled)()) return;
    (0, $jPTl4.showDesktopNotification)(notification);
}


function* $d4bd78bc3efd9ba4$export$2e2bcd8739ae039() {
    yield (0, $ea41bdbb61e4673e$export$3d8c2f653ac9d0b9)([
        // Aucun préchargement global au démarrage : la liste complète des patients
        // était chargée ici pour alimenter le sélecteur « Sélectionner un dossier »
        // de la page d'accueil, retiré depuis. Les écrans qui en ont besoin la
        // demandent eux-mêmes, et la palette de recherche interroge le serveur au
        // fil de la frappe.
        (0, $dee57c5cdb246743$export$69cdf029f4a41df6)(),
        (0, $f441bc348656247e$export$3fba891cce9bc0fc)(),
        (0, $c53002b6d2544f6a$export$ba167e6966f67fa3)(),
        (0, $c748ae4cb6ffe618$export$f38b7279d687b980)(),
        (0, $dc8238234740fdf4$export$5780c4e999337024)(),
        (0, $186cfbdb78c1b849$export$191c78fd1f55c48)(),
        (0, $7be91130359c23b6$export$fd18071c517ba7ca)(),
        (0, $7cf2e6c5d41f0bc8$export$9b4b6fc2ea328ffb)(),
        (0, $b7b22715ffb14150$export$1caf205f5d983d56)(),
        (0, $cb60ede53fc5d9a1$export$d1d27484fd27faac)(),
        (0, $d690996a07d9fe3a$export$ce39863be0b3f74c)(),
        (0, $e6abd374566586d9$export$eec980169f6ce9)(),
        (0, $afbfb079054e0ce7$export$8bf88ef8899c92ed)(),
        (0, $2aa02ba6fff16504$export$b15451a8fc765f2d)(),
        (0, $7ce4b66052df5153$export$3b3a1f44ff32d7da)()
    ]);
}


const $169071f093a0ffde$export$2baeafd31d835d40 = "CRISTAL_DATA_REQUEST";
const $169071f093a0ffde$export$27bcbe975c490e10 = "CRISTAL_DATA_SUCCESS";
const $169071f093a0ffde$export$338fcca83eb3c58f = "CRISTAL_DATA_FAILURE";
const $169071f093a0ffde$export$a63ec489c9b8f437 = "CRISTAL_HORIZONTAL_MAX_TOGGLE_REQUEST";
const $169071f093a0ffde$export$b9374dc1d1779436 = "CRISTAL_HORIZONTAL_MAX_TOGGLE_SUCCESS";
const $169071f093a0ffde$export$ce3ad0212db05822 = "CRISTAL_HORIZONTAL_MAX_TOGGLE_FAILURE";
function $169071f093a0ffde$export$e5f640ef93fb2141() {
    return {
        type: $169071f093a0ffde$export$2baeafd31d835d40
    };
}
function $169071f093a0ffde$export$32f1abe5377eb32e() {
    return {
        type: $169071f093a0ffde$export$a63ec489c9b8f437
    };
}


const $3715ec32cc4feaac$var$defaultState = {
    json: [
        {}
    ],
    horizontalMax: false
};
function $3715ec32cc4feaac$export$a2235b180452a76c(state = $3715ec32cc4feaac$var$defaultState, action) {
    switch(action.type){
        case 0, $169071f093a0ffde$export$27bcbe975c490e10:
            return $3715ec32cc4feaac$var$handleCristalDataSuccess(state, action);
        case 0, $169071f093a0ffde$export$b9374dc1d1779436:
            return $3715ec32cc4feaac$var$handleToggleHorizontalMaximizeSuccess(state, action);
    }
    return state;
}
function $3715ec32cc4feaac$var$handleCristalDataSuccess(state, action) {
    return {
        ...state,
        json: action.result
    };
}
function $3715ec32cc4feaac$var$handleToggleHorizontalMaximizeSuccess(state, action) {
    return {
        ...state,
        horizontalMax: !state.horizontalMax
    };
}


const $cabb8e605e595a42$export$3a371ef94c74ee0e = "FILTER_DATE_ADD";
const $cabb8e605e595a42$export$42488a55cf9e586f = "FILTER_DATE_REMOVE";
const $cabb8e605e595a42$export$8128d509daca5df1 = "FILTER_DATE_REMOVE_ALL";
function $cabb8e605e595a42$export$82ce9dde49299a38(date) {
    return {
        type: $cabb8e605e595a42$export$3a371ef94c74ee0e,
        date: date
    };
}
function $cabb8e605e595a42$export$a6c58029c7f29931(date) {
    return {
        type: $cabb8e605e595a42$export$42488a55cf9e586f,
        date: date
    };
}
function $cabb8e605e595a42$export$7f2c51a2daedb358() {
    return {
        type: $cabb8e605e595a42$export$8128d509daca5df1
    };
}


const $e848ddf179134b3f$var$defaultState = {
    dates: []
};
function $e848ddf179134b3f$export$5ee5ef6732e241a5(state = $e848ddf179134b3f$var$defaultState, action) {
    switch(action.type){
        case 0, $cabb8e605e595a42$export$3a371ef94c74ee0e:
            return $e848ddf179134b3f$var$handleFilterAddDate(state, action);
        case 0, $cabb8e605e595a42$export$42488a55cf9e586f:
            return $e848ddf179134b3f$var$handleFilterRemoveDate(state, action);
        case 0, $cabb8e605e595a42$export$8128d509daca5df1:
            return $e848ddf179134b3f$var$handleFilterRemoveAllDate(state, action);
    }
    return state;
}
function $e848ddf179134b3f$var$handleFilterAddDate(state, action) {
    return {
        ...state,
        dates: [
            ...state.dates,
            action.date
        ]
    };
}
function $e848ddf179134b3f$var$handleFilterRemoveDate(state, action) {
    return {
        ...state,
        dates: state.dates.filter((date)=>date !== action.date)
    };
}
function $e848ddf179134b3f$var$handleFilterRemoveAllDate(state, action) {
    return {
        ...state,
        dates: []
    };
}



const $c007e27a1066555d$var$defaultState = {
    series: []
};
function $c007e27a1066555d$export$34e44dfacc715642(state = $c007e27a1066555d$var$defaultState, action) {
    switch(action.type){
        case 0, $cabb8e605e595a42$export$3a371ef94c74ee0e:
            return $c007e27a1066555d$var$handleFilterAddDate(state, action);
        case 0, $cabb8e605e595a42$export$42488a55cf9e586f:
            return $c007e27a1066555d$var$handleFilterRemoveDate(state, action);
        case 0, $cabb8e605e595a42$export$8128d509daca5df1:
            return $c007e27a1066555d$var$handleFilterRemoveAllDate(state, action);
    }
    return state;
}
function $c007e27a1066555d$var$handleFilterAddDate(state, action) {
    return {
        ...state
    };
}
function $c007e27a1066555d$var$handleFilterRemoveDate(state, action) {
    return {
        ...state
    };
}
function $c007e27a1066555d$var$handleFilterRemoveAllDate(state, action) {
    return {
        ...state,
        series: []
    };
}



var $aLSdY = parcelRequire("aLSdY");

var $cQJbh = parcelRequire("cQJbh");
const $48d4298eec4b7d00$var$defaultState = {
    isLoggedIn: false,
    idToken: "",
    refreshToken: "",
    accessToken: "",
    user: null,
    patientsPreferences: {
        byInlogID: {}
    }
};
function $48d4298eec4b7d00$export$db1bad41120e7760(state = $48d4298eec4b7d00$var$defaultState, action) {
    switch(action.type){
        case 0, $aLSdY.USER_LOGIN_REQUEST_SUCCESS:
            return $48d4298eec4b7d00$var$handleClientLoginRequestSuccess(state, action);
        case 0, $aLSdY.USER_LOGIN_CHECK_SUCCESS:
            return $48d4298eec4b7d00$var$handleClientLoginCheckSuccess(state, action);
        case 0, $aLSdY.REFRESH_ACCESS_TOKEN_SUCCESS:
            return $48d4298eec4b7d00$var$handleRefreshAccessTokenSuccess(state, action);
        case 0, $aLSdY.REFRESH_ACCESS_TOKEN_FAILURE:
            return $48d4298eec4b7d00$var$handleRefreshAccessTokenFailure(state, action);
        case 0, $aLSdY.USER_LOGOUT_REQUEST_SUCCESS:
            return $48d4298eec4b7d00$var$handleClientLogoutSuccess(state, action);
        case 0, $aLSdY.USER_LOGIN_INFO_REQUEST_SUCCESS:
            return $48d4298eec4b7d00$var$handleLoginInfoSuccess(state, action);
        case 0, $cQJbh.SWITCH_TENANT_REQUEST_SUCCESS:
            return $48d4298eec4b7d00$var$switchTenantSucess(state, action);
    }
    return state;
}
function $48d4298eec4b7d00$var$handleClientLoginRequestSuccess(state, action) {
    return {
        ...state
    };
}
function $48d4298eec4b7d00$var$handleClientLogoutSuccess(state, action) {
    return {
        ...state,
        isLoggedIn: false,
        idToken: "",
        refreshToken: "",
        accessToken: "",
        user: null,
        patientsPreferences: {
            byInlogID: {}
        }
    };
}
function $48d4298eec4b7d00$var$handleClientLoginCheckSuccess(state, action) {
    return {
        ...state,
        isLoggedIn: action.result.isLoggedIn,
        idToken: action.result.idToken,
        accessToken: action.result.accessToken,
        refreshToken: action.result.refreshToken,
        user: action.result.user
    };
}
function $48d4298eec4b7d00$var$handleRefreshAccessTokenSuccess(state, action) {
    return {
        ...state,
        accessToken: action.accessToken,
        refreshToken: action.refreshToken
    };
}
function $48d4298eec4b7d00$var$handleRefreshAccessTokenFailure(state, action) {
    return {
        ...state,
        isLoggedIn: false,
        idToken: "",
        refreshToken: "",
        accessToken: "",
        user: null,
        patientsPreferences: {
            byInlogID: {}
        }
    };
}
function $48d4298eec4b7d00$var$handleLoginInfoSuccess(state, action) {
    const newState = {
        ...state
    };
    if (newState.user != null) {
        newState.user.roles = action.result.data.User.Roles;
        newState.user.subject = action.result.data.User.Subject;
        newState.user.username = action.result.data.User.Username;
        newState.user.tenant = action.result.data.Tenant;
    }
    return newState;
}
function $48d4298eec4b7d00$var$switchTenantSucess(state, action) {
    const newState = {
        ...state
    };
    if (newState.user != null) newState.user.tenant = action.tenant;
    return newState;
}


const $6d4c6336ebab7912$export$1b83270259bb0cf7 = "UI_TOGGLE_PROP";
function $6d4c6336ebab7912$export$9ca6f6f5e28d1739(prop) {
    return {
        type: $6d4c6336ebab7912$export$1b83270259bb0cf7,
        prop: prop
    };
}


const $da1175cc42823cca$var$defaultState = {
    patientCardFolded: false
};
function $da1175cc42823cca$export$95881ffef5b0c248(state = $da1175cc42823cca$var$defaultState, action) {
    switch(action.type){
        case 0, $6d4c6336ebab7912$export$1b83270259bb0cf7:
            return $da1175cc42823cca$var$handleTogglePropSuccess(state, action);
    }
    return state;
}
function $da1175cc42823cca$var$handleTogglePropSuccess(state, action) {
    return {
        ...state,
        [action.prop]: !state[action.prop]
    };
}



var $aAq0B = parcelRequire("aAq0B");

var $dPdDj = parcelRequire("dPdDj");

var $6zmIz = parcelRequire("6zmIz");

var $ksXGV = parcelRequire("ksXGV");

var $6pLjA = parcelRequire("6pLjA");
// Modify this to automatically create indexes
// for the different object collections.
const $9f1fb3f37447b067$var$indexes = {
    byNamespace: {
        [(0, $6zmIz.PATIENT_NAMESPACE)]: {
            byDomain: {
                [(0, $dPdDj.PrivacyDomain).Public]: [
                    "inlogId"
                ]
            }
        },
        [(0, $ksXGV.ANALYSIS_REAGENT_PROVIDER_NAMESPACE)]: {
            byDomain: {
                [(0, $dPdDj.PrivacyDomain).Public]: [
                    "code"
                ]
            }
        },
        [(0, $ksXGV.ANALYSIS_REQUEST_CODE_NAMESPACE)]: {
            byDomain: {
                [(0, $dPdDj.PrivacyDomain).Public]: [
                    "code"
                ]
            }
        },
        [(0, $6pLjA.HLA_ENGINE_RESULT_GROUP_NAMESPACE)]: {
            byDomain: {
                [(0, $dPdDj.PrivacyDomain).Public]: [
                    "code"
                ]
            }
        },
        [(0, $ksXGV.ANALYSIS_REQUEST_CATEGORY_NAMESPACE)]: {
            byDomain: {
                [(0, $dPdDj.PrivacyDomain).Public]: [
                    "code"
                ]
            }
        }
    }
};
const $9f1fb3f37447b067$var$defaultState = {
    byNamespace: {}
};
const $9f1fb3f37447b067$export$84712e2f3438ceda = (state = $9f1fb3f37447b067$var$defaultState, action)=>{
    switch(action.type){
        case 0, $aAq0B.FETCH_OBJECT_SUCCESS:
            return $9f1fb3f37447b067$var$updateIndexes($9f1fb3f37447b067$var$handleSingleObjectSuccess(state, action), action);
        case 0, $aAq0B.CREATE_OBJECT_SUCCESS:
            return $9f1fb3f37447b067$var$updateIndexes($9f1fb3f37447b067$var$handleSingleObjectSuccess(state, action), action);
        case 0, $aAq0B.UPDATE_OBJECT_SUCCESS:
            return $9f1fb3f37447b067$var$updateIndexes($9f1fb3f37447b067$var$handleSingleObjectSuccess(state, action), action);
        case 0, $aAq0B.QUERY_OBJECTS_SUCCESS:
            return $9f1fb3f37447b067$var$updateIndexes($9f1fb3f37447b067$var$handleQueryObjectsSuccess(state, action), action);
        case 0, $aAq0B.DELETE_OBJECT_SUCCESS:
            return $9f1fb3f37447b067$var$updateIndexes($9f1fb3f37447b067$var$handleDeleteObjectSuccess(state, action), action);
    }
    return state;
};
function $9f1fb3f37447b067$var$handleSingleObjectSuccess(state, action) {
    return {
        ...state,
        byNamespace: {
            ...state.byNamespace,
            [action.namespace]: {
                ...state.byNamespace[action.namespace],
                byDomain: {
                    ...state.byNamespace[action.namespace]?.byDomain,
                    [action.privacyDomain]: {
                        ...state.byNamespace[action.namespace]?.byDomain[action.privacyDomain],
                        byId: {
                            ...state.byNamespace[action.namespace]?.byDomain[action.privacyDomain]?.byId,
                            [action.object.id]: action.object
                        },
                        byAttr: {
                            ...state.byNamespace[action.namespace]?.byDomain[action.privacyDomain]?.byAttr
                        }
                    }
                }
            }
        }
    };
}
function $9f1fb3f37447b067$var$handleDeleteObjectSuccess(state, action) {
    const newState = {
        ...state,
        byNamespace: {
            ...state.byNamespace,
            [action.namespace]: {
                ...state.byNamespace[action.namespace],
                byDomain: {
                    ...state.byNamespace[action.namespace]?.byDomain,
                    [action.privacyDomain]: {
                        ...state.byNamespace[action.namespace]?.byDomain[action.privacyDomain],
                        byId: {
                            ...state.byNamespace[action.namespace]?.byDomain[action.privacyDomain]?.byId
                        }
                    }
                }
            }
        }
    };
    delete newState.byNamespace[action.namespace]?.byDomain[action.privacyDomain]?.byId[action.id];
    return newState;
}
function $9f1fb3f37447b067$var$handleQueryObjectsSuccess(state, action) {
    return {
        ...state,
        byNamespace: {
            ...state.byNamespace,
            [action.namespace]: {
                ...state.byNamespace[action.namespace],
                byDomain: {
                    ...state.byNamespace[action.namespace]?.byDomain,
                    [action.privacyDomain]: {
                        ...state.byNamespace[action.namespace]?.byDomain[action.privacyDomain],
                        byId: action.objects.reduce((byId, head)=>{
                            let obj = {
                                ...byId[head.id] ?? {},
                                ...head
                            };
                            byId[obj.id] = {
                                ...byId[obj.id] || {},
                                ...obj
                            };
                            return byId;
                        }, {
                            ...state.byNamespace[action.namespace]?.byDomain[action.privacyDomain]?.byId
                        }),
                        byAttr: {
                            ...state.byNamespace[action.namespace]?.byDomain[action.privacyDomain]?.byAttr
                        }
                    }
                }
            }
        }
    };
}
function $9f1fb3f37447b067$var$updateIndexes(state, action) {
    const toAdd = [];
    const toDelete = [];
    if ("object" in action && "data" in action.object) toAdd.push(action.object);
    else if ("objects" in action) action.objects.forEach((obj)=>{
        if (!("data" in obj)) return;
        toAdd.push(obj);
    });
    else if ("id" in action && "namespace" in action && "privacyDomain" in action) toDelete.push({
        namespace: action.namespace,
        privacyDomain: action.privacyDomain,
        id: action.id
    });
    toDelete.forEach((obj)=>{
        const byAttr = state.byNamespace[obj.namespace]?.byDomain[obj.privacyDomain]?.byAttr ?? {};
        Object.keys(byAttr).forEach((attr)=>{
            Object.keys(byAttr[attr]).forEach((key)=>{
                if (byAttr[attr][key] !== obj.id) return;
                delete byAttr[attr][key];
            });
        });
    });
    const attributes = $9f1fb3f37447b067$var$indexes.byNamespace[action.namespace]?.byDomain[action.privacyDomain];
    if (!attributes) return state;
    attributes.forEach((name)=>{
        state = {
            ...state,
            byNamespace: {
                ...state.byNamespace,
                [action.namespace]: {
                    ...state.byNamespace[action.namespace],
                    byDomain: {
                        ...state.byNamespace[action.namespace]?.byDomain,
                        [action.privacyDomain]: {
                            ...state.byNamespace[action.namespace]?.byDomain[action.privacyDomain],
                            byAttr: {
                                ...state.byNamespace[action.namespace]?.byDomain[action.privacyDomain]?.byAttr,
                                [name]: {
                                    ...(state.byNamespace[action.namespace]?.byDomain[action.privacyDomain]?.byAttr || {})[name]
                                }
                            }
                        }
                    }
                }
            }
        };
        toAdd.forEach((obj)=>{
            const value = obj.data[name];
            if (value === undefined) return;
            state = {
                ...state,
                byNamespace: {
                    ...state.byNamespace,
                    [action.namespace]: {
                        ...state.byNamespace[action.namespace],
                        byDomain: {
                            ...state.byNamespace[action.namespace]?.byDomain,
                            [action.privacyDomain]: {
                                ...state.byNamespace[action.namespace]?.byDomain[action.privacyDomain],
                                byAttr: {
                                    ...state.byNamespace[action.namespace]?.byDomain[action.privacyDomain]?.byAttr,
                                    [name]: {
                                        ...(state.byNamespace[action.namespace]?.byDomain[action.privacyDomain]?.byAttr || {})[name],
                                        [value]: obj.id
                                    }
                                }
                            }
                        }
                    }
                }
            };
        });
    });
    return state;
}



var $1SG9b = parcelRequire("1SG9b");
const $7a15c2ad53978b0a$var$defaultState = {
    byId: {}
};
function $7a15c2ad53978b0a$export$110001d7b9ada782(state = $7a15c2ad53978b0a$var$defaultState, action) {
    if (action.type === (0, $1SG9b.CLEAR_TRANSACTIONS)) return $7a15c2ad53978b0a$var$handleClearTransactions(state, action);
    if (action.txId === null) return state;
    if (/_REQUEST$/g.test(action.type)) return $7a15c2ad53978b0a$var$handleTransactionRequest(state, action);
    else if (/_SUCCESS$/g.test(action.type)) return $7a15c2ad53978b0a$var$handleTransactionSuccess(state, action);
    else if (/_FAILURE$/g.test(action.type)) return $7a15c2ad53978b0a$var$handleTransactionFailure(state, action);
    return state;
}
function $7a15c2ad53978b0a$var$handleTransactionRequest(state, action) {
    return {
        ...state,
        byId: {
            ...state.byId,
            [action.txId]: {
                loading: true,
                started: true,
                done: false,
                errors: undefined,
                results: undefined
            }
        }
    };
}
function $7a15c2ad53978b0a$var$handleTransactionSuccess(state, action) {
    return {
        ...state,
        byId: {
            ...state.byId,
            [action.txId]: {
                loading: false,
                started: true,
                done: true,
                errors: undefined,
                results: Array.isArray(state.byId[action.txId]?.results) ? [
                    ...state.byId[action.txId]?.results ?? [],
                    action
                ] : [
                    action
                ]
            }
        }
    };
}
function $7a15c2ad53978b0a$var$handleTransactionFailure(state, action) {
    return {
        ...state,
        byId: {
            ...state.byId,
            [action.txId]: {
                loading: false,
                started: true,
                done: true,
                results: undefined,
                errors: Array.isArray(state.byId[action.txId]?.errors) ? [
                    ...state.byId[action.txId]?.errors ?? [],
                    action.error
                ] : [
                    action.error
                ]
            }
        }
    };
}
function $7a15c2ad53978b0a$var$handleClearTransactions(state, action) {
    const newState = {
        ...state,
        byId: {
            ...state.byId
        }
    };
    action.txIds.forEach((txId)=>{
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete newState.byId[txId];
    });
    return newState;
}



var $5Jfnn = parcelRequire("5Jfnn");
const $be9d7cbad269f7a4$var$defaultState = {
    byId: {}
};
function $be9d7cbad269f7a4$export$1e8c7d75bf62e791(state = $be9d7cbad269f7a4$var$defaultState, action) {
    switch(action.type){
        case 0, $5Jfnn.ADD_NOTIFICATION:
            return $be9d7cbad269f7a4$var$handleAddNotification(state, action);
        case 0, $5Jfnn.REMOVE_NOTIFICATION:
            return $be9d7cbad269f7a4$var$handleRemoveNotification(state, action);
    }
    return state;
}
function $be9d7cbad269f7a4$var$handleAddNotification(state, action) {
    const notification = action.notification;
    const date = new Date();
    notification.date = date;
    notification.id = date.getTime();
    return {
        ...state,
        byId: {
            ...state.byId,
            [notification.id]: notification
        }
    };
}
function $be9d7cbad269f7a4$var$handleRemoveNotification(state, action) {
    const newState = {
        ...state,
        byId: {
            ...state.byId
        }
    };
    delete newState.byId[action.notificationId];
    return newState;
}



var $2gkyY = parcelRequire("2gkyY");
const $e5a2412188bc1252$var$defaultState = {
    results: undefined
};
function $e5a2412188bc1252$export$2b7921d28693b007(state = $e5a2412188bc1252$var$defaultState, action) {
    switch(action.type){
        case 0, $2gkyY.SEARCH_OBJECT_REQUEST_SUCCESS:
            return $e5a2412188bc1252$var$handleSearchObjectRequestSuccess(state, action);
        case 0, $2gkyY.RESET_SEARCH_RESULTS:
            return $e5a2412188bc1252$var$handleResetSearchResults(state, action);
    }
    return state;
}
function $e5a2412188bc1252$var$handleSearchObjectRequestSuccess(state, action) {
    const newState = {
        ...state
    };
    newState.results = action.results;
    return newState;
}
function $e5a2412188bc1252$var$handleResetSearchResults(state, action) {
    const newState = {
        ...state
    };
    newState.results = undefined;
    return newState;
}



var $cQJbh = parcelRequire("cQJbh");
const $f85b5c8ad9ac0aa0$var$defaultState = {
    byName: {},
    users: {},
    roleByUser: {}
};
function $f85b5c8ad9ac0aa0$export$de16e6555c480509(state = $f85b5c8ad9ac0aa0$var$defaultState, action) {
    switch(action.type){
        case 0, $cQJbh.TENANTS_DATA_REQUEST_SUCCESS:
            return $f85b5c8ad9ac0aa0$var$handleTenantsList(state, action);
        case 0, $cQJbh.TENANT_DATA_REQUEST_SUCCESS:
            return $f85b5c8ad9ac0aa0$var$handleTenant(state, action);
        case 0, $cQJbh.GET_ROLE_REQUEST_SUCCESS:
            return $f85b5c8ad9ac0aa0$var$handleRole(state, action);
        case 0, $cQJbh.ADD_ROLE_REQUEST_SUCCESS:
            return $f85b5c8ad9ac0aa0$var$handleRole(state, action);
        case 0, $cQJbh.REMOVE_ROLE_REQUEST_SUCCESS:
            return $f85b5c8ad9ac0aa0$var$handleRole(state, action);
    }
    return state;
}
function $f85b5c8ad9ac0aa0$var$handleTenantsList(state, action) {
    const tenantsResult = action.result.data.Tenants;
    const tenants = {};
    tenantsResult.forEach((tenant)=>{
        tenants[tenant.Name] = {
            Name: tenant.Name,
            Title: tenant.Title
        };
    });
    return {
        ...state,
        byName: tenants
    };
}
function $f85b5c8ad9ac0aa0$var$handleTenant(state, action) {
    const tenant = action.result.data.Tenant;
    const newState = {
        ...state
    };
    newState.users[tenant.Name] = {
        Subjects: tenant.Subjects
    };
    return newState;
}
function $f85b5c8ad9ac0aa0$var$handleRole(state, action) {
    const newState = {
        ...state
    };
    newState.roleByUser[action.subject] = action.result.data.Roles;
    return newState;
}



var $aLhwe = parcelRequire("aLhwe");
const $2896446c5ef18b0c$var$defaultState = {
    byId: {},
    total: 0
};
function $2896446c5ef18b0c$export$652cbc36395e06ca(state = $2896446c5ef18b0c$var$defaultState, action) {
    switch(action.type){
        case 0, $aLhwe.AUDIT_REQUEST_SUCCESS:
            return $2896446c5ef18b0c$var$handleAuditLog(state, action);
    }
    return state;
}
function $2896446c5ef18b0c$var$handleAuditLog(state, action) {
    const result = action.result.data;
    const logsResult = result.Decisions;
    const logs = {};
    logsResult.forEach((log)=>{
        logs[log.ID] = log;
    });
    return {
        ...state,
        byId: logs,
        total: result.Total
    };
}



var $kjFAP = parcelRequire("kjFAP");
const $e649bf3f4d594284$var$defaultState = {
    byModules: {}
};
function $e649bf3f4d594284$export$c13eaac1a0856ed2(state = $e649bf3f4d594284$var$defaultState, action) {
    switch(action.type){
        case 0, $kjFAP.CHECK_AUTHZ_REQUEST_SUCCESS:
            return $e649bf3f4d594284$var$handleCheckAuthzSuccess(state, action);
    }
    return state;
}
function $e649bf3f4d594284$var$handleCheckAuthzSuccess(state, action) {
    const newState = {
        ...state
    };
    const module = {
        ...newState.byModules[action.result.authzResource.kind]
    };
    module[action.result.authzAction] = {
        ...module[action.result.authzAction],
        [action.result.authzResource.id]: action.result.allowed
    };
    newState.byModules[action.result.authzResource.kind] = module;
    return newState;
}



var $1Jthw = parcelRequire("1Jthw");
const $f55656f8e8b24f4c$var$LAST_VIEWED_STORAGE_KEY = "timeline_last_viewed_at";
function $f55656f8e8b24f4c$var$getLastViewedFromStorage() {
    const stored = localStorage.getItem($f55656f8e8b24f4c$var$LAST_VIEWED_STORAGE_KEY);
    if (stored) return new Date(stored);
    return null;
}
const $f55656f8e8b24f4c$var$defaultState = {
    total: 0,
    byId: {},
    lastViewedAt: $f55656f8e8b24f4c$var$getLastViewedFromStorage(),
    isPolling: false
};
function $f55656f8e8b24f4c$export$f08a7b1176f2bc95(state = $f55656f8e8b24f4c$var$defaultState, action) {
    switch(action.type){
        case 0, $1Jthw.EVENT_REQUEST_SUCCESS:
            return $f55656f8e8b24f4c$var$handleRequestSucess(state, action);
        case 0, $1Jthw.EVENT_MARK_VIEWED:
            return $f55656f8e8b24f4c$var$handleMarkViewed(state, action);
        default:
            return state;
    }
}
function $f55656f8e8b24f4c$var$handleRequestSucess(state, action) {
    const events = action.events;
    // Merge new events with existing ones (for polling support)
    const newIndexedEvents = [
        ...events
    ].reduce((acc, event)=>{
        acc[event.id] = event;
        return acc;
    }, {});
    return {
        ...state,
        total: action.total,
        byId: {
            ...action.reset ? {} : state.byId,
            ...newIndexedEvents // Add/overwrite with new events
        }
    };
}
function $f55656f8e8b24f4c$var$handleMarkViewed(state, action) {
    const sorted = Object.values(state.byId).sort((e1, e2)=>e2.createdAt.getTime() - e1.createdAt.getTime());
    if (sorted.length === 0) return state;
    localStorage.setItem($f55656f8e8b24f4c$var$LAST_VIEWED_STORAGE_KEY, sorted[0].createdAt.toISOString());
    return {
        ...state,
        lastViewedAt: sorted[0].createdAt
    };
}


var $ddb1ed18d1f52d55$export$2e2bcd8739ae039 = {
    cristalData: (0, $3715ec32cc4feaac$export$a2235b180452a76c),
    filters: (0, $e848ddf179134b3f$export$5ee5ef6732e241a5),
    histogramSeries: (0, $c007e27a1066555d$export$34e44dfacc715642),
    ui: (0, $da1175cc42823cca$export$95881ffef5b0c248),
    session: (0, $48d4298eec4b7d00$export$db1bad41120e7760),
    objects: (0, $9f1fb3f37447b067$export$84712e2f3438ceda),
    transactions: (0, $7a15c2ad53978b0a$export$110001d7b9ada782),
    notifications: (0, $be9d7cbad269f7a4$export$1e8c7d75bf62e791),
    search: (0, $e5a2412188bc1252$export$2b7921d28693b007),
    tenants: (0, $f85b5c8ad9ac0aa0$export$de16e6555c480509),
    audit: (0, $2896446c5ef18b0c$export$652cbc36395e06ca),
    authz: (0, $e649bf3f4d594284$export$c13eaac1a0856ed2),
    events: (0, $f55656f8e8b24f4c$export$f08a7b1176f2bc95)
};


const $f1d9f8eb4f980839$export$4fba1bc89ad9e04d = (store)=>(next)=>(action)=>{
            if (!Array.isArray(action)) return next(action);
            return action.map((a)=>store.dispatch(a));
        };



var $kQ0sT = parcelRequire("kQ0sT");
var $l1oVX = parcelRequire("l1oVX");
var $kGYVh = parcelRequire("kGYVh");
const $c0d6a2270452487f$var$ACTION_BREADCRUMB_CATEGORY = "redux.action";
const $c0d6a2270452487f$var$ACTION_BREADCRUMB_TYPE = "info";
const $c0d6a2270452487f$var$defaultOptions = {
    attachReduxState: true,
    actionTransformer: (action)=>action,
    stateTransformer: (state)=>state || null
};
/**
 * Creates an enhancer that would be passed to Redux's createStore to log actions and the latest state to Sentry.
 *
 * @param enhancerOptions Options to pass to the enhancer
 */ function $c0d6a2270452487f$export$c4506dd2040faa8a(enhancerOptions) {
    // Note: We return an any type as to not have type conflicts.
    const options = {
        ...$c0d6a2270452487f$var$defaultOptions,
        ...enhancerOptions
    };
    return (next)=>(reducer, initialState)=>{
            options.attachReduxState && (0, $kGYVh.getGlobalScope)().addEventProcessor((event, hint)=>{
                try {
                    // @ts-expect-error try catch to reduce bundle size
                    if (event.type === undefined && event.contexts.state.state.type === "redux") hint.attachments = [
                        ...hint.attachments || [],
                        // @ts-expect-error try catch to reduce bundle size
                        {
                            filename: "redux_state.json",
                            data: JSON.stringify(event.contexts.state.state.value)
                        }
                    ];
                } catch (_) {
                // empty
                }
                return event;
            });
            const sentryReducer = (state, action)=>{
                const newState = reducer(state, action);
                const scope = (0, $kGYVh.getCurrentScope)();
                /* Action breadcrumbs */ const transformedAction = options.actionTransformer(action);
                if (typeof transformedAction !== "undefined" && transformedAction !== null) (0, $4d76c9d78abc3a9e$export$efda9a273d7a036d)({
                    category: $c0d6a2270452487f$var$ACTION_BREADCRUMB_CATEGORY,
                    data: transformedAction,
                    type: $c0d6a2270452487f$var$ACTION_BREADCRUMB_TYPE
                });
                /* Set latest state to scope */ const transformedState = options.stateTransformer(newState);
                if (typeof transformedState !== "undefined" && transformedState !== null) {
                    const client = (0, $kGYVh.getClient)();
                    const options = client && client.getOptions();
                    const normalizationDepth = options && options.normalizeDepth || 3; // default state normalization depth to 3
                    // Set the normalization depth of the redux state to the configured `normalizeDepth` option or a sane number as a fallback
                    const newStateContext = {
                        state: {
                            type: "redux",
                            value: transformedState
                        }
                    };
                    (0, $l1oVX.addNonEnumerableProperty)(newStateContext, "__sentry_override_normalization_depth__", 3 + // 3 layers for `state.value.transformedState`
                    normalizationDepth);
                    scope.setContext("state", newStateContext);
                } else scope.setContext("state", null);
                /* Allow user to configure scope with latest state */ const { configureScopeWithState: configureScopeWithState } = options;
                if (typeof configureScopeWithState === "function") configureScopeWithState(scope, newState);
                return newState;
            };
            return next(sentryReducer, initialState);
        };
}


var $dc4a47ea750d5f98$export$711117ad6ad27992 = "persist:";
var $dc4a47ea750d5f98$export$2aaee4793dd13a52 = "persist/FLUSH";
var $dc4a47ea750d5f98$export$1647ef958242c4e2 = "persist/REHYDRATE";
var $dc4a47ea750d5f98$export$dd1033c27a16bbd3 = "persist/PAUSE";
var $dc4a47ea750d5f98$export$913fe0e161ed92a2 = "persist/PERSIST";
var $dc4a47ea750d5f98$export$5514fc3b4067675f = "persist/PURGE";
var $dc4a47ea750d5f98$export$51e82cdd7353a0e1 = "persist/REGISTER";
var $dc4a47ea750d5f98$export$363ebe89e6e7aeef = -1;


function $2df6cf986f188332$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2df6cf986f188332$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $2df6cf986f188332$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2df6cf986f188332$var$_typeof(obj);
}
function $2df6cf986f188332$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2df6cf986f188332$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2df6cf986f188332$var$ownKeys(source, true).forEach(function(key) {
            $2df6cf986f188332$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2df6cf986f188332$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2df6cf986f188332$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2df6cf986f188332$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $2df6cf986f188332$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $2df6cf986f188332$var$_typeof(inboundState) === "object") Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === "_persist") return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
         // otherwise hard set the new value
        newState[key] = inboundState[key];
    });
    return newState;
}



function $a17e9ce2c74bd9e8$export$2e2bcd8739ae039(config) {
    // defaults
    var blacklist = config.blacklist || null;
    var whitelist = config.whitelist || null;
    var transforms = config.transforms || [];
    var throttle = config.throttle || 0;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $dc4a47ea750d5f98$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var serialize;
    if (config.serialize === false) serialize = function serialize(x) {
        return x;
    };
    else if (typeof config.serialize === "function") serialize = config.serialize;
    else serialize = $a17e9ce2c74bd9e8$var$defaultSerialize;
    var writeFailHandler = config.writeFailHandler || null; // initialize stateful values
    var lastState = {};
    var stagedState = {};
    var keysToProcess = [];
    var timeIterator = null;
    var writePromise = null;
    var update = function update(state) {
        // add any changed keys to the queue
        Object.keys(state).forEach(function(key) {
            if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
            if (lastState[key] === state[key]) return; // value unchanged? noop
            if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
            keysToProcess.push(key); // add key to queue
        }); //if any key is missing in the new state which was present in the lastState,
        //add it for processing too
        Object.keys(lastState).forEach(function(key) {
            if (state[key] === undefined && passWhitelistBlacklist(key) && keysToProcess.indexOf(key) === -1 && lastState[key] !== undefined) keysToProcess.push(key);
        }); // start the time iterator if not running (read: throttle)
        if (timeIterator === null) timeIterator = setInterval(processNextKey, throttle);
        lastState = state;
    };
    function processNextKey() {
        if (keysToProcess.length === 0) {
            if (timeIterator) clearInterval(timeIterator);
            timeIterator = null;
            return;
        }
        var key = keysToProcess.shift();
        var endState = transforms.reduce(function(subState, transformer) {
            return transformer.in(subState, key, lastState);
        }, lastState[key]);
        if (endState !== undefined) try {
            stagedState[key] = serialize(endState);
        } catch (err) {
            console.error("redux-persist/createPersistoid: error serializing state", err);
        }
        else //if the endState is undefined, no need to persist the existing serialized content
        delete stagedState[key];
        if (keysToProcess.length === 0) writeStagedState();
    }
    function writeStagedState() {
        // cleanup any removed keys just before write.
        Object.keys(stagedState).forEach(function(key) {
            if (lastState[key] === undefined) delete stagedState[key];
        });
        writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
    }
    function passWhitelistBlacklist(key) {
        if (whitelist && whitelist.indexOf(key) === -1 && key !== "_persist") return false;
        if (blacklist && blacklist.indexOf(key) !== -1) return false;
        return true;
    }
    function onWriteFail(err) {
        // @TODO add fail handlers (typically storage full)
        if (writeFailHandler) writeFailHandler(err);
    }
    var flush = function flush() {
        while(keysToProcess.length !== 0)processNextKey();
        return writePromise || Promise.resolve();
    }; // return `persistoid`
    return {
        update: update,
        flush: flush
    };
} // @NOTE in the future this may be exposed via config
function $a17e9ce2c74bd9e8$var$defaultSerialize(data) {
    return JSON.stringify(data);
}



function $0a2c0a3a61a7a1b9$export$2e2bcd8739ae039(config) {
    var transforms = config.transforms || [];
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $dc4a47ea750d5f98$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var debug = config.debug;
    var deserialize;
    if (config.deserialize === false) deserialize = function deserialize(x) {
        return x;
    };
    else if (typeof config.deserialize === "function") deserialize = config.deserialize;
    else deserialize = $0a2c0a3a61a7a1b9$var$defaultDeserialize;
    return storage.getItem(storageKey).then(function(serialized) {
        if (!serialized) return undefined;
        else try {
            var state = {};
            var rawState = deserialize(serialized);
            Object.keys(rawState).forEach(function(key) {
                state[key] = transforms.reduceRight(function(subState, transformer) {
                    return transformer.out(subState, key, rawState);
                }, deserialize(rawState[key]));
            });
            return state;
        } catch (err) {
            throw err;
        }
    });
}
function $0a2c0a3a61a7a1b9$var$defaultDeserialize(serial) {
    return JSON.parse(serial);
}



function $4db55e14b5a1f785$export$2e2bcd8739ae039(config) {
    var storage = config.storage;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $dc4a47ea750d5f98$export$711117ad6ad27992)).concat(config.key);
    return storage.removeItem(storageKey, $4db55e14b5a1f785$var$warnIfRemoveError);
}
function $4db55e14b5a1f785$var$warnIfRemoveError(err) {}


function $73e435e2fc216b6c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $73e435e2fc216b6c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $73e435e2fc216b6c$var$ownKeys(source, true).forEach(function(key) {
            $73e435e2fc216b6c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $73e435e2fc216b6c$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $73e435e2fc216b6c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $73e435e2fc216b6c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $73e435e2fc216b6c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $73e435e2fc216b6c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $73e435e2fc216b6c$var$DEFAULT_TIMEOUT = 5000;
function $73e435e2fc216b6c$export$2e2bcd8739ae039(config, baseReducer) {
    var version = config.version !== undefined ? config.version : (0, $dc4a47ea750d5f98$export$363ebe89e6e7aeef);
    var debug = config.debug || false;
    var stateReconciler = config.stateReconciler === undefined ? (0, $2df6cf986f188332$export$2e2bcd8739ae039) : config.stateReconciler;
    var getStoredState = config.getStoredState || (0, $0a2c0a3a61a7a1b9$export$2e2bcd8739ae039);
    var timeout = config.timeout !== undefined ? config.timeout : $73e435e2fc216b6c$var$DEFAULT_TIMEOUT;
    var _persistoid = null;
    var _purge = false;
    var _paused = true;
    var conditionalUpdate = function conditionalUpdate(state) {
        // update the persistoid only if we are rehydrated and not paused
        state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
        return state;
    };
    return function(state, action) {
        var _ref = state || {}, _persist = _ref._persist, rest = $73e435e2fc216b6c$var$_objectWithoutProperties(_ref, [
            "_persist"
        ]); // $FlowIgnore need to update State type
        var restState = rest;
        if (action.type === (0, $dc4a47ea750d5f98$export$913fe0e161ed92a2)) {
            var _sealed = false;
            var _rehydrate = function _rehydrate(payload, err) {
                if (!_sealed) {
                    action.rehydrate(config.key, payload, err);
                    _sealed = true;
                }
            };
            timeout && setTimeout(function() {
                !_sealed && _rehydrate(undefined, new Error('redux-persist: persist timed out for persist key "'.concat(config.key, '"')));
            }, timeout); // @NOTE PERSIST resumes if paused.
            _paused = false; // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
            if (!_persistoid) _persistoid = (0, $a17e9ce2c74bd9e8$export$2e2bcd8739ae039)(config); // @NOTE PERSIST can be called multiple times, noop after the first
            if (_persist) // We still need to call the base reducer because there might be nested
            // uses of persistReducer which need to be aware of the PERSIST action
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
            if (typeof action.rehydrate !== "function" || typeof action.register !== "function") throw new Error("redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.");
            action.register(config.key);
            getStoredState(config).then(function(restoredState) {
                var migrate = config.migrate || function(s, v) {
                    return Promise.resolve(s);
                };
                migrate(restoredState, version).then(function(migratedState) {
                    _rehydrate(migratedState);
                }, function(migrateErr) {
                    _rehydrate(undefined, migrateErr);
                });
            }, function(err) {
                _rehydrate(undefined, err);
            });
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: {
                    version: version,
                    rehydrated: false
                }
            });
        } else if (action.type === (0, $dc4a47ea750d5f98$export$5514fc3b4067675f)) {
            _purge = true;
            action.result((0, $4db55e14b5a1f785$export$2e2bcd8739ae039)(config));
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $dc4a47ea750d5f98$export$2aaee4793dd13a52)) {
            action.result(_persistoid && _persistoid.flush());
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $dc4a47ea750d5f98$export$dd1033c27a16bbd3)) _paused = true;
        else if (action.type === (0, $dc4a47ea750d5f98$export$1647ef958242c4e2)) {
            // noop on restState if purging
            if (_purge) return $73e435e2fc216b6c$var$_objectSpread({}, restState, {
                _persist: $73e435e2fc216b6c$var$_objectSpread({}, _persist, {
                    rehydrated: true
                }) // @NOTE if key does not match, will continue to default else below
            });
            if (action.key === config.key) {
                var reducedState = baseReducer(restState, action);
                var inboundState = action.payload; // only reconcile state if stateReconciler and inboundState are both defined
                var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;
                var _newState = $73e435e2fc216b6c$var$_objectSpread({}, reconciledRest, {
                    _persist: $73e435e2fc216b6c$var$_objectSpread({}, _persist, {
                        rehydrated: true
                    })
                });
                return conditionalUpdate(_newState);
            }
        } // if we have not already handled PERSIST, straight passthrough
        if (!_persist) return baseReducer(state, action); // run base reducer:
        // is state modified ? return original : return updated
        var newState = baseReducer(restState, action);
        if (newState === restState) return state;
        return conditionalUpdate($73e435e2fc216b6c$var$_objectSpread({}, newState, {
            _persist: _persist
        }));
    };
}



var $eShmq = parcelRequire("eShmq");

function $792f2290643e73f9$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $792f2290643e73f9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $792f2290643e73f9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $792f2290643e73f9$var$_typeof(obj);
}
function $792f2290643e73f9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $792f2290643e73f9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $792f2290643e73f9$var$ownKeys(source, true).forEach(function(key) {
            $792f2290643e73f9$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $792f2290643e73f9$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $792f2290643e73f9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $792f2290643e73f9$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $792f2290643e73f9$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $792f2290643e73f9$var$_typeof(inboundState) === "object") Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === "_persist") return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
        if ($792f2290643e73f9$var$isPlainEnoughObject(reducedState[key])) {
            // if object is plain enough shallow merge the new values (hence "Level2")
            newState[key] = $792f2290643e73f9$var$_objectSpread({}, newState[key], {}, inboundState[key]);
            return;
        } // otherwise hard set
        newState[key] = inboundState[key];
    });
    return newState;
}
function $792f2290643e73f9$var$isPlainEnoughObject(o) {
    return o !== null && !Array.isArray(o) && $792f2290643e73f9$var$_typeof(o) === "object";
}


function $04cffa891861b45f$export$2e2bcd8739ae039(config, reducers) {
    config.stateReconciler = config.stateReconciler === undefined ? (0, $792f2290643e73f9$export$2e2bcd8739ae039) : config.stateReconciler;
    return (0, $73e435e2fc216b6c$export$2e2bcd8739ae039)(config, (0, $eShmq.combineReducers)(reducers));
}



var $eShmq = parcelRequire("eShmq");

function $46c0b3c6eec1f9fa$var$_toConsumableArray(arr) {
    return $46c0b3c6eec1f9fa$var$_arrayWithoutHoles(arr) || $46c0b3c6eec1f9fa$var$_iterableToArray(arr) || $46c0b3c6eec1f9fa$var$_nonIterableSpread();
}
function $46c0b3c6eec1f9fa$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $46c0b3c6eec1f9fa$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $46c0b3c6eec1f9fa$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $46c0b3c6eec1f9fa$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $46c0b3c6eec1f9fa$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $46c0b3c6eec1f9fa$var$ownKeys(source, true).forEach(function(key) {
            $46c0b3c6eec1f9fa$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $46c0b3c6eec1f9fa$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $46c0b3c6eec1f9fa$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $46c0b3c6eec1f9fa$var$initialState = {
    registry: [],
    bootstrapped: false
};
var $46c0b3c6eec1f9fa$var$persistorReducer = function persistorReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $46c0b3c6eec1f9fa$var$initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $dc4a47ea750d5f98$export$51e82cdd7353a0e1:
            return $46c0b3c6eec1f9fa$var$_objectSpread({}, state, {
                registry: [].concat($46c0b3c6eec1f9fa$var$_toConsumableArray(state.registry), [
                    action.key
                ])
            });
        case 0, $dc4a47ea750d5f98$export$1647ef958242c4e2:
            var firstIndex = state.registry.indexOf(action.key);
            var registry = $46c0b3c6eec1f9fa$var$_toConsumableArray(state.registry);
            registry.splice(firstIndex, 1);
            return $46c0b3c6eec1f9fa$var$_objectSpread({}, state, {
                registry: registry,
                bootstrapped: registry.length === 0
            });
        default:
            return state;
    }
};
function $46c0b3c6eec1f9fa$export$2e2bcd8739ae039(store, options, cb) {
    var optionsToTest, bannedKeys;
    var boostrappedCb = cb || false;
    var _pStore = (0, $eShmq.createStore)($46c0b3c6eec1f9fa$var$persistorReducer, $46c0b3c6eec1f9fa$var$initialState, options && options.enhancer ? options.enhancer : undefined);
    var register = function register(key) {
        _pStore.dispatch({
            type: (0, $dc4a47ea750d5f98$export$51e82cdd7353a0e1),
            key: key
        });
    };
    var rehydrate = function rehydrate(key, payload, err) {
        var rehydrateAction = {
            type: (0, $dc4a47ea750d5f98$export$1647ef958242c4e2),
            payload: payload,
            err: err,
            key: key // dispatch to `store` to rehydrate and `persistor` to track result
        };
        store.dispatch(rehydrateAction);
        _pStore.dispatch(rehydrateAction);
        if (boostrappedCb && persistor.getState().bootstrapped) {
            boostrappedCb();
            boostrappedCb = false;
        }
    };
    var persistor = $46c0b3c6eec1f9fa$var$_objectSpread({}, _pStore, {
        purge: function purge() {
            var results = [];
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$5514fc3b4067675f),
                result: function result(purgeResult) {
                    results.push(purgeResult);
                }
            });
            return Promise.all(results);
        },
        flush: function flush() {
            var results = [];
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$2aaee4793dd13a52),
                result: function result(flushResult) {
                    results.push(flushResult);
                }
            });
            return Promise.all(results);
        },
        pause: function pause() {
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$dd1033c27a16bbd3)
            });
        },
        persist: function persist() {
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$913fe0e161ed92a2),
                register: register,
                rehydrate: rehydrate
            });
        }
    });
    if (!(options && options.manualPersist)) persistor.persist();
    return persistor;
}



function $e8e82c4ef51638c8$export$2e2bcd8739ae039(migrations, config) {
    var _ref = config || {}, debug = _ref.debug;
    return function(state, currentVersion) {
        if (!state) return Promise.resolve(undefined);
        var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : (0, $dc4a47ea750d5f98$export$363ebe89e6e7aeef);
        if (inboundVersion === currentVersion) return Promise.resolve(state);
        if (inboundVersion > currentVersion) return Promise.resolve(state);
        var migrationKeys = Object.keys(migrations).map(function(ver) {
            return parseInt(ver);
        }).filter(function(key) {
            return currentVersion >= key && key > inboundVersion;
        }).sort(function(a, b) {
            return a - b;
        });
        try {
            var migratedState = migrationKeys.reduce(function(state, versionKey) {
                return migrations[versionKey](state);
            }, state);
            return Promise.resolve(migratedState);
        } catch (err) {
            return Promise.reject(err);
        }
    };
}


function $a82db8a0418f5db2$export$2e2bcd8739ae039(inbound, outbound) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var whitelist = config.whitelist || null;
    var blacklist = config.blacklist || null;
    function whitelistBlacklistCheck(key) {
        if (whitelist && whitelist.indexOf(key) === -1) return true;
        if (blacklist && blacklist.indexOf(key) !== -1) return true;
        return false;
    }
    return {
        in: function _in(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
        },
        out: function out(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
        }
    };
}








var $f2960b1611dd0ab6$export$1e511d4a378977f5;
var $f2960b1611dd0ab6$export$2e2bcd8739ae039;
"use strict";
$f2960b1611dd0ab6$export$1e511d4a378977f5 = true;
$f2960b1611dd0ab6$export$2e2bcd8739ae039 = void 0;

var $f2960b1611dd0ab6$var$_createWebStorage = $f2960b1611dd0ab6$var$_interopRequireDefault((parcelRequire("7Asxf")));
function $f2960b1611dd0ab6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f2960b1611dd0ab6$var$_default = (0, $f2960b1611dd0ab6$var$_createWebStorage.default)("session");
$f2960b1611dd0ab6$export$2e2bcd8739ae039 = $f2960b1611dd0ab6$var$_default;


parcelRequire("3OncY");
const $68f6ed6174fa5191$var$sagaMiddleware = (0, $bea0a19dd4c5e28d$export$2e2bcd8739ae039)({
    onError: (err, info)=>{
        $4d76c9d78abc3a9e$export$efda9a273d7a036d({
            category: "redux-saga",
            level: "error",
            message: "Unhandled saga error",
            data: {
                sagaStack: info.sagaStack
            }
        });
        $kQ0sT.captureException(err);
    }
});
const $68f6ed6174fa5191$var$rootReducerConfig = {
    key: "root",
    storage: (0, $f2960b1611dd0ab6$export$2e2bcd8739ae039),
    whitelist: [
        "session"
    ]
};
const $68f6ed6174fa5191$var$combinedReducer = (0, $eShmq.combineReducers)((0, $ddb1ed18d1f52d55$export$2e2bcd8739ae039));
const $68f6ed6174fa5191$var$persistReducerCustom = (0, $73e435e2fc216b6c$export$2e2bcd8739ae039)($68f6ed6174fa5191$var$rootReducerConfig, $68f6ed6174fa5191$var$combinedReducer);
const $68f6ed6174fa5191$var$enhancers = [
    $c0d6a2270452487f$export$c4506dd2040faa8a(),
    (0, $eShmq.applyMiddleware)((0, $f1d9f8eb4f980839$export$4fba1bc89ad9e04d)),
    (0, $eShmq.applyMiddleware)($68f6ed6174fa5191$var$sagaMiddleware)
];
const $68f6ed6174fa5191$var$composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || (0, $eShmq.compose);
function $68f6ed6174fa5191$export$7d8a5b498da695ac(initialState = {}) {
    const store = (0, $eShmq.createStore)($68f6ed6174fa5191$var$persistReducerCustom, initialState, $68f6ed6174fa5191$var$composeEnhancers(...$68f6ed6174fa5191$var$enhancers));
    $68f6ed6174fa5191$var$sagaMiddleware.run((0, $d4bd78bc3efd9ba4$export$2e2bcd8739ae039));
    const persistor = (0, $46c0b3c6eec1f9fa$export$2e2bcd8739ae039)(store);
    return {
        store: store,
        persistor: persistor
    };
}


parcelRequire("jHTLJ");
var $4hUQH = parcelRequire("4hUQH");

var $acw62 = parcelRequire("acw62");
function $6e12196636af0b10$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6e12196636af0b10$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6e12196636af0b10$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6e12196636af0b10$var$_typeof(obj);
}
function $6e12196636af0b10$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6e12196636af0b10$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6e12196636af0b10$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6e12196636af0b10$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6e12196636af0b10$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6e12196636af0b10$var$_possibleConstructorReturn(self, call) {
    if (call && ($6e12196636af0b10$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $6e12196636af0b10$var$_assertThisInitialized(self);
}
function $6e12196636af0b10$var$_getPrototypeOf(o) {
    $6e12196636af0b10$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6e12196636af0b10$var$_getPrototypeOf(o);
}
function $6e12196636af0b10$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6e12196636af0b10$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6e12196636af0b10$var$_setPrototypeOf(subClass, superClass);
}
function $6e12196636af0b10$var$_setPrototypeOf(o, p) {
    $6e12196636af0b10$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6e12196636af0b10$var$_setPrototypeOf(o, p);
}
function $6e12196636af0b10$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $6e12196636af0b10$export$311ca220e7478cda = /*#__PURE__*/ function(_PureComponent) {
    $6e12196636af0b10$var$_inherits(PersistGate, _PureComponent);
    function PersistGate() {
        var _getPrototypeOf2;
        var _this;
        $6e12196636af0b10$var$_classCallCheck(this, PersistGate);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $6e12196636af0b10$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $6e12196636af0b10$var$_getPrototypeOf(PersistGate)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        $6e12196636af0b10$var$_defineProperty($6e12196636af0b10$var$_assertThisInitialized(_this), "state", {
            bootstrapped: false
        });
        $6e12196636af0b10$var$_defineProperty($6e12196636af0b10$var$_assertThisInitialized(_this), "_unsubscribe", void 0);
        $6e12196636af0b10$var$_defineProperty($6e12196636af0b10$var$_assertThisInitialized(_this), "handlePersistorState", function() {
            var persistor = _this.props.persistor;
            var _persistor$getState = persistor.getState(), bootstrapped = _persistor$getState.bootstrapped;
            if (bootstrapped) {
                if (_this.props.onBeforeLift) Promise.resolve(_this.props.onBeforeLift()).finally(function() {
                    return _this.setState({
                        bootstrapped: true
                    });
                });
                else _this.setState({
                    bootstrapped: true
                });
                _this._unsubscribe && _this._unsubscribe();
            }
        });
        return _this;
    }
    $6e12196636af0b10$var$_createClass(PersistGate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
                this.handlePersistorState();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._unsubscribe && this._unsubscribe();
            }
        },
        {
            key: "render",
            value: function render() {
                if (typeof this.props.children === "function") return this.props.children(this.state.bootstrapped);
                return this.state.bootstrapped ? this.props.children : this.props.loading;
            }
        }
    ]);
    return PersistGate;
}((0, $acw62.PureComponent));
$6e12196636af0b10$var$_defineProperty($6e12196636af0b10$export$311ca220e7478cda, "defaultProps", {
    children: null,
    loading: null
});


$07b303fd558e140e$export$2cd8252107eb640b({
    dsn: (0, $3OncY.Config).sentryDSN,
    release: `${(0, $3OncY.Config).appVersion ?? "0.0.0"}`,
    environment: (0, $3OncY.Config).sentryEnvironment,
    integrations: [
        $864e8fb5870202bb$export$5ed0db6416cb6ea2({
            prefix: "~",
            root: (0, $3OncY.Config).basePath
        }),
        $400f75f99113439b$export$b4109253475213e9(),
        $8042c6839aeabaab$export$2c7b5d6dd5622f23()
    ],
    tracesSampleRate: (0, $3OncY.Config).sentryTracesSampleRate,
    normalizeDepth: 8
});
const { store: $70fc9a727fa662ae$var$store, persistor: $70fc9a727fa662ae$var$persistor } = (0, $68f6ed6174fa5191$export$7d8a5b498da695ac)();
(0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4hUQH.default), {
    store: $70fc9a727fa662ae$var$store
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6e12196636af0b10$export$311ca220e7478cda), {
    loading: null,
    persistor: $70fc9a727fa662ae$var$persistor
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6840e8b44f75a905$export$86fbec116b87613f), null))), document.getElementById("app"));
if (null) null.accept();


//# sourceMappingURL=index.1f7b5ae6.js.map
